import { g as Dn, j as r } from "./icons/AccesRecoveryIcon-CUPieIxT.js";
import nt, { useRef as Ee, useEffect as fe, useState as R, useCallback as Nt, useMemo as ht, Component as Pi, createElement as Ir, createContext as Ai, forwardRef as Ri, memo as Oi, useImperativeHandle as Vr } from "react";
import { C as rn } from "./icons/ChevronDownIcon-8n4-wKXO.js";
import { I as Ft } from "./icons/InfoIcon-MbSD89GU.js";
import { S as Fi } from "./icons/StarProgressIcon-CxxR_oo5.js";
import { S as Bi } from "./icons/StarProgressLightIcon-A7Zr40Sq.js";
import { A as Ln } from "./icons/AlertIcon-CfCpNooe.js";
import { C as Mo } from "./icons/CheckOutlinedIcon-CbeZSQDD.js";
import { C as an } from "./icons/CloseIcon-C4vus27P.js";
import { A as Zt } from "./icons/ArrowDownIcon-BO_7voCs.js";
import { E as Tr } from "./icons/ExternalLinkIcon-XYAQtq__.js";
import { S as Do } from "./icons/StopIcon-Bz858HqN.js";
import { D as Mi } from "./icons/DiscordIcon-K_XLccM7.js";
import { T as Di } from "./icons/TelegramIcon-CJBPF-Is.js";
import { B as Li } from "./icons/BuyIcon-Bqd8EhNQ.js";
import { M as Lo } from "./icons/MessageIcon-XS8Trady.js";
import { A as na } from "./icons/ArrowUpIcon-C1e9VjlP.js";
import { A as Wr } from "./icons/ArrowLeftIcon-Db12oM6p.js";
import { A as Gr } from "./icons/ArrowRightIcon-DkdgmDFC.js";
import { P as zr } from "./icons/PlayIcon-BInkAaXz.js";
import { F as Ui } from "./icons/FacebookIcon-DnrA3rtR.js";
import { L as Vi } from "./icons/LinkedinIcon-DErrbs9B.js";
import { X as Wi } from "./icons/XIcon-CQ3j8zwZ.js";
import { R as ra } from "./icons/RewardsIcon-Cl5LsCsu.js";
import { C as Uo } from "./icons/CheckIcon-Df3VFxGN.js";
import { C as Gi } from "./icons/CopyIcon-CXCWwbKo.js";
import { S as Vo } from "./icons/ShareIcon-BnBpLhp3.js";
import { T as zi } from "./icons/TokenLPIcon-CcP0cM3n.js";
import { T as Hi } from "./icons/TokenPairIcon-6wsKeM_I.js";
import { T as Wo } from "./icons/TUTIcon-BzC-DNN1.js";
import { B as qi } from "./icons/BurgerIcon-Bf2cIp66.js";
import { A as Go } from "./icons/AddCircleIcon-CSXlFmrQ.js";
import { A as Yi } from "./icons/ArrowCircleDownIcon-CbzFBwE6.js";
import { C as Ki } from "./icons/ChevronUpIcon-CKHBjCbS.js";
import { S as Xi } from "./icons/SwapIcon-CqeTRV6H.js";
import { C as Zi } from "./icons/CloseCircleIcon-c7wqNhQr.js";
import { C as Ji } from "./icons/ChangeIcon-DTU_Y28d.js";
import { I as aa } from "./icons/InfoFilledIcon-DhBH6WlG.js";
import { F as Qi } from "./icons/FITIcon-CdAYoVtJ.js";
import { F as es } from "./icons/FITUSDTIcon-kkHAAs1i.js";
import { F as ts } from "./icons/FITOutlineIcon-DbQT-ID6.js";
import { F as ns } from "./icons/FITWBTCIcon-D7Y0utZ3.js";
import { F as rs } from "./icons/FITWBTCOutlineIcon-C8IzKFSc.js";
import { G as as } from "./icons/GT3Icon-cej4wM8P.js";
import { G as os } from "./icons/GT3OutlineIcon-DcXx40zw.js";
import { R as is } from "./icons/RNTIcon-DidyN_7Q.js";
import { R as ss } from "./icons/RNTOutlineIcon-XUc-gvQy.js";
import { R as oa } from "./icons/RNTUSDTIcon-jqsbId3S.js";
import { R as ia } from "./icons/RNTUSDTOutlineIcon-C-GGNaTe.js";
import { T as ls } from "./icons/TINYIcon-SXkEkjgj.js";
import { T as cs } from "./icons/TURINIcon-C-X5nPYv.js";
import { T as ds } from "./icons/TUTOutlineIcon-DfggkGNe.js";
import { T as sa } from "./icons/TUTWBTCIcon-BUDgqvkc.js";
import { T as la } from "./icons/TUTWBTCOutlineIcon-BJ6g9HMs.js";
import { U as us } from "./icons/UnknownTokenIcon-BIcGZotD.js";
import { U as hs } from "./icons/USDCIcon-5UFpb9Oq.js";
import { U as qn } from "./icons/USDTGT3Icon-D36jAas8.js";
import { U as Yn } from "./icons/USDTGT3OutlineIcon-DLfmTA0d.js";
import { U as ca } from "./icons/USDTIcon-BPhA4lWs.js";
import { U as da } from "./icons/USDTOutlineIcon-DJCj9i6k.js";
import { W as ua } from "./icons/WBTCGT3Icon-BkLa-KxZ.js";
import { W as ha } from "./icons/WBTCGT3OutlineIcon-BL0kyTbA.js";
import { W as fs } from "./icons/WBTCIcon-DDiaYgn1.js";
import { W as ms } from "./icons/WBTCOutlineIcon-Q912vZM0.js";
import { W as _s } from "./icons/WETHIcon-AVYJBM0n.js";
import { W as $s } from "./icons/WPOLIcon-Bm7WM0Lm.js";
import { X as ps } from "./icons/XGT3Icon-DdJ-9yPA.js";
import { X as gs } from "./icons/XGT3OutlineIcon-DyDfo5iJ.js";
import { G as vs } from "./icons/GT3FITIcon-mM54tTBH.js";
import { G as xs } from "./icons/GT3ZHTIcon-BlIGbj7v.js";
import { X as bs } from "./icons/XRNTIcon-CA_lSjcn.js";
import { Z as ys } from "./icons/ZEEMIcon-CMguC9Ax.js";
import { Z as Cs } from "./icons/ZHTIcon-BYQRXcup.js";
import { Z as Ns } from "./icons/ZHTUSDTIcon-DWr-IVNj.js";
import { S as js } from "./icons/SpinnerIcon-Dwq-C25Y.js";
import { C as ws } from "./icons/CloseThinIcon-BETQ4Oom.js";
import { P as Is } from "./icons/PostIcon-Blpl3q3e.js";
import { C as Ts } from "./icons/CheckFilledIcon-CJC7Yh4J.js";
import { A as Ss } from "./icons/AddUserIcon-BM_RcOv5.js";
import { E as zo } from "./icons/EarnIcon-Dnd96day.js";
import { M as Es } from "./icons/MailIcon-BUuoOc-f.js";
import { C as ks } from "./icons/CommentIcon-Ba57LF5Z.js";
import { D as Ho } from "./icons/DeleteIcon-Cn5TblGw.js";
import { E as qo } from "./icons/EditIcon-DWuGHGfE.js";
import { V as fa } from "./icons/VoteUpIcon-DT7qrHE0.js";
import { C as Ps } from "./icons/CoinIcon-BVj30yj7.js";
import { L as As } from "./icons/LikeOutlineIcon-CjfY1fBh.js";
import { O as Rs } from "./icons/OptionsIcon-vIE_RC8C.js";
import { S as Os } from "./icons/SaveIcon-Cb-F-e0A.js";
import { V as Fs } from "./icons/ViewIcon-CXjHIjsj.js";
import { C as Bs } from "./icons/ClockIcon-Dkb_ZoXB.js";
import './index.css';var Kn, ma;
function Ms() {
  if (ma) return Kn;
  ma = 1;
  var e = function(n) {
    n == null && (n = (/* @__PURE__ */ new Date()).getTime()), this.N = 624, this.M = 397, this.MATRIX_A = 2567483615, this.UPPER_MASK = 2147483648, this.LOWER_MASK = 2147483647, this.mt = new Array(this.N), this.mti = this.N + 1, n.constructor == Array ? this.init_by_array(n, n.length) : this.init_seed(n);
  };
  return e.prototype.init_seed = function(n) {
    for (this.mt[0] = n >>> 0, this.mti = 1; this.mti < this.N; this.mti++) {
      var n = this.mt[this.mti - 1] ^ this.mt[this.mti - 1] >>> 30;
      this.mt[this.mti] = (((n & 4294901760) >>> 16) * 1812433253 << 16) + (n & 65535) * 1812433253 + this.mti, this.mt[this.mti] >>>= 0;
    }
  }, e.prototype.init_by_array = function(n, t) {
    var a, o, i;
    for (this.init_seed(19650218), a = 1, o = 0, i = this.N > t ? this.N : t; i; i--) {
      var l = this.mt[a - 1] ^ this.mt[a - 1] >>> 30;
      this.mt[a] = (this.mt[a] ^ (((l & 4294901760) >>> 16) * 1664525 << 16) + (l & 65535) * 1664525) + n[o] + o, this.mt[a] >>>= 0, a++, o++, a >= this.N && (this.mt[0] = this.mt[this.N - 1], a = 1), o >= t && (o = 0);
    }
    for (i = this.N - 1; i; i--) {
      var l = this.mt[a - 1] ^ this.mt[a - 1] >>> 30;
      this.mt[a] = (this.mt[a] ^ (((l & 4294901760) >>> 16) * 1566083941 << 16) + (l & 65535) * 1566083941) - a, this.mt[a] >>>= 0, a++, a >= this.N && (this.mt[0] = this.mt[this.N - 1], a = 1);
    }
    this.mt[0] = 2147483648;
  }, e.prototype.random_int = function() {
    var n, t = new Array(0, this.MATRIX_A);
    if (this.mti >= this.N) {
      var a;
      for (this.mti == this.N + 1 && this.init_seed(5489), a = 0; a < this.N - this.M; a++)
        n = this.mt[a] & this.UPPER_MASK | this.mt[a + 1] & this.LOWER_MASK, this.mt[a] = this.mt[a + this.M] ^ n >>> 1 ^ t[n & 1];
      for (; a < this.N - 1; a++)
        n = this.mt[a] & this.UPPER_MASK | this.mt[a + 1] & this.LOWER_MASK, this.mt[a] = this.mt[a + (this.M - this.N)] ^ n >>> 1 ^ t[n & 1];
      n = this.mt[this.N - 1] & this.UPPER_MASK | this.mt[0] & this.LOWER_MASK, this.mt[this.N - 1] = this.mt[this.M - 1] ^ n >>> 1 ^ t[n & 1], this.mti = 0;
    }
    return n = this.mt[this.mti++], n ^= n >>> 11, n ^= n << 7 & 2636928640, n ^= n << 15 & 4022730752, n ^= n >>> 18, n >>> 0;
  }, e.prototype.random_int31 = function() {
    return this.random_int() >>> 1;
  }, e.prototype.random_incl = function() {
    return this.random_int() * (1 / 4294967295);
  }, e.prototype.random = function() {
    return this.random_int() * (1 / 4294967296);
  }, e.prototype.random_excl = function() {
    return (this.random_int() + 0.5) * (1 / 4294967296);
  }, e.prototype.random_long = function() {
    var n = this.random_int() >>> 5, t = this.random_int() >>> 6;
    return (n * 67108864 + t) * (1 / 9007199254740992);
  }, Kn = e, Kn;
}
var Xn, _a;
function Ds() {
  if (_a) return Xn;
  _a = 1;
  function e(n, t) {
    var a = document.createElement("div");
    return a.style.borderRadius = "50px", a.style.overflow = "hidden", a.style.padding = "0px", a.style.margin = "0px", a.style.width = "" + n + "px", a.style.height = "" + n + "px", a.style.display = "inline-block", a.style.background = t, {
      container: a
    };
  }
  return Xn = e, Xn;
}
var Zn = { exports: {} }, $a;
function Ls() {
  return $a || ($a = 1, function(e) {
    var n = function() {
      function t(s, c, d, h) {
        typeof c == "object" && (d = c.depth, h = c.prototype, c.filter, c = c.circular);
        var f = [], m = [], _ = typeof Buffer < "u";
        typeof c > "u" && (c = !0), typeof d > "u" && (d = 1 / 0);
        function g($, x) {
          if ($ === null)
            return null;
          if (x == 0)
            return $;
          var b, C;
          if (typeof $ != "object")
            return $;
          if (t.__isArray($))
            b = [];
          else if (t.__isRegExp($))
            b = new RegExp($.source, u($)), $.lastIndex && (b.lastIndex = $.lastIndex);
          else if (t.__isDate($))
            b = new Date($.getTime());
          else {
            if (_ && Buffer.isBuffer($))
              return Buffer.allocUnsafe ? b = Buffer.allocUnsafe($.length) : b = new Buffer($.length), $.copy(b), b;
            typeof h > "u" ? (C = Object.getPrototypeOf($), b = Object.create(C)) : (b = Object.create(h), C = h);
          }
          if (c) {
            var p = f.indexOf($);
            if (p != -1)
              return m[p];
            f.push($), m.push(b);
          }
          for (var v in $) {
            var w;
            C && (w = Object.getOwnPropertyDescriptor(C, v)), !(w && w.set == null) && (b[v] = g($[v], x - 1));
          }
          return b;
        }
        return g(s, d);
      }
      t.clonePrototype = function(c) {
        if (c === null)
          return null;
        var d = function() {
        };
        return d.prototype = c, new d();
      };
      function a(s) {
        return Object.prototype.toString.call(s);
      }
      t.__objToStr = a;
      function o(s) {
        return typeof s == "object" && a(s) === "[object Date]";
      }
      t.__isDate = o;
      function i(s) {
        return typeof s == "object" && a(s) === "[object Array]";
      }
      t.__isArray = i;
      function l(s) {
        return typeof s == "object" && a(s) === "[object RegExp]";
      }
      t.__isRegExp = l;
      function u(s) {
        var c = "";
        return s.global && (c += "g"), s.ignoreCase && (c += "i"), s.multiline && (c += "m"), c;
      }
      return t.__getRegExpFlags = u, t;
    }();
    e.exports && (e.exports = n);
  }(Zn)), Zn.exports;
}
var Jn = { exports: {} }, Qn, pa;
function Us() {
  return pa || (pa = 1, Qn = {
    aliceblue: [240, 248, 255],
    antiquewhite: [250, 235, 215],
    aqua: [0, 255, 255],
    aquamarine: [127, 255, 212],
    azure: [240, 255, 255],
    beige: [245, 245, 220],
    bisque: [255, 228, 196],
    black: [0, 0, 0],
    blanchedalmond: [255, 235, 205],
    blue: [0, 0, 255],
    blueviolet: [138, 43, 226],
    brown: [165, 42, 42],
    burlywood: [222, 184, 135],
    cadetblue: [95, 158, 160],
    chartreuse: [127, 255, 0],
    chocolate: [210, 105, 30],
    coral: [255, 127, 80],
    cornflowerblue: [100, 149, 237],
    cornsilk: [255, 248, 220],
    crimson: [220, 20, 60],
    cyan: [0, 255, 255],
    darkblue: [0, 0, 139],
    darkcyan: [0, 139, 139],
    darkgoldenrod: [184, 134, 11],
    darkgray: [169, 169, 169],
    darkgreen: [0, 100, 0],
    darkgrey: [169, 169, 169],
    darkkhaki: [189, 183, 107],
    darkmagenta: [139, 0, 139],
    darkolivegreen: [85, 107, 47],
    darkorange: [255, 140, 0],
    darkorchid: [153, 50, 204],
    darkred: [139, 0, 0],
    darksalmon: [233, 150, 122],
    darkseagreen: [143, 188, 143],
    darkslateblue: [72, 61, 139],
    darkslategray: [47, 79, 79],
    darkslategrey: [47, 79, 79],
    darkturquoise: [0, 206, 209],
    darkviolet: [148, 0, 211],
    deeppink: [255, 20, 147],
    deepskyblue: [0, 191, 255],
    dimgray: [105, 105, 105],
    dimgrey: [105, 105, 105],
    dodgerblue: [30, 144, 255],
    firebrick: [178, 34, 34],
    floralwhite: [255, 250, 240],
    forestgreen: [34, 139, 34],
    fuchsia: [255, 0, 255],
    gainsboro: [220, 220, 220],
    ghostwhite: [248, 248, 255],
    gold: [255, 215, 0],
    goldenrod: [218, 165, 32],
    gray: [128, 128, 128],
    green: [0, 128, 0],
    greenyellow: [173, 255, 47],
    grey: [128, 128, 128],
    honeydew: [240, 255, 240],
    hotpink: [255, 105, 180],
    indianred: [205, 92, 92],
    indigo: [75, 0, 130],
    ivory: [255, 255, 240],
    khaki: [240, 230, 140],
    lavender: [230, 230, 250],
    lavenderblush: [255, 240, 245],
    lawngreen: [124, 252, 0],
    lemonchiffon: [255, 250, 205],
    lightblue: [173, 216, 230],
    lightcoral: [240, 128, 128],
    lightcyan: [224, 255, 255],
    lightgoldenrodyellow: [250, 250, 210],
    lightgray: [211, 211, 211],
    lightgreen: [144, 238, 144],
    lightgrey: [211, 211, 211],
    lightpink: [255, 182, 193],
    lightsalmon: [255, 160, 122],
    lightseagreen: [32, 178, 170],
    lightskyblue: [135, 206, 250],
    lightslategray: [119, 136, 153],
    lightslategrey: [119, 136, 153],
    lightsteelblue: [176, 196, 222],
    lightyellow: [255, 255, 224],
    lime: [0, 255, 0],
    limegreen: [50, 205, 50],
    linen: [250, 240, 230],
    magenta: [255, 0, 255],
    maroon: [128, 0, 0],
    mediumaquamarine: [102, 205, 170],
    mediumblue: [0, 0, 205],
    mediumorchid: [186, 85, 211],
    mediumpurple: [147, 112, 219],
    mediumseagreen: [60, 179, 113],
    mediumslateblue: [123, 104, 238],
    mediumspringgreen: [0, 250, 154],
    mediumturquoise: [72, 209, 204],
    mediumvioletred: [199, 21, 133],
    midnightblue: [25, 25, 112],
    mintcream: [245, 255, 250],
    mistyrose: [255, 228, 225],
    moccasin: [255, 228, 181],
    navajowhite: [255, 222, 173],
    navy: [0, 0, 128],
    oldlace: [253, 245, 230],
    olive: [128, 128, 0],
    olivedrab: [107, 142, 35],
    orange: [255, 165, 0],
    orangered: [255, 69, 0],
    orchid: [218, 112, 214],
    palegoldenrod: [238, 232, 170],
    palegreen: [152, 251, 152],
    paleturquoise: [175, 238, 238],
    palevioletred: [219, 112, 147],
    papayawhip: [255, 239, 213],
    peachpuff: [255, 218, 185],
    peru: [205, 133, 63],
    pink: [255, 192, 203],
    plum: [221, 160, 221],
    powderblue: [176, 224, 230],
    purple: [128, 0, 128],
    rebeccapurple: [102, 51, 153],
    red: [255, 0, 0],
    rosybrown: [188, 143, 143],
    royalblue: [65, 105, 225],
    saddlebrown: [139, 69, 19],
    salmon: [250, 128, 114],
    sandybrown: [244, 164, 96],
    seagreen: [46, 139, 87],
    seashell: [255, 245, 238],
    sienna: [160, 82, 45],
    silver: [192, 192, 192],
    skyblue: [135, 206, 235],
    slateblue: [106, 90, 205],
    slategray: [112, 128, 144],
    slategrey: [112, 128, 144],
    snow: [255, 250, 250],
    springgreen: [0, 255, 127],
    steelblue: [70, 130, 180],
    tan: [210, 180, 140],
    teal: [0, 128, 128],
    thistle: [216, 191, 216],
    tomato: [255, 99, 71],
    turquoise: [64, 224, 208],
    violet: [238, 130, 238],
    wheat: [245, 222, 179],
    white: [255, 255, 255],
    whitesmoke: [245, 245, 245],
    yellow: [255, 255, 0],
    yellowgreen: [154, 205, 50]
  }), Qn;
}
var ga;
function Yo() {
  if (ga) return Jn.exports;
  ga = 1;
  var e = Us(), n = {};
  for (var t in e)
    e.hasOwnProperty(t) && (n[e[t]] = t);
  var a = Jn.exports = {
    rgb: { channels: 3, labels: "rgb" },
    hsl: { channels: 3, labels: "hsl" },
    hsv: { channels: 3, labels: "hsv" },
    hwb: { channels: 3, labels: "hwb" },
    cmyk: { channels: 4, labels: "cmyk" },
    xyz: { channels: 3, labels: "xyz" },
    lab: { channels: 3, labels: "lab" },
    lch: { channels: 3, labels: "lch" },
    hex: { channels: 1, labels: ["hex"] },
    keyword: { channels: 1, labels: ["keyword"] },
    ansi16: { channels: 1, labels: ["ansi16"] },
    ansi256: { channels: 1, labels: ["ansi256"] },
    hcg: { channels: 3, labels: ["h", "c", "g"] },
    apple: { channels: 3, labels: ["r16", "g16", "b16"] },
    gray: { channels: 1, labels: ["gray"] }
  };
  for (var o in a)
    if (a.hasOwnProperty(o)) {
      if (!("channels" in a[o]))
        throw new Error("missing channels property: " + o);
      if (!("labels" in a[o]))
        throw new Error("missing channel labels property: " + o);
      if (a[o].labels.length !== a[o].channels)
        throw new Error("channel and label counts mismatch: " + o);
      var i = a[o].channels, l = a[o].labels;
      delete a[o].channels, delete a[o].labels, Object.defineProperty(a[o], "channels", { value: i }), Object.defineProperty(a[o], "labels", { value: l });
    }
  a.rgb.hsl = function(s) {
    var c = s[0] / 255, d = s[1] / 255, h = s[2] / 255, f = Math.min(c, d, h), m = Math.max(c, d, h), _ = m - f, g, $, x;
    return m === f ? g = 0 : c === m ? g = (d - h) / _ : d === m ? g = 2 + (h - c) / _ : h === m && (g = 4 + (c - d) / _), g = Math.min(g * 60, 360), g < 0 && (g += 360), x = (f + m) / 2, m === f ? $ = 0 : x <= 0.5 ? $ = _ / (m + f) : $ = _ / (2 - m - f), [g, $ * 100, x * 100];
  }, a.rgb.hsv = function(s) {
    var c, d, h, f, m, _ = s[0] / 255, g = s[1] / 255, $ = s[2] / 255, x = Math.max(_, g, $), b = x - Math.min(_, g, $), C = function(p) {
      return (x - p) / 6 / b + 1 / 2;
    };
    return b === 0 ? f = m = 0 : (m = b / x, c = C(_), d = C(g), h = C($), _ === x ? f = h - d : g === x ? f = 1 / 3 + c - h : $ === x && (f = 2 / 3 + d - c), f < 0 ? f += 1 : f > 1 && (f -= 1)), [
      f * 360,
      m * 100,
      x * 100
    ];
  }, a.rgb.hwb = function(s) {
    var c = s[0], d = s[1], h = s[2], f = a.rgb.hsl(s)[0], m = 1 / 255 * Math.min(c, Math.min(d, h));
    return h = 1 - 1 / 255 * Math.max(c, Math.max(d, h)), [f, m * 100, h * 100];
  }, a.rgb.cmyk = function(s) {
    var c = s[0] / 255, d = s[1] / 255, h = s[2] / 255, f, m, _, g;
    return g = Math.min(1 - c, 1 - d, 1 - h), f = (1 - c - g) / (1 - g) || 0, m = (1 - d - g) / (1 - g) || 0, _ = (1 - h - g) / (1 - g) || 0, [f * 100, m * 100, _ * 100, g * 100];
  };
  function u(s, c) {
    return Math.pow(s[0] - c[0], 2) + Math.pow(s[1] - c[1], 2) + Math.pow(s[2] - c[2], 2);
  }
  return a.rgb.keyword = function(s) {
    var c = n[s];
    if (c)
      return c;
    var d = 1 / 0, h;
    for (var f in e)
      if (e.hasOwnProperty(f)) {
        var m = e[f], _ = u(s, m);
        _ < d && (d = _, h = f);
      }
    return h;
  }, a.keyword.rgb = function(s) {
    return e[s];
  }, a.rgb.xyz = function(s) {
    var c = s[0] / 255, d = s[1] / 255, h = s[2] / 255;
    c = c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92, d = d > 0.04045 ? Math.pow((d + 0.055) / 1.055, 2.4) : d / 12.92, h = h > 0.04045 ? Math.pow((h + 0.055) / 1.055, 2.4) : h / 12.92;
    var f = c * 0.4124 + d * 0.3576 + h * 0.1805, m = c * 0.2126 + d * 0.7152 + h * 0.0722, _ = c * 0.0193 + d * 0.1192 + h * 0.9505;
    return [f * 100, m * 100, _ * 100];
  }, a.rgb.lab = function(s) {
    var c = a.rgb.xyz(s), d = c[0], h = c[1], f = c[2], m, _, g;
    return d /= 95.047, h /= 100, f /= 108.883, d = d > 8856e-6 ? Math.pow(d, 1 / 3) : 7.787 * d + 16 / 116, h = h > 8856e-6 ? Math.pow(h, 1 / 3) : 7.787 * h + 16 / 116, f = f > 8856e-6 ? Math.pow(f, 1 / 3) : 7.787 * f + 16 / 116, m = 116 * h - 16, _ = 500 * (d - h), g = 200 * (h - f), [m, _, g];
  }, a.hsl.rgb = function(s) {
    var c = s[0] / 360, d = s[1] / 100, h = s[2] / 100, f, m, _, g, $;
    if (d === 0)
      return $ = h * 255, [$, $, $];
    h < 0.5 ? m = h * (1 + d) : m = h + d - h * d, f = 2 * h - m, g = [0, 0, 0];
    for (var x = 0; x < 3; x++)
      _ = c + 1 / 3 * -(x - 1), _ < 0 && _++, _ > 1 && _--, 6 * _ < 1 ? $ = f + (m - f) * 6 * _ : 2 * _ < 1 ? $ = m : 3 * _ < 2 ? $ = f + (m - f) * (2 / 3 - _) * 6 : $ = f, g[x] = $ * 255;
    return g;
  }, a.hsl.hsv = function(s) {
    var c = s[0], d = s[1] / 100, h = s[2] / 100, f = d, m = Math.max(h, 0.01), _, g;
    return h *= 2, d *= h <= 1 ? h : 2 - h, f *= m <= 1 ? m : 2 - m, g = (h + d) / 2, _ = h === 0 ? 2 * f / (m + f) : 2 * d / (h + d), [c, _ * 100, g * 100];
  }, a.hsv.rgb = function(s) {
    var c = s[0] / 60, d = s[1] / 100, h = s[2] / 100, f = Math.floor(c) % 6, m = c - Math.floor(c), _ = 255 * h * (1 - d), g = 255 * h * (1 - d * m), $ = 255 * h * (1 - d * (1 - m));
    switch (h *= 255, f) {
      case 0:
        return [h, $, _];
      case 1:
        return [g, h, _];
      case 2:
        return [_, h, $];
      case 3:
        return [_, g, h];
      case 4:
        return [$, _, h];
      case 5:
        return [h, _, g];
    }
  }, a.hsv.hsl = function(s) {
    var c = s[0], d = s[1] / 100, h = s[2] / 100, f = Math.max(h, 0.01), m, _, g;
    return g = (2 - d) * h, m = (2 - d) * f, _ = d * f, _ /= m <= 1 ? m : 2 - m, _ = _ || 0, g /= 2, [c, _ * 100, g * 100];
  }, a.hwb.rgb = function(s) {
    var c = s[0] / 360, d = s[1] / 100, h = s[2] / 100, f = d + h, m, _, g, $;
    f > 1 && (d /= f, h /= f), m = Math.floor(6 * c), _ = 1 - h, g = 6 * c - m, (m & 1) !== 0 && (g = 1 - g), $ = d + g * (_ - d);
    var x, b, C;
    switch (m) {
      default:
      case 6:
      case 0:
        x = _, b = $, C = d;
        break;
      case 1:
        x = $, b = _, C = d;
        break;
      case 2:
        x = d, b = _, C = $;
        break;
      case 3:
        x = d, b = $, C = _;
        break;
      case 4:
        x = $, b = d, C = _;
        break;
      case 5:
        x = _, b = d, C = $;
        break;
    }
    return [x * 255, b * 255, C * 255];
  }, a.cmyk.rgb = function(s) {
    var c = s[0] / 100, d = s[1] / 100, h = s[2] / 100, f = s[3] / 100, m, _, g;
    return m = 1 - Math.min(1, c * (1 - f) + f), _ = 1 - Math.min(1, d * (1 - f) + f), g = 1 - Math.min(1, h * (1 - f) + f), [m * 255, _ * 255, g * 255];
  }, a.xyz.rgb = function(s) {
    var c = s[0] / 100, d = s[1] / 100, h = s[2] / 100, f, m, _;
    return f = c * 3.2406 + d * -1.5372 + h * -0.4986, m = c * -0.9689 + d * 1.8758 + h * 0.0415, _ = c * 0.0557 + d * -0.204 + h * 1.057, f = f > 31308e-7 ? 1.055 * Math.pow(f, 1 / 2.4) - 0.055 : f * 12.92, m = m > 31308e-7 ? 1.055 * Math.pow(m, 1 / 2.4) - 0.055 : m * 12.92, _ = _ > 31308e-7 ? 1.055 * Math.pow(_, 1 / 2.4) - 0.055 : _ * 12.92, f = Math.min(Math.max(0, f), 1), m = Math.min(Math.max(0, m), 1), _ = Math.min(Math.max(0, _), 1), [f * 255, m * 255, _ * 255];
  }, a.xyz.lab = function(s) {
    var c = s[0], d = s[1], h = s[2], f, m, _;
    return c /= 95.047, d /= 100, h /= 108.883, c = c > 8856e-6 ? Math.pow(c, 1 / 3) : 7.787 * c + 16 / 116, d = d > 8856e-6 ? Math.pow(d, 1 / 3) : 7.787 * d + 16 / 116, h = h > 8856e-6 ? Math.pow(h, 1 / 3) : 7.787 * h + 16 / 116, f = 116 * d - 16, m = 500 * (c - d), _ = 200 * (d - h), [f, m, _];
  }, a.lab.xyz = function(s) {
    var c = s[0], d = s[1], h = s[2], f, m, _;
    m = (c + 16) / 116, f = d / 500 + m, _ = m - h / 200;
    var g = Math.pow(m, 3), $ = Math.pow(f, 3), x = Math.pow(_, 3);
    return m = g > 8856e-6 ? g : (m - 16 / 116) / 7.787, f = $ > 8856e-6 ? $ : (f - 16 / 116) / 7.787, _ = x > 8856e-6 ? x : (_ - 16 / 116) / 7.787, f *= 95.047, m *= 100, _ *= 108.883, [f, m, _];
  }, a.lab.lch = function(s) {
    var c = s[0], d = s[1], h = s[2], f, m, _;
    return f = Math.atan2(h, d), m = f * 360 / 2 / Math.PI, m < 0 && (m += 360), _ = Math.sqrt(d * d + h * h), [c, _, m];
  }, a.lch.lab = function(s) {
    var c = s[0], d = s[1], h = s[2], f, m, _;
    return _ = h / 360 * 2 * Math.PI, f = d * Math.cos(_), m = d * Math.sin(_), [c, f, m];
  }, a.rgb.ansi16 = function(s) {
    var c = s[0], d = s[1], h = s[2], f = 1 in arguments ? arguments[1] : a.rgb.hsv(s)[2];
    if (f = Math.round(f / 50), f === 0)
      return 30;
    var m = 30 + (Math.round(h / 255) << 2 | Math.round(d / 255) << 1 | Math.round(c / 255));
    return f === 2 && (m += 60), m;
  }, a.hsv.ansi16 = function(s) {
    return a.rgb.ansi16(a.hsv.rgb(s), s[2]);
  }, a.rgb.ansi256 = function(s) {
    var c = s[0], d = s[1], h = s[2];
    if (c === d && d === h)
      return c < 8 ? 16 : c > 248 ? 231 : Math.round((c - 8) / 247 * 24) + 232;
    var f = 16 + 36 * Math.round(c / 255 * 5) + 6 * Math.round(d / 255 * 5) + Math.round(h / 255 * 5);
    return f;
  }, a.ansi16.rgb = function(s) {
    var c = s % 10;
    if (c === 0 || c === 7)
      return s > 50 && (c += 3.5), c = c / 10.5 * 255, [c, c, c];
    var d = (~~(s > 50) + 1) * 0.5, h = (c & 1) * d * 255, f = (c >> 1 & 1) * d * 255, m = (c >> 2 & 1) * d * 255;
    return [h, f, m];
  }, a.ansi256.rgb = function(s) {
    if (s >= 232) {
      var c = (s - 232) * 10 + 8;
      return [c, c, c];
    }
    s -= 16;
    var d, h = Math.floor(s / 36) / 5 * 255, f = Math.floor((d = s % 36) / 6) / 5 * 255, m = d % 6 / 5 * 255;
    return [h, f, m];
  }, a.rgb.hex = function(s) {
    var c = ((Math.round(s[0]) & 255) << 16) + ((Math.round(s[1]) & 255) << 8) + (Math.round(s[2]) & 255), d = c.toString(16).toUpperCase();
    return "000000".substring(d.length) + d;
  }, a.hex.rgb = function(s) {
    var c = s.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
    if (!c)
      return [0, 0, 0];
    var d = c[0];
    c[0].length === 3 && (d = d.split("").map(function(g) {
      return g + g;
    }).join(""));
    var h = parseInt(d, 16), f = h >> 16 & 255, m = h >> 8 & 255, _ = h & 255;
    return [f, m, _];
  }, a.rgb.hcg = function(s) {
    var c = s[0] / 255, d = s[1] / 255, h = s[2] / 255, f = Math.max(Math.max(c, d), h), m = Math.min(Math.min(c, d), h), _ = f - m, g, $;
    return _ < 1 ? g = m / (1 - _) : g = 0, _ <= 0 ? $ = 0 : f === c ? $ = (d - h) / _ % 6 : f === d ? $ = 2 + (h - c) / _ : $ = 4 + (c - d) / _ + 4, $ /= 6, $ %= 1, [$ * 360, _ * 100, g * 100];
  }, a.hsl.hcg = function(s) {
    var c = s[1] / 100, d = s[2] / 100, h = 1, f = 0;
    return d < 0.5 ? h = 2 * c * d : h = 2 * c * (1 - d), h < 1 && (f = (d - 0.5 * h) / (1 - h)), [s[0], h * 100, f * 100];
  }, a.hsv.hcg = function(s) {
    var c = s[1] / 100, d = s[2] / 100, h = c * d, f = 0;
    return h < 1 && (f = (d - h) / (1 - h)), [s[0], h * 100, f * 100];
  }, a.hcg.rgb = function(s) {
    var c = s[0] / 360, d = s[1] / 100, h = s[2] / 100;
    if (d === 0)
      return [h * 255, h * 255, h * 255];
    var f = [0, 0, 0], m = c % 1 * 6, _ = m % 1, g = 1 - _, $ = 0;
    switch (Math.floor(m)) {
      case 0:
        f[0] = 1, f[1] = _, f[2] = 0;
        break;
      case 1:
        f[0] = g, f[1] = 1, f[2] = 0;
        break;
      case 2:
        f[0] = 0, f[1] = 1, f[2] = _;
        break;
      case 3:
        f[0] = 0, f[1] = g, f[2] = 1;
        break;
      case 4:
        f[0] = _, f[1] = 0, f[2] = 1;
        break;
      default:
        f[0] = 1, f[1] = 0, f[2] = g;
    }
    return $ = (1 - d) * h, [
      (d * f[0] + $) * 255,
      (d * f[1] + $) * 255,
      (d * f[2] + $) * 255
    ];
  }, a.hcg.hsv = function(s) {
    var c = s[1] / 100, d = s[2] / 100, h = c + d * (1 - c), f = 0;
    return h > 0 && (f = c / h), [s[0], f * 100, h * 100];
  }, a.hcg.hsl = function(s) {
    var c = s[1] / 100, d = s[2] / 100, h = d * (1 - c) + 0.5 * c, f = 0;
    return h > 0 && h < 0.5 ? f = c / (2 * h) : h >= 0.5 && h < 1 && (f = c / (2 * (1 - h))), [s[0], f * 100, h * 100];
  }, a.hcg.hwb = function(s) {
    var c = s[1] / 100, d = s[2] / 100, h = c + d * (1 - c);
    return [s[0], (h - c) * 100, (1 - h) * 100];
  }, a.hwb.hcg = function(s) {
    var c = s[1] / 100, d = s[2] / 100, h = 1 - d, f = h - c, m = 0;
    return f < 1 && (m = (h - f) / (1 - f)), [s[0], f * 100, m * 100];
  }, a.apple.rgb = function(s) {
    return [s[0] / 65535 * 255, s[1] / 65535 * 255, s[2] / 65535 * 255];
  }, a.rgb.apple = function(s) {
    return [s[0] / 255 * 65535, s[1] / 255 * 65535, s[2] / 255 * 65535];
  }, a.gray.rgb = function(s) {
    return [s[0] / 100 * 255, s[0] / 100 * 255, s[0] / 100 * 255];
  }, a.gray.hsl = a.gray.hsv = function(s) {
    return [0, 0, s[0]];
  }, a.gray.hwb = function(s) {
    return [0, 100, s[0]];
  }, a.gray.cmyk = function(s) {
    return [0, 0, 0, s[0]];
  }, a.gray.lab = function(s) {
    return [s[0], 0, 0];
  }, a.gray.hex = function(s) {
    var c = Math.round(s[0] / 100 * 255) & 255, d = (c << 16) + (c << 8) + c, h = d.toString(16).toUpperCase();
    return "000000".substring(h.length) + h;
  }, a.rgb.gray = function(s) {
    var c = (s[0] + s[1] + s[2]) / 3;
    return [c / 255 * 100];
  }, Jn.exports;
}
var er, va;
function Vs() {
  if (va) return er;
  va = 1;
  var e = Yo();
  function n() {
    for (var i = {}, l = Object.keys(e), u = l.length, s = 0; s < u; s++)
      i[l[s]] = {
        // http://jsperf.com/1-vs-infinity
        // micro-opt, but this is simple.
        distance: -1,
        parent: null
      };
    return i;
  }
  function t(i) {
    var l = n(), u = [i];
    for (l[i].distance = 0; u.length; )
      for (var s = u.pop(), c = Object.keys(e[s]), d = c.length, h = 0; h < d; h++) {
        var f = c[h], m = l[f];
        m.distance === -1 && (m.distance = l[s].distance + 1, m.parent = s, u.unshift(f));
      }
    return l;
  }
  function a(i, l) {
    return function(u) {
      return l(i(u));
    };
  }
  function o(i, l) {
    for (var u = [l[i].parent, i], s = e[l[i].parent][i], c = l[i].parent; l[c].parent; )
      u.unshift(l[c].parent), s = a(e[l[c].parent][c], s), c = l[c].parent;
    return s.conversion = u, s;
  }
  return er = function(i) {
    for (var l = t(i), u = {}, s = Object.keys(l), c = s.length, d = 0; d < c; d++) {
      var h = s[d], f = l[h];
      f.parent !== null && (u[h] = o(h, l));
    }
    return u;
  }, er;
}
var tr, xa;
function Ws() {
  if (xa) return tr;
  xa = 1;
  var e = Yo(), n = Vs(), t = {}, a = Object.keys(e);
  function o(l) {
    var u = function(s) {
      return s == null ? s : (arguments.length > 1 && (s = Array.prototype.slice.call(arguments)), l(s));
    };
    return "conversion" in l && (u.conversion = l.conversion), u;
  }
  function i(l) {
    var u = function(s) {
      if (s == null)
        return s;
      arguments.length > 1 && (s = Array.prototype.slice.call(arguments));
      var c = l(s);
      if (typeof c == "object")
        for (var d = c.length, h = 0; h < d; h++)
          c[h] = Math.round(c[h]);
      return c;
    };
    return "conversion" in l && (u.conversion = l.conversion), u;
  }
  return a.forEach(function(l) {
    t[l] = {}, Object.defineProperty(t[l], "channels", { value: e[l].channels }), Object.defineProperty(t[l], "labels", { value: e[l].labels });
    var u = n(l), s = Object.keys(u);
    s.forEach(function(c) {
      var d = u[c];
      t[l][c] = i(d), t[l][c].raw = o(d);
    });
  }), tr = t, tr;
}
var nr, ba;
function Gs() {
  return ba || (ba = 1, nr = {
    aliceblue: [240, 248, 255],
    antiquewhite: [250, 235, 215],
    aqua: [0, 255, 255],
    aquamarine: [127, 255, 212],
    azure: [240, 255, 255],
    beige: [245, 245, 220],
    bisque: [255, 228, 196],
    black: [0, 0, 0],
    blanchedalmond: [255, 235, 205],
    blue: [0, 0, 255],
    blueviolet: [138, 43, 226],
    brown: [165, 42, 42],
    burlywood: [222, 184, 135],
    cadetblue: [95, 158, 160],
    chartreuse: [127, 255, 0],
    chocolate: [210, 105, 30],
    coral: [255, 127, 80],
    cornflowerblue: [100, 149, 237],
    cornsilk: [255, 248, 220],
    crimson: [220, 20, 60],
    cyan: [0, 255, 255],
    darkblue: [0, 0, 139],
    darkcyan: [0, 139, 139],
    darkgoldenrod: [184, 134, 11],
    darkgray: [169, 169, 169],
    darkgreen: [0, 100, 0],
    darkgrey: [169, 169, 169],
    darkkhaki: [189, 183, 107],
    darkmagenta: [139, 0, 139],
    darkolivegreen: [85, 107, 47],
    darkorange: [255, 140, 0],
    darkorchid: [153, 50, 204],
    darkred: [139, 0, 0],
    darksalmon: [233, 150, 122],
    darkseagreen: [143, 188, 143],
    darkslateblue: [72, 61, 139],
    darkslategray: [47, 79, 79],
    darkslategrey: [47, 79, 79],
    darkturquoise: [0, 206, 209],
    darkviolet: [148, 0, 211],
    deeppink: [255, 20, 147],
    deepskyblue: [0, 191, 255],
    dimgray: [105, 105, 105],
    dimgrey: [105, 105, 105],
    dodgerblue: [30, 144, 255],
    firebrick: [178, 34, 34],
    floralwhite: [255, 250, 240],
    forestgreen: [34, 139, 34],
    fuchsia: [255, 0, 255],
    gainsboro: [220, 220, 220],
    ghostwhite: [248, 248, 255],
    gold: [255, 215, 0],
    goldenrod: [218, 165, 32],
    gray: [128, 128, 128],
    green: [0, 128, 0],
    greenyellow: [173, 255, 47],
    grey: [128, 128, 128],
    honeydew: [240, 255, 240],
    hotpink: [255, 105, 180],
    indianred: [205, 92, 92],
    indigo: [75, 0, 130],
    ivory: [255, 255, 240],
    khaki: [240, 230, 140],
    lavender: [230, 230, 250],
    lavenderblush: [255, 240, 245],
    lawngreen: [124, 252, 0],
    lemonchiffon: [255, 250, 205],
    lightblue: [173, 216, 230],
    lightcoral: [240, 128, 128],
    lightcyan: [224, 255, 255],
    lightgoldenrodyellow: [250, 250, 210],
    lightgray: [211, 211, 211],
    lightgreen: [144, 238, 144],
    lightgrey: [211, 211, 211],
    lightpink: [255, 182, 193],
    lightsalmon: [255, 160, 122],
    lightseagreen: [32, 178, 170],
    lightskyblue: [135, 206, 250],
    lightslategray: [119, 136, 153],
    lightslategrey: [119, 136, 153],
    lightsteelblue: [176, 196, 222],
    lightyellow: [255, 255, 224],
    lime: [0, 255, 0],
    limegreen: [50, 205, 50],
    linen: [250, 240, 230],
    magenta: [255, 0, 255],
    maroon: [128, 0, 0],
    mediumaquamarine: [102, 205, 170],
    mediumblue: [0, 0, 205],
    mediumorchid: [186, 85, 211],
    mediumpurple: [147, 112, 219],
    mediumseagreen: [60, 179, 113],
    mediumslateblue: [123, 104, 238],
    mediumspringgreen: [0, 250, 154],
    mediumturquoise: [72, 209, 204],
    mediumvioletred: [199, 21, 133],
    midnightblue: [25, 25, 112],
    mintcream: [245, 255, 250],
    mistyrose: [255, 228, 225],
    moccasin: [255, 228, 181],
    navajowhite: [255, 222, 173],
    navy: [0, 0, 128],
    oldlace: [253, 245, 230],
    olive: [128, 128, 0],
    olivedrab: [107, 142, 35],
    orange: [255, 165, 0],
    orangered: [255, 69, 0],
    orchid: [218, 112, 214],
    palegoldenrod: [238, 232, 170],
    palegreen: [152, 251, 152],
    paleturquoise: [175, 238, 238],
    palevioletred: [219, 112, 147],
    papayawhip: [255, 239, 213],
    peachpuff: [255, 218, 185],
    peru: [205, 133, 63],
    pink: [255, 192, 203],
    plum: [221, 160, 221],
    powderblue: [176, 224, 230],
    purple: [128, 0, 128],
    rebeccapurple: [102, 51, 153],
    red: [255, 0, 0],
    rosybrown: [188, 143, 143],
    royalblue: [65, 105, 225],
    saddlebrown: [139, 69, 19],
    salmon: [250, 128, 114],
    sandybrown: [244, 164, 96],
    seagreen: [46, 139, 87],
    seashell: [255, 245, 238],
    sienna: [160, 82, 45],
    silver: [192, 192, 192],
    skyblue: [135, 206, 235],
    slateblue: [106, 90, 205],
    slategray: [112, 128, 144],
    slategrey: [112, 128, 144],
    snow: [255, 250, 250],
    springgreen: [0, 255, 127],
    steelblue: [70, 130, 180],
    tan: [210, 180, 140],
    teal: [0, 128, 128],
    thistle: [216, 191, 216],
    tomato: [255, 99, 71],
    turquoise: [64, 224, 208],
    violet: [238, 130, 238],
    wheat: [245, 222, 179],
    white: [255, 255, 255],
    whitesmoke: [245, 245, 245],
    yellow: [255, 255, 0],
    yellowgreen: [154, 205, 50]
  }), nr;
}
var rr, ya;
function zs() {
  if (ya) return rr;
  ya = 1;
  var e = Gs();
  rr = {
    getRgba: n,
    getHsla: t,
    getRgb: o,
    getHsl: i,
    getHwb: a,
    getAlpha: l,
    hexString: u,
    rgbString: s,
    rgbaString: c,
    percentString: d,
    percentaString: h,
    hslString: f,
    hslaString: m,
    hwbString: _,
    keyword: g
  };
  function n(p) {
    if (p) {
      var v = /^#([a-fA-F0-9]{3})$/, w = /^#([a-fA-F0-9]{6})$/, S = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/, D = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/, Z = /(\D+)/, O = [0, 0, 0], B = 1, M = p.match(v);
      if (M) {
        M = M[1];
        for (var k = 0; k < O.length; k++)
          O[k] = parseInt(M[k] + M[k], 16);
      } else if (M = p.match(w)) {
        M = M[1];
        for (var k = 0; k < O.length; k++)
          O[k] = parseInt(M.slice(k * 2, k * 2 + 2), 16);
      } else if (M = p.match(S)) {
        for (var k = 0; k < O.length; k++)
          O[k] = parseInt(M[k + 1]);
        B = parseFloat(M[4]);
      } else if (M = p.match(D)) {
        for (var k = 0; k < O.length; k++)
          O[k] = Math.round(parseFloat(M[k + 1]) * 2.55);
        B = parseFloat(M[4]);
      } else if (M = p.match(Z)) {
        if (M[1] == "transparent")
          return [0, 0, 0, 0];
        if (O = e[M[1]], !O)
          return;
      }
      for (var k = 0; k < O.length; k++)
        O[k] = $(O[k], 0, 255);
      return !B && B != 0 ? B = 1 : B = $(B, 0, 1), O[3] = B, O;
    }
  }
  function t(p) {
    if (p) {
      var v = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/, w = p.match(v);
      if (w) {
        var S = parseFloat(w[4]), D = $(parseInt(w[1]), 0, 360), Z = $(parseFloat(w[2]), 0, 100), O = $(parseFloat(w[3]), 0, 100), B = $(isNaN(S) ? 1 : S, 0, 1);
        return [D, Z, O, B];
      }
    }
  }
  function a(p) {
    if (p) {
      var v = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/, w = p.match(v);
      if (w) {
        var S = parseFloat(w[4]), D = $(parseInt(w[1]), 0, 360), Z = $(parseFloat(w[2]), 0, 100), O = $(parseFloat(w[3]), 0, 100), B = $(isNaN(S) ? 1 : S, 0, 1);
        return [D, Z, O, B];
      }
    }
  }
  function o(p) {
    var v = n(p);
    return v && v.slice(0, 3);
  }
  function i(p) {
    var v = t(p);
    return v && v.slice(0, 3);
  }
  function l(p) {
    var v = n(p);
    if (v)
      return v[3];
    if (v = t(p))
      return v[3];
    if (v = a(p))
      return v[3];
  }
  function u(p) {
    return "#" + x(p[0]) + x(p[1]) + x(p[2]);
  }
  function s(p, v) {
    return v < 1 || p[3] && p[3] < 1 ? c(p, v) : "rgb(" + p[0] + ", " + p[1] + ", " + p[2] + ")";
  }
  function c(p, v) {
    return v === void 0 && (v = p[3] !== void 0 ? p[3] : 1), "rgba(" + p[0] + ", " + p[1] + ", " + p[2] + ", " + v + ")";
  }
  function d(p, v) {
    if (v < 1 || p[3] && p[3] < 1)
      return h(p, v);
    var w = Math.round(p[0] / 255 * 100), S = Math.round(p[1] / 255 * 100), D = Math.round(p[2] / 255 * 100);
    return "rgb(" + w + "%, " + S + "%, " + D + "%)";
  }
  function h(p, v) {
    var w = Math.round(p[0] / 255 * 100), S = Math.round(p[1] / 255 * 100), D = Math.round(p[2] / 255 * 100);
    return "rgba(" + w + "%, " + S + "%, " + D + "%, " + (v || p[3] || 1) + ")";
  }
  function f(p, v) {
    return v < 1 || p[3] && p[3] < 1 ? m(p, v) : "hsl(" + p[0] + ", " + p[1] + "%, " + p[2] + "%)";
  }
  function m(p, v) {
    return v === void 0 && (v = p[3] !== void 0 ? p[3] : 1), "hsla(" + p[0] + ", " + p[1] + "%, " + p[2] + "%, " + v + ")";
  }
  function _(p, v) {
    return v === void 0 && (v = p[3] !== void 0 ? p[3] : 1), "hwb(" + p[0] + ", " + p[1] + "%, " + p[2] + "%" + (v !== void 0 && v !== 1 ? ", " + v : "") + ")";
  }
  function g(p) {
    return b[p.slice(0, 3)];
  }
  function $(p, v, w) {
    return Math.min(Math.max(v, p), w);
  }
  function x(p) {
    var v = p.toString(16).toUpperCase();
    return v.length < 2 ? "0" + v : v;
  }
  var b = {};
  for (var C in e)
    b[e[C]] = C;
  return rr;
}
var ar, Ca;
function Hs() {
  if (Ca) return ar;
  Ca = 1;
  var e = Ls(), n = Ws(), t = zs(), a = function(o) {
    if (o instanceof a)
      return o;
    if (!(this instanceof a))
      return new a(o);
    this.values = {
      rgb: [0, 0, 0],
      hsl: [0, 0, 0],
      hsv: [0, 0, 0],
      hwb: [0, 0, 0],
      cmyk: [0, 0, 0, 0],
      alpha: 1
    };
    var i;
    if (typeof o == "string")
      if (i = t.getRgba(o), i)
        this.setValues("rgb", i);
      else if (i = t.getHsla(o))
        this.setValues("hsl", i);
      else if (i = t.getHwb(o))
        this.setValues("hwb", i);
      else
        throw new Error('Unable to parse color from string "' + o + '"');
    else if (typeof o == "object")
      if (i = o, i.r !== void 0 || i.red !== void 0)
        this.setValues("rgb", i);
      else if (i.l !== void 0 || i.lightness !== void 0)
        this.setValues("hsl", i);
      else if (i.v !== void 0 || i.value !== void 0)
        this.setValues("hsv", i);
      else if (i.w !== void 0 || i.whiteness !== void 0)
        this.setValues("hwb", i);
      else if (i.c !== void 0 || i.cyan !== void 0)
        this.setValues("cmyk", i);
      else
        throw new Error("Unable to parse color from object " + JSON.stringify(o));
  };
  return a.prototype = {
    rgb: function() {
      return this.setSpace("rgb", arguments);
    },
    hsl: function() {
      return this.setSpace("hsl", arguments);
    },
    hsv: function() {
      return this.setSpace("hsv", arguments);
    },
    hwb: function() {
      return this.setSpace("hwb", arguments);
    },
    cmyk: function() {
      return this.setSpace("cmyk", arguments);
    },
    rgbArray: function() {
      return this.values.rgb;
    },
    hslArray: function() {
      return this.values.hsl;
    },
    hsvArray: function() {
      return this.values.hsv;
    },
    hwbArray: function() {
      return this.values.alpha !== 1 ? this.values.hwb.concat([this.values.alpha]) : this.values.hwb;
    },
    cmykArray: function() {
      return this.values.cmyk;
    },
    rgbaArray: function() {
      var o = this.values.rgb;
      return o.concat([this.values.alpha]);
    },
    rgbaArrayNormalized: function() {
      for (var o = this.values.rgb, i = [], l = 0; l < 3; l++)
        i[l] = o[l] / 255;
      return i.push(this.values.alpha), i;
    },
    hslaArray: function() {
      var o = this.values.hsl;
      return o.concat([this.values.alpha]);
    },
    alpha: function(o) {
      return o === void 0 ? this.values.alpha : (this.setValues("alpha", o), this);
    },
    red: function(o) {
      return this.setChannel("rgb", 0, o);
    },
    green: function(o) {
      return this.setChannel("rgb", 1, o);
    },
    blue: function(o) {
      return this.setChannel("rgb", 2, o);
    },
    hue: function(o) {
      return o && (o %= 360, o = o < 0 ? 360 + o : o), this.setChannel("hsl", 0, o);
    },
    saturation: function(o) {
      return this.setChannel("hsl", 1, o);
    },
    lightness: function(o) {
      return this.setChannel("hsl", 2, o);
    },
    saturationv: function(o) {
      return this.setChannel("hsv", 1, o);
    },
    whiteness: function(o) {
      return this.setChannel("hwb", 1, o);
    },
    blackness: function(o) {
      return this.setChannel("hwb", 2, o);
    },
    value: function(o) {
      return this.setChannel("hsv", 2, o);
    },
    cyan: function(o) {
      return this.setChannel("cmyk", 0, o);
    },
    magenta: function(o) {
      return this.setChannel("cmyk", 1, o);
    },
    yellow: function(o) {
      return this.setChannel("cmyk", 2, o);
    },
    black: function(o) {
      return this.setChannel("cmyk", 3, o);
    },
    hexString: function() {
      return t.hexString(this.values.rgb);
    },
    rgbString: function() {
      return t.rgbString(this.values.rgb, this.values.alpha);
    },
    rgbaString: function() {
      return t.rgbaString(this.values.rgb, this.values.alpha);
    },
    percentString: function() {
      return t.percentString(this.values.rgb, this.values.alpha);
    },
    hslString: function() {
      return t.hslString(this.values.hsl, this.values.alpha);
    },
    hslaString: function() {
      return t.hslaString(this.values.hsl, this.values.alpha);
    },
    hwbString: function() {
      return t.hwbString(this.values.hwb, this.values.alpha);
    },
    keyword: function() {
      return t.keyword(this.values.rgb, this.values.alpha);
    },
    rgbNumber: function() {
      return this.values.rgb[0] << 16 | this.values.rgb[1] << 8 | this.values.rgb[2];
    },
    luminosity: function() {
      for (var o = this.values.rgb, i = [], l = 0; l < o.length; l++) {
        var u = o[l] / 255;
        i[l] = u <= 0.03928 ? u / 12.92 : Math.pow((u + 0.055) / 1.055, 2.4);
      }
      return 0.2126 * i[0] + 0.7152 * i[1] + 0.0722 * i[2];
    },
    contrast: function(o) {
      var i = this.luminosity(), l = o.luminosity();
      return i > l ? (i + 0.05) / (l + 0.05) : (l + 0.05) / (i + 0.05);
    },
    level: function(o) {
      var i = this.contrast(o);
      return i >= 7.1 ? "AAA" : i >= 4.5 ? "AA" : "";
    },
    dark: function() {
      var o = this.values.rgb, i = (o[0] * 299 + o[1] * 587 + o[2] * 114) / 1e3;
      return i < 128;
    },
    light: function() {
      return !this.dark();
    },
    negate: function() {
      for (var o = [], i = 0; i < 3; i++)
        o[i] = 255 - this.values.rgb[i];
      return this.setValues("rgb", o), this;
    },
    lighten: function(o) {
      return this.values.hsl[2] += this.values.hsl[2] * o, this.setValues("hsl", this.values.hsl), this;
    },
    darken: function(o) {
      return this.values.hsl[2] -= this.values.hsl[2] * o, this.setValues("hsl", this.values.hsl), this;
    },
    saturate: function(o) {
      return this.values.hsl[1] += this.values.hsl[1] * o, this.setValues("hsl", this.values.hsl), this;
    },
    desaturate: function(o) {
      return this.values.hsl[1] -= this.values.hsl[1] * o, this.setValues("hsl", this.values.hsl), this;
    },
    whiten: function(o) {
      return this.values.hwb[1] += this.values.hwb[1] * o, this.setValues("hwb", this.values.hwb), this;
    },
    blacken: function(o) {
      return this.values.hwb[2] += this.values.hwb[2] * o, this.setValues("hwb", this.values.hwb), this;
    },
    greyscale: function() {
      var o = this.values.rgb, i = o[0] * 0.3 + o[1] * 0.59 + o[2] * 0.11;
      return this.setValues("rgb", [i, i, i]), this;
    },
    clearer: function(o) {
      return this.setValues("alpha", this.values.alpha - this.values.alpha * o), this;
    },
    opaquer: function(o) {
      return this.setValues("alpha", this.values.alpha + this.values.alpha * o), this;
    },
    rotate: function(o) {
      var i = this.values.hsl[0];
      return i = (i + o) % 360, i = i < 0 ? 360 + i : i, this.values.hsl[0] = i, this.setValues("hsl", this.values.hsl), this;
    },
    /**
     * Ported from sass implementation in C
     * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
     */
    mix: function(o, i) {
      var l = this, u = o, s = i === void 0 ? 0.5 : i, c = 2 * s - 1, d = l.alpha() - u.alpha(), h = ((c * d === -1 ? c : (c + d) / (1 + c * d)) + 1) / 2, f = 1 - h;
      return this.rgb(
        h * l.red() + f * u.red(),
        h * l.green() + f * u.green(),
        h * l.blue() + f * u.blue()
      ).alpha(l.alpha() * s + u.alpha() * (1 - s));
    },
    toJSON: function() {
      return this.rgb();
    },
    clone: function() {
      var o = new a();
      return o.values = e(this.values), o;
    }
  }, a.prototype.getValues = function(o) {
    for (var i = {}, l = 0; l < o.length; l++)
      i[o.charAt(l)] = this.values[o][l];
    return this.values.alpha !== 1 && (i.a = this.values.alpha), i;
  }, a.prototype.setValues = function(o, i) {
    var l = {
      rgb: ["red", "green", "blue"],
      hsl: ["hue", "saturation", "lightness"],
      hsv: ["hue", "saturation", "value"],
      hwb: ["hue", "whiteness", "blackness"],
      cmyk: ["cyan", "magenta", "yellow", "black"]
    }, u = {
      rgb: [255, 255, 255],
      hsl: [360, 100, 100],
      hsv: [360, 100, 100],
      hwb: [360, 100, 100],
      cmyk: [100, 100, 100, 100]
    }, s, c = 1;
    if (o === "alpha")
      c = i;
    else if (i.length)
      this.values[o] = i.slice(0, o.length), c = i[o.length];
    else if (i[o.charAt(0)] !== void 0) {
      for (s = 0; s < o.length; s++)
        this.values[o][s] = i[o.charAt(s)];
      c = i.a;
    } else if (i[l[o][0]] !== void 0) {
      var d = l[o];
      for (s = 0; s < o.length; s++)
        this.values[o][s] = i[d[s]];
      c = i.alpha;
    }
    if (this.values.alpha = Math.max(0, Math.min(1, c === void 0 ? this.values.alpha : c)), o === "alpha")
      return !1;
    var h;
    for (s = 0; s < o.length; s++)
      h = Math.max(0, Math.min(u[o][s], this.values[o][s])), this.values[o][s] = Math.round(h);
    for (var f in l)
      for (f !== o && (this.values[f] = n[o][f](this.values[o])), s = 0; s < f.length; s++)
        h = Math.max(0, Math.min(u[f][s], this.values[f][s])), this.values[f][s] = Math.round(h);
    return !0;
  }, a.prototype.setSpace = function(o, i) {
    var l = i[0];
    return l === void 0 ? this.getValues(o) : (typeof l == "number" && (l = Array.prototype.slice.call(i)), this.setValues(o, l), this);
  }, a.prototype.setChannel = function(o, i, l) {
    return l === void 0 ? this.values[o][i] : l === this.values[o][i] ? this : (this.values[o][i] = l, this.setValues(o, this.values[o]), this);
  }, ar = a, ar;
}
var or, Na;
function qs() {
  return Na || (Na = 1, or = [
    "#01888C",
    // teal
    "#FC7500",
    // bright orange
    "#034F5D",
    // dark teal
    "#F73F01",
    // orangered
    "#FC1960",
    // magenta
    "#C7144C",
    // raspberry
    "#F3C100",
    // goldenrod
    "#1598F2",
    // lightning blue
    "#2465E1",
    // sail blue
    "#F19E02"
    // gold
  ]), or;
}
var ir, ja;
function Ys() {
  if (ja) return ir;
  ja = 1;
  var e = Ms(), n = Ds(), t = Hs(), a = qs(), o = 4, i = "http://www.w3.org/2000/svg";
  ir = u;
  var l;
  function u(f, m) {
    l = new e(m);
    var _ = h(a.slice(), l), g = n(f, c(_)), $ = g.container, x = document.createElementNS(i, "svg");
    x.setAttributeNS(null, "x", "0"), x.setAttributeNS(null, "y", "0"), x.setAttributeNS(null, "width", f), x.setAttributeNS(null, "height", f), $.appendChild(x);
    for (var b = 0; b < o - 1; b++)
      s(_, f, b, o - 1, x);
    return $;
  }
  function s(f, m, _, g, $) {
    var x = m / 2, b = document.createElementNS(i, "rect");
    b.setAttributeNS(null, "x", "0"), b.setAttributeNS(null, "y", "0"), b.setAttributeNS(null, "width", m), b.setAttributeNS(null, "height", m);
    var C = l.random(), p = Math.PI * 2 * C, v = m / g * l.random() + _ * m / g, w = Math.cos(p) * v, S = Math.sin(p) * v, D = "translate(" + w + " " + S + ")", Z = l.random(), O = C * 360 + Z * 180, B = "rotate(" + O.toFixed(1) + " " + x + " " + x + ")", M = D + " " + B;
    b.setAttributeNS(null, "transform", M);
    var k = c(f);
    b.setAttributeNS(null, "fill", k), $.appendChild(b);
  }
  function c(f) {
    l.random();
    var m = Math.floor(f.length * l.random()), _ = f.splice(m, 1)[0];
    return _;
  }
  var d = 30;
  function h(f, m) {
    var _ = m.random() * 30 - d / 2;
    return f.map(function(g) {
      var $ = t(g);
      return $.rotate(_), $.hexString();
    });
  }
  return ir;
}
var Ks = Ys();
const Xs = /* @__PURE__ */ Dn(Ks), Zs = "0x0000000000000000000000000000000000000000", Js = ({ diameter: e = 16, account: n = Zs }) => {
  const t = Ee();
  return fe(() => {
    const a = t.current;
    if (a && n) {
      const o = n.slice(2, 10), i = parseInt(o, 16), l = Xs(e, i);
      a.firstChild && a.removeChild(a.firstChild), a.appendChild(l);
    }
  }, [n, t, e]), /* @__PURE__ */ r.jsx("div", { ref: t });
}, Qs = {
  auto: "size-auto",
  full: "size-full",
  s: "size-s",
  m: "size-m",
  l: "size-l",
  xl: "size-xl",
  "2xl": "size-2xl",
  "3xl": "size-3xl",
  "4xl": "size-4xl",
  "5xl": "size-5xl"
};
var sr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var wa;
function el() {
  return wa || (wa = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function t() {
        for (var i = "", l = 0; l < arguments.length; l++) {
          var u = arguments[l];
          u && (i = o(i, a(u)));
        }
        return i;
      }
      function a(i) {
        if (typeof i == "string" || typeof i == "number")
          return i;
        if (typeof i != "object")
          return "";
        if (Array.isArray(i))
          return t.apply(null, i);
        if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
          return i.toString();
        var l = "";
        for (var u in i)
          n.call(i, u) && i[u] && (l = o(l, u));
        return l;
      }
      function o(i, l) {
        return l ? i ? i + " " + l : i + l : i;
      }
      e.exports ? (t.default = t, e.exports = t) : window.classNames = t;
    })();
  }(sr)), sr.exports;
}
var tl = el();
const y = /* @__PURE__ */ Dn(tl), nl = "_tokenIcon_awlka_1", Ia = {
  tokenIcon: nl,
  "size-auto": "_size-auto_awlka_5",
  "size-full": "_size-full_awlka_10",
  "size-xs": "_size-xs_awlka_15",
  "size-s": "_size-s_awlka_20",
  "size-m": "_size-m_awlka_25",
  "size-l": "_size-l_awlka_30",
  "size-xl": "_size-xl_awlka_35",
  "size-2xl": "_size-2xl_awlka_40",
  "size-3xl": "_size-3xl_awlka_45",
  "size-4xl": "_size-4xl_awlka_50",
  "size-5xl": "_size-5xl_awlka_55"
}, Mt = {
  filled: {
    "FIT-USDT": es,
    "FUSDT-GT3": qn,
    "GT3-FIT": vs,
    "GT3-USDT": qn,
    "GT3-WBTC": ua,
    "GT3-ZHT": xs,
    "RNT-FUSDT": oa,
    "RNT-USDT": oa,
    "USDT-GT3": qn,
    "WBTC-GT3": ua,
    "ZHT-USDT": Ns,
    FIT: Qi,
    FITWBTC: ns,
    FUSDT: ca,
    GT3: as,
    RNT: is,
    TINY: ls,
    TURIN: cs,
    TUT_WBTC: sa,
    TUT: Wo,
    TUTWBTC: sa,
    USDC: hs,
    USDT: ca,
    WBTC: fs,
    WETH: _s,
    WPOL: $s,
    XGT3: ps,
    XRNT: bs,
    ZEEM: ys,
    ZHT: Cs
  },
  outlined: {
    "FUSDT-GT3": Yn,
    "GT3-USDT": Yn,
    "GT3-WBTC": ha,
    "RNT-FUSDT": ia,
    "RNT-USDT": ia,
    "USDT-GT3": Yn,
    "WBTC-GT3": ha,
    FIT: ts,
    FITWBTC: rs,
    FUSDT: da,
    GT3: os,
    RNT: ss,
    TUT_WBTC: la,
    TUT: ds,
    TUTWBTC: la,
    USDT: da,
    WBTC: ms,
    XGT3: gs
  },
  unknown: us
}, jt = ({ iconKey: e, size: n = "full", variant: t = "filled" }) => {
  const a = y(Ia[Qs[n]], Ia.tokenIcon);
  let o = Mt.unknown;
  return t === "outlined" && (o = Mt.outlined[e.toUpperCase()] ?? Mt.unknown), t === "filled" && (o = Mt.filled[e.toUpperCase()] ?? Mt.unknown), /* @__PURE__ */ r.jsx("span", { className: a, "data-testid": "token-icon", children: /* @__PURE__ */ r.jsx(o, {}) });
}, rl = "_button_1uujv_3", al = "_disabled_1uujv_39", ol = "_filled_1uujv_57", il = "_outline_1uujv_75", sl = "_colorPrimary_1uujv_93", ll = "_colorAccent_1uujv_107", cl = "_colorInfo_1uujv_121", dl = "_colorError_1uujv_135", ul = "_colorSuccess_1uujv_151", hl = "_colorWarning_1uujv_167", fl = "_colorSurfaceInverse_1uujv_183", ml = "_colorOnSurfaceInverse_1uujv_193", _l = "_text_1uujv_351", $l = "_loading_1uujv_481", pl = "_pendingPulse_1uujv_1", gl = "_textContent_1uujv_491", vl = "_spin_1uujv_1", xl = "_small_1uujv_589", bl = "_medium_1uujv_611", yl = "_large_1uujv_635", Cl = "_fullWidth_1uujv_655", Nl = "_icon_1uujv_665", jl = "_onlyIconButton_1uujv_715", wl = "_onlyIcon_1uujv_715", Il = "_gradientBorder_1uujv_735", Tl = "_gradientBox_1uujv_751", Sl = "_hideTextMobile_1uujv_785", le = {
  button: rl,
  disabled: al,
  filled: ol,
  outline: il,
  colorPrimary: sl,
  colorAccent: ll,
  colorInfo: cl,
  colorError: dl,
  colorSuccess: ul,
  colorWarning: hl,
  colorSurfaceInverse: fl,
  colorOnSurfaceInverse: ml,
  text: _l,
  loading: $l,
  pendingPulse: pl,
  textContent: gl,
  spin: vl,
  small: xl,
  medium: bl,
  large: yl,
  fullWidth: Cl,
  icon: Nl,
  onlyIconButton: jl,
  onlyIcon: wl,
  gradientBorder: Il,
  gradientBox: Tl,
  hideTextMobile: Sl
}, P = {
  PRIMARY: "primary",
  ACCENT: "accent",
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
  SURFACE_INVERSE: "surfaceInverse",
  ON_SURFACE_INVERSE: "onSurfaceInverse"
}, dt = {
  MEDIUM: "medium",
  LARGE: "large",
  SMALL: "small"
}, ne = {
  FILLED: "filled",
  OUTLINE: "outline",
  TEXT: "text"
}, El = {
  [ne.FILLED]: le.filled,
  [ne.OUTLINE]: le.outline,
  [ne.TEXT]: le.text
}, kl = {
  [P.PRIMARY]: le.colorPrimary,
  [P.ACCENT]: le.colorAccent,
  [P.ERROR]: le.colorError,
  [P.SUCCESS]: le.colorSuccess,
  [P.WARNING]: le.colorWarning,
  [P.INFO]: le.colorInfo,
  [P.SURFACE_INVERSE]: le.colorSurfaceInverse,
  [P.ON_SURFACE_INVERSE]: le.colorOnSurfaceInverse
}, E = ({
  color: e = P.PRIMARY,
  size: n = dt.MEDIUM,
  type: t = ne.FILLED,
  iconLeft: a,
  iconRight: o,
  form: i,
  isDisabled: l = !1,
  isFull: u = !1,
  isLoading: s = !1,
  isSubmit: c,
  isGradientBorder: d = !1,
  hideTextOnMobile: h = !1,
  htmlId: f,
  htmlType: m = "button",
  children: _,
  className: g,
  ...$
}) => {
  const x = le[n || dt.MEDIUM], b = y(
    le.button,
    kl[e ?? P.PRIMARY],
    El[t ?? ne.FILLED],
    x,
    {
      [le.onlyIconButton]: !_,
      [le.fullWidth]: u,
      [le.disabled]: l,
      [le.loading]: s,
      [le.gradientBorder]: d,
      [le.hideTextMobile]: h
    },
    g
  ), C = y(le.icon, {
    [le.onlyIcon]: !_
  }), p = /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    a && /* @__PURE__ */ r.jsx("span", { className: C, children: a }),
    _ && /* @__PURE__ */ r.jsx("div", { className: le.textContent, children: _ }),
    o && /* @__PURE__ */ r.jsx("span", { className: C, children: o })
  ] });
  return /* @__PURE__ */ r.jsx(
    "button",
    {
      disabled: l || s,
      type: c ? "submit" : m,
      className: b,
      form: i,
      id: f,
      ...$,
      children: d ? /* @__PURE__ */ r.jsx("span", { className: le.gradientBox, children: p }) : p
    }
  );
}, Pl = "_loader_13bpe_1", Al = "_fullScreen_13bpe_25", Rl = "_iconContainer_13bpe_47", Ol = "_loadingBar_13bpe_61", Fl = "_loadingProgress_13bpe_77", St = {
  loader: Pl,
  fullScreen: Al,
  iconContainer: Rl,
  loadingBar: Ol,
  loadingProgress: Fl
}, Bl = {
  auto: "",
  dark: "dark",
  light: "light"
}, n7 = ({ icon: e, children: n, isFullScreen: t, mode: a = "auto" }) => {
  const o = y(St.loader, Bl[a], {
    [St.fullScreen]: t
  });
  return /* @__PURE__ */ r.jsxs("div", { className: o, children: [
    e && /* @__PURE__ */ r.jsx("div", { className: St.iconContainer, children: e }),
    /* @__PURE__ */ r.jsx("div", { className: St.loadingBar, children: /* @__PURE__ */ r.jsx("div", { className: St.loadingProgress }) }),
    n && /* @__PURE__ */ r.jsx("span", { className: St.text, children: n })
  ] });
}, Ml = "_chip_fmnnm_1", Dl = "_selected_fmnnm_65", Ll = "_iconLeftClass_fmnnm_85", Ul = "_textContent_fmnnm_99", Xt = {
  chip: Ml,
  default: "_default_fmnnm_43",
  selected: Dl,
  iconLeftClass: Ll,
  textContent: Ul
}, Jt = {
  DEFAULT: "default",
  SELECTED: "selected"
}, Vl = {
  [Jt.DEFAULT]: Xt.default,
  [Jt.SELECTED]: Xt.selected
}, Wl = ({ status: e = Jt.DEFAULT, onClick: n, iconLeft: t, children: a }) => {
  const o = Vl[e], i = (l) => {
    n && n(l);
  };
  return /* @__PURE__ */ r.jsxs("div", { className: `${Xt.chip} ${o}`, onClick: i, children: [
    t && /* @__PURE__ */ r.jsx("span", { className: Xt.iconLeftClass, children: t }),
    /* @__PURE__ */ r.jsx("div", { className: Xt.textContent, children: a })
  ] });
}, Gl = "_logo_ybljb_1", zl = "_image_ybljb_23", Ta = {
  logo: Gl,
  image: zl
}, r7 = ({ mobileLogo: e, desktopLogo: n, isWalletConnected: t, alt: a = "Logo" }) => /* @__PURE__ */ r.jsx(r.Fragment, { children: /* @__PURE__ */ r.jsxs("picture", { className: Ta.logo, children: [
  /* @__PURE__ */ r.jsx("source", { media: "(max-width:" + (t ? "384" : "479") + "px", srcSet: e }),
  /* @__PURE__ */ r.jsx("source", { media: "(min-width:" + (t ? "385" : "440") + "px", srcSet: n }),
  /* @__PURE__ */ r.jsx("img", { className: Ta.image, srcSet: n, alt: a })
] }) }), Hl = "_toggle_wztn7_1", ql = "_toggleButton_wztn7_29", Yl = "_toggleButtonActive_wztn7_57", Kl = "_sizeS_wztn7_89", mt = {
  toggle: Hl,
  toggleButton: ql,
  toggleButtonActive: Yl,
  sizeS: Kl
}, Ko = ({
  items: e,
  size: n = "medium",
  selectedItem: t,
  onChange: a
}) => {
  const o = y(mt.toggle, {
    [mt.sizeS]: n === "small",
    [mt.sizeM]: n === "medium"
  });
  return /* @__PURE__ */ r.jsx("div", { className: o, children: e.map((i) => {
    const l = y(mt.toggleButton, {
      [mt.toggleButtonActive]: i.value === t
    });
    return /* @__PURE__ */ r.jsxs(
      "button",
      {
        className: l,
        onClick: () => a(i.value),
        "aria-pressed": i.value === t ? "true" : "false",
        "aria-label": i.label,
        children: [
          i.icon && /* @__PURE__ */ r.jsx("span", { className: mt.toggleIcon, children: i.icon }),
          /* @__PURE__ */ r.jsx("span", { className: mt.toggleLabel, children: i.label })
        ]
      },
      i.label
    );
  }) });
}, a7 = {
  S: "small",
  M: "medium"
}, Xl = "_containerDropdownButton_1u5um_2", Zl = "_containerDropdownButtonIcon_1u5um_11", Jl = "_dropdownButton_1u5um_16", Ql = "_dropdownButtonOpen_1u5um_35", ec = "_hoverTextColor_1u5um_44", tc = "_iconLeftDropdownButton_1u5um_48", nc = "_iconLeftItem_1u5um_54", rc = "_iconRightDropdownButton_1u5um_61", ac = "_textDropdownButton_1u5um_66", oc = "_iconDropdownButtonRotate_1u5um_72", ic = "_containerContentDropdownButton_1u5um_76", sc = "_containerContentTextDropdownButton_1u5um_90", lc = "_contentTextDropdownButton_1u5um_98", Te = {
  containerDropdownButton: Xl,
  containerDropdownButtonIcon: Zl,
  dropdownButton: Jl,
  dropdownButtonOpen: Ql,
  hoverTextColor: ec,
  iconLeftDropdownButton: tc,
  iconLeftItem: nc,
  iconRightDropdownButton: rc,
  textDropdownButton: ac,
  iconDropdownButtonRotate: oc,
  containerContentDropdownButton: ic,
  containerContentTextDropdownButton: sc,
  contentTextDropdownButton: lc
}, o7 = ({ items: e, label: n, iconLeft: t }) => {
  const [a, o] = R(!1), i = Ee(null);
  fe(() => {
    const c = (d) => {
      i.current && !i.current.contains(d.target) && o(!1);
    };
    return document.addEventListener("click", c, !0), () => {
      document.removeEventListener("click", c, !0);
    };
  }, []);
  const l = y(Te.dropdownButton, Te.hoverTextColor, {
    [Te.dropdownButtonOpen]: a
  }), u = y(Te.iconRightDropdownButton, {
    [Te.iconDropdownButtonRotate]: a
  }), s = y(Te.contentTextDropdownButton, Te.hoverTextColor);
  return /* @__PURE__ */ r.jsxs("div", { className: Te.containerDropdownButton, children: [
    /* @__PURE__ */ r.jsxs("div", { className: l, onClick: () => o((c) => !c), ref: i, children: [
      /* @__PURE__ */ r.jsxs("span", { className: Te.containerDropdownButtonIcon, children: [
        t && /* @__PURE__ */ r.jsx("span", { className: Te.iconLeftDropdownButton, children: t }),
        /* @__PURE__ */ r.jsx("span", { className: Te.textDropdownButton, children: n })
      ] }),
      /* @__PURE__ */ r.jsx("span", { className: u, children: /* @__PURE__ */ r.jsx(rn, {}) })
    ] }),
    a && e?.length > 0 && /* @__PURE__ */ r.jsx("div", { className: Te.containerContentDropdownButton, children: /* @__PURE__ */ r.jsx("div", { className: Te.containerContentTextDropdownButton, children: e?.map((c, d) => /* @__PURE__ */ r.jsxs("a", { className: s, href: c.link, target: "_blank", rel: "noreferrer", children: [
      c.icon && /* @__PURE__ */ r.jsx("span", { className: Te.iconLeftItem, children: c.icon }),
      c.text
    ] }, d)) }) })
  ] });
}, cc = "_container_19hx4_1", dc = "_label_19hx4_7", uc = "_inputWrapper_19hx4_13", hc = "_input_19hx4_13", fc = "_iconLeft_19hx4_35", mc = "_countrySelectWrapper_19hx4_35", _c = "_iconRight_19hx4_39", $c = "_iconWrapper_19hx4_66", pc = "_invalidEmail_19hx4_89", gc = "_errorText_19hx4_112", Re = {
  container: cc,
  label: dc,
  inputWrapper: uc,
  input: hc,
  iconLeft: fc,
  countrySelectWrapper: mc,
  iconRight: _c,
  iconWrapper: $c,
  invalidEmail: pc,
  errorText: gc
}, Pn = ({
  children: e,
  className: n,
  position: t
}) => /* @__PURE__ */ r.jsx(
  "div",
  {
    className: y(Re.iconWrapper, n, {
      [Re.iconLeft]: t === "left",
      [Re.iconRight]: t === "right"
    }),
    children: e
  }
), Hr = ({ label: e, errorText: n, children: t, required: a }) => /* @__PURE__ */ r.jsxs("label", { className: Re.container, children: [
  e && /* @__PURE__ */ r.jsxs("p", { className: Re.label, children: [
    e,
    " ",
    a && /* @__PURE__ */ r.jsx("span", { children: "*" })
  ] }),
  /* @__PURE__ */ r.jsx("div", { className: Re.inputWrapper, children: t }),
  n && /* @__PURE__ */ r.jsx("small", { className: Re.errorText, children: n })
] }), Sr = (e) => new RegExp(`^\\d+(\\.\\d{0,${e}})?$`), Sa = new RegExp(
  /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i
), vc = ({ label: e, errorText: n, ...t }) => {
  const [a, o] = R(!1), i = (l) => {
    const u = l.target.value, s = u.length > 0 && Sa.test(u);
    o(s), t.onChange && t.onChange?.(l);
  };
  return /* @__PURE__ */ r.jsxs(Hr, { label: e, errorText: n, required: t.required, children: [
    t.iconLeft && /* @__PURE__ */ r.jsx(Pn, { position: "left", children: t.iconLeft }),
    /* @__PURE__ */ r.jsx("input", { ...t, pattern: Sa.source, onChange: i, className: Re.input }),
    /* @__PURE__ */ r.jsx(Pn, { position: "right", className: y({ [Re.invalidEmail]: !a }), children: /* @__PURE__ */ r.jsx(Ts, {}) })
  ] });
}, xc = { AC: "40123", AD: "312345", AE: "501234567", AF: "701234567", AG: "2684641234", AI: "2642351234", AL: "672123456", AM: "77123456", AO: "923123456", AR: "91123456789", AS: "6847331234", AT: "664123456", AU: "412345678", AW: "5601234", AX: "412345678", AZ: "401234567", BA: "61123456", BB: "2462501234", BD: "1812345678", BE: "470123456", BF: "70123456", BG: "43012345", BH: "36001234", BI: "79561234", BJ: "0195123456", BL: "690001234", BM: "4413701234", BN: "7123456", BO: "71234567", BQ: "3181234", BR: "11961234567", BS: "2423591234", BT: "17123456", BW: "71123456", BY: "294911911", BZ: "6221234", CA: "5062345678", CC: "412345678", CD: "991234567", CF: "70012345", CG: "061234567", CH: "781234567", CI: "0123456789", CK: "71234", CL: "221234567", CM: "671234567", CN: "13123456789", CO: "3211234567", CR: "83123456", CU: "51234567", CV: "9911234", CW: "95181234", CX: "412345678", CY: "96123456", CZ: "601123456", DE: "15123456789", DJ: "77831001", DK: "34412345", DM: "7672251234", DO: "8092345678", DZ: "551234567", EC: "991234567", EE: "51234567", EG: "1001234567", EH: "650123456", ER: "7123456", ES: "612345678", ET: "911234567", FI: "412345678", FJ: "7012345", FK: "51234", FM: "3501234", FO: "211234", FR: "612345678", GA: "06031234", GB: "7400123456", GD: "4734031234", GE: "555123456", GF: "694201234", GG: "7781123456", GH: "231234567", GI: "57123456", GL: "221234", GM: "3012345", GN: "601123456", GP: "690001234", GQ: "222123456", GR: "6912345678", GT: "51234567", GU: "6713001234", GW: "955012345", GY: "6091234", HK: "51234567", HN: "91234567", HR: "921234567", HT: "34101234", HU: "201234567", ID: "812345678", IE: "850123456", IL: "502345678", IM: "7924123456", IN: "8123456789", IO: "3801234", IQ: "7912345678", IR: "9123456789", IS: "6111234", IT: "3123456789", JE: "7797712345", JM: "8762101234", JO: "790123456", JP: "9012345678", KE: "712123456", KG: "700123456", KH: "91234567", KI: "72001234", KM: "3212345", KN: "8697652917", KP: "1921234567", KR: "1020000000", KW: "50012345", KY: "3453231234", KZ: "7710009998", LA: "2023123456", LB: "71123456", LC: "7582845678", LI: "660234567", LK: "712345678", LR: "770123456", LS: "50123456", LT: "61234567", LU: "628123456", LV: "21234567", LY: "912345678", MA: "650123456", MC: "612345678", MD: "62112345", ME: "67622901", MF: "690001234", MG: "321234567", MH: "2351234", MK: "72345678", ML: "65012345", MM: "92123456", MN: "88123456", MO: "66123456", MP: "6702345678", MQ: "696201234", MR: "22123456", MS: "6644923456", MT: "96961234", MU: "52512345", MV: "7712345", MW: "991234567", MX: "2221234567", MY: "123456789", MZ: "821234567", NA: "811234567", NC: "751234", NE: "93123456", NF: "381234", NG: "8021234567", NI: "81234567", NL: "612345678", NO: "40612345", NP: "9841234567", NR: "5551234", NU: "8884012", NZ: "211234567", OM: "92123456", PA: "61234567", PE: "912345678", PF: "87123456", PG: "70123456", PH: "9051234567", PK: "3012345678", PL: "512345678", PM: "551234", PR: "7872345678", PS: "599123456", PT: "912345678", PW: "6201234", PY: "961456789", QA: "33123456", RE: "692123456", RO: "712034567", RS: "601234567", RU: "9123456789", RW: "720123456", SA: "512345678", SB: "7421234", SC: "2510123", SD: "911231234", SE: "701234567", SG: "81234567", SH: "51234", SI: "31234567", SJ: "41234567", SK: "912123456", SL: "25123456", SM: "66661212", SN: "701234567", SO: "71123456", SR: "7412345", SS: "977123456", ST: "9812345", SV: "70123456", SX: "7215205678", SY: "944567890", SZ: "76123456", TA: "8999", TC: "6492311234", TD: "63012345", TG: "90112345", TH: "812345678", TJ: "917123456", TK: "7290", TL: "77212345", TM: "66123456", TN: "20123456", TO: "7715123", TR: "5012345678", TT: "8682911234", TV: "901234", TW: "912345678", TZ: "621234567", UA: "501234567", UG: "712345678", US: "2015550123", UY: "94231234", UZ: "912345678", VA: "3123456789", VC: "7844301234", VE: "4121234567", VG: "2843001234", VI: "3406421234", VN: "912345678", VU: "5912345", WF: "821234", WS: "7212345", XK: "43201234", YE: "712345678", YT: "639012345", ZA: "711234567", ZM: "955123456", ZW: "712345678" }, bc = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], BJ: ["229", "00", "(?:01\\d|[24-689])\\d{7}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["0"]]]], BL: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], BO: ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], CA: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], "0"], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["46"]], ["(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], CU: ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], FK: ["500", "00", "[2-7]\\d{4}", [5]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], GF: ["594", "00", "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], GP: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], HR: ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], ID: ["62", "00[89]", "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24"], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}", [6, 7, 8, 9, 10, 11]], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1"], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[0135-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], LR: ["231", "00", "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0"], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]"], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-5]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], MF: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], MQ: ["596", "00", "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]|8(?:0[6-9]|[36])"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], MX: ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], NG: ["234", "009", "38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}", [8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["3"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], NR: ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], RE: ["262", "00", "709\\d{6}|(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], SB: ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], SC: ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|7[67]|9[2-9]"]]], "0"], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], SV: ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], SY: ["963", "00", "[1-359]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-4]|5[1-3]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[59]"], "0$1", 1]], "0"], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], TD: ["235", "00|16", "(?:22|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], TM: ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[0-468]))\\d{4}|(?:2742|305[3-9]|472[247-9]|505[2-57-9]|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], UZ: ["998", "00", "(?:20|33|[5-9]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]]], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698"], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], WF: ["681", "00", "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[47-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], XK: ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0"], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], YT: ["262", "00", "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], ZM: ["260", "00", "800\\d{6}|(?:21|[579]\\d|63)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[579]"], "0$1"]], "0"], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[235-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"], 0, 0, 0, 0, 0, 0, ["2\\d{8}", [9]]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function on(e, n) {
  var t = Array.prototype.slice.call(n);
  return t.push(bc), e.apply(this, t);
}
function Ea(e, n) {
  e = e.split("-"), n = n.split("-");
  for (var t = e[0].split("."), a = n[0].split("."), o = 0; o < 3; o++) {
    var i = Number(t[o]), l = Number(a[o]);
    if (i > l) return 1;
    if (l > i) return -1;
    if (!isNaN(i) && isNaN(l)) return 1;
    if (isNaN(i) && !isNaN(l)) return -1;
  }
  return e[1] && n[1] ? e[1] > n[1] ? 1 : e[1] < n[1] ? -1 : 0 : !e[1] && n[1] ? 1 : e[1] && !n[1] ? -1 : 0;
}
var yc = {}.constructor;
function Ct(e) {
  return e != null && e.constructor === yc;
}
function Er(e) {
  "@babel/helpers - typeof";
  return Er = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Er(e);
}
function Un(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function Cc(e, n) {
  for (var t = 0; t < n.length; t++) {
    var a = n[t];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
  }
}
function Vn(e, n, t) {
  return n && Cc(e.prototype, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Nc = "1.2.0", jc = "1.7.35", ka = " ext. ", wc = /^\d+$/, ve = /* @__PURE__ */ function() {
  function e(n) {
    Un(this, e), Xo(n), this.metadata = n, Zo.call(this, n);
  }
  return Vn(e, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(t) {
        return t !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(t) {
      return this.metadata.countries[t];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(t) {
      return this.getCountryMetadata(t) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(t) {
      if (this.getCountryCodesForCallingCode(t))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[t])
          return !0;
      } else {
        var a = this.countryCallingCodes()[t];
        if (a && a.length === 1 && a[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(t) {
      return this.nonGeographic() ? !!this.nonGeographic()[t] : !this.getCountryCodesForCallingCode(t);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(t) {
      return this.selectNumberingPlan(t);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(t, a) {
      if (t && wc.test(t) && (a = t, t = null), t && t !== "001") {
        if (!this.hasCountry(t))
          throw new Error("Unknown country: ".concat(t));
        this.numberingPlan = new Pa(this.getCountryMetadata(t), this);
      } else if (a) {
        if (!this.hasCallingCode(a))
          throw new Error("Unknown calling code: ".concat(a));
        this.numberingPlan = new Pa(this.getNumberingPlanMetadata(a), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(t) {
      var a = this.countryCallingCodes()[t];
      if (a)
        return a.length === 1 && a[0].length === 3 ? void 0 : a;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(t) {
      var a = this.getCountryCodesForCallingCode(t);
      if (a)
        return a[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(t) {
      var a = this.getCountryCodeForCallingCode(t);
      if (a)
        return this.getCountryMetadata(a);
      if (this.nonGeographic()) {
        var o = this.nonGeographic()[t];
        if (o)
          return o;
      } else {
        var i = this.countryCallingCodes()[t];
        if (i && i.length === 1 && i[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(t) {
      return this.numberingPlan.type(t);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(t) {
      return this.selectNumberingPlan(t);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), e;
}(), Pa = /* @__PURE__ */ function() {
  function e(n, t) {
    Un(this, e), this.globalMetadataObject = t, this.metadata = n, Zo.call(this, t.metadata);
  }
  return Vn(e, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(t) {
      return t[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var t = this, a = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return a.map(function(o) {
        return new Ic(o, t);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(t) {
      return t[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(t) {
      if (this.hasTypes() && Aa(this.types(), t))
        return new Sc(Aa(this.types(), t), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? ka : this.metadata[13] || ka;
    }
  }]), e;
}(), Ic = /* @__PURE__ */ function() {
  function e(n, t) {
    Un(this, e), this._format = n, this.metadata = t;
  }
  return Vn(e, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !Tc.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), e;
}(), Tc = /^\(?\$1\)?$/, Sc = /* @__PURE__ */ function() {
  function e(n, t) {
    Un(this, e), this.type = n, this.metadata = t;
  }
  return Vn(e, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), e;
}();
function Aa(e, n) {
  switch (n) {
    case "FIXED_LINE":
      return e[0];
    case "MOBILE":
      return e[1];
    case "TOLL_FREE":
      return e[2];
    case "PREMIUM_RATE":
      return e[3];
    case "PERSONAL_NUMBER":
      return e[4];
    case "VOICEMAIL":
      return e[5];
    case "UAN":
      return e[6];
    case "PAGER":
      return e[7];
    case "VOIP":
      return e[8];
    case "SHARED_COST":
      return e[9];
  }
}
function Xo(e) {
  if (!e)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!Ct(e) || !Ct(e.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(Ct(e) ? "an object of shape: { " + Object.keys(e).join(", ") + " }" : "a " + Ec(e) + ": " + e, "."));
}
var Ec = function(n) {
  return Er(n);
};
function Wn(e, n) {
  if (n = new ve(n), n.hasCountry(e))
    return n.country(e).countryCallingCode();
  throw new Error("Unknown country: ".concat(e));
}
function Zo(e) {
  var n = e.version;
  typeof n == "number" ? (this.v1 = n === 1, this.v2 = n === 2, this.v3 = n === 3, this.v4 = n === 4) : n ? Ea(n, Nc) === -1 ? this.v2 = !0 : Ea(n, jc) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
function Gn(e, n) {
  return kc(e, void 0, n);
}
function kc(e, n, t) {
  var a = t.type(n), o = a && a.possibleLengths() || t.possibleLengths();
  if (!o)
    return "IS_POSSIBLE";
  var i = e.length, l = o[0];
  return l === i ? "IS_POSSIBLE" : l > i ? "TOO_SHORT" : o[o.length - 1] < i ? "TOO_LONG" : o.indexOf(i, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function Pc(e, n, t) {
  if (n === void 0 && (n = {}), t = new ve(t), n.v2) {
    if (!e.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    t.selectNumberingPlan(e.countryCallingCode);
  } else {
    if (!e.phone)
      return !1;
    if (e.country) {
      if (!t.hasCountry(e.country))
        throw new Error("Unknown country: ".concat(e.country));
      t.country(e.country);
    } else {
      if (!e.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      t.selectNumberingPlan(e.countryCallingCode);
    }
  }
  if (t.possibleLengths())
    return Jo(e.phone || e.nationalNumber, t);
  if (e.countryCallingCode && t.isNonGeographicCallingCode(e.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function Jo(e, n) {
  switch (Gn(e, n)) {
    case "IS_POSSIBLE":
      return !0;
    // This library ignores "local-only" phone numbers (for simplicity).
    // See the readme for more info on what are "local-only" phone numbers.
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational
    default:
      return !1;
  }
}
function rt(e, n) {
  return e = e || "", new RegExp("^(?:" + n + ")$").test(e);
}
function Ac(e, n) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = Rc(e)) || n) {
    t && (e = t);
    var a = 0;
    return function() {
      return a >= e.length ? { done: !0 } : { done: !1, value: e[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Rc(e, n) {
  if (e) {
    if (typeof e == "string") return Ra(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Ra(e, n);
  }
}
function Ra(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, a = new Array(n); t < n; t++)
    a[t] = e[t];
  return a;
}
var Oc = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function qr(e, n, t) {
  if (n = n || {}, !(!e.country && !e.countryCallingCode)) {
    t = new ve(t), t.selectNumberingPlan(e.country, e.countryCallingCode);
    var a = n.v2 ? e.nationalNumber : e.phone;
    if (rt(a, t.nationalNumberPattern())) {
      if (lr(a, "FIXED_LINE", t))
        return t.type("MOBILE") && t.type("MOBILE").pattern() === "" || !t.type("MOBILE") || lr(a, "MOBILE", t) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var o = Ac(Oc), i; !(i = o()).done; ) {
        var l = i.value;
        if (lr(a, l, t))
          return l;
      }
    }
  }
}
function lr(e, n, t) {
  return n = t.type(n), !n || !n.pattern() || n.possibleLengths() && n.possibleLengths().indexOf(e.length) < 0 ? !1 : rt(e, n.pattern());
}
function Fc(e, n, t) {
  if (n = n || {}, t = new ve(t), t.selectNumberingPlan(e.country, e.countryCallingCode), t.hasTypes())
    return qr(e, n, t.metadata) !== void 0;
  var a = n.v2 ? e.nationalNumber : e.phone;
  return rt(a, t.nationalNumberPattern());
}
function Bc(e, n, t) {
  var a = new ve(t), o = a.getCountryCodesForCallingCode(e);
  return o ? o.filter(function(i) {
    return Mc(n, i, t);
  }) : [];
}
function Mc(e, n, t) {
  var a = new ve(t);
  return a.selectNumberingPlan(n), a.numberingPlan.possibleLengths().indexOf(e.length) >= 0;
}
var Yr = 2, Dc = 17, Lc = 3, we = "0-9０-９٠-٩۰-۹", Uc = "-‐-―−ー－", Vc = "／/", Wc = "．.", Gc = "  ­​⁠　", zc = "()（）［］\\[\\]", Hc = "~⁓∼～", qe = "".concat(Uc).concat(Vc).concat(Wc).concat(Gc).concat(zc).concat(Hc), zn = "+＋", qc = new RegExp("([" + we + "])");
function Qo(e, n, t, a) {
  if (n) {
    var o = new ve(a);
    o.selectNumberingPlan(n, t);
    var i = new RegExp(o.IDDPrefix());
    if (e.search(i) === 0) {
      e = e.slice(e.match(i)[0].length);
      var l = e.match(qc);
      if (!(l && l[1] != null && l[1].length > 0 && l[1] === "0"))
        return e;
    }
  }
}
function kr(e, n) {
  if (e && n.numberingPlan.nationalPrefixForParsing()) {
    var t = new RegExp("^(?:" + n.numberingPlan.nationalPrefixForParsing() + ")"), a = t.exec(e);
    if (a) {
      var o, i, l = a.length - 1, u = l > 0 && a[l];
      if (n.nationalPrefixTransformRule() && u)
        o = e.replace(t, n.nationalPrefixTransformRule()), l > 1 && (i = a[1]);
      else {
        var s = a[0];
        o = e.slice(s.length), u && (i = a[1]);
      }
      var c;
      if (u) {
        var d = e.indexOf(a[1]), h = e.slice(0, d);
        h === n.numberingPlan.nationalPrefix() && (c = n.numberingPlan.nationalPrefix());
      } else
        c = a[0];
      return {
        nationalNumber: o,
        nationalPrefix: c,
        carrierCode: i
      };
    }
  }
  return {
    nationalNumber: e
  };
}
function Pr(e, n) {
  var t = kr(e, n), a = t.carrierCode, o = t.nationalNumber;
  if (o !== e) {
    if (!Yc(e, o, n))
      return {
        nationalNumber: e
      };
    if (n.possibleLengths() && !Kc(o, n))
      return {
        nationalNumber: e
      };
  }
  return {
    nationalNumber: o,
    carrierCode: a
  };
}
function Yc(e, n, t) {
  return !(rt(e, t.nationalNumberPattern()) && !rt(n, t.nationalNumberPattern()));
}
function Kc(e, n) {
  switch (Gn(e, n)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function ei(e, n, t, a) {
  var o = n ? Wn(n, a) : t;
  if (e.indexOf(o) === 0) {
    a = new ve(a), a.selectNumberingPlan(n, t);
    var i = e.slice(o.length), l = Pr(i, a), u = l.nationalNumber, s = Pr(e, a), c = s.nationalNumber;
    if (!rt(c, a.nationalNumberPattern()) && rt(u, a.nationalNumberPattern()) || Gn(c, a) === "TOO_LONG")
      return {
        countryCallingCode: o,
        number: i
      };
  }
  return {
    number: e
  };
}
function Kr(e, n, t, a) {
  if (!e)
    return {};
  var o;
  if (e[0] !== "+") {
    var i = Qo(e, n, t, a);
    if (i && i !== e)
      o = !0, e = "+" + i;
    else {
      if (n || t) {
        var l = ei(e, n, t, a), u = l.countryCallingCode, s = l.number;
        if (u)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: u,
            number: s
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: e
      };
    }
  }
  if (e[1] === "0")
    return {};
  a = new ve(a);
  for (var c = 2; c - 1 <= Lc && c <= e.length; ) {
    var d = e.slice(1, c);
    if (a.hasCallingCode(d))
      return a.selectNumberingPlan(d), {
        countryCallingCodeSource: o ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: d,
        number: e.slice(c)
      };
    c++;
  }
  return {};
}
function ti(e) {
  return e.replace(new RegExp("[".concat(qe, "]+"), "g"), " ").trim();
}
var ni = /(\$\d)/;
function ri(e, n, t) {
  var a = t.useInternationalFormat, o = t.withNationalPrefix;
  t.carrierCode, t.metadata;
  var i = e.replace(new RegExp(n.pattern()), a ? n.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    o && n.nationalPrefixFormattingRule() ? n.format().replace(ni, n.nationalPrefixFormattingRule()) : n.format()
  ));
  return a ? ti(i) : i;
}
var Xc = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function Zc(e, n, t) {
  var a = new ve(t);
  if (a.selectNumberingPlan(e, n), a.defaultIDDPrefix())
    return a.defaultIDDPrefix();
  if (Xc.test(a.IDDPrefix()))
    return a.IDDPrefix();
}
var Jc = ";ext=", Et = function(n) {
  return "([".concat(we, "]{1,").concat(n, "})");
};
function ai(e) {
  var n = "20", t = "15", a = "9", o = "6", i = "[  \\t,]*", l = "[:\\.．]?[  \\t,-]*", u = "#?", s = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", c = "(?:[xｘ#＃~～]|int|ｉｎｔ)", d = "[- ]+", h = "[  \\t]*", f = "(?:,{2}|;)", m = Jc + Et(n), _ = i + s + l + Et(n) + u, g = i + c + l + Et(a) + u, $ = d + Et(o) + "#", x = h + f + l + Et(t) + u, b = h + "(?:,)+" + l + Et(a) + u;
  return m + "|" + _ + "|" + g + "|" + $ + "|" + x + "|" + b;
}
var Qc = "[" + we + "]{" + Yr + "}", ed = "[" + zn + "]{0,1}(?:[" + qe + "]*[" + we + "]){3,}[" + qe + we + "]*", td = new RegExp("^[" + zn + "]{0,1}(?:[" + qe + "]*[" + we + "]){1,2}$", "i"), nd = ed + // Phone number extensions
"(?:" + ai() + ")?", rd = new RegExp(
  // Either a short two-digit-only phone number
  "^" + Qc + "$|^" + nd + "$",
  "i"
);
function ad(e) {
  return e.length >= Yr && rd.test(e);
}
function od(e) {
  return td.test(e);
}
function id(e) {
  var n = e.number, t = e.ext;
  if (!n)
    return "";
  if (n[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(n).concat(t ? ";ext=" + t : "");
}
function sd(e, n) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = ld(e)) || n) {
    t && (e = t);
    var a = 0;
    return function() {
      return a >= e.length ? { done: !0 } : { done: !1, value: e[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ld(e, n) {
  if (e) {
    if (typeof e == "string") return Oa(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Oa(e, n);
  }
}
function Oa(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, a = new Array(n); t < n; t++)
    a[t] = e[t];
  return a;
}
function Fa(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    n && (a = a.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, a);
  }
  return t;
}
function Ba(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? arguments[n] : {};
    n % 2 ? Fa(Object(t), !0).forEach(function(a) {
      cd(e, a, t[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Fa(Object(t)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(t, a));
    });
  }
  return e;
}
function cd(e, n, t) {
  return n in e ? Object.defineProperty(e, n, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = t, e;
}
var Ma = {
  formatExtension: function(n, t, a) {
    return "".concat(n).concat(a.ext()).concat(t);
  }
};
function dd(e, n, t, a) {
  if (t ? t = Ba(Ba({}, Ma), t) : t = Ma, a = new ve(a), e.country && e.country !== "001") {
    if (!a.hasCountry(e.country))
      throw new Error("Unknown country: ".concat(e.country));
    a.country(e.country);
  } else if (e.countryCallingCode)
    a.selectNumberingPlan(e.countryCallingCode);
  else return e.phone || "";
  var o = a.countryCallingCode(), i = t.v2 ? e.nationalNumber : e.phone, l;
  switch (n) {
    case "NATIONAL":
      return i ? (l = An(i, e.carrierCode, "NATIONAL", a, t), cr(l, e.ext, a, t.formatExtension)) : "";
    case "INTERNATIONAL":
      return i ? (l = An(i, null, "INTERNATIONAL", a, t), l = "+".concat(o, " ").concat(l), cr(l, e.ext, a, t.formatExtension)) : "+".concat(o);
    case "E.164":
      return "+".concat(o).concat(i);
    case "RFC3966":
      return id({
        number: "+".concat(o).concat(i),
        ext: e.ext
      });
    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?
    case "IDD":
      if (!t.fromCountry)
        return;
      var u = hd(i, e.carrierCode, o, t.fromCountry, a);
      return cr(u, e.ext, a, t.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(n, '"'));
  }
}
function An(e, n, t, a, o) {
  var i = ud(a.formats(), e);
  return i ? ri(e, i, {
    useInternationalFormat: t === "INTERNATIONAL",
    withNationalPrefix: !(i.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && o && o.nationalPrefix === !1),
    carrierCode: n,
    metadata: a
  }) : e;
}
function ud(e, n) {
  for (var t = sd(e), a; !(a = t()).done; ) {
    var o = a.value;
    if (o.leadingDigitsPatterns().length > 0) {
      var i = o.leadingDigitsPatterns()[o.leadingDigitsPatterns().length - 1];
      if (n.search(i) !== 0)
        continue;
    }
    if (rt(n, o.pattern()))
      return o;
  }
}
function cr(e, n, t, a) {
  return n ? a(e, n, t) : e;
}
function hd(e, n, t, a, o) {
  var i = Wn(a, o.metadata);
  if (i === t) {
    var l = An(e, n, "NATIONAL", o);
    return t === "1" ? t + " " + l : l;
  }
  var u = Zc(a, void 0, o.metadata);
  if (u)
    return "".concat(u, " ").concat(t, " ").concat(An(e, null, "INTERNATIONAL", o));
}
function Da(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    n && (a = a.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, a);
  }
  return t;
}
function La(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? arguments[n] : {};
    n % 2 ? Da(Object(t), !0).forEach(function(a) {
      fd(e, a, t[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Da(Object(t)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(t, a));
    });
  }
  return e;
}
function fd(e, n, t) {
  return n in e ? Object.defineProperty(e, n, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = t, e;
}
function md(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function _d(e, n) {
  for (var t = 0; t < n.length; t++) {
    var a = n[t];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
  }
}
function $d(e, n, t) {
  return n && _d(e.prototype, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Xr = /* @__PURE__ */ function() {
  function e(n, t, a) {
    if (md(this, e), !n)
      throw new TypeError("First argument is required");
    if (typeof n != "string")
      throw new TypeError("First argument must be a string");
    if (typeof n == "string") {
      if (n[0] === "+" && !t)
        throw new TypeError("`metadata` argument not passed");
      if (Ct(t) && Ct(t.countries)) {
        a = t;
        var o = n;
        if (!vd.test(o))
          throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
        var i = Kr(o, void 0, void 0, a), l = i.countryCallingCode, u = i.number;
        if (t = u, n = l, !t)
          throw new Error("Invalid `number` argument passed: too short");
      }
    }
    if (!t)
      throw new TypeError("`nationalNumber` argument is required");
    if (typeof t != "string")
      throw new TypeError("`nationalNumber` argument must be a string");
    Xo(a);
    var s = gd(n, a), c = s.country, d = s.countryCallingCode;
    this.country = c, this.countryCallingCode = d, this.nationalNumber = t, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return a;
    };
  }
  return $d(e, [{
    key: "setExt",
    value: function(t) {
      this.ext = t;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : Bc(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return Pc(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return Fc(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var t = new ve(this.getMetadata());
      return t.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(t) {
      return this.number === t.number && this.ext === t.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return qr(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(t, a) {
      return dd(this, t, a ? La(La({}, a), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(t) {
      return this.format("NATIONAL", t);
    }
  }, {
    key: "formatInternational",
    value: function(t) {
      return this.format("INTERNATIONAL", t);
    }
  }, {
    key: "getURI",
    value: function(t) {
      return this.format("RFC3966", t);
    }
  }]), e;
}(), pd = function(n) {
  return /^[A-Z]{2}$/.test(n);
};
function gd(e, n) {
  var t, a, o = new ve(n);
  return pd(e) ? (t = e, o.selectNumberingPlan(t), a = o.countryCallingCode()) : a = e, {
    country: t,
    countryCallingCode: a
  };
}
var vd = /^\+\d+$/;
function Ar(e) {
  "@babel/helpers - typeof";
  return Ar = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Ar(e);
}
function xd(e, n, t) {
  return Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function bd(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function yd(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), n && Qt(e, n);
}
function Cd(e) {
  var n = ii();
  return function() {
    var a = en(e), o;
    if (n) {
      var i = en(this).constructor;
      o = Reflect.construct(a, arguments, i);
    } else
      o = a.apply(this, arguments);
    return Nd(this, o);
  };
}
function Nd(e, n) {
  if (n && (Ar(n) === "object" || typeof n == "function"))
    return n;
  if (n !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return oi(e);
}
function oi(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Rr(e) {
  var n = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Rr = function(a) {
    if (a === null || !jd(a)) return a;
    if (typeof a != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof n < "u") {
      if (n.has(a)) return n.get(a);
      n.set(a, o);
    }
    function o() {
      return Sn(a, arguments, en(this).constructor);
    }
    return o.prototype = Object.create(a.prototype, { constructor: { value: o, enumerable: !1, writable: !0, configurable: !0 } }), Qt(o, a);
  }, Rr(e);
}
function Sn(e, n, t) {
  return ii() ? Sn = Reflect.construct : Sn = function(o, i, l) {
    var u = [null];
    u.push.apply(u, i);
    var s = Function.bind.apply(o, u), c = new s();
    return l && Qt(c, l.prototype), c;
  }, Sn.apply(null, arguments);
}
function ii() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function jd(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function Qt(e, n) {
  return Qt = Object.setPrototypeOf || function(a, o) {
    return a.__proto__ = o, a;
  }, Qt(e, n);
}
function en(e) {
  return en = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, en(e);
}
var ct = /* @__PURE__ */ function(e) {
  yd(t, e);
  var n = Cd(t);
  function t(a) {
    var o;
    return bd(this, t), o = n.call(this, a), Object.setPrototypeOf(oi(o), t.prototype), o.name = o.constructor.name, o;
  }
  return xd(t);
}(/* @__PURE__ */ Rr(Error)), Ua = new RegExp("(?:" + ai() + ")$", "i");
function wd(e) {
  var n = e.search(Ua);
  if (n < 0)
    return {};
  for (var t = e.slice(0, n), a = e.match(Ua), o = 1; o < a.length; ) {
    if (a[o])
      return {
        number: t,
        ext: a[o]
      };
    o++;
  }
}
function Id(e, n) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = Td(e)) || n) {
    t && (e = t);
    var a = 0;
    return function() {
      return a >= e.length ? { done: !0 } : { done: !1, value: e[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Td(e, n) {
  if (e) {
    if (typeof e == "string") return Va(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Va(e, n);
  }
}
function Va(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, a = new Array(n); t < n; t++)
    a[t] = e[t];
  return a;
}
var Sd = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function si(e) {
  return Sd[e];
}
function Rn(e) {
  for (var n = "", t = Id(e.split("")), a; !(a = t()).done; ) {
    var o = a.value, i = si(o);
    i && (n += i);
  }
  return n;
}
function Ed(e, n) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = kd(e)) || n) {
    t && (e = t);
    var a = 0;
    return function() {
      return a >= e.length ? { done: !0 } : { done: !1, value: e[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function kd(e, n) {
  if (e) {
    if (typeof e == "string") return Wa(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Wa(e, n);
  }
}
function Wa(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, a = new Array(n); t < n; t++)
    a[t] = e[t];
  return a;
}
function Ga(e) {
  for (var n = "", t = Ed(e.split("")), a; !(a = t()).done; ) {
    var o = a.value;
    n += Pd(o, n) || "";
  }
  return n;
}
function Pd(e, n, t) {
  return e === "+" ? n ? void 0 : "+" : si(e);
}
function Ad(e, n) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = Rd(e)) || n) {
    t && (e = t);
    var a = 0;
    return function() {
      return a >= e.length ? { done: !0 } : { done: !1, value: e[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Rd(e, n) {
  if (e) {
    if (typeof e == "string") return za(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return za(e, n);
  }
}
function za(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, a = new Array(n); t < n; t++)
    a[t] = e[t];
  return a;
}
function li(e, n) {
  var t = n.countries;
  n.defaultCountry;
  var a = n.metadata;
  a = new ve(a);
  for (var o = Ad(t), i; !(i = o()).done; ) {
    var l = i.value;
    if (a.country(l), a.leadingDigits()) {
      if (e && e.search(a.leadingDigits()) === 0)
        return l;
    } else if (qr({
      phone: e,
      country: l
    }, void 0, a.metadata))
      return l;
  }
}
function ci(e, n) {
  var t = n.nationalNumber, a = n.defaultCountry, o = n.metadata, i = o.getCountryCodesForCallingCode(e);
  if (i)
    return i.length === 1 ? i[0] : li(t, {
      countries: i,
      defaultCountry: a,
      metadata: o.metadata
    });
}
var di = "+", Od = "[\\-\\.\\(\\)]?", Ha = "([" + we + "]|" + Od + ")", Fd = "^\\" + di + Ha + "*[" + we + "]" + Ha + "*$", Bd = new RegExp(Fd, "g"), Or = we, Md = "[" + Or + "]+((\\-)*[" + Or + "])*", Dd = "a-zA-Z", Ld = "[" + Dd + "]+((\\-)*[" + Or + "])*", Ud = "^(" + Md + "\\.)*" + Ld + "\\.?$", Vd = new RegExp(Ud, "g"), qa = "tel:", Fr = ";phone-context=", Wd = ";isub=";
function Gd(e) {
  var n = e.indexOf(Fr);
  if (n < 0)
    return null;
  var t = n + Fr.length;
  if (t >= e.length)
    return "";
  var a = e.indexOf(";", t);
  return a >= 0 ? e.substring(t, a) : e.substring(t);
}
function zd(e) {
  return e === null ? !0 : e.length === 0 ? !1 : Bd.test(e) || Vd.test(e);
}
function Hd(e, n) {
  var t = n.extractFormattedPhoneNumber, a = Gd(e);
  if (!zd(a))
    throw new ct("NOT_A_NUMBER");
  var o;
  if (a === null)
    o = t(e) || "";
  else {
    o = "", a.charAt(0) === di && (o += a);
    var i = e.indexOf(qa), l;
    i >= 0 ? l = i + qa.length : l = 0;
    var u = e.indexOf(Fr);
    o += e.substring(l, u);
  }
  var s = o.indexOf(Wd);
  if (s > 0 && (o = o.substring(0, s)), o !== "")
    return o;
}
var qd = 250, Yd = new RegExp("[" + zn + we + "]"), Kd = new RegExp("[^" + we + "#]+$");
function Xd(e, n, t) {
  if (n = n || {}, t = new ve(t), n.defaultCountry && !t.hasCountry(n.defaultCountry))
    throw n.v2 ? new ct("INVALID_COUNTRY") : new Error("Unknown country: ".concat(n.defaultCountry));
  var a = Jd(e, n.v2, n.extract), o = a.number, i = a.ext, l = a.error;
  if (!o) {
    if (n.v2)
      throw l === "TOO_SHORT" ? new ct("TOO_SHORT") : new ct("NOT_A_NUMBER");
    return {};
  }
  var u = e1(o, n.defaultCountry, n.defaultCallingCode, t), s = u.country, c = u.nationalNumber, d = u.countryCallingCode, h = u.countryCallingCodeSource, f = u.carrierCode;
  if (!t.hasSelectedNumberingPlan()) {
    if (n.v2)
      throw new ct("INVALID_COUNTRY");
    return {};
  }
  if (!c || c.length < Yr) {
    if (n.v2)
      throw new ct("TOO_SHORT");
    return {};
  }
  if (c.length > Dc) {
    if (n.v2)
      throw new ct("TOO_LONG");
    return {};
  }
  if (n.v2) {
    var m = new Xr(d, c, t.metadata);
    return s && (m.country = s), f && (m.carrierCode = f), i && (m.ext = i), m.__countryCallingCodeSource = h, m;
  }
  var _ = (n.extended ? t.hasSelectedNumberingPlan() : s) ? rt(c, t.nationalNumberPattern()) : !1;
  return n.extended ? {
    country: s,
    countryCallingCode: d,
    carrierCode: f,
    valid: _,
    possible: _ ? !0 : !!(n.extended === !0 && t.possibleLengths() && Jo(c, t)),
    phone: c,
    ext: i
  } : _ ? Qd(s, c, i) : {};
}
function Zd(e, n, t) {
  if (e) {
    if (e.length > qd) {
      if (t)
        throw new ct("TOO_LONG");
      return;
    }
    if (n === !1)
      return e;
    var a = e.search(Yd);
    if (!(a < 0))
      return e.slice(a).replace(Kd, "");
  }
}
function Jd(e, n, t) {
  var a = Hd(e, {
    extractFormattedPhoneNumber: function(l) {
      return Zd(l, t, n);
    }
  });
  if (!a)
    return {};
  if (!ad(a))
    return od(a) ? {
      error: "TOO_SHORT"
    } : {};
  var o = wd(a);
  return o.ext ? o : {
    number: a
  };
}
function Qd(e, n, t) {
  var a = {
    country: e,
    phone: n
  };
  return t && (a.ext = t), a;
}
function e1(e, n, t, a) {
  var o = Kr(Ga(e), n, t, a.metadata), i = o.countryCallingCodeSource, l = o.countryCallingCode, u = o.number, s;
  if (l)
    a.selectNumberingPlan(l);
  else if (u && (n || t))
    a.selectNumberingPlan(n, t), n && (s = n), l = t || Wn(n, a.metadata);
  else return {};
  if (!u)
    return {
      countryCallingCodeSource: i,
      countryCallingCode: l
    };
  var c = Pr(Ga(u), a), d = c.nationalNumber, h = c.carrierCode, f = ci(l, {
    nationalNumber: d,
    defaultCountry: n,
    metadata: a
  });
  return f && (s = f, f === "001" || a.country(s)), {
    country: s,
    countryCallingCode: l,
    countryCallingCodeSource: i,
    nationalNumber: d,
    carrierCode: h
  };
}
function Ya(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    n && (a = a.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, a);
  }
  return t;
}
function Ka(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? arguments[n] : {};
    n % 2 ? Ya(Object(t), !0).forEach(function(a) {
      t1(e, a, t[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Ya(Object(t)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(t, a));
    });
  }
  return e;
}
function t1(e, n, t) {
  return n in e ? Object.defineProperty(e, n, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = t, e;
}
function n1(e, n, t) {
  return Xd(e, Ka(Ka({}, n), {}, {
    v2: !0
  }), t);
}
function Xa(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    n && (a = a.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, a);
  }
  return t;
}
function r1(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? arguments[n] : {};
    n % 2 ? Xa(Object(t), !0).forEach(function(a) {
      a1(e, a, t[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Xa(Object(t)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(t, a));
    });
  }
  return e;
}
function a1(e, n, t) {
  return n in e ? Object.defineProperty(e, n, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = t, e;
}
function o1(e, n) {
  return c1(e) || l1(e, n) || s1(e, n) || i1();
}
function i1() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function s1(e, n) {
  if (e) {
    if (typeof e == "string") return Za(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Za(e, n);
  }
}
function Za(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, a = new Array(n); t < n; t++)
    a[t] = e[t];
  return a;
}
function l1(e, n) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var a = [], o = !0, i = !1, l, u;
    try {
      for (t = t.call(e); !(o = (l = t.next()).done) && (a.push(l.value), !(n && a.length === n)); o = !0)
        ;
    } catch (s) {
      i = !0, u = s;
    } finally {
      try {
        !o && t.return != null && t.return();
      } finally {
        if (i) throw u;
      }
    }
    return a;
  }
}
function c1(e) {
  if (Array.isArray(e)) return e;
}
function d1(e) {
  var n = Array.prototype.slice.call(e), t = o1(n, 4), a = t[0], o = t[1], i = t[2], l = t[3], u, s, c;
  if (typeof a == "string")
    u = a;
  else throw new TypeError("A text for parsing must be a string.");
  if (!o || typeof o == "string")
    l ? (s = i, c = l) : (s = void 0, c = i), o && (s = r1({
      defaultCountry: o
    }, s));
  else if (Ct(o))
    i ? (s = o, c = i) : c = o;
  else throw new Error("Invalid second argument: ".concat(o));
  return {
    text: u,
    options: s,
    metadata: c
  };
}
function u1() {
  var e = d1(arguments), n = e.text, t = e.options, a = e.metadata;
  return n1(n, t, a);
}
function h1(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function f1(e, n) {
  for (var t = 0; t < n.length; t++) {
    var a = n[t];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
  }
}
function m1(e, n, t) {
  return n && f1(e.prototype, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var _1 = /* @__PURE__ */ function() {
  function e(n) {
    var t = n.onCountryChange, a = n.onCallingCodeChange;
    h1(this, e), this.onCountryChange = t, this.onCallingCodeChange = a;
  }
  return m1(e, [{
    key: "reset",
    value: function(t) {
      var a = t.country, o = t.callingCode;
      this.international = !1, this.missingPlus = !1, this.IDDPrefix = void 0, this.callingCode = void 0, this.digits = "", this.resetNationalSignificantNumber(), this.initCountryAndCallingCode(a, o);
    }
  }, {
    key: "resetNationalSignificantNumber",
    value: function() {
      this.nationalSignificantNumber = this.getNationalDigits(), this.nationalSignificantNumberMatchesInput = !0, this.nationalPrefix = void 0, this.carrierCode = void 0, this.complexPrefixBeforeNationalSignificantNumber = void 0;
    }
  }, {
    key: "update",
    value: function(t) {
      for (var a = 0, o = Object.keys(t); a < o.length; a++) {
        var i = o[a];
        this[i] = t[i];
      }
    }
  }, {
    key: "initCountryAndCallingCode",
    value: function(t, a) {
      this.setCountry(t), this.setCallingCode(a);
    }
  }, {
    key: "setCountry",
    value: function(t) {
      this.country = t, this.onCountryChange(t);
    }
  }, {
    key: "setCallingCode",
    value: function(t) {
      this.callingCode = t, this.onCallingCodeChange(t, this.country);
    }
  }, {
    key: "startInternationalNumber",
    value: function(t, a) {
      this.international = !0, this.initCountryAndCallingCode(t, a);
    }
  }, {
    key: "appendDigits",
    value: function(t) {
      this.digits += t;
    }
  }, {
    key: "appendNationalSignificantNumberDigits",
    value: function(t) {
      this.nationalSignificantNumber += t;
    }
    /**
     * Returns the part of `this.digits` that corresponds to the national number.
     * Basically, all digits that have been input by the user, except for the
     * international prefix and the country calling code part
     * (if the number is an international one).
     * @return {string}
     */
  }, {
    key: "getNationalDigits",
    value: function() {
      return this.international ? this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0)) : this.digits;
    }
  }, {
    key: "getDigitsWithoutInternationalPrefix",
    value: function() {
      return this.international && this.IDDPrefix ? this.digits.slice(this.IDDPrefix.length) : this.digits;
    }
  }]), e;
}();
function $1(e, n) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = p1(e)) || n) {
    t && (e = t);
    var a = 0;
    return function() {
      return a >= e.length ? { done: !0 } : { done: !1, value: e[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function p1(e, n) {
  if (e) {
    if (typeof e == "string") return Ja(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Ja(e, n);
  }
}
function Ja(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, a = new Array(n); t < n; t++)
    a[t] = e[t];
  return a;
}
var Ge = "x", dr = new RegExp(Ge);
function En(e, n) {
  if (n < 1)
    return "";
  for (var t = ""; n > 1; )
    n & 1 && (t += e), n >>= 1, e += e;
  return t + e;
}
function Qa(e, n) {
  return e[n] === ")" && n++, g1(e.slice(0, n));
}
function g1(e) {
  for (var n = [], t = 0; t < e.length; )
    e[t] === "(" ? n.push(t) : e[t] === ")" && n.pop(), t++;
  var a = 0, o = "";
  n.push(e.length);
  for (var i = 0, l = n; i < l.length; i++) {
    var u = l[i];
    o += e.slice(a, u), a = u + 1;
  }
  return o;
}
function v1(e, n, t) {
  for (var a = $1(t.split("")), o; !(o = a()).done; ) {
    var i = o.value;
    if (e.slice(n + 1).search(dr) < 0)
      return;
    n = e.search(dr), e = e.replace(dr, i);
  }
  return [e, n];
}
function x1(e, n, t) {
  var a = t.metadata, o = t.shouldTryNationalPrefixFormattingRule, i = t.getSeparatorAfterNationalPrefix, l = new RegExp("^(?:".concat(n.pattern(), ")$"));
  if (l.test(e.nationalSignificantNumber))
    return y1(e, n, {
      metadata: a,
      shouldTryNationalPrefixFormattingRule: o,
      getSeparatorAfterNationalPrefix: i
    });
}
function b1(e, n) {
  return Gn(e, n) === "IS_POSSIBLE";
}
function y1(e, n, t) {
  var a = t.metadata, o = t.shouldTryNationalPrefixFormattingRule, i = t.getSeparatorAfterNationalPrefix;
  if (e.nationalSignificantNumber, e.international, e.nationalPrefix, e.carrierCode, o(n)) {
    var l = eo(e, n, {
      useNationalPrefixFormattingRule: !0,
      getSeparatorAfterNationalPrefix: i,
      metadata: a
    });
    if (l)
      return l;
  }
  return eo(e, n, {
    useNationalPrefixFormattingRule: !1,
    getSeparatorAfterNationalPrefix: i,
    metadata: a
  });
}
function eo(e, n, t) {
  var a = t.metadata, o = t.useNationalPrefixFormattingRule, i = t.getSeparatorAfterNationalPrefix, l = ri(e.nationalSignificantNumber, n, {
    carrierCode: e.carrierCode,
    useInternationalFormat: e.international,
    withNationalPrefix: o,
    metadata: a
  });
  if (o || (e.nationalPrefix ? l = e.nationalPrefix + i(n) + l : e.complexPrefixBeforeNationalSignificantNumber && (l = e.complexPrefixBeforeNationalSignificantNumber + " " + l)), C1(l, e))
    return l;
}
function C1(e, n) {
  return Rn(e) === n.getNationalDigits();
}
function N1(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function j1(e, n) {
  for (var t = 0; t < n.length; t++) {
    var a = n[t];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
  }
}
function w1(e, n, t) {
  return n && j1(e.prototype, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var I1 = /* @__PURE__ */ function() {
  function e() {
    N1(this, e);
  }
  return w1(e, [{
    key: "parse",
    value: function(t) {
      if (this.context = [{
        or: !0,
        instructions: []
      }], this.parsePattern(t), this.context.length !== 1)
        throw new Error("Non-finalized contexts left when pattern parse ended");
      var a = this.context[0], o = a.branches, i = a.instructions;
      if (o)
        return {
          op: "|",
          args: o.concat([ur(i)])
        };
      if (i.length === 0)
        throw new Error("Pattern is required");
      return i.length === 1 ? i[0] : i;
    }
  }, {
    key: "startContext",
    value: function(t) {
      this.context.push(t);
    }
  }, {
    key: "endContext",
    value: function() {
      this.context.pop();
    }
  }, {
    key: "getContext",
    value: function() {
      return this.context[this.context.length - 1];
    }
  }, {
    key: "parsePattern",
    value: function(t) {
      if (!t)
        throw new Error("Pattern is required");
      var a = t.match(E1);
      if (!a) {
        if (S1.test(t))
          throw new Error("Illegal characters found in a pattern: ".concat(t));
        this.getContext().instructions = this.getContext().instructions.concat(t.split(""));
        return;
      }
      var o = a[1], i = t.slice(0, a.index), l = t.slice(a.index + o.length);
      switch (o) {
        case "(?:":
          i && this.parsePattern(i), this.startContext({
            or: !0,
            instructions: [],
            branches: []
          });
          break;
        case ")":
          if (!this.getContext().or)
            throw new Error('")" operator must be preceded by "(?:" operator');
          if (i && this.parsePattern(i), this.getContext().instructions.length === 0)
            throw new Error('No instructions found after "|" operator in an "or" group');
          var u = this.getContext(), s = u.branches;
          s.push(ur(this.getContext().instructions)), this.endContext(), this.getContext().instructions.push({
            op: "|",
            args: s
          });
          break;
        case "|":
          if (!this.getContext().or)
            throw new Error('"|" operator can only be used inside "or" groups');
          if (i && this.parsePattern(i), !this.getContext().branches)
            if (this.context.length === 1)
              this.getContext().branches = [];
            else
              throw new Error('"branches" not found in an "or" group context');
          this.getContext().branches.push(ur(this.getContext().instructions)), this.getContext().instructions = [];
          break;
        case "[":
          i && this.parsePattern(i), this.startContext({
            oneOfSet: !0
          });
          break;
        case "]":
          if (!this.getContext().oneOfSet)
            throw new Error('"]" operator must be preceded by "[" operator');
          this.endContext(), this.getContext().instructions.push({
            op: "[]",
            args: T1(i)
          });
          break;
        /* istanbul ignore next */
        default:
          throw new Error("Unknown operator: ".concat(o));
      }
      l && this.parsePattern(l);
    }
  }]), e;
}();
function T1(e) {
  for (var n = [], t = 0; t < e.length; ) {
    if (e[t] === "-") {
      if (t === 0 || t === e.length - 1)
        throw new Error("Couldn't parse a one-of set pattern: ".concat(e));
      for (var a = e[t - 1].charCodeAt(0) + 1, o = e[t + 1].charCodeAt(0) - 1, i = a; i <= o; )
        n.push(String.fromCharCode(i)), i++;
    } else
      n.push(e[t]);
    t++;
  }
  return n;
}
var S1 = /[\(\)\[\]\?\:\|]/, E1 = new RegExp(
  // any of:
  "(\\||\\(\\?\\:|\\)|\\[|\\])"
);
function ur(e) {
  return e.length === 1 ? e[0] : e;
}
function to(e, n) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = k1(e)) || n) {
    t && (e = t);
    var a = 0;
    return function() {
      return a >= e.length ? { done: !0 } : { done: !1, value: e[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function k1(e, n) {
  if (e) {
    if (typeof e == "string") return no(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return no(e, n);
  }
}
function no(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, a = new Array(n); t < n; t++)
    a[t] = e[t];
  return a;
}
function P1(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function A1(e, n) {
  for (var t = 0; t < n.length; t++) {
    var a = n[t];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
  }
}
function R1(e, n, t) {
  return n && A1(e.prototype, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var O1 = /* @__PURE__ */ function() {
  function e(n) {
    P1(this, e), this.matchTree = new I1().parse(n);
  }
  return R1(e, [{
    key: "match",
    value: function(t) {
      var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = a.allowOverflow;
      if (!t)
        throw new Error("String is required");
      var i = Br(t.split(""), this.matchTree, !0);
      if (i && i.match && delete i.matchedChars, !(i && i.overflow && !o))
        return i;
    }
  }]), e;
}();
function Br(e, n, t) {
  if (typeof n == "string") {
    var a = e.join("");
    return n.indexOf(a) === 0 ? e.length === n.length ? {
      match: !0,
      matchedChars: e
    } : {
      partialMatch: !0
      // matchedChars: characters
    } : a.indexOf(n) === 0 ? t && e.length > n.length ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: e.slice(0, n.length)
    } : void 0;
  }
  if (Array.isArray(n)) {
    for (var o = e.slice(), i = 0; i < n.length; ) {
      var l = n[i], u = Br(o, l, t && i === n.length - 1);
      if (u) {
        if (u.overflow)
          return u;
        if (u.match) {
          if (o = o.slice(u.matchedChars.length), o.length === 0)
            return i === n.length - 1 ? {
              match: !0,
              matchedChars: e
            } : {
              partialMatch: !0
              // matchedChars: characters
            };
        } else {
          if (u.partialMatch)
            return {
              partialMatch: !0
              // matchedChars: characters
            };
          throw new Error(`Unsupported match result:
`.concat(JSON.stringify(u, null, 2)));
        }
      } else return;
      i++;
    }
    return t ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: e.slice(0, e.length - o.length)
    };
  }
  switch (n.op) {
    case "|":
      for (var s, c = to(n.args), d; !(d = c()).done; ) {
        var h = d.value, f = Br(e, h, t);
        if (f) {
          if (f.overflow)
            return f;
          if (f.match)
            return {
              match: !0,
              matchedChars: f.matchedChars
            };
          if (f.partialMatch)
            s = !0;
          else
            throw new Error(`Unsupported match result:
`.concat(JSON.stringify(f, null, 2)));
        }
      }
      return s ? {
        partialMatch: !0
        // matchedChars: ...
      } : void 0;
    case "[]":
      for (var m = to(n.args), _; !(_ = m()).done; ) {
        var g = _.value;
        if (e[0] === g)
          return e.length === 1 ? {
            match: !0,
            matchedChars: e
          } : t ? {
            overflow: !0
          } : {
            match: !0,
            matchedChars: [g]
          };
      }
      return;
    /* istanbul ignore next */
    default:
      throw new Error("Unsupported instruction tree: ".concat(n));
  }
}
function ro(e, n) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = F1(e)) || n) {
    t && (e = t);
    var a = 0;
    return function() {
      return a >= e.length ? { done: !0 } : { done: !1, value: e[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function F1(e, n) {
  if (e) {
    if (typeof e == "string") return ao(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return ao(e, n);
  }
}
function ao(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, a = new Array(n); t < n; t++)
    a[t] = e[t];
  return a;
}
function B1(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function M1(e, n) {
  for (var t = 0; t < n.length; t++) {
    var a = n[t];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
  }
}
function D1(e, n, t) {
  return n && M1(e.prototype, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Mr = "9", L1 = 15, U1 = En(Mr, L1), V1 = /[- ]/, W1 = function() {
  return /\[([^\[\]])*\]/g;
}, G1 = function() {
  return /\d(?=[^,}][^,}])/g;
}, z1 = new RegExp("[" + qe + "]*\\$1[" + qe + "]*(\\$\\d[" + qe + "]*)*$"), oo = 3, H1 = /* @__PURE__ */ function() {
  function e(n) {
    n.state;
    var t = n.metadata;
    B1(this, e), this.metadata = t, this.resetFormat();
  }
  return D1(e, [{
    key: "resetFormat",
    value: function() {
      this.chosenFormat = void 0, this.template = void 0, this.nationalNumberTemplate = void 0, this.populatedNationalNumberTemplate = void 0, this.populatedNationalNumberTemplatePosition = -1;
    }
  }, {
    key: "reset",
    value: function(t, a) {
      this.resetFormat(), t ? (this.isNANP = t.callingCode() === "1", this.matchingFormats = t.formats(), a.nationalSignificantNumber && this.narrowDownMatchingFormats(a)) : (this.isNANP = void 0, this.matchingFormats = []);
    }
    /**
     * Formats an updated phone number.
     * @param  {string} nextDigits — Additional phone number digits.
     * @param  {object} state — `AsYouType` state.
     * @return {[string]} Returns undefined if the updated phone number can't be formatted using any of the available formats.
     */
  }, {
    key: "format",
    value: function(t, a) {
      var o = this;
      if (b1(a.nationalSignificantNumber, this.metadata))
        for (var i = ro(this.matchingFormats), l; !(l = i()).done; ) {
          var u = l.value, s = x1(a, u, {
            metadata: this.metadata,
            shouldTryNationalPrefixFormattingRule: function(d) {
              return o.shouldTryNationalPrefixFormattingRule(d, {
                international: a.international,
                nationalPrefix: a.nationalPrefix
              });
            },
            getSeparatorAfterNationalPrefix: function(d) {
              return o.getSeparatorAfterNationalPrefix(d);
            }
          });
          if (s)
            return this.resetFormat(), this.chosenFormat = u, this.setNationalNumberTemplate(s.replace(/\d/g, Ge), a), this.populatedNationalNumberTemplate = s, this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf(Ge), s;
        }
      return this.formatNationalNumberWithNextDigits(t, a);
    }
    // Formats the next phone number digits.
  }, {
    key: "formatNationalNumberWithNextDigits",
    value: function(t, a) {
      var o = this.chosenFormat, i = this.chooseFormat(a);
      if (i)
        return i === o ? this.formatNextNationalNumberDigits(t) : this.formatNextNationalNumberDigits(a.getNationalDigits());
    }
  }, {
    key: "narrowDownMatchingFormats",
    value: function(t) {
      var a = this, o = t.nationalSignificantNumber, i = t.nationalPrefix, l = t.international, u = o, s = u.length - oo;
      s < 0 && (s = 0), this.matchingFormats = this.matchingFormats.filter(function(c) {
        return a.formatSuits(c, l, i) && a.formatMatches(c, u, s);
      }), this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1 && this.resetFormat();
    }
  }, {
    key: "formatSuits",
    value: function(t, a, o) {
      return !(o && !t.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
      !t.nationalPrefixIsOptionalWhenFormattingInNationalFormat() || !a && !o && t.nationalPrefixIsMandatoryWhenFormattingInNationalFormat());
    }
  }, {
    key: "formatMatches",
    value: function(t, a, o) {
      var i = t.leadingDigitsPatterns().length;
      if (i === 0)
        return !0;
      o = Math.min(o, i - 1);
      var l = t.leadingDigitsPatterns()[o];
      if (a.length < oo)
        try {
          return new O1(l).match(a, {
            allowOverflow: !0
          }) !== void 0;
        } catch (u) {
          return console.error(u), !0;
        }
      return new RegExp("^(".concat(l, ")")).test(a);
    }
  }, {
    key: "getFormatFormat",
    value: function(t, a) {
      return a ? t.internationalFormat() : t.format();
    }
  }, {
    key: "chooseFormat",
    value: function(t) {
      for (var a = this, o = function() {
        var c = l.value;
        return a.chosenFormat === c ? "break" : z1.test(a.getFormatFormat(c, t.international)) ? a.createTemplateForFormat(c, t) ? (a.chosenFormat = c, "break") : (a.matchingFormats = a.matchingFormats.filter(function(d) {
          return d !== c;
        }), "continue") : "continue";
      }, i = ro(this.matchingFormats.slice()), l; !(l = i()).done; ) {
        var u = o();
        if (u === "break") break;
      }
      return this.chosenFormat || this.resetFormat(), this.chosenFormat;
    }
  }, {
    key: "createTemplateForFormat",
    value: function(t, a) {
      if (!(t.pattern().indexOf("|") >= 0)) {
        var o = this.getTemplateForFormat(t, a);
        if (o)
          return this.setNationalNumberTemplate(o, a), !0;
      }
    }
  }, {
    key: "getSeparatorAfterNationalPrefix",
    value: function(t) {
      return this.isNANP || t && t.nationalPrefixFormattingRule() && V1.test(t.nationalPrefixFormattingRule()) ? " " : "";
    }
  }, {
    key: "getInternationalPrefixBeforeCountryCallingCode",
    value: function(t, a) {
      var o = t.IDDPrefix, i = t.missingPlus;
      return o ? a && a.spacing === !1 ? o : o + " " : i ? "" : "+";
    }
  }, {
    key: "getTemplate",
    value: function(t) {
      if (this.template) {
        for (var a = -1, o = 0, i = t.international ? this.getInternationalPrefixBeforeCountryCallingCode(t, {
          spacing: !1
        }) : ""; o < i.length + t.getDigitsWithoutInternationalPrefix().length; )
          a = this.template.indexOf(Ge, a + 1), o++;
        return Qa(this.template, a + 1);
      }
    }
  }, {
    key: "setNationalNumberTemplate",
    value: function(t, a) {
      this.nationalNumberTemplate = t, this.populatedNationalNumberTemplate = t, this.populatedNationalNumberTemplatePosition = -1, a.international ? this.template = this.getInternationalPrefixBeforeCountryCallingCode(a).replace(/[\d\+]/g, Ge) + En(Ge, a.callingCode.length) + " " + t : this.template = t;
    }
    /**
     * Generates formatting template for a national phone number,
     * optionally containing a national prefix, for a format.
     * @param  {Format} format
     * @param  {string} nationalPrefix
     * @return {string}
     */
  }, {
    key: "getTemplateForFormat",
    value: function(t, a) {
      var o = a.nationalSignificantNumber, i = a.international, l = a.nationalPrefix, u = a.complexPrefixBeforeNationalSignificantNumber, s = t.pattern();
      s = s.replace(W1(), "\\d").replace(G1(), "\\d");
      var c = U1.match(s)[0];
      if (!(o.length > c.length)) {
        var d = new RegExp("^" + s + "$"), h = o.replace(/\d/g, Mr);
        d.test(h) && (c = h);
        var f = this.getFormatFormat(t, i), m;
        if (this.shouldTryNationalPrefixFormattingRule(t, {
          international: i,
          nationalPrefix: l
        })) {
          var _ = f.replace(ni, t.nationalPrefixFormattingRule());
          if (Rn(t.nationalPrefixFormattingRule()) === (l || "") + Rn("$1") && (f = _, m = !0, l))
            for (var g = l.length; g > 0; )
              f = f.replace(/\d/, Ge), g--;
        }
        var $ = c.replace(new RegExp(s), f).replace(new RegExp(Mr, "g"), Ge);
        return m || (u ? $ = En(Ge, u.length) + " " + $ : l && ($ = En(Ge, l.length) + this.getSeparatorAfterNationalPrefix(t) + $)), i && ($ = ti($)), $;
      }
    }
  }, {
    key: "formatNextNationalNumberDigits",
    value: function(t) {
      var a = v1(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, t);
      if (!a) {
        this.resetFormat();
        return;
      }
      return this.populatedNationalNumberTemplate = a[0], this.populatedNationalNumberTemplatePosition = a[1], Qa(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1);
    }
  }, {
    key: "shouldTryNationalPrefixFormattingRule",
    value: function(t, a) {
      var o = a.international, i = a.nationalPrefix;
      if (t.nationalPrefixFormattingRule()) {
        var l = t.usesNationalPrefix();
        if (l && i || !l && !o)
          return !0;
      }
    }
  }]), e;
}();
function ui(e, n) {
  return X1(e) || K1(e, n) || Y1(e, n) || q1();
}
function q1() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Y1(e, n) {
  if (e) {
    if (typeof e == "string") return io(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return io(e, n);
  }
}
function io(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, a = new Array(n); t < n; t++)
    a[t] = e[t];
  return a;
}
function K1(e, n) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var a = [], o = !0, i = !1, l, u;
    try {
      for (t = t.call(e); !(o = (l = t.next()).done) && (a.push(l.value), !(n && a.length === n)); o = !0)
        ;
    } catch (s) {
      i = !0, u = s;
    } finally {
      try {
        !o && t.return != null && t.return();
      } finally {
        if (i) throw u;
      }
    }
    return a;
  }
}
function X1(e) {
  if (Array.isArray(e)) return e;
}
function Z1(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function J1(e, n) {
  for (var t = 0; t < n.length; t++) {
    var a = n[t];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
  }
}
function Q1(e, n, t) {
  return n && J1(e.prototype, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var eu = "[" + qe + we + "]+", tu = new RegExp("^" + eu + "$", "i"), nu = "(?:[" + zn + "][" + qe + we + "]*|[" + qe + we + "]+)", ru = new RegExp("[^" + qe + we + "]+.*$"), au = /[^\d\[\]]/, ou = /* @__PURE__ */ function() {
  function e(n) {
    var t = n.defaultCountry, a = n.defaultCallingCode, o = n.metadata, i = n.onNationalSignificantNumberChange;
    Z1(this, e), this.defaultCountry = t, this.defaultCallingCode = a, this.metadata = o, this.onNationalSignificantNumberChange = i;
  }
  return Q1(e, [{
    key: "input",
    value: function(t, a) {
      var o = lu(t), i = ui(o, 2), l = i[0], u = i[1], s = Rn(l), c;
      return u && (a.digits || (a.startInternationalNumber(), s || (c = !0))), s && this.inputDigits(s, a), {
        digits: s,
        justLeadingPlus: c
      };
    }
    /**
     * Inputs "next" phone number digits.
     * @param  {string} digits
     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
     */
  }, {
    key: "inputDigits",
    value: function(t, a) {
      var o = a.digits, i = o.length < 3 && o.length + t.length >= 3;
      if (a.appendDigits(t), i && this.extractIddPrefix(a), this.isWaitingForCountryCallingCode(a)) {
        if (!this.extractCountryCallingCode(a))
          return;
      } else
        a.appendNationalSignificantNumberDigits(t);
      a.international || this.hasExtractedNationalSignificantNumber || this.extractNationalSignificantNumber(a.getNationalDigits(), function(l) {
        return a.update(l);
      });
    }
  }, {
    key: "isWaitingForCountryCallingCode",
    value: function(t) {
      var a = t.international, o = t.callingCode;
      return a && !o;
    }
    // Extracts a country calling code from a number
    // being entered in internatonal format.
  }, {
    key: "extractCountryCallingCode",
    value: function(t) {
      var a = Kr("+" + t.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), o = a.countryCallingCode, i = a.number;
      if (o)
        return t.setCallingCode(o), t.update({
          nationalSignificantNumber: i
        }), !0;
    }
  }, {
    key: "reset",
    value: function(t) {
      if (t) {
        this.hasSelectedNumberingPlan = !0;
        var a = t._nationalPrefixForParsing();
        this.couldPossiblyExtractAnotherNationalSignificantNumber = a && au.test(a);
      } else
        this.hasSelectedNumberingPlan = void 0, this.couldPossiblyExtractAnotherNationalSignificantNumber = void 0;
    }
    /**
     * Extracts a national (significant) number from user input.
     * Google's library is different in that it only applies `national_prefix_for_parsing`
     * and doesn't apply `national_prefix_transform_rule` after that.
     * https://github.com/google/libphonenumber/blob/a3d70b0487875475e6ad659af404943211d26456/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L539
     * @return {boolean} [extracted]
     */
  }, {
    key: "extractNationalSignificantNumber",
    value: function(t, a) {
      if (this.hasSelectedNumberingPlan) {
        var o = kr(t, this.metadata), i = o.nationalPrefix, l = o.nationalNumber, u = o.carrierCode;
        if (l !== t)
          return this.onExtractedNationalNumber(i, u, l, t, a), !0;
      }
    }
    /**
     * In Google's code this function is called "attempt to extract longer NDD".
     * "Some national prefixes are a substring of others", they say.
     * @return {boolean} [result] — Returns `true` if extracting a national prefix produced different results from what they were.
     */
  }, {
    key: "extractAnotherNationalSignificantNumber",
    value: function(t, a, o) {
      if (!this.hasExtractedNationalSignificantNumber)
        return this.extractNationalSignificantNumber(t, o);
      if (this.couldPossiblyExtractAnotherNationalSignificantNumber) {
        var i = kr(t, this.metadata), l = i.nationalPrefix, u = i.nationalNumber, s = i.carrierCode;
        if (u !== a)
          return this.onExtractedNationalNumber(l, s, u, t, o), !0;
      }
    }
  }, {
    key: "onExtractedNationalNumber",
    value: function(t, a, o, i, l) {
      var u, s, c = i.lastIndexOf(o);
      if (c >= 0 && c === i.length - o.length) {
        s = !0;
        var d = i.slice(0, c);
        d !== t && (u = d);
      }
      l({
        nationalPrefix: t,
        carrierCode: a,
        nationalSignificantNumber: o,
        nationalSignificantNumberMatchesInput: s,
        complexPrefixBeforeNationalSignificantNumber: u
      }), this.hasExtractedNationalSignificantNumber = !0, this.onNationalSignificantNumberChange();
    }
  }, {
    key: "reExtractNationalSignificantNumber",
    value: function(t) {
      if (this.extractAnotherNationalSignificantNumber(t.getNationalDigits(), t.nationalSignificantNumber, function(a) {
        return t.update(a);
      }))
        return !0;
      if (this.extractIddPrefix(t))
        return this.extractCallingCodeAndNationalSignificantNumber(t), !0;
      if (this.fixMissingPlus(t))
        return this.extractCallingCodeAndNationalSignificantNumber(t), !0;
    }
  }, {
    key: "extractIddPrefix",
    value: function(t) {
      var a = t.international, o = t.IDDPrefix, i = t.digits;
      if (t.nationalSignificantNumber, !(a || o)) {
        var l = Qo(i, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
        if (l !== void 0 && l !== i)
          return t.update({
            IDDPrefix: i.slice(0, i.length - l.length)
          }), this.startInternationalNumber(t, {
            country: void 0,
            callingCode: void 0
          }), !0;
      }
    }
  }, {
    key: "fixMissingPlus",
    value: function(t) {
      if (!t.international) {
        var a = ei(t.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), o = a.countryCallingCode;
        if (a.number, o)
          return t.update({
            missingPlus: !0
          }), this.startInternationalNumber(t, {
            country: t.country,
            callingCode: o
          }), !0;
      }
    }
  }, {
    key: "startInternationalNumber",
    value: function(t, a) {
      var o = a.country, i = a.callingCode;
      t.startInternationalNumber(o, i), t.nationalSignificantNumber && (t.resetNationalSignificantNumber(), this.onNationalSignificantNumberChange(), this.hasExtractedNationalSignificantNumber = void 0);
    }
  }, {
    key: "extractCallingCodeAndNationalSignificantNumber",
    value: function(t) {
      this.extractCountryCallingCode(t) && this.extractNationalSignificantNumber(t.getNationalDigits(), function(a) {
        return t.update(a);
      });
    }
  }]), e;
}();
function iu(e) {
  var n = e.search(nu);
  if (!(n < 0)) {
    e = e.slice(n);
    var t;
    return e[0] === "+" && (t = !0, e = e.slice(1)), e = e.replace(ru, ""), t && (e = "+" + e), e;
  }
}
function su(e) {
  var n = iu(e) || "";
  return n[0] === "+" ? [n.slice(1), !0] : [n];
}
function lu(e) {
  var n = su(e), t = ui(n, 2), a = t[0], o = t[1];
  return tu.test(a) || (a = ""), [a, o];
}
function cu(e, n) {
  return fu(e) || hu(e, n) || uu(e, n) || du();
}
function du() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function uu(e, n) {
  if (e) {
    if (typeof e == "string") return so(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return so(e, n);
  }
}
function so(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, a = new Array(n); t < n; t++)
    a[t] = e[t];
  return a;
}
function hu(e, n) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var a = [], o = !0, i = !1, l, u;
    try {
      for (t = t.call(e); !(o = (l = t.next()).done) && (a.push(l.value), !(n && a.length === n)); o = !0)
        ;
    } catch (s) {
      i = !0, u = s;
    } finally {
      try {
        !o && t.return != null && t.return();
      } finally {
        if (i) throw u;
      }
    }
    return a;
  }
}
function fu(e) {
  if (Array.isArray(e)) return e;
}
function mu(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function _u(e, n) {
  for (var t = 0; t < n.length; t++) {
    var a = n[t];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
  }
}
function $u(e, n, t) {
  return n && _u(e.prototype, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var pu = /* @__PURE__ */ function() {
  function e(n, t) {
    mu(this, e), this.metadata = new ve(t);
    var a = this.getCountryAndCallingCode(n), o = cu(a, 2), i = o[0], l = o[1];
    this.defaultCountry = i, this.defaultCallingCode = l, this.reset();
  }
  return $u(e, [{
    key: "getCountryAndCallingCode",
    value: function(t) {
      var a, o;
      return t && (Ct(t) ? (a = t.defaultCountry, o = t.defaultCallingCode) : a = t), a && !this.metadata.hasCountry(a) && (a = void 0), [a, o];
    }
    /**
     * Inputs "next" phone number characters.
     * @param  {string} text
     * @return {string} Formatted phone number characters that have been input so far.
     */
  }, {
    key: "input",
    value: function(t) {
      var a = this.parser.input(t, this.state), o = a.digits, i = a.justLeadingPlus;
      if (i)
        this.formattedOutput = "+";
      else if (o) {
        this.determineTheCountryIfNeeded(), this.state.nationalSignificantNumber && this.formatter.narrowDownMatchingFormats(this.state);
        var l;
        if (this.metadata.hasSelectedNumberingPlan() && (l = this.formatter.format(o, this.state)), l === void 0 && this.parser.reExtractNationalSignificantNumber(this.state)) {
          this.determineTheCountryIfNeeded();
          var u = this.state.getNationalDigits();
          u && (l = this.formatter.format(u, this.state));
        }
        this.formattedOutput = l ? this.getFullNumber(l) : this.getNonFormattedNumber();
      }
      return this.formattedOutput;
    }
  }, {
    key: "reset",
    value: function() {
      var t = this;
      return this.state = new _1({
        onCountryChange: function(o) {
          t.country = o;
        },
        onCallingCodeChange: function(o, i) {
          t.metadata.selectNumberingPlan(i, o), t.formatter.reset(t.metadata.numberingPlan, t.state), t.parser.reset(t.metadata.numberingPlan);
        }
      }), this.formatter = new H1({
        state: this.state,
        metadata: this.metadata
      }), this.parser = new ou({
        defaultCountry: this.defaultCountry,
        defaultCallingCode: this.defaultCallingCode,
        metadata: this.metadata,
        state: this.state,
        onNationalSignificantNumberChange: function() {
          t.determineTheCountryIfNeeded(), t.formatter.reset(t.metadata.numberingPlan, t.state);
        }
      }), this.state.reset({
        country: this.defaultCountry,
        callingCode: this.defaultCallingCode
      }), this.formattedOutput = "", this;
    }
    /**
     * Returns `true` if the phone number is being input in international format.
     * In other words, returns `true` if and only if the parsed phone number starts with a `"+"`.
     * @return {boolean}
     */
  }, {
    key: "isInternational",
    value: function() {
      return this.state.international;
    }
    /**
     * Returns the "calling code" part of the phone number when it's being input
     * in an international format.
     * If no valid calling code has been entered so far, returns `undefined`.
     * @return {string} [callingCode]
     */
  }, {
    key: "getCallingCode",
    value: function() {
      if (this.isInternational())
        return this.state.callingCode;
    }
    // A legacy alias.
  }, {
    key: "getCountryCallingCode",
    value: function() {
      return this.getCallingCode();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * Returns `undefined` if no phone number has been input yet.
     * @return {string} [country]
     */
  }, {
    key: "getCountry",
    value: function() {
      var t = this.state.digits;
      if (t)
        return this._getCountry();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * @return {string} [country]
     */
  }, {
    key: "_getCountry",
    value: function() {
      var t = this.state.country;
      return t;
    }
  }, {
    key: "determineTheCountryIfNeeded",
    value: function() {
      (!this.state.country || this.isCountryCallingCodeAmbiguous()) && this.determineTheCountry();
    }
    // Prepends `+CountryCode ` in case of an international phone number
  }, {
    key: "getFullNumber",
    value: function(t) {
      var a = this;
      if (this.isInternational()) {
        var o = function(u) {
          return a.formatter.getInternationalPrefixBeforeCountryCallingCode(a.state, {
            spacing: !!u
          }) + u;
        }, i = this.state.callingCode;
        return o(i ? t ? "".concat(i, " ").concat(t) : i : "".concat(this.state.getDigitsWithoutInternationalPrefix()));
      }
      return t;
    }
  }, {
    key: "getNonFormattedNationalNumberWithPrefix",
    value: function() {
      var t = this.state, a = t.nationalSignificantNumber, o = t.complexPrefixBeforeNationalSignificantNumber, i = t.nationalPrefix, l = a, u = o || i;
      return u && (l = u + l), l;
    }
  }, {
    key: "getNonFormattedNumber",
    value: function() {
      var t = this.state.nationalSignificantNumberMatchesInput;
      return this.getFullNumber(t ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
    }
  }, {
    key: "getNonFormattedTemplate",
    value: function() {
      var t = this.getNonFormattedNumber();
      if (t)
        return t.replace(/[\+\d]/g, Ge);
    }
  }, {
    key: "isCountryCallingCodeAmbiguous",
    value: function() {
      var t = this.state.callingCode, a = this.metadata.getCountryCodesForCallingCode(t);
      return a && a.length > 1;
    }
    // Determines the country of the phone number
    // entered so far based on the country phone code
    // and the national phone number.
  }, {
    key: "determineTheCountry",
    value: function() {
      this.state.setCountry(ci(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, {
        nationalNumber: this.state.nationalSignificantNumber,
        defaultCountry: this.defaultCountry,
        metadata: this.metadata
      }));
    }
    /**
     * Returns a E.164 phone number value for the user's input.
     *
     * For example, for country `"US"` and input `"(222) 333-4444"`
     * it will return `"+12223334444"`.
     *
     * For international phone number input, it will also auto-correct
     * some minor errors such as using a national prefix when writing
     * an international phone number. For example, if the user inputs
     * `"+44 0 7400 000000"` then it will return an auto-corrected
     * `"+447400000000"` phone number value.
     *
     * Will return `undefined` if no digits have been input,
     * or when inputting a phone number in national format and no
     * default country or default "country calling code" have been set.
     *
     * @return {string} [value]
     */
  }, {
    key: "getNumberValue",
    value: function() {
      var t = this.state, a = t.digits, o = t.callingCode, i = t.country, l = t.nationalSignificantNumber;
      if (a) {
        if (this.isInternational())
          return o ? "+" + o + l : "+" + a;
        if (i || o) {
          var u = i ? this.metadata.countryCallingCode() : o;
          return "+" + u + l;
        }
      }
    }
    /**
     * Returns an instance of `PhoneNumber` class.
     * Will return `undefined` if no national (significant) number
     * digits have been entered so far, or if no `defaultCountry` has been
     * set and the user enters a phone number not in international format.
     */
  }, {
    key: "getNumber",
    value: function() {
      var t = this.state, a = t.nationalSignificantNumber, o = t.carrierCode, i = t.callingCode, l = this._getCountry();
      if (a && !(!l && !i)) {
        if (l && l === this.defaultCountry) {
          var u = new ve(this.metadata.metadata);
          u.selectNumberingPlan(l);
          var s = u.numberingPlan.callingCode(), c = this.metadata.getCountryCodesForCallingCode(s);
          if (c.length > 1) {
            var d = li(a, {
              countries: c,
              defaultCountry: this.defaultCountry,
              metadata: this.metadata.metadata
            });
            d && (l = d);
          }
        }
        var h = new Xr(l || i, a, this.metadata.metadata);
        return o && (h.carrierCode = o), h;
      }
    }
    /**
     * Returns `true` if the phone number is "possible".
     * Is just a shortcut for `PhoneNumber.isPossible()`.
     * @return {boolean}
     */
  }, {
    key: "isPossible",
    value: function() {
      var t = this.getNumber();
      return t ? t.isPossible() : !1;
    }
    /**
     * Returns `true` if the phone number is "valid".
     * Is just a shortcut for `PhoneNumber.isValid()`.
     * @return {boolean}
     */
  }, {
    key: "isValid",
    value: function() {
      var t = this.getNumber();
      return t ? t.isValid() : !1;
    }
    /**
     * @deprecated
     * This method is used in `react-phone-number-input/source/input-control.js`
     * in versions before `3.0.16`.
     */
  }, {
    key: "getNationalNumber",
    value: function() {
      return this.state.nationalSignificantNumber;
    }
    /**
     * Returns the phone number characters entered by the user.
     * @return {string}
     */
  }, {
    key: "getChars",
    value: function() {
      return (this.state.international ? "+" : "") + this.state.digits;
    }
    /**
     * Returns the template for the formatted phone number.
     * @return {string}
     */
  }, {
    key: "getTemplate",
    value: function() {
      return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || "";
    }
  }]), e;
}();
function gu(e) {
  return new ve(e).getCountries();
}
function vu(e, n, t) {
  if (n[e])
    return new Xr(e, n[e], t);
}
function xu(e, n, t) {
  return t || (t = n, n = void 0), new pu(n, t).input(e);
}
function bu() {
  return on(u1, arguments);
}
function yu() {
  return on(gu, arguments);
}
function Cu() {
  return on(Wn, arguments);
}
function Nu() {
  return on(vu, arguments);
}
function ju() {
  return on(xu, arguments);
}
const wu = ({
  label: e,
  name: n,
  countryCodes: t,
  defaultCountryCode: a,
  errorText: o,
  ...i
}) => {
  const [l, u] = R(a || "ES"), [s, c] = R(0), d = Ee(null), h = Ee(null);
  fe(() => {
    if (h.current) {
      const $ = h.current.getBoundingClientRect().width;
      c($);
    }
  }, [l]);
  const f = ju(
    Nu(l, xc)?.formatInternational() || "",
    l
  ), _ = (t ?? yu()).filter(($) => $ === "ES" || $ === "US" || $ === "GB").map(($) => ({
    code: $,
    callingCode: Cu($),
    name: $.toUpperCase()
  })), g = ($) => {
    const x = $.target, b = bu(x.value, l);
    b.isValid() ? x.setCustomValidity("") : x.setCustomValidity("Invalid phone number"), d.current && (d.current.value = b.formatInternational()), i.onChange && i.onChange?.($);
  };
  return /* @__PURE__ */ r.jsxs(Hr, { label: e, errorText: o, required: i.required, children: [
    /* @__PURE__ */ r.jsx("div", { className: Re.countrySelectWrapper, children: /* @__PURE__ */ r.jsx(
      "select",
      {
        defaultValue: a,
        ref: h,
        className: Re.select,
        value: l,
        onChange: ($) => u($.target.value),
        children: _.map(($) => /* @__PURE__ */ r.jsxs("option", { value: $.code, children: [
          $.name,
          " (+",
          $.callingCode,
          ")"
        ] }, $.code))
      }
    ) }),
    /* @__PURE__ */ r.jsx(
      "input",
      {
        ...i,
        ref: d,
        name: n,
        placeholder: f,
        onChange: g,
        className: Re.input,
        style: { paddingLeft: `calc(${s}px + var(--size-s))` }
      }
    )
  ] });
}, Iu = ({ ...e }) => e.type === "email" ? /* @__PURE__ */ r.jsx(vc, { ...e }) : e.type === "tel" ? /* @__PURE__ */ r.jsx(wu, { ...e }) : /* @__PURE__ */ r.jsxs(Hr, { label: e.label, errorText: e.errorText, children: [
  e.iconLeft && /* @__PURE__ */ r.jsx(Pn, { position: "left", children: e.iconLeft }),
  /* @__PURE__ */ r.jsx("input", { ...e, className: Re.input }),
  e.iconRight && /* @__PURE__ */ r.jsx(Pn, { position: "right", children: e.iconRight })
] });
var cn = { exports: {} }, dn = { exports: {} }, Y = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lo;
function Tu() {
  if (lo) return Y;
  lo = 1;
  var e = typeof Symbol == "function" && Symbol.for, n = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, s = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, _ = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, $ = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, b = e ? Symbol.for("react.scope") : 60119;
  function C(v) {
    if (typeof v == "object" && v !== null) {
      var w = v.$$typeof;
      switch (w) {
        case n:
          switch (v = v.type, v) {
            case s:
            case c:
            case a:
            case i:
            case o:
            case h:
              return v;
            default:
              switch (v = v && v.$$typeof, v) {
                case u:
                case d:
                case _:
                case m:
                case l:
                  return v;
                default:
                  return w;
              }
          }
        case t:
          return w;
      }
    }
  }
  function p(v) {
    return C(v) === c;
  }
  return Y.AsyncMode = s, Y.ConcurrentMode = c, Y.ContextConsumer = u, Y.ContextProvider = l, Y.Element = n, Y.ForwardRef = d, Y.Fragment = a, Y.Lazy = _, Y.Memo = m, Y.Portal = t, Y.Profiler = i, Y.StrictMode = o, Y.Suspense = h, Y.isAsyncMode = function(v) {
    return p(v) || C(v) === s;
  }, Y.isConcurrentMode = p, Y.isContextConsumer = function(v) {
    return C(v) === u;
  }, Y.isContextProvider = function(v) {
    return C(v) === l;
  }, Y.isElement = function(v) {
    return typeof v == "object" && v !== null && v.$$typeof === n;
  }, Y.isForwardRef = function(v) {
    return C(v) === d;
  }, Y.isFragment = function(v) {
    return C(v) === a;
  }, Y.isLazy = function(v) {
    return C(v) === _;
  }, Y.isMemo = function(v) {
    return C(v) === m;
  }, Y.isPortal = function(v) {
    return C(v) === t;
  }, Y.isProfiler = function(v) {
    return C(v) === i;
  }, Y.isStrictMode = function(v) {
    return C(v) === o;
  }, Y.isSuspense = function(v) {
    return C(v) === h;
  }, Y.isValidElementType = function(v) {
    return typeof v == "string" || typeof v == "function" || v === a || v === c || v === i || v === o || v === h || v === f || typeof v == "object" && v !== null && (v.$$typeof === _ || v.$$typeof === m || v.$$typeof === l || v.$$typeof === u || v.$$typeof === d || v.$$typeof === $ || v.$$typeof === x || v.$$typeof === b || v.$$typeof === g);
  }, Y.typeOf = C, Y;
}
var K = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var co;
function Su() {
  return co || (co = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, n = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, s = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, _ = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, $ = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, b = e ? Symbol.for("react.scope") : 60119;
    function C(j) {
      return typeof j == "string" || typeof j == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      j === a || j === c || j === i || j === o || j === h || j === f || typeof j == "object" && j !== null && (j.$$typeof === _ || j.$$typeof === m || j.$$typeof === l || j.$$typeof === u || j.$$typeof === d || j.$$typeof === $ || j.$$typeof === x || j.$$typeof === b || j.$$typeof === g);
    }
    function p(j) {
      if (typeof j == "object" && j !== null) {
        var Ye = j.$$typeof;
        switch (Ye) {
          case n:
            var ln = j.type;
            switch (ln) {
              case s:
              case c:
              case a:
              case i:
              case o:
              case h:
                return ln;
              default:
                var ta = ln && ln.$$typeof;
                switch (ta) {
                  case u:
                  case d:
                  case _:
                  case m:
                  case l:
                    return ta;
                  default:
                    return Ye;
                }
            }
          case t:
            return Ye;
        }
      }
    }
    var v = s, w = c, S = u, D = l, Z = n, O = d, B = a, M = _, k = m, Oe = t, Fe = i, se = o, Le = h, Tt = !1;
    function Hn(j) {
      return Tt || (Tt = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), N(j) || p(j) === s;
    }
    function N(j) {
      return p(j) === c;
    }
    function I(j) {
      return p(j) === u;
    }
    function W(j) {
      return p(j) === l;
    }
    function U(j) {
      return typeof j == "object" && j !== null && j.$$typeof === n;
    }
    function F(j) {
      return p(j) === d;
    }
    function G(j) {
      return p(j) === a;
    }
    function L(j) {
      return p(j) === _;
    }
    function V(j) {
      return p(j) === m;
    }
    function z(j) {
      return p(j) === t;
    }
    function X(j) {
      return p(j) === i;
    }
    function H(j) {
      return p(j) === o;
    }
    function Ie(j) {
      return p(j) === h;
    }
    K.AsyncMode = v, K.ConcurrentMode = w, K.ContextConsumer = S, K.ContextProvider = D, K.Element = Z, K.ForwardRef = O, K.Fragment = B, K.Lazy = M, K.Memo = k, K.Portal = Oe, K.Profiler = Fe, K.StrictMode = se, K.Suspense = Le, K.isAsyncMode = Hn, K.isConcurrentMode = N, K.isContextConsumer = I, K.isContextProvider = W, K.isElement = U, K.isForwardRef = F, K.isFragment = G, K.isLazy = L, K.isMemo = V, K.isPortal = z, K.isProfiler = X, K.isStrictMode = H, K.isSuspense = Ie, K.isValidElementType = C, K.typeOf = p;
  }()), K;
}
var uo;
function hi() {
  return uo || (uo = 1, process.env.NODE_ENV === "production" ? dn.exports = Tu() : dn.exports = Su()), dn.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var hr, ho;
function Eu() {
  if (ho) return hr;
  ho = 1;
  var e = Object.getOwnPropertySymbols, n = Object.prototype.hasOwnProperty, t = Object.prototype.propertyIsEnumerable;
  function a(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var l = {}, u = 0; u < 10; u++)
        l["_" + String.fromCharCode(u)] = u;
      var s = Object.getOwnPropertyNames(l).map(function(d) {
        return l[d];
      });
      if (s.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(d) {
        c[d] = d;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return hr = o() ? Object.assign : function(i, l) {
    for (var u, s = a(i), c, d = 1; d < arguments.length; d++) {
      u = Object(arguments[d]);
      for (var h in u)
        n.call(u, h) && (s[h] = u[h]);
      if (e) {
        c = e(u);
        for (var f = 0; f < c.length; f++)
          t.call(u, c[f]) && (s[c[f]] = u[c[f]]);
      }
    }
    return s;
  }, hr;
}
var fr, fo;
function Zr() {
  if (fo) return fr;
  fo = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return fr = e, fr;
}
var mr, mo;
function fi() {
  return mo || (mo = 1, mr = Function.call.bind(Object.prototype.hasOwnProperty)), mr;
}
var _r, _o;
function ku() {
  if (_o) return _r;
  _o = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var n = /* @__PURE__ */ Zr(), t = {}, a = /* @__PURE__ */ fi();
    e = function(i) {
      var l = "Warning: " + i;
      typeof console < "u" && console.error(l);
      try {
        throw new Error(l);
      } catch {
      }
    };
  }
  function o(i, l, u, s, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var d in i)
        if (a(i, d)) {
          var h;
          try {
            if (typeof i[d] != "function") {
              var f = Error(
                (s || "React class") + ": " + u + " type `" + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[d] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            h = i[d](l, d, s, u, null, n);
          } catch (_) {
            h = _;
          }
          if (h && !(h instanceof Error) && e(
            (s || "React class") + ": type specification of " + u + " `" + d + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof h + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), h instanceof Error && !(h.message in t)) {
            t[h.message] = !0;
            var m = c ? c() : "";
            e(
              "Failed " + u + " type: " + h.message + (m ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (t = {});
  }, _r = o, _r;
}
var $r, $o;
function Pu() {
  if ($o) return $r;
  $o = 1;
  var e = hi(), n = Eu(), t = /* @__PURE__ */ Zr(), a = /* @__PURE__ */ fi(), o = /* @__PURE__ */ ku(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(u) {
    var s = "Warning: " + u;
    typeof console < "u" && console.error(s);
    try {
      throw new Error(s);
    } catch {
    }
  });
  function l() {
    return null;
  }
  return $r = function(u, s) {
    var c = typeof Symbol == "function" && Symbol.iterator, d = "@@iterator";
    function h(N) {
      var I = N && (c && N[c] || N[d]);
      if (typeof I == "function")
        return I;
    }
    var f = "<<anonymous>>", m = {
      array: x("array"),
      bigint: x("bigint"),
      bool: x("boolean"),
      func: x("function"),
      number: x("number"),
      object: x("object"),
      string: x("string"),
      symbol: x("symbol"),
      any: b(),
      arrayOf: C,
      element: p(),
      elementType: v(),
      instanceOf: w,
      node: O(),
      objectOf: D,
      oneOf: S,
      oneOfType: Z,
      shape: M,
      exact: k
    };
    function _(N, I) {
      return N === I ? N !== 0 || 1 / N === 1 / I : N !== N && I !== I;
    }
    function g(N, I) {
      this.message = N, this.data = I && typeof I == "object" ? I : {}, this.stack = "";
    }
    g.prototype = Error.prototype;
    function $(N) {
      if (process.env.NODE_ENV !== "production")
        var I = {}, W = 0;
      function U(G, L, V, z, X, H, Ie) {
        if (z = z || f, H = H || V, Ie !== t) {
          if (s) {
            var j = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw j.name = "Invariant Violation", j;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Ye = z + ":" + V;
            !I[Ye] && // Avoid spamming the console because they are often not actionable except for lib authors
            W < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + H + "` prop on `" + z + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), I[Ye] = !0, W++);
          }
        }
        return L[V] == null ? G ? L[V] === null ? new g("The " + X + " `" + H + "` is marked as required " + ("in `" + z + "`, but its value is `null`.")) : new g("The " + X + " `" + H + "` is marked as required in " + ("`" + z + "`, but its value is `undefined`.")) : null : N(L, V, z, X, H);
      }
      var F = U.bind(null, !1);
      return F.isRequired = U.bind(null, !0), F;
    }
    function x(N) {
      function I(W, U, F, G, L, V) {
        var z = W[U], X = se(z);
        if (X !== N) {
          var H = Le(z);
          return new g(
            "Invalid " + G + " `" + L + "` of type " + ("`" + H + "` supplied to `" + F + "`, expected ") + ("`" + N + "`."),
            { expectedType: N }
          );
        }
        return null;
      }
      return $(I);
    }
    function b() {
      return $(l);
    }
    function C(N) {
      function I(W, U, F, G, L) {
        if (typeof N != "function")
          return new g("Property `" + L + "` of component `" + F + "` has invalid PropType notation inside arrayOf.");
        var V = W[U];
        if (!Array.isArray(V)) {
          var z = se(V);
          return new g("Invalid " + G + " `" + L + "` of type " + ("`" + z + "` supplied to `" + F + "`, expected an array."));
        }
        for (var X = 0; X < V.length; X++) {
          var H = N(V, X, F, G, L + "[" + X + "]", t);
          if (H instanceof Error)
            return H;
        }
        return null;
      }
      return $(I);
    }
    function p() {
      function N(I, W, U, F, G) {
        var L = I[W];
        if (!u(L)) {
          var V = se(L);
          return new g("Invalid " + F + " `" + G + "` of type " + ("`" + V + "` supplied to `" + U + "`, expected a single ReactElement."));
        }
        return null;
      }
      return $(N);
    }
    function v() {
      function N(I, W, U, F, G) {
        var L = I[W];
        if (!e.isValidElementType(L)) {
          var V = se(L);
          return new g("Invalid " + F + " `" + G + "` of type " + ("`" + V + "` supplied to `" + U + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return $(N);
    }
    function w(N) {
      function I(W, U, F, G, L) {
        if (!(W[U] instanceof N)) {
          var V = N.name || f, z = Hn(W[U]);
          return new g("Invalid " + G + " `" + L + "` of type " + ("`" + z + "` supplied to `" + F + "`, expected ") + ("instance of `" + V + "`."));
        }
        return null;
      }
      return $(I);
    }
    function S(N) {
      if (!Array.isArray(N))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), l;
      function I(W, U, F, G, L) {
        for (var V = W[U], z = 0; z < N.length; z++)
          if (_(V, N[z]))
            return null;
        var X = JSON.stringify(N, function(Ie, j) {
          var Ye = Le(j);
          return Ye === "symbol" ? String(j) : j;
        });
        return new g("Invalid " + G + " `" + L + "` of value `" + String(V) + "` " + ("supplied to `" + F + "`, expected one of " + X + "."));
      }
      return $(I);
    }
    function D(N) {
      function I(W, U, F, G, L) {
        if (typeof N != "function")
          return new g("Property `" + L + "` of component `" + F + "` has invalid PropType notation inside objectOf.");
        var V = W[U], z = se(V);
        if (z !== "object")
          return new g("Invalid " + G + " `" + L + "` of type " + ("`" + z + "` supplied to `" + F + "`, expected an object."));
        for (var X in V)
          if (a(V, X)) {
            var H = N(V, X, F, G, L + "." + X, t);
            if (H instanceof Error)
              return H;
          }
        return null;
      }
      return $(I);
    }
    function Z(N) {
      if (!Array.isArray(N))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), l;
      for (var I = 0; I < N.length; I++) {
        var W = N[I];
        if (typeof W != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Tt(W) + " at index " + I + "."
          ), l;
      }
      function U(F, G, L, V, z) {
        for (var X = [], H = 0; H < N.length; H++) {
          var Ie = N[H], j = Ie(F, G, L, V, z, t);
          if (j == null)
            return null;
          j.data && a(j.data, "expectedType") && X.push(j.data.expectedType);
        }
        var Ye = X.length > 0 ? ", expected one of type [" + X.join(", ") + "]" : "";
        return new g("Invalid " + V + " `" + z + "` supplied to " + ("`" + L + "`" + Ye + "."));
      }
      return $(U);
    }
    function O() {
      function N(I, W, U, F, G) {
        return Oe(I[W]) ? null : new g("Invalid " + F + " `" + G + "` supplied to " + ("`" + U + "`, expected a ReactNode."));
      }
      return $(N);
    }
    function B(N, I, W, U, F) {
      return new g(
        (N || "React class") + ": " + I + " type `" + W + "." + U + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + F + "`."
      );
    }
    function M(N) {
      function I(W, U, F, G, L) {
        var V = W[U], z = se(V);
        if (z !== "object")
          return new g("Invalid " + G + " `" + L + "` of type `" + z + "` " + ("supplied to `" + F + "`, expected `object`."));
        for (var X in N) {
          var H = N[X];
          if (typeof H != "function")
            return B(F, G, L, X, Le(H));
          var Ie = H(V, X, F, G, L + "." + X, t);
          if (Ie)
            return Ie;
        }
        return null;
      }
      return $(I);
    }
    function k(N) {
      function I(W, U, F, G, L) {
        var V = W[U], z = se(V);
        if (z !== "object")
          return new g("Invalid " + G + " `" + L + "` of type `" + z + "` " + ("supplied to `" + F + "`, expected `object`."));
        var X = n({}, W[U], N);
        for (var H in X) {
          var Ie = N[H];
          if (a(N, H) && typeof Ie != "function")
            return B(F, G, L, H, Le(Ie));
          if (!Ie)
            return new g(
              "Invalid " + G + " `" + L + "` key `" + H + "` supplied to `" + F + "`.\nBad object: " + JSON.stringify(W[U], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(N), null, "  ")
            );
          var j = Ie(V, H, F, G, L + "." + H, t);
          if (j)
            return j;
        }
        return null;
      }
      return $(I);
    }
    function Oe(N) {
      switch (typeof N) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !N;
        case "object":
          if (Array.isArray(N))
            return N.every(Oe);
          if (N === null || u(N))
            return !0;
          var I = h(N);
          if (I) {
            var W = I.call(N), U;
            if (I !== N.entries) {
              for (; !(U = W.next()).done; )
                if (!Oe(U.value))
                  return !1;
            } else
              for (; !(U = W.next()).done; ) {
                var F = U.value;
                if (F && !Oe(F[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function Fe(N, I) {
      return N === "symbol" ? !0 : I ? I["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && I instanceof Symbol : !1;
    }
    function se(N) {
      var I = typeof N;
      return Array.isArray(N) ? "array" : N instanceof RegExp ? "object" : Fe(I, N) ? "symbol" : I;
    }
    function Le(N) {
      if (typeof N > "u" || N === null)
        return "" + N;
      var I = se(N);
      if (I === "object") {
        if (N instanceof Date)
          return "date";
        if (N instanceof RegExp)
          return "regexp";
      }
      return I;
    }
    function Tt(N) {
      var I = Le(N);
      switch (I) {
        case "array":
        case "object":
          return "an " + I;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + I;
        default:
          return I;
      }
    }
    function Hn(N) {
      return !N.constructor || !N.constructor.name ? f : N.constructor.name;
    }
    return m.checkPropTypes = o, m.resetWarningCache = o.resetWarningCache, m.PropTypes = m, m;
  }, $r;
}
var pr, po;
function Au() {
  if (po) return pr;
  po = 1;
  var e = /* @__PURE__ */ Zr();
  function n() {
  }
  function t() {
  }
  return t.resetWarningCache = n, pr = function() {
    function a(l, u, s, c, d, h) {
      if (h !== e) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    a.isRequired = a;
    function o() {
      return a;
    }
    var i = {
      array: a,
      bigint: a,
      bool: a,
      func: a,
      number: a,
      object: a,
      string: a,
      symbol: a,
      any: a,
      arrayOf: o,
      element: a,
      elementType: a,
      instanceOf: o,
      node: a,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: t,
      resetWarningCache: n
    };
    return i.PropTypes = i, i;
  }, pr;
}
var go;
function Ru() {
  if (go) return cn.exports;
  if (go = 1, process.env.NODE_ENV !== "production") {
    var e = hi(), n = !0;
    cn.exports = /* @__PURE__ */ Pu()(e.isElement, n);
  } else
    cn.exports = /* @__PURE__ */ Au()();
  return cn.exports;
}
var Ou = /* @__PURE__ */ Ru();
const A = /* @__PURE__ */ Dn(Ou), Fu = "_tooltip_1fxkz_1", Bu = "_sizeS_1fxkz_130", Mu = "_sizeM_1fxkz_133", Du = "_sizeL_1fxkz_136", un = {
  tooltip: Fu,
  sizeS: Bu,
  sizeM: Mu,
  sizeL: Du
}, tn = {
  TOP: "top",
  BOTTOM: "bottom",
  LEFT: "left",
  RIGHT: "right"
}, yt = {
  S: "small",
  M: "medium",
  L: "large"
}, nn = ({ text: e = "", placement: n = tn.BOTTOM, size: t = yt.M, children: a }) => {
  const o = y(un.tooltip, {
    [un.sizeS]: t === yt.S,
    [un.sizeM]: t === yt.M,
    [un.sizeL]: t === yt.L
  });
  return /* @__PURE__ */ r.jsx("div", { className: o, "data-tooltip": e, "data-tooltip-location": n, children: a });
}, Lu = "_targetLabel_2j1g4_1", Uu = "_containerLabel_2j1g4_14", Vu = "_label_2j1g4_22", Wu = "_labelSpacing_2j1g4_30", Gu = "_labelInputDisabled_2j1g4_36", Dt = {
  targetLabel: Lu,
  containerLabel: Uu,
  label: Vu,
  labelSpacing: Wu,
  labelInputDisabled: Gu
}, mi = ({ label: e, tooltip: n, id: t, disabled: a = !1 }) => {
  const o = y(Dt.label, {
    [Dt.labelInputDisabled]: a
  }), i = /* @__PURE__ */ r.jsx("div", { className: Dt.targetLabel, children: /* @__PURE__ */ r.jsx(Ft, {}) });
  return /* @__PURE__ */ r.jsx("div", { className: Dt.containerLabel, children: /* @__PURE__ */ r.jsx("label", { htmlFor: t, className: o, children: /* @__PURE__ */ r.jsxs("span", { className: Dt.labelSpacing, children: [
    e,
    " ",
    n && /* @__PURE__ */ r.jsx(nn, { placement: tn.TOP, text: n, children: i })
  ] }) }) });
}, zu = "_textareaContainer_7le5x_1", Hu = "_textarea_7le5x_1", vo = {
  textareaContainer: zu,
  textarea: Hu
}, _i = ({ label: e, tooltip: n = "", disabled: t = !1, value: a = "", placeholder: o = "", onChange: i, id: l }) => /* @__PURE__ */ r.jsxs("div", { children: [
  e && /* @__PURE__ */ r.jsx(mi, { id: l, label: e, tooltip: n, disabled: t }),
  /* @__PURE__ */ r.jsx("div", { className: vo.textareaContainer, children: /* @__PURE__ */ r.jsx(
    "textarea",
    {
      rows: 4,
      name: l,
      id: l,
      disabled: t,
      className: vo.textarea,
      onChange: i,
      value: a,
      placeholder: o
    }
  ) })
] });
_i.displayName = "Textarea";
_i.prototypes = {
  label: A.string,
  tooltip: A.string,
  disabled: A.bool,
  value: A.string,
  placeholder: A.string,
  onChange: A.func.prototype,
  id: A.string.isRequired
};
const qu = "_selectContainer_1n9ww_1", Yu = "_select_1n9ww_1", Ku = "_sectionIcon_1n9ww_34", Xu = "_arrowIcon_1n9ww_42", hn = {
  selectContainer: qu,
  select: Yu,
  sectionIcon: Ku,
  arrowIcon: Xu
}, Zu = ({ ref: e, options: n, placeholder: t, label: a, tooltip: o, iconLeft: i, ...l }) => /* @__PURE__ */ r.jsxs("div", { className: hn.selectContainer, children: [
  a && /* @__PURE__ */ r.jsx(mi, { id: l.id, label: a, tooltip: o, disabled: l.disabled }),
  i && /* @__PURE__ */ r.jsx("span", { className: hn.sectionIcon, children: nt.createElement(i) }),
  /* @__PURE__ */ r.jsxs("select", { ...l, ref: e, className: hn.select, children: [
    t && /* @__PURE__ */ r.jsx("option", { value: "", disabled: !0, hidden: !0, children: t }),
    n.map((u, s) => /* @__PURE__ */ r.jsx("option", { ...u, children: u.children }, s))
  ] }),
  /* @__PURE__ */ r.jsx("span", { className: hn.arrowIcon, children: /* @__PURE__ */ r.jsx(rn, {}) })
] }), Ju = "_radioContainer_ka9jl_1", Qu = "_radioElement_ka9jl_8", e0 = "_radioInput_ka9jl_20", t0 = "_radioIcon_ka9jl_38", n0 = "_radioIconInner_ka9jl_57", r0 = "_label_ka9jl_77", _t = {
  radioContainer: Ju,
  radioElement: Qu,
  radioInput: e0,
  radioIcon: t0,
  radioIconInner: n0,
  label: r0
}, $i = ({ label: e, ...n }) => {
  const { id: t, disabled: a } = n;
  return /* @__PURE__ */ r.jsxs("label", { className: _t.radioContainer, children: [
    /* @__PURE__ */ r.jsxs(
      "span",
      {
        className: y(_t.radioElement, {
          [_t.disabled]: a
        }),
        children: [
          /* @__PURE__ */ r.jsx("input", { type: "radio", className: _t.radioInput, ...n }),
          /* @__PURE__ */ r.jsx("span", { className: _t.radioIcon, children: /* @__PURE__ */ r.jsx("span", { className: _t.radioIconInner }) })
        ]
      }
    ),
    e && /* @__PURE__ */ r.jsx("label", { htmlFor: t, className: _t.label, children: e })
  ] });
}, a0 = "_radioGroup_en7v8_1", o0 = {
  radioGroup: a0
}, xo = ({ name: e, options: n, defaultValue: t }) => /* @__PURE__ */ r.jsx("fieldset", { className: o0.radioGroup, children: n.map((a, o) => /* @__PURE__ */ r.jsx(
  $i,
  {
    id: a.id || `${e}-${o}`,
    name: e,
    value: a.value,
    label: a.label,
    defaultChecked: a.value === t
  },
  a.id || `${e}-${o}`
)) }), i0 = "_container_spg2h_1", s0 = "_slideContainer_spg2h_8", l0 = "_focus_spg2h_19", c0 = "_unfocus_spg2h_23", d0 = "_containerButton_spg2h_27", u0 = "_button_spg2h_40", h0 = "_buttonFocus_spg2h_55", at = {
  container: i0,
  slideContainer: s0,
  focus: l0,
  unfocus: c0,
  containerButton: d0,
  button: u0,
  buttonFocus: h0
}, i7 = ({ slides: e, delay: n = 5e3 }) => {
  const [t, a] = R(0), o = y(at.buttonFocus, at.opacity), i = () => t === e.length - 1 ? a(0) : a(t + 1);
  return fe(() => {
    const l = setTimeout(() => {
      i();
    }, n);
    return () => {
      clearTimeout(l);
    };
  }, [t]), /* @__PURE__ */ r.jsxs("div", { className: at.container, children: [
    e.map((l, u) => {
      const s = [at.slideContainer, u === t && at.focus].filter(Boolean).join(" ");
      return /* @__PURE__ */ r.jsx("div", { className: s, children: /* @__PURE__ */ r.jsx(l, {}) }, u);
    }),
    /* @__PURE__ */ r.jsx("div", { className: at.containerButton, children: e.map((l, u) => {
      const s = [at.button, u === t ? o : at.unfocus].filter(Boolean).join(" ");
      return /* @__PURE__ */ r.jsx("button", { className: s, onClick: () => a(u) }, u);
    }) })
  ] });
}, f0 = "_container_164ri_1", m0 = "_inner_164ri_9", Lt = {
  container: f0,
  inner: m0,
  "mb-s": "_mb-s_164ri_15",
  "mb-m": "_mb-m_164ri_19",
  "mb-l": "_mb-l_164ri_23",
  "mb-xl": "_mb-xl_164ri_27",
  "mb-xxl": "_mb-xxl_164ri_31",
  "gap-xs": "_gap-xs_164ri_37",
  "gap-s": "_gap-s_164ri_41",
  "gap-m": "_gap-m_164ri_45",
  "gap-l": "_gap-l_164ri_49",
  "gap-xl": "_gap-xl_164ri_53",
  "gap-xxl": "_gap-xxl_164ri_57"
}, _0 = {
  s: "mb-s",
  m: "mb-m",
  l: "mb-l",
  xl: "mb-xl",
  xxl: "mb-xxl"
}, $0 = {
  xs: "gap-xs",
  s: "gap-s",
  m: "gap-m",
  l: "gap-l",
  xl: "gap-xl",
  xxl: "gap-xxl"
}, s7 = ({ children: e, grid: n, gap: t = "m", mb: a, inner: o, maxWidth: i }) => {
  const l = n ? { gridTemplateColumns: `repeat(${n}, 1fr)` } : {}, u = a ? Lt[_0[a]] : "", s = t ? Lt[$0[t]] : "", c = i ? { maxWidth: `${i}px` } : {}, d = y(Lt.container, Lt.grid, u, s, {
    [Lt.inner]: o
  });
  return /* @__PURE__ */ r.jsx("div", { className: d, style: { ...l, ...c }, children: e });
}, p0 = "_barBg_tldhh_1", g0 = "_title_tldhh_9", v0 = "_textBottom_tldhh_13", x0 = "_percentCompleted_tldhh_17", b0 = "_linkBottom_tldhh_21", y0 = "_barFill_tldhh_30", C0 = "_star_tldhh_37", N0 = "_tooltip_tldhh_44", Qe = {
  barBg: p0,
  title: g0,
  textBottom: v0,
  percentCompleted: x0,
  linkBottom: b0,
  barFill: y0,
  star: C0,
  tooltip: N0
}, l7 = ({
  title: e,
  titleCompleted: n,
  textBottomBefore: t,
  textLink: a,
  link: o,
  tooltip: i,
  courseCompleted: l
}) => /* @__PURE__ */ r.jsxs("div", { className: Qe.container, children: [
  /* @__PURE__ */ r.jsxs("div", { className: Qe.title, children: [
    l >= 100 ? /* @__PURE__ */ r.jsx("span", { children: n }) : /* @__PURE__ */ r.jsxs("span", { children: [
      /* @__PURE__ */ r.jsxs("span", { className: Qe.percentCompleted, children: [
        l,
        "%"
      ] }),
      " ",
      e
    ] }),
    /* @__PURE__ */ r.jsx("div", { className: Qe.tooltip, children: /* @__PURE__ */ r.jsx(nn, { text: i, children: /* @__PURE__ */ r.jsx(Ft, {}) }) })
  ] }),
  /* @__PURE__ */ r.jsxs("div", { className: Qe.barBg, children: [
    /* @__PURE__ */ r.jsx("div", { className: Qe.barFill, style: { width: `${l}%` } }),
    /* @__PURE__ */ r.jsx("div", { className: Qe.star, children: l >= 90 ? /* @__PURE__ */ r.jsx(Fi, {}) : /* @__PURE__ */ r.jsx(Bi, {}) }),
    l >= 90 && /* @__PURE__ */ r.jsxs("p", { className: Qe.textBottom, children: [
      t,
      " ",
      /* @__PURE__ */ r.jsx("a", { className: Qe.linkBottom, href: o, children: a }),
      "."
    ] })
  ] })
] }), ze = {
  PRIMARY: "primary",
  ACCENT: "accent",
  RED: "red",
  GREEN: "green"
}, bo = {
  SOLID: "solid",
  OUTLINE: "outline"
}, j0 = "_tag_130ks_1", w0 = "_bgPrimary_130ks_14", I0 = "_bgAccent_130ks_19", T0 = "_bgGreen_130ks_24", S0 = "_bgRed_130ks_29", E0 = "_outline_130ks_34", k0 = "_iconClose_130ks_41", $t = {
  tag: j0,
  bgPrimary: w0,
  bgAccent: I0,
  bgGreen: T0,
  bgRed: S0,
  outline: E0,
  iconClose: k0
}, On = ({
  children: e,
  color: n = ze.PRIMARY,
  type: t = bo.SOLID,
  iconClose: a = !1,
  onClickClose: o = () => {
  }
}) => {
  const i = y($t.tag, {
    [$t.bgPrimary]: n === ze.PRIMARY,
    [$t.bgAccent]: n === ze.ACCENT,
    [$t.bgGreen]: n === ze.GREEN,
    [$t.bgRed]: n === ze.RED,
    [$t.outline]: t === bo.OUTLINE
  });
  return /* @__PURE__ */ r.jsxs("div", { className: i, children: [
    e,
    a && /* @__PURE__ */ r.jsx("span", { className: $t.iconClose, onClick: o, children: "X" })
  ] });
}, pt = {
  PRIMARY: "primary",
  SUCCESS: "success",
  ERROR: "error"
}, P0 = "_container_1dp13_1", A0 = "_content_1dp13_10", R0 = "_icon_1dp13_15", O0 = "_contentText_1dp13_21", F0 = "_title_1dp13_27", B0 = "_text_1dp13_34", M0 = "_contentXIcon_1dp13_41", D0 = "_iconXCircle_1dp13_46", L0 = "_typePrimary_1dp13_52", U0 = "_typeSuccess_1dp13_57", V0 = "_typeError_1dp13_62", Ue = {
  container: P0,
  content: A0,
  icon: R0,
  contentText: O0,
  title: F0,
  text: B0,
  contentXIcon: M0,
  iconXCircle: D0,
  typePrimary: L0,
  typeSuccess: U0,
  typeError: V0
}, c7 = ({ type: e = pt.PRIMARY, title: n, text: t, onClose: a }) => {
  const o = {
    [pt.PRIMARY]: Ue.typePrimary,
    [pt.SUCCESS]: Ue.typeSuccess,
    [pt.ERROR]: Ue.typeError
  }, i = {
    [pt.PRIMARY]: /* @__PURE__ */ r.jsx(Ft, {}),
    [pt.SUCCESS]: /* @__PURE__ */ r.jsx(Mo, {}),
    [pt.ERROR]: /* @__PURE__ */ r.jsx(Ln, {})
  };
  return /* @__PURE__ */ r.jsx("div", { className: y(Ue.container, o[e]), children: /* @__PURE__ */ r.jsxs("div", { className: Ue.content, children: [
    /* @__PURE__ */ r.jsx("div", { className: Ue.icon, children: i[e] }),
    /* @__PURE__ */ r.jsxs("div", { className: Ue.contentText, children: [
      /* @__PURE__ */ r.jsx("p", { className: Ue.title, children: n }),
      /* @__PURE__ */ r.jsx("p", { className: Ue.text, children: t })
    ] }),
    /* @__PURE__ */ r.jsx("div", { className: Ue.contentXIcon, onClick: a, children: /* @__PURE__ */ r.jsx("div", { className: Ue.iconXCircle, children: /* @__PURE__ */ r.jsx(an, {}) }) })
  ] }) });
}, W0 = "_container_15x4t_1", G0 = "_account_15x4t_13", z0 = "_icon_15x4t_23", H0 = "_success_15x4t_29", fn = {
  container: W0,
  account: G0,
  icon: z0,
  success: H0
}, sn = ({
  url: e,
  account: n,
  truncate: t = 8,
  onCopy: a = () => {
  },
  copyIcon: o = Gi,
  successIcon: i = Uo
}) => {
  const [l, u] = R(!1), s = n ? n.length : 0, c = t >= s / 2 ? n : `${n.slice(0, t)}...${n.slice(s - t, s)}`, d = () => {
    navigator.clipboard.writeText(n), u(!0), a(), setTimeout(() => {
      u(!1);
    }, 1e4);
  };
  return /* @__PURE__ */ r.jsxs("div", { className: fn.container, onClick: d, children: [
    /* @__PURE__ */ r.jsx("div", { className: fn.account, children: e ? /* @__PURE__ */ r.jsx("a", { href: e, target: "_blank", rel: "noopener noreferrer", children: c }) : c }),
    /* @__PURE__ */ r.jsx(
      "div",
      {
        className: y(fn.icon, {
          [fn.success]: l
        }),
        children: l ? i() : o()
      }
    )
  ] });
};
sn.displayName = "AddressBox";
sn.propTypes = {
  truncate: A.number,
  account: A.string.isRequired
};
const q0 = "_container_13qcl_1", Y0 = "_label_13qcl_13", K0 = "_timestamp_13qcl_20", X0 = "_icon_13qcl_28", mn = {
  container: q0,
  label: Y0,
  timestamp: K0,
  icon: X0
}, Z0 = ({ label: e, timestamp: n, url: t, withTimestamp: a = !1, icon: o }) => {
  const l = new Date(n).toLocaleString("es-ES", { hour12: !1 });
  return /* @__PURE__ */ r.jsxs("a", { className: mn.container, href: t, target: "_blank", rel: "noopener noreferrer", children: [
    /* @__PURE__ */ r.jsxs("div", { children: [
      /* @__PURE__ */ r.jsx("p", { className: mn.label, children: e }),
      a && /* @__PURE__ */ r.jsx("p", { className: mn.timestamp, children: l })
    ] }),
    o && /* @__PURE__ */ r.jsx("div", { className: mn.icon, children: /* @__PURE__ */ r.jsx(o, {}) })
  ] });
}, J0 = "_container_ttmgv_1", Q0 = "_containerContent_ttmgv_5", e2 = "_title_ttmgv_18", t2 = "_arrow_ttmgv_24", n2 = "_rotateArrow_ttmgv_34", r2 = "_text_ttmgv_38", kt = {
  container: J0,
  containerContent: Q0,
  title: e2,
  arrow: t2,
  rotateArrow: n2,
  text: r2
}, d7 = ({ title: e, text: n }) => {
  const [t, a] = R(!1), o = y(kt.arrow, {
    [kt.rotateArrow]: t
  });
  return /* @__PURE__ */ r.jsxs("div", { className: kt.container, children: [
    /* @__PURE__ */ r.jsxs("div", { className: kt.containerContent, onClick: () => a(!t), children: [
      /* @__PURE__ */ r.jsx("div", { className: kt.title, children: e }),
      /* @__PURE__ */ r.jsx("div", { className: o, children: /* @__PURE__ */ r.jsx(Zt, {}) })
    ] }),
    t && /* @__PURE__ */ r.jsx("p", { className: kt.text, dangerouslySetInnerHTML: { __html: n } })
  ] });
}, a2 = "_container_uh5t2_1", o2 = "_label_uh5t2_5", i2 = "_title_uh5t2_16", s2 = "_description_uh5t2_26", l2 = "_icon_uh5t2_31", c2 = "_background_uh5t2_42", d2 = "_current_uh5t2_51", u2 = "_labelIconSubExternal_uh5t2_61", h2 = "_backButton_uh5t2_93", Ke = {
  container: a2,
  label: o2,
  title: i2,
  description: s2,
  icon: l2,
  background: c2,
  current: d2,
  labelIconSubExternal: u2,
  backButton: h2
}, pi = ({
  menu: e,
  currentRoute: n,
  isCollapsable: t = !1,
  isOpen: a = !1,
  returnText: o = "Volver",
  onRouteChange: i = (l) => l
}) => {
  const [l, u] = R(null), s = ({ icon: c, label: d, url: h, onClick: f, index: m, description: _, subitems: g = [] }) => {
    const $ = a || !t, x = g.length > 0, b = n === h, C = h?.startsWith("http"), p = () => {
      x ? u(m) : (f && f(), h && i(h));
    };
    return /* @__PURE__ */ r.jsxs("div", { className: y(Ke.label, { [Ke.current]: b }), onClick: p, children: [
      /* @__PURE__ */ r.jsxs("span", { className: Ke.title, children: [
        /* @__PURE__ */ r.jsx("span", { className: Ke.icon, children: /* @__PURE__ */ r.jsx(c, {}) }),
        $ && /* @__PURE__ */ r.jsx("span", { className: Ke.labelText, children: d }),
        C && $ && /* @__PURE__ */ r.jsx("span", { className: Ke.labelIconSubExternal, children: /* @__PURE__ */ r.jsx(Tr, {}) })
      ] }),
      _ && /* @__PURE__ */ r.jsx("div", { className: Ke.description, children: _ })
    ] });
  };
  return /* @__PURE__ */ r.jsx("div", { className: Ke.container, children: /* @__PURE__ */ r.jsx("div", { className: Ke.background, children: l === null ? /* @__PURE__ */ r.jsx(r.Fragment, { children: e.map((c, d) => {
    const h = c.items || [];
    return /* @__PURE__ */ r.jsx(s, { index: d, subitems: h, ...c }, d);
  }) }) : /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsxs("div", { className: Ke.backButton, onClick: () => u(null), children: [
      /* @__PURE__ */ r.jsx(Wr, {}),
      o
    ] }),
    e[l].items.map((c, d) => /* @__PURE__ */ r.jsx(s, { ...c }, d))
  ] }) }) });
}, f2 = "_nav_myass_1", m2 = "_transparent_myass_13", _2 = "_block_myass_17", $2 = "_active_myass_21", p2 = "_item_myass_21", g2 = "_link_myass_35", v2 = "_content_myass_39", x2 = "_hover_myass_43", b2 = "_contentGrid_myass_65", y2 = "_iconBig_myass_81", C2 = "_iconSm_myass_88", N2 = "_description_myass_95", j2 = "_options_myass_103", w2 = "_descriptionTitle_myass_109", I2 = "_descriptionText_myass_116", T2 = "_linkContent_myass_121", S2 = "_linkContentText_myass_129", E2 = "_linkContentTitle_myass_136", k2 = "_linkContentDescription_myass_146", P2 = "_current_myass_156", A2 = "_labelIconSubExternal_myass_167", R2 = "_hide_myass_172", te = {
  nav: f2,
  transparent: m2,
  block: _2,
  active: $2,
  item: p2,
  link: g2,
  content: v2,
  hover: x2,
  contentGrid: b2,
  iconBig: y2,
  iconSm: C2,
  description: N2,
  options: j2,
  descriptionTitle: w2,
  descriptionText: I2,
  linkContent: T2,
  linkContentText: S2,
  linkContentTitle: E2,
  linkContentDescription: k2,
  current: P2,
  labelIconSubExternal: A2,
  hide: R2
}, O2 = ({ icon: e }) => /* @__PURE__ */ r.jsx("div", { className: te.iconSm, children: /* @__PURE__ */ r.jsx(e, {}) }), F2 = ({ icon: e }) => /* @__PURE__ */ r.jsx("div", { className: te.iconBig, children: /* @__PURE__ */ r.jsx(e, {}) }), yo = (e) => e?.toString().includes("_blank") || !1, u7 = ({
  menu: e,
  currentRoute: n,
  onRouteChange: t = () => {
  },
  transparent: a
}) => {
  const [o, i] = R(null), [l, u] = R(!1), s = Nt(
    (d) => {
      d.onClick && d.onClick(), d.url && t(d.url), u(!0), setTimeout(() => u(!1), 100);
    },
    [t]
  ), c = ht(
    () => (d) => /* @__PURE__ */ r.jsx("div", { className: te.options, children: d.map((h, f) => /* @__PURE__ */ r.jsxs(
      "div",
      {
        className: y(te.linkContent, {
          [te.current]: n === h.url
        }),
        onClick: () => s(h),
        children: [
          /* @__PURE__ */ r.jsx(O2, { icon: h.icon }),
          /* @__PURE__ */ r.jsxs(
            "div",
            {
              className: y(te.linkContentText, {
                [te.current]: n === h.url
              }),
              children: [
                /* @__PURE__ */ r.jsxs("span", { className: te.linkContentTitle, children: [
                  h.label,
                  yo(h.onClick) && /* @__PURE__ */ r.jsx("div", { className: te.labelIconSubExternal, children: /* @__PURE__ */ r.jsx(Tr, {}) }),
                  h.tag && /* @__PURE__ */ r.jsx("div", { className: te.tag, children: /* @__PURE__ */ r.jsx(On, { color: ze.RED, children: h.tag }) })
                ] }),
                /* @__PURE__ */ r.jsx("span", { className: te.linkContentDescription, children: h.description })
              ]
            }
          )
        ]
      },
      f
    )) }),
    [n, s]
  );
  return /* @__PURE__ */ r.jsx("nav", { className: y(te.nav, { [te.transparent]: a }), children: e.map((d, h) => {
    const f = n === d.url, m = d.items?.some((_) => n === _.url);
    return /* @__PURE__ */ r.jsxs("div", { className: y(te.block, { [te.active]: o === h }), children: [
      /* @__PURE__ */ r.jsx(
        "div",
        {
          className: y(te.hover, {
            [te.link]: d.url || d.onClick,
            [te.current]: f || m
          }),
          onMouseEnter: () => i(h),
          onMouseLeave: () => i(null),
          onClick: () => s(d),
          children: /* @__PURE__ */ r.jsxs("span", { className: te.item, children: [
            d.label,
            yo(d.onClick) && /* @__PURE__ */ r.jsx("div", { className: te.labelIconSubExternal, children: /* @__PURE__ */ r.jsx(Tr, {}) }),
            d.tag && /* @__PURE__ */ r.jsx("div", { className: te.tag, children: /* @__PURE__ */ r.jsx(On, { color: ze.RED, children: d.tag }) })
          ] })
        }
      ),
      d.items && /* @__PURE__ */ r.jsx(
        "div",
        {
          className: y(te.content, { [te.hide]: l }),
          onMouseEnter: () => i(h),
          onMouseLeave: () => i(null),
          children: /* @__PURE__ */ r.jsxs("div", { className: te.contentGrid, children: [
            d.label && d.description && d.icon && /* @__PURE__ */ r.jsxs("div", { className: te.description, children: [
              /* @__PURE__ */ r.jsx("span", { className: te.descriptionTitle, children: d.label }),
              /* @__PURE__ */ r.jsx("span", { className: te.descriptionText, children: d.description }),
              /* @__PURE__ */ r.jsx(F2, { icon: d.icon })
            ] }),
            c(d.items)
          ] })
        }
      )
    ] }, h);
  }) });
}, B2 = {
  s: "size-s",
  m: "size-m",
  l: "size-l",
  xl: "size-xl",
  "2xl": "size-2xl",
  "3xl": "size-3xl",
  "4xl": "size-4xl",
  "5xl": "size-5xl"
}, M2 = "_spinner_15xym_3", D2 = "_spin_15xym_3", Co = {
  spinner: M2,
  spin: D2,
  "size-xs": "_size-xs_15xym_17",
  "size-s": "_size-s_15xym_22",
  "size-m": "_size-m_15xym_27",
  "size-l": "_size-l_15xym_32",
  "size-xl": "_size-xl_15xym_37",
  "size-2xl": "_size-2xl_15xym_42",
  "size-3xl": "_size-3xl_15xym_47",
  "size-4xl": "_size-4xl_15xym_52",
  "size-5xl": "_size-5xl_15xym_57"
}, L2 = ({ size: e = "l" }) => {
  const n = y(Co.spinner, Co[B2[e]]);
  return /* @__PURE__ */ r.jsx("span", { className: n, children: /* @__PURE__ */ r.jsx(js, {}) });
}, U2 = Ai(null), gr = {
  didCatch: !1,
  error: null
};
let V2 = class extends Pi {
  constructor(n) {
    super(n), this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.state = gr;
  }
  static getDerivedStateFromError(n) {
    return {
      didCatch: !0,
      error: n
    };
  }
  resetErrorBoundary() {
    const {
      error: n
    } = this.state;
    if (n !== null) {
      for (var t, a, o = arguments.length, i = new Array(o), l = 0; l < o; l++)
        i[l] = arguments[l];
      (t = (a = this.props).onReset) === null || t === void 0 || t.call(a, {
        args: i,
        reason: "imperative-api"
      }), this.setState(gr);
    }
  }
  componentDidCatch(n, t) {
    var a, o;
    (a = (o = this.props).onError) === null || a === void 0 || a.call(o, n, t);
  }
  componentDidUpdate(n, t) {
    const {
      didCatch: a
    } = this.state, {
      resetKeys: o
    } = this.props;
    if (a && t.error !== null && W2(n.resetKeys, o)) {
      var i, l;
      (i = (l = this.props).onReset) === null || i === void 0 || i.call(l, {
        next: o,
        prev: n.resetKeys,
        reason: "keys"
      }), this.setState(gr);
    }
  }
  render() {
    const {
      children: n,
      fallbackRender: t,
      FallbackComponent: a,
      fallback: o
    } = this.props, {
      didCatch: i,
      error: l
    } = this.state;
    let u = n;
    if (i) {
      const s = {
        error: l,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (typeof t == "function")
        u = t(s);
      else if (a)
        u = Ir(a, s);
      else if (o !== void 0)
        u = o;
      else
        throw l;
    }
    return Ir(U2.Provider, {
      value: {
        didCatch: i,
        error: l,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, u);
  }
};
function W2() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return e.length !== n.length || e.some((t, a) => !Object.is(t, n[a]));
}
const G2 = "_container_t88q5_1", z2 = "_title_t88q5_16", H2 = "_icon_t88q5_23", q2 = "_heading_t88q5_29", _n = {
  container: G2,
  title: z2,
  icon: H2,
  heading: q2
}, f7 = ({
  icon: e,
  onError: n,
  errorMessage: t,
  children: a,
  onReset: o,
  componentName: i = "Component error",
  cta: l = "try again"
}) => {
  const u = ({ resetErrorBoundary: s }) => /* @__PURE__ */ r.jsxs("div", { role: "alert", className: _n.container, children: [
    /* @__PURE__ */ r.jsxs("div", { className: _n.heading, children: [
      /* @__PURE__ */ r.jsx("span", { className: _n.icon, children: e || /* @__PURE__ */ r.jsx(Ln, {}) }),
      /* @__PURE__ */ r.jsxs("h2", { className: _n.title, children: [
        i,
        ":"
      ] })
    ] }),
    /* @__PURE__ */ r.jsx("p", { children: t || "An error has occurred" }),
    /* @__PURE__ */ r.jsx(E, { type: ne.OUTLINE, onClick: s, children: l })
  ] });
  return /* @__PURE__ */ r.jsx(
    V2,
    {
      onReset: o,
      FallbackComponent: u,
      onError: n,
      errorMessage: t,
      children: a
    }
  );
}, Y2 = "_container_fm8el_1", K2 = "_background_fm8el_10", X2 = "_labelTitle_fm8el_23", Z2 = "_submenuOpen_fm8el_45", J2 = "_submenuNotOpen_fm8el_53", Q2 = "_sectionHeader_fm8el_81", eh = "_toggleIcon_fm8el_87", th = "_rotate_fm8el_104", et = {
  container: Y2,
  background: K2,
  labelTitle: X2,
  submenuOpen: Z2,
  submenuNotOpen: J2,
  sectionHeader: Q2,
  toggleIcon: eh,
  rotate: th
}, m7 = ({ menu: e, currentRoute: n, isCollapsable: t = !1, onRouteChange: a = () => {
} }) => {
  const [o, i] = R([]), l = (s) => {
    const [...c] = o;
    c.includes(s) ? i(c.filter((d) => d !== s)) : (c.push(s), i(c));
  }, u = ({ text: s, index: c, isSectionOpen: d }) => /* @__PURE__ */ r.jsxs("div", { className: y(et.labelTitle, et.sectionHeader), onClick: () => l(c), children: [
    /* @__PURE__ */ r.jsx("div", { children: s }),
    /* @__PURE__ */ r.jsx(
      "div",
      {
        className: y(et.toggleIcon, {
          [et.rotate]: d
        }),
        children: /* @__PURE__ */ r.jsx(Zt, {})
      }
    )
  ] });
  return /* @__PURE__ */ r.jsx("div", { className: et.container, children: /* @__PURE__ */ r.jsx("div", { className: et.background, children: e.map((s, c) => {
    const d = s.items || [], h = o.includes(c);
    return /* @__PURE__ */ r.jsx("div", { children: t ? /* @__PURE__ */ r.jsx(r.Fragment, { children: /* @__PURE__ */ r.jsx(xo, { options: d, value: n, onChange: (f) => a(f.target.value) }) }) : /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
      /* @__PURE__ */ r.jsx(u, { ...s, index: c, isSectionOpen: h }),
      /* @__PURE__ */ r.jsx(
        "div",
        {
          className: y(et.submenu, {
            [et.submenuNotOpen]: !h,
            [et.submenuOpen]: h
          }),
          children: /* @__PURE__ */ r.jsx(
            xo,
            {
              options: d,
              value: n,
              onChange: (f) => a(f.target.value)
            }
          )
        }
      )
    ] }) }, c);
  }) }) });
}, nh = "_container_1w2in_1", rh = "_list_1w2in_8", ah = "_checkbox_1w2in_17", oh = "_checkboxInput_1w2in_22", ih = "_checkboxLabel_1w2in_27", Ut = {
  container: nh,
  list: rh,
  checkbox: ah,
  checkboxInput: oh,
  checkboxLabel: ih
}, _7 = ({ disabled: e, onChange: n = () => {
}, id: t = "", options: a = [] }) => /* @__PURE__ */ r.jsx("div", { className: Ut.container, children: /* @__PURE__ */ r.jsx("div", { className: Ut.list, children: a.map((o, i) => /* @__PURE__ */ r.jsxs("div", { className: Ut.checkbox, children: [
  /* @__PURE__ */ r.jsx(
    "input",
    {
      onChange: n,
      value: o.value,
      disabled: e,
      id: `${t}-${o.value}`,
      type: "checkbox",
      className: Ut.checkboxInput
    }
  ),
  /* @__PURE__ */ r.jsx("label", { htmlFor: `${t}-${o.value}`, className: Ut.checkboxLabel, children: o.text })
] }, i)) }) }), sh = ({ id: e }) => {
  const n = `
    <iframe
      src="https://www.googletagmanager.com/ns.html?id=${e}"
      height="0"
      width="0"
      style="display:none;visibility:hidden"
    >
    </iframe>
  `;
  return /* @__PURE__ */ r.jsx("noscript", { dangerouslySetInnerHTML: { __html: n } });
};
sh.propTypes = {
  id: A.string.isRequired
};
const lh = ({ id: e }) => {
  const n = `https://www.googletagmanager.com/gtm.js?id=${e}&gtm_cookies_win=x`, t = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){
      dataLayer.push(arguments);
    };
    gtag('js', new Date());
    gtag('config', '${e}', {
      'anonymize_ip': true,
      'cookie_expires': 0,
      'cookie_flags': 'max-age=0;secure;samesite=none',
    });
    gtag('consent', 'default', {
      'ad_storage': 'denied',
      'analytics_storage': 'denied',
      'functionality_storage': 'denied',
      'security_storage': 'denied',
    });
  `;
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx("script", { async: !0, src: n }),
    /* @__PURE__ */ r.jsx("script", { dangerouslySetInnerHTML: { __html: t } })
  ] });
};
lh.propTypes = {
  id: A.string.isRequired
};
const ch = ({ events: e }) => (fe(() => {
  const n = (t) => {
    window.dataLayer = window.dataLayer || [], window.dataLayer.push({
      event: "pageview",
      page: t,
      title: document.title
    });
  };
  return e.on("routeChangeComplete", n), () => {
    e.off("routeChangeComplete", n);
  };
}, [e]), null);
ch.propTypes = {
  events: A.shape({
    on: A.func.isRequired,
    off: A.func.isRequired
  }).isRequired
};
const dh = "_container_18vp3_1", uh = {
  container: dh
}, $7 = ({ children: e }) => /* @__PURE__ */ r.jsx("div", { className: uh.container, children: e }), hh = "_tabContainer_ie28l_1", fh = "_indicator_ie28l_10", No = {
  tabContainer: hh,
  indicator: fh
}, p7 = ({ children: e }) => {
  const [n, t] = R(0), a = Nt(
    (o) => {
      t(o);
    },
    [t]
  );
  return fe(() => {
    const i = nt.Children.toArray(e).findIndex((l) => {
      const u = nt.isValidElement(l) && l.props.children, s = nt.isValidElement(u) ? u : l;
      return s.props.checked ?? s.props.defaultChecked;
    });
    i >= 0 && t(i);
  }, [e]), /* @__PURE__ */ r.jsxs("div", { className: No.tabContainer, role: "tablist", children: [
    nt.Children.map(
      e,
      (o, i) => nt.cloneElement(o, {
        onClick: () => a(i)
      })
    ),
    /* @__PURE__ */ r.jsx(
      "span",
      {
        className: No.indicator,
        style: {
          width: `${100 / nt.Children.count(e)}%`,
          transform: `translateX(${n * 100}%)`
        }
      }
    )
  ] });
}, mh = "_tabLabel_r0why_1", vr = {
  tabLabel: mh
}, g7 = ({ label: e, ...n }) => {
  const t = n.id ?? n.value?.toString();
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx("input", { id: t, type: "radio", className: y(vr.tab), hidden: !0, ...n }),
    /* @__PURE__ */ r.jsx(
      "label",
      {
        className: y(vr.tabLabel, {
          [vr.active]: n.checked
        }),
        htmlFor: t,
        role: "tab",
        "aria-selected": n.checked,
        children: e
      }
    )
  ] });
}, _h = "_tableContainer_1adqb_1", $h = "_table_1adqb_1", ph = "_standard_1adqb_1", gh = "_card_1adqb_1", vh = "_tbody_1adqb_1", xh = "_trow_1adqb_1", bh = "_thead_1adqb_1", yh = "_caption_1adqb_1", Ch = "_top_1adqb_1", Nh = "_bottom_1adqb_1", jh = "_tcell_1adqb_1", wh = "_tcellContainer_1adqb_1", Ih = "_tcellContent_1adqb_1", Th = "_tcol_1adqb_1", Sh = "_tcolgroup_1adqb_1", Eh = "_tfoot_1adqb_1", kh = "_collapseTrigger_1adqb_1", Ph = "_collapsibleContentInner_1adqb_1", Ah = "_collapsibleContentWrapper_1adqb_1", Rh = "_collapsibleContentVisible_1adqb_1", Oh = "_expanded_1adqb_1", Fh = "_clickable_1adqb_1", Bh = "_collapseText_1adqb_1", Mh = "_collapseContent_1adqb_1", Dh = "_fadeInContent_1adqb_1", q = {
  tableContainer: _h,
  table: $h,
  standard: ph,
  card: gh,
  tbody: vh,
  trow: xh,
  thead: bh,
  caption: yh,
  top: Ch,
  bottom: Nh,
  tcell: jh,
  tcellContainer: wh,
  tcellContent: Ih,
  "vertical-top": "_vertical-top_1adqb_1",
  "vertical-middle": "_vertical-middle_1adqb_1",
  "vertical-bottom": "_vertical-bottom_1adqb_1",
  tcol: Th,
  tcolgroup: Sh,
  tfoot: Eh,
  collapseTrigger: kh,
  collapsibleContentInner: Ph,
  collapsibleContentWrapper: Ah,
  collapsibleContentVisible: Rh,
  expanded: Oh,
  clickable: Fh,
  collapseText: Bh,
  collapseContent: Mh,
  fadeInContent: Dh
}, Dr = {
  STANDARD: "standard",
  CARD: "card"
}, Lh = {
  [Dr.CARD]: q.card,
  [Dr.STANDARD]: q.standard
}, Uh = ({ children: e, variant: n = Dr.STANDARD, className: t }) => {
  const a = y(q.tableContainer, t, Lh[n]);
  return /* @__PURE__ */ r.jsx("div", { className: a, children: /* @__PURE__ */ r.jsx("table", { className: q.table, children: e }) });
}, Vh = ({ children: e, captionSide: n = "top" }) => {
  if (!e) return null;
  const t = y(q.caption, q[n]);
  return /* @__PURE__ */ r.jsx("caption", { className: t, children: e });
}, Wh = ({ children: e }) => /* @__PURE__ */ r.jsx("tbody", { className: q.tbody, children: e }), Gh = {
  big: "big",
  small: "small",
  medium: "medium"
}, zh = {
  top: "vertical-top",
  middle: "vertical-middle",
  bottom: "vertical-bottom"
}, gt = ({
  size: e = "medium",
  valign: n = "middle",
  expandButton: t = !1,
  children: a,
  ...o
}) => {
  const i = y(q.tcell, q[Gh[e]], q[zh[n]], {
    [q.expandButton]: t
  });
  return /* @__PURE__ */ r.jsx("td", { className: i, ...o, children: a });
}, v7 = ({ children: e, className: n, ...t }) => {
  const a = y(q.tfoot, n);
  return /* @__PURE__ */ r.jsx("footer", { className: a, ...t, children: e });
}, kn = {
  TEXT: "text",
  PRIMARY: "primary",
  ACCENT: "accent"
}, Lr = {
  DEFAULT: "default",
  CARD: "card"
}, Hh = {
  [kn.TEXT]: q.colorText,
  [kn.PRIMARY]: q.colorPrimary,
  [kn.ACCENT]: q.colorAccent
}, qh = {
  [Lr.DEFAULT]: q.variantDefault,
  [Lr.CARD]: q.variantCard
}, Yh = ({
  children: e,
  mobile: n,
  color: t = kn.TEXT,
  border: a,
  variant: o = Lr.DEFAULT
}) => {
  const i = y(
    q.thead,
    { [q.mobile]: n, [q.border]: a },
    Hh[t],
    qh[o]
  );
  return /* @__PURE__ */ r.jsx("thead", { className: i, children: e });
}, $n = ({
  children: e,
  collapsibleContent: n,
  isCollapsible: t = !1,
  columnsNumber: a,
  defaultExpanded: o = !1,
  onClick: i
}) => {
  const [l, u] = R(o), s = Ee(null), [c, d] = R(0);
  fe(() => {
    if (s.current) {
      const f = () => {
        s.current && d(s.current.scrollHeight);
      };
      f();
      const m = new ResizeObserver(f), _ = s.current;
      return m.observe(_), () => {
        _ && m.unobserve(_);
      };
    }
  }, [n, l]);
  const h = (f) => {
    if (i && i(f), t) {
      const m = f.target;
      if (["BUTTON", "A", "INPUT", "SELECT", "TEXTAREA", "LABEL"].includes(m.tagName) || m.closest("button, a, input, select, textarea, label"))
        return;
      u((g) => !g);
    }
  };
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx(
      "tr",
      {
        className: y(q.trow, {
          [q.collapseTrigger]: t,
          [q.clickable]: !!i,
          [q.expanded]: t && l
        }),
        onClick: h,
        children: e
      }
    ),
    t && n && /* @__PURE__ */ r.jsx("tr", { className: y(q.trow, q.collapseContent), children: /* @__PURE__ */ r.jsx("td", { className: q.collapseContentTd, colSpan: a ?? 100, children: /* @__PURE__ */ r.jsx(
      "div",
      {
        className: y(q.collapsibleContentWrapper, {
          [q.collapsibleContentVisible]: l
        }),
        style: {
          "--content-height": `${c}px`
        },
        children: /* @__PURE__ */ r.jsx("div", { ref: s, className: q.collapsibleContentInner, children: n })
      }
    ) }) })
  ] });
}, x7 = ({ children: e, className: n, ...t }) => {
  const a = y(q.tcol, n);
  return /* @__PURE__ */ r.jsx("col", { className: a, ...t, children: e });
}, b7 = ({ children: e, className: n, ...t }) => {
  const a = y(q.tcolgroup, n);
  return /* @__PURE__ */ r.jsx("colgroup", { className: a, ...t, children: e });
}, Kh = "_card_8bjl2_1", ot = {
  card: Kh,
  "flex-row": "_flex-row_8bjl2_9",
  "flex-col": "_flex-col_8bjl2_14",
  "bg-background": "_bg-background_8bjl2_19",
  "bg-surface": "_bg-surface_8bjl2_23",
  "bg-surface-2": "_bg-surface-2_8bjl2_27",
  "bg-surface-3": "_bg-surface-3_8bjl2_31",
  "padding-m": "_padding-m_8bjl2_35",
  "padding-s": "_padding-s_8bjl2_39",
  "border-primary": "_border-primary_8bjl2_43",
  "border-accent": "_border-accent_8bjl2_47",
  "border-gray": "_border-gray_8bjl2_51",
  "align-start": "_align-start_8bjl2_55",
  "align-center": "_align-center_8bjl2_59",
  "align-end": "_align-end_8bjl2_63",
  "align-stretch": "_align-stretch_8bjl2_67",
  "justify-start": "_justify-start_8bjl2_71",
  "justify-center": "_justify-center_8bjl2_75",
  "justify-end": "_justify-end_8bjl2_79",
  "justify-space-between": "_justify-space-between_8bjl2_83",
  "justify-space-around": "_justify-space-around_8bjl2_87",
  "justify-space-evenly": "_justify-space-evenly_8bjl2_91",
  "gap-2xs": "_gap-2xs_8bjl2_95",
  "gap-xs": "_gap-xs_8bjl2_99",
  "gap-s": "_gap-s_8bjl2_103",
  "gap-m": "_gap-m_8bjl2_107",
  "gap-l": "_gap-l_8bjl2_111",
  "gap-xl": "_gap-xl_8bjl2_115",
  "gap-2xl": "_gap-2xl_8bjl2_119"
}, Xh = {
  background: "bg-background",
  surface: "bg-surface",
  surface2: "bg-surface-2",
  surface3: "bg-surface-3"
}, Zh = {
  row: "flex-row",
  column: "flex-col"
}, Jh = {
  m: "padding-m",
  s: "padding-s"
}, Qh = {
  primary: "border-primary",
  accent: "border-accent",
  gray: "border-gray"
}, e3 = {
  center: "align-center",
  start: "align-start",
  end: "align-end",
  stretch: "align-stretch"
}, t3 = {
  center: "justify-center",
  start: "justify-start",
  end: "justify-end",
  between: "justify-space-between",
  around: "justify-space-around",
  evenly: "justify-space-evenly"
}, n3 = {
  "2xs": "gap-2xs",
  xs: "gap-xs",
  s: "gap-s",
  m: "gap-m",
  l: "gap-l",
  xl: "gap-xl",
  "2xl": "gap-2xl"
}, gi = ({
  as: e,
  bgColor: n = "surface",
  direction: t = "column",
  padding: a = "m",
  contentAlign: o = "stretch",
  justifyContent: i = "start",
  border: l,
  children: u,
  gap: s = "m",
  ...c
}) => {
  const d = e || "div", h = y(
    ot.card,
    ot[Xh[n]],
    ot[Zh[t]],
    ot[Jh[a]],
    ot[e3[o]],
    ot[t3[i]],
    ot[n3[s]],
    l && ot[Qh[l]]
  );
  return /* @__PURE__ */ r.jsx(d, { className: h, ...c, children: u });
}, r3 = "_header_82jh6_1", xr = {
  header: r3,
  "bg-surface-inverse": "_bg-surface-inverse_82jh6_22",
  "bg-primary": "_bg-primary_82jh6_27",
  "bg-accent": "_bg-accent_82jh6_32",
  "bg-background": "_bg-background_82jh6_37",
  "bg-gray-strong": "_bg-gray-strong_82jh6_41",
  "bg-success": "_bg-success_82jh6_46",
  "bg-warning": "_bg-warning_82jh6_51",
  "bg-error": "_bg-error_82jh6_56",
  "padding-m": "_padding-m_82jh6_61",
  "padding-s": "_padding-s_82jh6_65"
}, a3 = {
  surfaceInverse: "bg-surface-inverse",
  primary: "bg-primary",
  accent: "bg-accent",
  background: "bg-background",
  grayStrong: "bg-gray-strong",
  success: "bg-success",
  error: "bg-error",
  warning: "bg-warning"
}, o3 = {
  none: "",
  m: "padding-m",
  s: "padding-s"
}, i3 = ({
  bgColor: e = "primary",
  padding: n = "m",
  children: t,
  ...a
}) => {
  const o = y(
    xr.header,
    xr[a3[e]],
    n && xr[o3[n]]
  );
  return /* @__PURE__ */ r.jsx("header", { className: o, ...a, children: t });
}, s3 = "_h1_9olqd_21", l3 = "_h2_9olqd_22", c3 = "_h3_9olqd_23", d3 = "_h4_9olqd_24", u3 = "_h5_9olqd_25", h3 = "_h6_9olqd_26", Vt = {
  "font-family--base": "_font-family--base_9olqd_1",
  "font-family--brand": "_font-family--brand_9olqd_5",
  "align-center": "_align-center_9olqd_9",
  "align-left": "_align-left_9olqd_13",
  "align-right": "_align-right_9olqd_17",
  h1: s3,
  h2: l3,
  h3: c3,
  h4: d3,
  h5: u3,
  h6: h3,
  "text-base": "_text-base_9olqd_58",
  "text-highlighted": "_text-highlighted_9olqd_62",
  "text-on-primary": "_text-on-primary_9olqd_66",
  "text-on-surface-inverse": "_text-on-surface-inverse_9olqd_70",
  "text-on-accent": "_text-on-accent_9olqd_74",
  "text-primary": "_text-primary_9olqd_78",
  "text-accent": "_text-accent_9olqd_82",
  "text-on-success": "_text-on-success_9olqd_86",
  "text-on-warning": "_text-on-warning_9olqd_90",
  "text-on-error": "_text-on-error_9olqd_94",
  "text-gray-soft": "_text-gray-soft_9olqd_98"
}, f3 = {
  text: "text-base",
  highlighted: "text-highlighted",
  "on-primary": "text-on-primary",
  "on-accent": "text-on-accent",
  primary: "text-primary",
  accent: "text-accent",
  success: "text-on-success",
  "on-surface-inverse": "text-on-surface-inverse",
  error: "text-on-error",
  warning: "text-on-warning",
  "gray-soft": "text-gray-soft"
}, m3 = {
  base: "font-family--base",
  brand: "font-family--brand"
}, _3 = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6"
}, $3 = {
  left: "align-left",
  center: "align-center",
  right: "align-right"
}, vi = ({
  children: e,
  as: n,
  fontFamily: t = "brand",
  color: a = "highlighted",
  align: o = "left",
  ...i
}) => {
  const l = n ?? "h2", u = y(
    Vt.typography,
    Vt[m3[t]],
    Vt[_3[l]],
    Vt[$3[o]],
    a && Vt[f3[a]]
  );
  return /* @__PURE__ */ r.jsx(l, { className: u, ...i, children: e });
}, pn = {
  info: "info",
  error: "error",
  warning: "warning",
  success: "success"
}, p3 = {
  [pn.info]: Ft,
  [pn.error]: Do,
  [pn.warning]: Ln,
  [pn.success]: Mo
}, g3 = "_infoCardContainer_1nncm_1", v3 = "_hidden_1nncm_10", x3 = "_infoCardIconContainer_1nncm_14", b3 = "_closeIconContainer_1nncm_15", y3 = "_icon_1nncm_30", C3 = "_infoCardContent_1nncm_42", N3 = "_infoCardContentTitle_1nncm_50", j3 = "_infoCardContentDescription_1nncm_57", w3 = "_infoCardContentControls_1nncm_64", I3 = "_infoCardContentButtonContainer_1nncm_75", T3 = "_infoCardContentCheckboxContainer_1nncm_80", S3 = "_info_1nncm_1", E3 = "_error_1nncm_102", k3 = "_warning_1nncm_117", P3 = "_success_1nncm_132", ke = {
  infoCardContainer: g3,
  hidden: v3,
  infoCardIconContainer: x3,
  closeIconContainer: b3,
  icon: y3,
  infoCardContent: C3,
  infoCardContentTitle: N3,
  infoCardContentDescription: j3,
  infoCardContentControls: w3,
  infoCardContentButtonContainer: I3,
  infoCardContentCheckboxContainer: T3,
  info: S3,
  error: E3,
  warning: k3,
  success: P3
}, He = {
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
  DEFAULT: "default"
}, A3 = {
  [He.INFO]: "color-info",
  [He.SUCCESS]: "color-success",
  [He.WARNING]: "color-warning",
  [He.ERROR]: "color-error",
  [He.DEFAULT]: "color-gray"
}, R3 = "_checkbox_1mth6_1", jo = {
  checkbox: R3,
  "color-info": "_color-info_1mth6_31",
  "color-success": "_color-success_1mth6_34",
  "color-warning": "_color-warning_1mth6_37",
  "color-error": "_color-error_1mth6_40",
  "color-gray": "_color-gray_1mth6_43"
}, xi = ({ ref: e, variant: n = He.DEFAULT, ...t }) => {
  const a = y(jo.checkbox, jo[A3[n]]);
  return /* @__PURE__ */ r.jsx("input", { ref: e, type: "checkbox", className: a, ...t });
};
xi.displayName = "Checkbox";
const y7 = ({
  variant: e,
  title: n,
  message: t,
  dismissable: a = !0,
  cta: o,
  checkbox: i
}) => {
  const [l, u] = R(!0), s = y(ke[e], ke.infoCardContainer, {
    [ke.hidden]: !l
  });
  let c = P.PRIMARY, d = He.INFO;
  return e === "info" && (c = P.PRIMARY, d = He.INFO), e === "success" && (c = P.SUCCESS, d = He.SUCCESS), e === "warning" && (c = P.WARNING, d = He.WARNING), e === "error" && (c = P.ERROR, d = He.ERROR), /* @__PURE__ */ r.jsxs("div", { className: s, children: [
    /* @__PURE__ */ r.jsx("span", { className: ke.infoCardIconContainer, children: /* @__PURE__ */ r.jsx("span", { className: ke.icon, children: p3[e]() }) }),
    /* @__PURE__ */ r.jsxs("div", { className: ke.infoCardContent, children: [
      n && /* @__PURE__ */ r.jsx("h2", { className: ke.infoCardContentTitle, children: n }),
      /* @__PURE__ */ r.jsx("p", { className: ke.infoCardContentDescription, children: t }),
      /* @__PURE__ */ r.jsxs("div", { className: ke.infoCardContentControls, children: [
        i && /* @__PURE__ */ r.jsxs("div", { className: ke.infoCardContentCheckboxContainer, children: [
          /* @__PURE__ */ r.jsx(xi, { ...i, variant: d }),
          /* @__PURE__ */ r.jsx("label", { htmlFor: i?.id, children: i?.label })
        ] }),
        o && /* @__PURE__ */ r.jsx("div", { className: ke.infoCardContentButtonContainer, children: /* @__PURE__ */ r.jsx(E, { onClick: o.onClick, isLoading: o.isLoading, size: "medium", isFull: !0, color: c, children: o.label }) })
      ] })
    ] }),
    a && /* @__PURE__ */ r.jsx("button", { className: ke.closeIconContainer, onClick: () => u((h) => !h), children: /* @__PURE__ */ r.jsx("span", { className: ke.icon, children: /* @__PURE__ */ r.jsx(an, {}) }) })
  ] });
}, O3 = {
  xl: "width-xl",
  l: "width-l",
  m: "width-m",
  s: "width-s"
}, F3 = "_modalContainer_b83wp_1", B3 = "_modalHeader_b83wp_51", M3 = "_closeButton_b83wp_65", D3 = "_modalContentContanier_b83wp_79", Wt = {
  modalContainer: F3,
  modalHeader: B3,
  closeButton: M3,
  modalContentContanier: D3,
  "width-xl": "_width-xl_b83wp_87",
  "width-l": "_width-l_b83wp_95",
  "width-m": "_width-m_b83wp_103",
  "width-s": "_width-s_b83wp_111"
}, Bt = ({
  title: e,
  onClose: n,
  isOpen: t = !0,
  children: a,
  closeOnEscape: o = !0,
  closeOnOutsideClick: i = !0,
  width: l = "m"
}) => {
  const u = Ee(null);
  fe(() => {
    const m = u.current;
    m && (t ? m.showModal() : m.close());
  }, [t]);
  const s = () => {
    n();
  }, c = (m) => {
    o && m.key === "Escape" && s();
  }, d = (m) => {
    i && m.target === u.current && s();
  }, h = !!n, f = y(Wt.modalContainer, Wt[O3[l]]);
  return /* @__PURE__ */ r.jsxs("dialog", { className: f, ref: u, onClose: s, onKeyDown: c, onClick: d, children: [
    /* @__PURE__ */ r.jsxs("header", { className: Wt.modalHeader, children: [
      /* @__PURE__ */ r.jsx(vi, { as: "h2", children: e }),
      h && /* @__PURE__ */ r.jsx("button", { className: Wt.closeButton, onClick: s, "aria-label": "Close modal", children: /* @__PURE__ */ r.jsx(Zi, {}) })
    ] }),
    /* @__PURE__ */ r.jsx("main", { className: Wt.modalContentContanier, children: a })
  ] });
}, ut = {
  error: "error",
  warning: "warning",
  success: "success",
  info: "info"
}, L3 = {
  [ut.info]: Ft,
  [ut.error]: Do,
  [ut.warning]: Ln,
  [ut.success]: Uo
}, U3 = {
  [ut.success]: P.SUCCESS,
  [ut.warning]: P.WARNING,
  [ut.error]: P.ERROR,
  [ut.info]: P.PRIMARY
}, V3 = "_toast_1o6ah_23", W3 = "_toastVariantIconContainer_1o6ah_44", G3 = "_toastVariantIcon_1o6ah_44", z3 = "_toastContent_1o6ah_56", H3 = "_toastContentMessage_1o6ah_66", q3 = "_toastCloseIconButton_1o6ah_73", Y3 = "_toastCloseIconButtonIcon_1o6ah_90", K3 = "_info_1o6ah_102", X3 = "_success_1o6ah_109", Z3 = "_warning_1o6ah_116", J3 = "_error_1o6ah_123", Q3 = "_toastCloseIconContainer_1o6ah_144", Xe = {
  toast: V3,
  "toast-enter": "_toast-enter_1o6ah_1",
  "toast-exiting": "_toast-exiting_1o6ah_40",
  "toast-exit": "_toast-exit_1o6ah_40",
  toastVariantIconContainer: W3,
  toastVariantIcon: G3,
  toastContent: z3,
  toastContentMessage: H3,
  toastCloseIconButton: q3,
  toastCloseIconButtonIcon: Y3,
  info: K3,
  success: X3,
  warning: Z3,
  error: J3,
  toastCloseIconContainer: Q3
}, ef = ({
  message: e,
  buttonText: n,
  onClose: t,
  variant: a,
  onButtonClick: o,
  isExiting: i = !1
}) => {
  const [l, u] = R(!1), s = ht(() => L3[a](), [a]), c = y(Xe.toast, Xe[a], { [Xe["toast-exiting"]]: l || i }), d = !!t, h = U3[a], f = () => {
    u(!0), setTimeout(t, 300);
  };
  return fe(() => {
    i && u(!0);
  }, [i]), /* @__PURE__ */ r.jsxs("div", { className: c, role: "alert", children: [
    /* @__PURE__ */ r.jsx("div", { className: Xe.toastVariantIconContainer, role: "img", "aria-label": a, children: /* @__PURE__ */ r.jsx("span", { className: Xe.toastVariantIcon, children: s }) }),
    /* @__PURE__ */ r.jsxs("main", { className: Xe.toastContent, children: [
      /* @__PURE__ */ r.jsx("p", { className: Xe.toastContentMessage, children: e }),
      n && /* @__PURE__ */ r.jsx(E, { onClick: o, size: "small", color: h, "aria-label": n, children: n })
    ] }),
    d && /* @__PURE__ */ r.jsxs("div", { className: Xe.toastCloseIconContainer, children: [
      /* @__PURE__ */ r.jsx("hr", {}),
      /* @__PURE__ */ r.jsx(
        "button",
        {
          className: Xe.toastCloseIconButton,
          onClick: f,
          "aria-label": "Close notification",
          "data-testid": "close-button",
          children: /* @__PURE__ */ r.jsx("span", { className: Xe.toastCloseIconButtonIcon, "aria-hidden": "true", children: /* @__PURE__ */ r.jsx(an, {}) })
        }
      )
    ] })
  ] });
}, tf = "_container_1a5os_1", nf = {
  container: tf
}, rf = ({ youtubeId: e }) => /* @__PURE__ */ r.jsx("div", { className: nf.container, children: /* @__PURE__ */ r.jsx(
  "iframe",
  {
    src: `https://www.youtube.com/embed/${e}`,
    title: "YouTube video player",
    frameBorder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
    allowFullScreen: !0
  }
) }), af = "_card_71agj_1", of = "_modal_71agj_19", sf = "_close_71agj_34", lf = "_video_71agj_40", cf = "_date_71agj_57", df = "_title_71agj_64", uf = "_image_71agj_71", hf = "_normalImage_71agj_77", ff = "_imagePlay_71agj_83", mf = "_author_71agj_94", _f = "_authorImage_71agj_100", $f = "_authorName_71agj_107", pf = "_descriptionContainer_71agj_117", gf = "_description_71agj_117", vf = "_titleContainer_71agj_186", be = {
  card: af,
  modal: of,
  close: sf,
  video: lf,
  date: cf,
  title: df,
  image: uf,
  normalImage: hf,
  imagePlay: ff,
  author: mf,
  authorImage: _f,
  authorName: $f,
  descriptionContainer: pf,
  description: gf,
  titleContainer: vf
}, xf = ({ post: e, customImage: n, communityItemTypes: t, onClick: a, onVideoClick: o }) => {
  const [i, l] = R(!1), { type: u, title: s, description: c, date: d, author: h, image: f, url: m } = e, _ = new Date(d).toLocaleDateString("es-ES"), g = u === t.VIDEO, $ = u === t.PRESS, x = () => {
    g ? i || (l(!0), o()) : (window.open(m, "_blank"), a());
  }, b = () => {
    l(!1);
  }, p = `${m.split("v=")[1]}`;
  return /* @__PURE__ */ r.jsxs("div", { className: be.card, onClick: x, children: [
    f && /* @__PURE__ */ r.jsxs("div", { className: be.image, children: [
      n || /* @__PURE__ */ r.jsx("img", { className: be.normalImage, src: f, alt: s }),
      g && /* @__PURE__ */ r.jsx("div", { className: be.imagePlay, children: /* @__PURE__ */ r.jsx(zr, {}) })
    ] }),
    /* @__PURE__ */ r.jsx("div", { className: be.date, children: _ }),
    /* @__PURE__ */ r.jsx("div", { className: be.titleContainer, children: /* @__PURE__ */ r.jsx("h2", { className: be.title, children: s }) }),
    h && /* @__PURE__ */ r.jsxs("div", { className: be.author, children: [
      h.image && !$ && /* @__PURE__ */ r.jsx("img", { className: be.authorImage, src: h.image, alt: h.name }),
      /* @__PURE__ */ r.jsx("div", { className: be.authorInfo, children: /* @__PURE__ */ r.jsx("div", { className: be.authorName, children: h.name }) })
    ] }),
    /* @__PURE__ */ r.jsx("div", { className: be.descriptionContainer, children: /* @__PURE__ */ r.jsx("p", { className: be.description, children: c }) }),
    g && i && /* @__PURE__ */ r.jsx("div", { className: be.modal, onClick: b, children: /* @__PURE__ */ r.jsxs("div", { className: be.video, children: [
      /* @__PURE__ */ r.jsx("span", { className: be.close, children: /* @__PURE__ */ r.jsx(ws, {}) }),
      /* @__PURE__ */ r.jsx(rf, { youtubeId: p })
    ] }) })
  ] });
}, bf = "_containerInfo_1vsvb_1", yf = "_iconContainer_1vsvb_8", Cf = "_iconContainerBig_1vsvb_18", Nf = "_text_1vsvb_36", jf = "_buyBoxInactive_1vsvb_44", wf = "_help_1vsvb_65", If = "_buyBox_1vsvb_44", Tf = "_title_1vsvb_83", Sf = "_titleSm_1vsvb_89", Ef = "_subTitleSm_1vsvb_97", kf = "_stepTwo_1vsvb_112", Pf = "_metamask_1vsvb_132", Af = "_number_1vsvb_146", Rf = "_stepOne_1vsvb_150", Of = "_transakIframe_1vsvb_164", Ff = "_buyBoxContent_1vsvb_174", J = {
  containerInfo: bf,
  iconContainer: yf,
  iconContainerBig: Cf,
  text: Nf,
  buyBoxInactive: jf,
  help: wf,
  buyBox: If,
  title: Tf,
  titleSm: Sf,
  subTitleSm: Ef,
  stepTwo: kf,
  metamask: Pf,
  number: Af,
  stepOne: Rf,
  transakIframe: Of,
  buyBoxContent: Ff
}, Bf = "https://staging-global.transak.com", C7 = ({
  isActive: e,
  onConnect: n,
  account: t,
  t: a,
  email: o,
  discord: i,
  telegram: l = !1,
  defaultFiatAmount: u,
  cryptoCurrencyCode: s,
  apiKey: c,
  countryCode: d = "ES",
  fiatCurrency: h = "EUR",
  prefix: f = "+34"
}) => {
  const m = new URLSearchParams({
    apiKey: c,
    defaultFiatAmount: u,
    defaultPaymentMethod: "sepa_bank_transfer",
    cryptoCurrencyCode: s,
    fiatCurrency: h,
    countryCode: d,
    userData: JSON.stringify({
      mobileNumber: f,
      address: {
        countryCode: d
      }
    }),
    exchangeScreenTitle: a.page.title
  }).toString();
  let _ = `${Bf}?${m}`;
  return t && (_ = `${_}&walletAddress=${t}`), /* @__PURE__ */ r.jsx(r.Fragment, { children: /* @__PURE__ */ r.jsx("div", { className: J.containerInfo, children: e ? /* @__PURE__ */ r.jsx(r.Fragment, { children: /* @__PURE__ */ r.jsxs("div", { className: J.buyBox, children: [
    /* @__PURE__ */ r.jsxs("div", { className: J.buyBoxContent, children: [
      /* @__PURE__ */ r.jsxs("div", { className: J.stepOne, children: [
        /* @__PURE__ */ r.jsxs("h2", { className: J.titleSm, children: [
          /* @__PURE__ */ r.jsx("span", { className: J.iconContainerBig, children: /* @__PURE__ */ r.jsx(Li, {}) }),
          a.tutorial.title
        ] }),
        /* @__PURE__ */ r.jsxs("p", { children: [
          /* @__PURE__ */ r.jsx("span", { className: J.number, children: "1." }),
          /* @__PURE__ */ r.jsx("span", { dangerouslySetInnerHTML: { __html: `${a.tutorial.step1}` } })
        ] }),
        /* @__PURE__ */ r.jsxs("p", { children: [
          /* @__PURE__ */ r.jsx("span", { className: J.number, children: "2." }),
          " ",
          /* @__PURE__ */ r.jsx("span", { dangerouslySetInnerHTML: { __html: `${a.tutorial.step2}` } })
        ] }),
        /* @__PURE__ */ r.jsxs("p", { children: [
          /* @__PURE__ */ r.jsx("span", { className: J.number, children: "3." }),
          " ",
          /* @__PURE__ */ r.jsx("span", { dangerouslySetInnerHTML: { __html: `${a.tutorial.step3}` } })
        ] })
      ] }),
      /* @__PURE__ */ r.jsxs("div", { className: J.stepTwo, children: [
        /* @__PURE__ */ r.jsx("h2", { className: J.subTitleSm, children: a.help.title }),
        o && /* @__PURE__ */ r.jsxs("div", { className: J.help, children: [
          /* @__PURE__ */ r.jsx("span", { className: J.iconContainer, children: /* @__PURE__ */ r.jsx(Lo, {}) }),
          /* @__PURE__ */ r.jsxs("div", { children: [
            /* @__PURE__ */ r.jsx("h3", { className: J.subTitleSm, children: a.help.items.email.title }),
            /* @__PURE__ */ r.jsx("p", { className: J.text, children: a.help.items.email.text }),
            /* @__PURE__ */ r.jsx("p", { children: /* @__PURE__ */ r.jsx("a", { href: `mailto:${a.help.items.email.address}`, rel: "noreferrer", children: a.help.items.email.address }) })
          ] })
        ] }),
        i && /* @__PURE__ */ r.jsxs("div", { className: J.help, children: [
          /* @__PURE__ */ r.jsx("span", { className: J.iconContainer, children: /* @__PURE__ */ r.jsx(Mi, {}) }),
          /* @__PURE__ */ r.jsxs("div", { children: [
            /* @__PURE__ */ r.jsx("h3", { className: J.subTitleSm, children: a.help.items.discord.title }),
            /* @__PURE__ */ r.jsx("p", { className: J.text, children: a.help.items.discord.text }),
            /* @__PURE__ */ r.jsx("p", { children: /* @__PURE__ */ r.jsx("a", { target: "_blank", href: `${a.help.items.discord.link}`, rel: "noreferrer", children: a.help.items.discord.link }) })
          ] })
        ] }),
        l && /* @__PURE__ */ r.jsxs("div", { className: J.help, children: [
          /* @__PURE__ */ r.jsx("span", { className: J.iconContainer, children: /* @__PURE__ */ r.jsx(Di, {}) }),
          /* @__PURE__ */ r.jsxs("div", { children: [
            /* @__PURE__ */ r.jsx("h3", { className: J.subTitleSm, children: a.help.items.telegram.title }),
            /* @__PURE__ */ r.jsx("p", { className: J.text, children: a.help.items.telegram.text }),
            /* @__PURE__ */ r.jsx("p", { children: /* @__PURE__ */ r.jsx("a", { target: "_blank", href: `${a.help.items.telegram.link}`, rel: "noreferrer", children: a.help.items.telegram.link }) })
          ] })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ r.jsx("div", { className: J.containerTransak, children: /* @__PURE__ */ r.jsx(
      "iframe",
      {
        allow: "camera;microphone;fullscreen;payment",
        title: "Transak",
        className: J.transakIframe,
        src: _
      }
    ) })
  ] }) }) : /* @__PURE__ */ r.jsx(r.Fragment, { children: /* @__PURE__ */ r.jsxs("div", { className: J.buyBoxInactive, children: [
    /* @__PURE__ */ r.jsx("img", { className: J.metamask, src: a.connect.image, alt: "Metamask" }),
    /* @__PURE__ */ r.jsx("h2", { className: J.title, children: a.connect.title }),
    /* @__PURE__ */ r.jsx("p", { dangerouslySetInnerHTML: { __html: `${a.connect.text}` } }),
    /* @__PURE__ */ r.jsx(E, { onClick: n, type: ne.OUTLINE, children: a.connect.button })
  ] }) }) }) });
}, Mf = "_card_46tp7_1", Df = "_header_46tp7_13", Lf = "_title_46tp7_21", Uf = "_incrementContainer_46tp7_33", Vf = "_increment_46tp7_33", Wf = "_label_46tp7_47", Gf = "_tag_46tp7_53", zf = "_tagIcon_46tp7_58", Hf = "_tagText_46tp7_63", qf = "_value_46tp7_68", Yf = "_icon_46tp7_75", ye = {
  card: Mf,
  header: Df,
  title: Lf,
  incrementContainer: Uf,
  increment: Vf,
  label: Wf,
  tag: Gf,
  tagIcon: zf,
  tagText: Hf,
  value: qf,
  icon: Yf
}, N7 = ({
  title: e,
  formattedCurrencyAmount: n,
  dailyIncrement: t = null,
  idoIncrement: a = null,
  icon: o
}) => {
  const i = t !== null && t >= 0 ? ze.GREEN : ze.RED, l = a && a >= 0 ? ze.GREEN : ze.RED, u = t !== null && t >= 0 ? /* @__PURE__ */ r.jsx(na, {}) : /* @__PURE__ */ r.jsx(Zt, {}), s = a && a >= 0 ? /* @__PURE__ */ r.jsx(na, {}) : /* @__PURE__ */ r.jsx(Zt, {});
  return /* @__PURE__ */ r.jsxs("div", { className: ye.card, children: [
    /* @__PURE__ */ r.jsxs("div", { className: ye.header, children: [
      /* @__PURE__ */ r.jsxs("p", { className: ye.title, children: [
        o && /* @__PURE__ */ r.jsx("span", { className: ye.icon, children: o }),
        e
      ] }),
      /* @__PURE__ */ r.jsxs("div", { className: ye.incrementContainer, children: [
        t && /* @__PURE__ */ r.jsxs("div", { className: ye.increment, children: [
          /* @__PURE__ */ r.jsx("span", { className: ye.label, children: "24h" }),
          /* @__PURE__ */ r.jsx(On, { color: i, children: /* @__PURE__ */ r.jsxs("div", { className: ye.tag, children: [
            /* @__PURE__ */ r.jsx("span", { className: ye.tagIcon, children: u }),
            /* @__PURE__ */ r.jsxs("span", { className: ye.tagText, children: [
              Math.abs(t).toFixed(2),
              "%"
            ] })
          ] }) })
        ] }),
        a && /* @__PURE__ */ r.jsxs("div", { className: ye.increment, children: [
          /* @__PURE__ */ r.jsx("span", { className: ye.label, children: "IDO" }),
          /* @__PURE__ */ r.jsx(On, { color: l, children: /* @__PURE__ */ r.jsxs("div", { className: ye.tag, children: [
            /* @__PURE__ */ r.jsx("span", { className: ye.tagIcon, children: s }),
            /* @__PURE__ */ r.jsxs("span", { className: ye.tagText, children: [
              Math.abs(a).toFixed(2),
              "%"
            ] })
          ] }) })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ r.jsx("span", { className: ye.value, children: n })
  ] });
}, Ze = {
  INFO: "info",
  ERROR: "error",
  ACCENT: "accent",
  SUCCESS: "success"
}, Kf = "_notifyBar_cbbvx_1", Xf = "_container_cbbvx_8", Zf = "_textBox_cbbvx_17", Jf = "_icon_cbbvx_27", Qf = "_text_cbbvx_17", em = "_bgInfo_cbbvx_43", tm = "_contentXIcon_cbbvx_44", nm = "_bgPrimary_cbbvx_50", rm = "_bgRed_cbbvx_64", am = "_bgAccent_cbbvx_71", om = "_bgSuccess_cbbvx_78", im = "_button_cbbvx_83", sm = "_iconXCircle_cbbvx_100", Pe = {
  notifyBar: Kf,
  container: Xf,
  textBox: Zf,
  icon: Jf,
  text: Qf,
  bgInfo: em,
  contentXIcon: tm,
  bgPrimary: nm,
  bgRed: rm,
  bgAccent: am,
  bgSuccess: om,
  button: im,
  iconXCircle: sm
}, j7 = ({ text: e, button: n, color: t = Ze.INFO, onClick: a, onClose: o, icon: i }) => {
  const l = y(Pe.notifyBar, {
    [Pe.bgPrimary]: t === Ze.PRIMARY,
    [Pe.bgInfo]: t === Ze.INFO,
    [Pe.bgRed]: t === Ze.ERROR,
    [Pe.bgAccent]: t === Ze.ACCENT,
    [Pe.bgSuccess]: t === Ze.SUCCESS
  }), u = (s) => {
    switch (s) {
      case Ze.INFO:
        return P.ACCENT;
      case Ze.ERROR:
        return P.ERROR;
      case Ze.ACCENT:
        return P.ACCENT;
      case Ze.SUCCESS:
        return P.SUCCESS;
      default:
        return P.DEFAULT;
    }
  };
  return /* @__PURE__ */ r.jsx("div", { className: y(l), children: /* @__PURE__ */ r.jsxs("div", { className: Pe.container, children: [
    /* @__PURE__ */ r.jsxs("div", { className: Pe.textBox, children: [
      /* @__PURE__ */ r.jsxs("div", { className: Pe.text, children: [
        i && /* @__PURE__ */ r.jsx("span", { className: Pe.icon, children: i }),
        e && /* @__PURE__ */ r.jsx("p", { children: e })
      ] }),
      n && /* @__PURE__ */ r.jsx("div", { className: Pe.button, children: /* @__PURE__ */ r.jsx(E, { onClick: a, type: "negative", color: u(t), children: n }) })
    ] }),
    o && /* @__PURE__ */ r.jsx("div", { className: Pe.contentXIcon, children: /* @__PURE__ */ r.jsx("div", { className: Pe.iconXCircle, onClick: o, children: /* @__PURE__ */ r.jsx(an, {}) }) })
  ] }) });
}, lm = "_container_rpjwx_1", cm = "_name_rpjwx_17", dm = "_nftPrice_rpjwx_30", um = "_tokenId_rpjwx_38", hm = "_picture_rpjwx_44", fm = "_hover_rpjwx_67", mm = "_content_rpjwx_77", _m = "_typeText_rpjwx_85", $m = "_imageCover_rpjwx_117", pm = "_nftIcon_rpjwx_169", gm = "_accent_rpjwx_187", vm = "_error_rpjwx_190", xm = "_success_rpjwx_194", bm = "_primary_rpjwx_198", ge = {
  container: lm,
  name: cm,
  nftPrice: dm,
  tokenId: um,
  picture: hm,
  hover: fm,
  content: mm,
  typeText: _m,
  imageCover: $m,
  nftIcon: pm,
  accent: gm,
  error: vm,
  success: xm,
  primary: bm
}, ym = 744, gn = {
  ACCENT: "accent",
  ERROR: "error",
  SUCCESS: "success",
  PRIMARY: "primary"
}, vn = {
  ACCENT: "accent",
  ERROR: "error",
  SUCCESS: "success",
  PRIMARY: "primary"
}, Cm = {
  [gn.ACCENT]: ge.accent,
  [gn.ERROR]: ge.error,
  [gn.SUCCESS]: ge.success,
  [gn.PRIMARY]: ge.primary
}, Nm = {
  [vn.ACCENT]: ge.accent,
  [vn.ERROR]: ge.error,
  [vn.SUCCESS]: ge.success,
  [vn.PRIMARY]: ge.primary
}, w7 = ({
  mediaUrl: e,
  name: n,
  price: t,
  tokenId: a,
  buttonLabel: o,
  onClick: i = () => {
  },
  buttonType: l = ne.FILLED,
  buttonColor: u = P.PRIMARY,
  tag: s,
  type: c
}) => {
  const d = e && e.endsWith(".mp4"), h = typeof window < "u" ? window.innerWidth < ym : !1, f = () => {
    h && i();
  }, m = y(ge.nftIcon, s ? Cm[s.color] : null), _ = y(ge.nftPrice, t ? Nm[t.color] : null);
  return /* @__PURE__ */ r.jsxs("article", { className: y(ge.container, ge.imageCover), onClick: f, children: [
    /* @__PURE__ */ r.jsx("div", { className: ge.picture, children: d ? /* @__PURE__ */ r.jsxs("video", { width: "400", height: "400", autoPlay: !0, loop: !0, playsInline: !0, children: [
      /* @__PURE__ */ r.jsx("source", { src: e, type: "video/mp4" }),
      "Your browser does not support the video tag."
    ] }) : e && /* @__PURE__ */ r.jsx("img", { src: e, alt: "NFT" }) }),
    /* @__PURE__ */ r.jsxs("div", { className: ge.content, children: [
      /* @__PURE__ */ r.jsx("h2", { className: ge.name, children: n }),
      t && /* @__PURE__ */ r.jsxs("p", { className: _, children: [
        t.value,
        " ",
        t.token
      ] }),
      a && /* @__PURE__ */ r.jsxs("p", { className: ge.tokenId, children: [
        "#",
        a
      ] })
    ] }),
    /* @__PURE__ */ r.jsx("div", { className: ge.hover, children: o && /* @__PURE__ */ r.jsx(E, { isFull: !0, type: l, color: u, onClick: i, children: o }) }),
    s && /* @__PURE__ */ r.jsxs("div", { className: m, children: [
      s.icon && /* @__PURE__ */ r.jsx("span", { children: s.icon }),
      " ",
      s.label
    ] }),
    c && /* @__PURE__ */ r.jsx("div", { className: ge.typeText, children: c && /* @__PURE__ */ r.jsx("span", { children: c }) })
  ] });
}, jm = "_container_1yhse_1", wm = "_gallery_1yhse_7", Im = "_single_1yhse_17", Tm = "_media_1yhse_21", Sm = "_arrows_1yhse_41", Em = "_thumbnailsContainer_1yhse_75", km = "_thumbnails_1yhse_75", Pm = "_image_1yhse_104", Am = "_active_1yhse_127", Rm = "_play_1yhse_164", Om = "_fade_1yhse_185", Ve = {
  container: jm,
  gallery: wm,
  single: Im,
  media: Tm,
  arrows: Sm,
  thumbnailsContainer: Em,
  thumbnails: km,
  image: Pm,
  active: Am,
  play: Rm,
  fade: Om
}, xn = {
  IMAGE: "image",
  VIDEO: "video"
}, I7 = ({ media: e, showThumbnails: n = !0, showArrows: t = !0 }) => {
  const [a, o] = R(0), [i, l] = R(!1), u = Ee(0);
  function s(m) {
    l(!0), o(m), setTimeout(() => l(!1), 500);
  }
  function c() {
    l(!0), o((m) => m === 0 ? e.length - 1 : m - 1), setTimeout(() => l(!1), 500);
  }
  const d = () => {
    l(!0), o((m) => m === e.length - 1 ? 0 : m + 1), setTimeout(() => l(!1), 500);
  }, h = (m) => {
    u.current = m.touches[0].clientX;
  }, f = (m) => {
    const _ = m.changedTouches[0].clientX, g = u.current - _;
    g > 50 ? d() : g < -50 && c();
  };
  return /* @__PURE__ */ r.jsx(r.Fragment, { children: /* @__PURE__ */ r.jsxs("div", { className: Ve.container, children: [
    /* @__PURE__ */ r.jsxs(
      "div",
      {
        className: y(Ve.gallery, {
          [Ve.single]: e.length === 1 || n === !1
        }),
        onTouchStart: h,
        onTouchEnd: f,
        children: [
          e.length > 1 && t && /* @__PURE__ */ r.jsxs("div", { className: Ve.arrows, children: [
            /* @__PURE__ */ r.jsx("span", { onClick: c, children: /* @__PURE__ */ r.jsx(Wr, {}) }),
            /* @__PURE__ */ r.jsx("span", { onClick: d, children: /* @__PURE__ */ r.jsx(Gr, {}) })
          ] }),
          e.length > 0 && /* @__PURE__ */ r.jsxs("div", { className: `${Ve.media} ${i ? Ve.fade : ""}`, children: [
            e[a].type === xn.IMAGE && /* @__PURE__ */ r.jsx("img", { src: e[a].url, alt: "" }),
            e[a].type === xn.VIDEO && /* @__PURE__ */ r.jsx(
              "video",
              {
                autoPlay: e[a].autoplay,
                loop: e[a].autoplay,
                muted: e[a].autoplay,
                playsInline: e[a].autoplay,
                controls: !e[a].autoplay,
                src: e[a].url
              }
            )
          ] })
        ]
      }
    ),
    e.length > 1 && n && /* @__PURE__ */ r.jsx("div", { className: Ve.thumbnailsContainer, children: /* @__PURE__ */ r.jsx("div", { className: Ve.thumbnails, children: e.map((m, _) => /* @__PURE__ */ r.jsx(
      "span",
      {
        className: _ === a ? Ve.active : "",
        onClick: () => s(_),
        children: /* @__PURE__ */ r.jsxs("span", { className: Ve.image, children: [
          e[_].type === xn.IMAGE && /* @__PURE__ */ r.jsx("img", { src: e[_].url, alt: "" }),
          e[_].type === xn.VIDEO && /* @__PURE__ */ r.jsxs("span", { children: [
            /* @__PURE__ */ r.jsx("img", { src: e[_].capture, alt: "" }),
            /* @__PURE__ */ r.jsx("span", { className: Ve.play, children: /* @__PURE__ */ r.jsx(zr, {}) })
          ] })
        ] })
      },
      _
    )) }) })
  ] }) });
}, Fm = "_gallery_8dacp_1", Bm = "_media_8dacp_9", wo = {
  gallery: Fm,
  media: Bm
}, Io = {
  IMAGE: "image",
  VIDEO: "video"
}, T7 = ({ media: e }) => /* @__PURE__ */ r.jsx(r.Fragment, { children: /* @__PURE__ */ r.jsx("div", { className: wo.gallery, children: e.length > 0 && e.map((n, t) => /* @__PURE__ */ r.jsxs("div", { className: wo.media, children: [
  n.type === Io.IMAGE && /* @__PURE__ */ r.jsx("img", { src: n.url, alt: "" }),
  n.type === Io.VIDEO && /* @__PURE__ */ r.jsx(
    "video",
    {
      autoPlay: n.autoplay,
      loop: n.autoplay,
      muted: n.autoplay,
      playsInline: n.autoplay,
      controls: !n.autoplay,
      src: n.url
    }
  )
] }, t)) }) }), Mm = "_container_1bf00_1", Dm = "_name_1bf00_12", Lm = "_description_1bf00_18", Um = "_picture_1bf00_22", Vm = "_content_1bf00_34", Wm = "_fee_1bf00_38", Gm = "_feeIcon_1bf00_47", zm = "_priceContainer_1bf00_54", Hm = "_availableContainer_1bf00_61", qm = "_priceValue_1bf00_73", Ym = "_priceLabel_1bf00_79", Km = "_priceValueNumber_1bf00_84", Xm = "_availableLoading_1bf00_89", Zm = "_availableNotEnough_1bf00_93", xe = {
  container: Mm,
  name: Dm,
  description: Lm,
  picture: Um,
  content: Vm,
  fee: Wm,
  feeIcon: Gm,
  priceContainer: zm,
  availableContainer: Hm,
  priceValue: qm,
  priceLabel: Ym,
  priceValueNumber: Km,
  availableLoading: Xm,
  availableNotEnough: Zm
}, S7 = ({
  mediaUrl: e,
  name: n,
  description: t,
  price: a,
  available: o,
  buttonLabel: i,
  buttonDisabled: l = !1,
  onClick: u = () => {
  },
  buttonType: s = ne.FILLED,
  buttonColor: c = P.PRIMARY,
  isButtonLoading: d = !1,
  fee: h
}) => /* @__PURE__ */ r.jsxs("article", { className: xe.container, children: [
  /* @__PURE__ */ r.jsx("div", { className: xe.picture, children: /* @__PURE__ */ r.jsx("img", { src: e, alt: n }) }),
  /* @__PURE__ */ r.jsxs("div", { className: xe.content, children: [
    /* @__PURE__ */ r.jsx("h2", { className: xe.name, children: n }),
    t && /* @__PURE__ */ r.jsx("p", { className: xe.description, children: t }),
    /* @__PURE__ */ r.jsxs("div", { className: xe.priceContainer, children: [
      a && /* @__PURE__ */ r.jsxs("div", { className: xe.priceText, children: [
        /* @__PURE__ */ r.jsx("span", { className: xe.priceLabel, children: a.label }),
        /* @__PURE__ */ r.jsxs("p", { className: xe.priceValue, children: [
          /* @__PURE__ */ r.jsx("span", { className: xe.priceValueNumber, children: a.value }),
          " ",
          /* @__PURE__ */ r.jsx("span", { className: xe.priceValueToken, children: a.token })
        ] })
      ] }),
      o && /* @__PURE__ */ r.jsxs(
        "div",
        {
          className: y(xe.availableContainer, {
            [xe.availableLoading]: o.isLoading,
            [xe.availableNotEnough]: o.isNotEnough
          }),
          children: [
            /* @__PURE__ */ r.jsx("span", { children: o.label }),
            /* @__PURE__ */ r.jsxs("p", { children: [
              o.value,
              " ",
              o.token
            ] })
          ]
        }
      )
    ] }),
    i && /* @__PURE__ */ r.jsx("div", { className: xe.buttonContainer, children: /* @__PURE__ */ r.jsx(
      E,
      {
        isDisabled: l,
        isFull: !0,
        type: s,
        color: c,
        onClick: u,
        isLoading: d,
        children: i
      }
    ) }),
    h && /* @__PURE__ */ r.jsxs("p", { className: xe.fee, children: [
      /* @__PURE__ */ r.jsx("span", { className: xe.feeIcon, children: h.icon }),
      h.label,
      " ",
      h.value
    ] })
  ] })
] }), Jm = "_container_v6436_1", Qm = "_header_v6436_13", e_ = "_name_v6436_18", t_ = "_picture_v6436_26", n_ = "_content_v6436_38", r_ = "_selectContainer_v6436_43", a_ = "_priceContainer_v6436_48", o_ = "_priceValue_v6436_55", i_ = "_priceValueNumber_v6436_66", Be = {
  container: Jm,
  header: Qm,
  name: e_,
  picture: t_,
  content: n_,
  selectContainer: r_,
  priceContainer: a_,
  priceValue: o_,
  priceValueNumber: i_,
  delete: "_delete_v6436_71"
}, E7 = ({
  mediaUrl: e,
  name: n,
  price: t,
  buttonLabel: a,
  onRemoveClick: o = () => {
  },
  onNumberChange: i = () => {
  },
  quantityLabel: l,
  quantityOptions: u,
  quantityValue: s
}) => {
  const [c, d] = R(s), h = (f) => {
    d(f), i(f);
  };
  return /* @__PURE__ */ r.jsxs("article", { className: Be.container, children: [
    /* @__PURE__ */ r.jsx("div", { className: Be.picture, children: /* @__PURE__ */ r.jsx("img", { src: e, alt: n }) }),
    /* @__PURE__ */ r.jsxs("div", { className: Be.content, children: [
      /* @__PURE__ */ r.jsxs("div", { className: Be.header, children: [
        /* @__PURE__ */ r.jsx("h2", { className: Be.name, children: n }),
        /* @__PURE__ */ r.jsx("div", { className: Be.priceContainer, children: t && /* @__PURE__ */ r.jsx("div", { className: Be.priceText, children: /* @__PURE__ */ r.jsxs("p", { className: Be.priceValue, children: [
          /* @__PURE__ */ r.jsx("span", { className: Be.priceValueNumber, children: t.value }),
          " ",
          /* @__PURE__ */ r.jsx("span", { className: Be.priceValueToken, children: t.token })
        ] }) }) })
      ] }),
      /* @__PURE__ */ r.jsx("div", { className: Be.selectContainer, children: /* @__PURE__ */ r.jsx(
        Zu,
        {
          label: l,
          options: u,
          value: c,
          onChange: h
        }
      ) }),
      a && /* @__PURE__ */ r.jsx("span", { className: Be.delete, onClick: o, children: a })
    ] })
  ] });
}, s_ = "_container_abbow_1", l_ = "_title_abbow_12", c_ = "_subtitle_abbow_19", d_ = "_content_abbow_25", u_ = "_text_abbow_31", h_ = "_image_abbow_40", Pt = {
  container: s_,
  title: l_,
  subtitle: c_,
  content: d_,
  text: u_,
  image: h_
}, k7 = ({
  title: e,
  subtitle: n,
  content: t,
  buttonText: a,
  buttonIcon: o,
  onClick: i
}) => /* @__PURE__ */ r.jsxs("article", { className: Pt.container, children: [
  /* @__PURE__ */ r.jsxs("div", { className: Pt.text, children: [
    e && /* @__PURE__ */ r.jsx("h2", { className: Pt.title, children: e }),
    n && /* @__PURE__ */ r.jsx("h3", { className: Pt.subtitle, children: n }),
    t && /* @__PURE__ */ r.jsx("h3", { className: Pt.content, children: t }),
    a && /* @__PURE__ */ r.jsx(E, { onClick: i, iconLeft: o, type: "filled", children: a })
  ] }),
  /* @__PURE__ */ r.jsx("div", { className: Pt.image, children: /* @__PURE__ */ r.jsx("img", { alt: e, src: "https://d1ddeojt5lrj1t.cloudfront.net/images/maintenance.webp" }) })
] }), Yt = "...", bn = (e, n) => {
  const t = n - e + 1;
  return Array.from({ length: t }, (a, o) => o + e);
}, f_ = ({ totalCount: e, pageSize: n, siblingCount: t = 1, currentPage: a }) => ht(() => {
  const i = Math.ceil(e / n);
  if (t + 5 >= i)
    return bn(1, i);
  const u = Math.max(a - t, 1), s = Math.min(a + t, i), c = u > 2, d = s < i - 2, h = 1, f = i;
  if (!c && d) {
    const m = 3 + 2 * t;
    return [...bn(1, m), Yt, i];
  }
  if (c && !d) {
    const m = 3 + 2 * t, _ = bn(i - m + 1, i);
    return [h, Yt, ..._];
  }
  if (c && d) {
    const m = bn(u, s);
    return [h, Yt, ...m, Yt, f];
  }
}, [e, n, t, a]), m_ = "_paginationContainer_1lqco_1", __ = "_arrowButton_1lqco_9", $_ = "_dotsButton_1lqco_12", yn = {
  paginationContainer: m_,
  arrowButton: __,
  dotsButton: $_
}, P7 = ({
  onPageChange: e,
  totalCount: n,
  siblingCount: t = 1,
  currentPage: a,
  pageSize: o,
  textArrowLeft: i,
  textArrowRight: l
}) => {
  const u = f_({
    currentPage: a,
    totalCount: n,
    siblingCount: t,
    pageSize: o
  });
  if (a === 0 || u.length < 2)
    return null;
  const s = () => {
    e(a + 1);
  }, c = () => {
    e(a - 1);
  }, d = u[u.length - 1];
  return /* @__PURE__ */ r.jsxs("div", { className: yn.paginationContainer, children: [
    /* @__PURE__ */ r.jsx("div", { className: yn.arrowButton, children: /* @__PURE__ */ r.jsx(
      E,
      {
        type: ne.OUTLINE,
        color: P.SURFACE_INVERSE,
        disabled: a === 1,
        onClick: () => c(),
        iconLeft: /* @__PURE__ */ r.jsx(Wr, {}),
        children: i
      }
    ) }),
    u.map((h, f) => h === Yt ? /* @__PURE__ */ r.jsx("div", { className: yn.dotsButton, children: /* @__PURE__ */ r.jsx(E, { type: ne.OUTLINE, color: P.SURFACE_INVERSE, children: "..." }) }, f) : /* @__PURE__ */ r.jsx(
      E,
      {
        type: h === a ? ne.SOLID : ne.OUTLINE,
        color: P.SURFACE_INVERSE,
        onClick: () => e(h),
        children: h
      },
      f
    )),
    /* @__PURE__ */ r.jsx("div", { className: yn.arrowButton, children: /* @__PURE__ */ r.jsx(
      E,
      {
        type: ne.OUTLINE,
        color: P.SURFACE_INVERSE,
        disabled: a === d,
        onClick: () => s(),
        iconRight: /* @__PURE__ */ r.jsx(Gr, {}),
        children: l
      }
    ) })
  ] });
}, p_ = "_container_4sdzm_1", g_ = "_balances_4sdzm_8", v_ = "_info_4sdzm_21", x_ = "_header_4sdzm_28", b_ = "_total_4sdzm_36", y_ = "_loading_4sdzm_44", C_ = "_totalContainer_4sdzm_48", N_ = "_title_4sdzm_52", j_ = "_heroTitle_4sdzm_62", Ae = {
  container: p_,
  balances: g_,
  info: v_,
  header: x_,
  total: b_,
  loading: y_,
  totalContainer: C_,
  title: N_,
  heroTitle: j_
}, w_ = ({ t: e, userBalances: n, isHero: t, isLoading: a }) => /* @__PURE__ */ r.jsxs("div", { className: Ae.header, children: [
  t && /* @__PURE__ */ r.jsx("h3", { className: Ae.heroTitle, children: e.header.balances }),
  !t && /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsxs("div", { className: Ae.totalContainer, children: [
      /* @__PURE__ */ r.jsx("label", { className: Ae.title, children: e.header.totalUSD }),
      /* @__PURE__ */ r.jsx(
        "div",
        {
          className: y(Ae.total, {
            [Ae.loading]: a
          }),
          children: n?.total?.usd?.formattedUSD || "..."
        }
      )
    ] }),
    /* @__PURE__ */ r.jsxs("div", { className: Ae.totalContainer, children: [
      /* @__PURE__ */ r.jsx("label", { className: Ae.title, children: e.header.totalToken }),
      /* @__PURE__ */ r.jsxs(
        "div",
        {
          className: y(Ae.total, {
            [Ae.loading]: a
          }),
          children: [
            n?.total?.token?.formatted || "...",
            " ",
            n?.total?.token?.symbol
          ]
        }
      )
    ] })
  ] })
] }), I_ = ({
  t: e,
  userBalances: n,
  isActive: t = !1,
  isLoading: a = !1,
  isHero: o = !1,
  tokenIcon: i = /* @__PURE__ */ r.jsx(Wo, {}),
  tokenPairIcon: l = /* @__PURE__ */ r.jsx(Hi, {}),
  tokenLPIcon: u = /* @__PURE__ */ r.jsx(zi, {}),
  shareIcon: s = /* @__PURE__ */ r.jsx(Vo, {})
}) => /* @__PURE__ */ r.jsxs("div", { className: Ae.container, children: [
  !t && !o && /* @__PURE__ */ r.jsx("div", { className: Ae.info, children: e.disconnected }),
  t && /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx(w_, { t: e, userBalances: n, isHero: o, isLoading: a }),
    /* @__PURE__ */ r.jsxs("div", { className: Ae.balances, children: [
      /* @__PURE__ */ r.jsx(
        Nn,
        {
          title: e.box.farming,
          value: n?.yields.farming,
          valueIcon: u,
          tokenPairIcon: l,
          tokenIcon: i,
          tokenSymbol: n?.wallet.token.symbol,
          shareIcon: s,
          isLoading: a
        }
      ),
      /* @__PURE__ */ r.jsx(
        Nn,
        {
          title: e.box.lp,
          value: n?.wallet.lp,
          valueIcon: u,
          tokenPairIcon: l,
          tokenIcon: i,
          tokenSymbol: n?.wallet.token.symbol,
          shareIcon: s,
          isLoading: a
        }
      ),
      /* @__PURE__ */ r.jsx(
        Nn,
        {
          title: e.box.staking,
          value: n?.yields.staking,
          valueIcon: i,
          shareIcon: s,
          isLoading: a
        }
      ),
      /* @__PURE__ */ r.jsx(
        Nn,
        {
          title: "Wallet",
          value: n?.wallet.token,
          valueIcon: i,
          isLoading: a
        }
      )
    ] })
  ] })
] }), Cn = A.shape({
  formatted: A.string.isRequired,
  formattedUSD: A.string.isRequired,
  symbol: A.string.isRequired,
  pool: A.array,
  share: A.string
});
I_.propTypes = {
  t: A.shape({
    disconnected: A.string.isRequired,
    loading: A.string.isRequired,
    box: A.shape({
      token: A.string.isRequired,
      staking: A.string.isRequired,
      lp: A.string.isRequired,
      farming: A.string.isRequired
    }).isRequired,
    header: A.shape({
      balances: A.string.isRequired,
      totalUSD: A.string.isRequired,
      totalToken: A.string.isRequired
    }).isRequired
  }),
  userBalances: A.shape({
    wallet: A.shape({
      token: Cn,
      lp: Cn
    }),
    yields: A.shape({
      staking: Cn,
      farming: Cn
    })
  }),
  isActive: A.bool,
  isHero: A.bool,
  tokenIcon: A.node,
  tokenPairIcon: A.node,
  tokenLPIcon: A.node,
  shareIcon: A.node
};
const T_ = "_box_17w07_1", S_ = "_skeleton_17w07_17", E_ = "_skeletonTitle_17w07_41", k_ = "_skeletonSubTitle_17w07_47", P_ = "_skeletonSubInfo_17w07_52", A_ = "_loading_17w07_60", R_ = "_title_17w07_78", O_ = "_balance_17w07_86", F_ = "_value_17w07_96", B_ = "_integer_17w07_100", M_ = "_decimal_17w07_104", D_ = "_symbol_17w07_108", L_ = "_usd_17w07_114", U_ = "_share_17w07_115", V_ = "_icon_17w07_128", W_ = "_poolTokens_17w07_135", G_ = "_poolValue_17w07_143", z_ = "_poolIcon_17w07_152", H_ = "_shareIcon_17w07_159", q_ = "_poolSymbol_17w07_165", Y_ = "_info_17w07_169", ce = {
  box: T_,
  skeleton: S_,
  skeletonTitle: E_,
  skeletonSubTitle: k_,
  skeletonSubInfo: P_,
  loading: A_,
  title: R_,
  balance: O_,
  value: F_,
  integer: B_,
  decimal: M_,
  symbol: D_,
  usd: L_,
  share: U_,
  icon: V_,
  poolTokens: W_,
  poolValue: G_,
  poolIcon: z_,
  shareIcon: H_,
  poolSymbol: q_,
  info: Y_
}, Nn = ({
  title: e,
  value: n,
  valueIcon: t,
  tokenIcon: a,
  tokenPairIcon: o,
  tokenSymbol: i,
  shareIcon: l,
  isLoading: u
}) => {
  const s = () => /* @__PURE__ */ r.jsxs("span", { className: ce.skeleton, children: [
    /* @__PURE__ */ r.jsx("span", { className: ce.skeletonTitle }),
    /* @__PURE__ */ r.jsx("span", { className: ce.skeletonSubTitle }),
    /* @__PURE__ */ r.jsx("span", { className: ce.skeletonSubInfo })
  ] });
  if (u)
    return /* @__PURE__ */ r.jsx("div", { className: y(ce.box, ce.loading), children: /* @__PURE__ */ r.jsx(s, {}) });
  const { symbol: c, pool: d, share: h, formatted: f, formattedUSD: m } = n, [_, g] = f.split(".");
  return /* @__PURE__ */ r.jsxs("div", { className: ce.box, children: [
    /* @__PURE__ */ r.jsx(s, {}),
    /* @__PURE__ */ r.jsx("h3", { className: ce.title, children: e }),
    /* @__PURE__ */ r.jsxs("div", { className: ce.balance, children: [
      /* @__PURE__ */ r.jsxs("div", { className: ce.value, children: [
        /* @__PURE__ */ r.jsx("span", { className: ce.integer, children: _ }),
        g && /* @__PURE__ */ r.jsxs("span", { className: ce.decimal, children: [
          ".",
          g
        ] })
      ] }),
      /* @__PURE__ */ r.jsxs("div", { className: ce.symbol, children: [
        /* @__PURE__ */ r.jsxs("span", { children: [
          " ",
          c
        ] }),
        /* @__PURE__ */ r.jsx("div", { className: ce.icon, children: t })
      ] })
    ] }),
    d && /* @__PURE__ */ r.jsx("div", { className: ce.poolTokens, children: /* @__PURE__ */ r.jsx(r.Fragment, { children: d.map(($) => /* @__PURE__ */ r.jsxs("div", { className: ce.poolValue, children: [
      /* @__PURE__ */ r.jsx("span", { children: $.formatted }),
      /* @__PURE__ */ r.jsxs("span", { className: ce.poolSymbol, children: [
        " ",
        $.symbol
      ] }),
      /* @__PURE__ */ r.jsx("div", { className: ce.poolIcon, children: $.symbol === i ? a : o })
    ] }, $.symbol)) }) }),
    /* @__PURE__ */ r.jsxs("div", { className: ce.info, children: [
      /* @__PURE__ */ r.jsx("span", { className: ce.usd, children: m }),
      h && /* @__PURE__ */ r.jsxs("div", { className: ce.share, children: [
        /* @__PURE__ */ r.jsx("span", { children: h }),
        " ",
        /* @__PURE__ */ r.jsx("div", { className: ce.shareIcon, children: l })
      ] })
    ] })
  ] });
}, K_ = "_container_1gvqa_1", X_ = "_box_1gvqa_13", Z_ = "_accountBox_1gvqa_20", J_ = "_avatar_1gvqa_33", Q_ = "_accountContainer_1gvqa_52", e$ = "_title_1gvqa_56", t$ = "_explorerLink_1gvqa_69", n$ = "_placeholder_1gvqa_80", r$ = "_footer_1gvqa_85", a$ = "_chainContainer_1gvqa_91", o$ = "_chainLogo_1gvqa_96", i$ = "_chainLabel_1gvqa_103", s$ = "_transactionContainer_1gvqa_110", Ce = {
  container: K_,
  box: X_,
  accountBox: Z_,
  avatar: J_,
  accountContainer: Q_,
  title: e$,
  explorerLink: t$,
  placeholder: n$,
  footer: r$,
  chainContainer: a$,
  chainLogo: o$,
  chainLabel: i$,
  transactionContainer: s$
}, A7 = ({
  t: e,
  account: n,
  chainLogo: t,
  chainName: a,
  explorerLink: o,
  onClose: i,
  onDisconnect: l,
  transactions: u = [],
  walletName: s
}) => /* @__PURE__ */ r.jsx(Bt, { title: e.title, onClose: i, children: /* @__PURE__ */ r.jsxs("div", { className: Ce.container, children: [
  /* @__PURE__ */ r.jsxs("div", { className: Ce.box, children: [
    /* @__PURE__ */ r.jsxs("div", { className: Ce.accountBox, children: [
      /* @__PURE__ */ r.jsx("div", { className: Ce.avatar, children: /* @__PURE__ */ r.jsx(Js, { diameter: 65, account: n }) }),
      /* @__PURE__ */ r.jsxs("div", { className: Ce.accountContainer, children: [
        /* @__PURE__ */ r.jsx("h3", { className: Ce.title, children: s }),
        n && /* @__PURE__ */ r.jsx(sn, { truncate: 6, account: n })
      ] })
    ] }),
    o && /* @__PURE__ */ r.jsx("a", { className: Ce.explorerLink, href: o, target: "_blank", rel: "noreferrer", children: e.explorer })
  ] }),
  /* @__PURE__ */ r.jsxs("div", { className: Ce.box, children: [
    /* @__PURE__ */ r.jsx("h3", { className: Ce.title, children: e.transactions.title }),
    u.length === 0 && /* @__PURE__ */ r.jsx("p", { className: Ce.placeholder, children: e.transactions.placeholder }),
    u.length > 0 && /* @__PURE__ */ r.jsx("div", { className: Ce.transactionContainer, children: u.map((c) => /* @__PURE__ */ r.jsx("div", { children: /* @__PURE__ */ r.jsx(Z0, { ...c, withTimestamp: !0 }, c.hash) }, c.hash)) })
  ] }),
  /* @__PURE__ */ r.jsxs("div", { className: Ce.footer, children: [
    /* @__PURE__ */ r.jsxs("div", { className: Ce.chainContainer, children: [
      t && /* @__PURE__ */ r.jsx("img", { className: Ce.chainLogo, src: t, alt: a }),
      /* @__PURE__ */ r.jsx("span", { className: Ce.chainLabel, children: a })
    ] }),
    /* @__PURE__ */ r.jsx(E, { type: ne.OUTLINE, onClick: l, children: e.disconnect })
  ] })
] }) });
var jn = { exports: {} }, wn = { exports: {} }, br, To;
function l$() {
  if (To) return br;
  To = 1;
  var e = 1e3, n = e * 60, t = n * 60, a = t * 24, o = a * 365.25;
  br = function(c, d) {
    d = d || {};
    var h = typeof c;
    if (h === "string" && c.length > 0)
      return i(c);
    if (h === "number" && isNaN(c) === !1)
      return d.long ? u(c) : l(c);
    throw new Error(
      "val is not a non-empty string or a valid number. val=" + JSON.stringify(c)
    );
  };
  function i(c) {
    if (c = String(c), !(c.length > 100)) {
      var d = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
        c
      );
      if (d) {
        var h = parseFloat(d[1]), f = (d[2] || "ms").toLowerCase();
        switch (f) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return h * o;
          case "days":
          case "day":
          case "d":
            return h * a;
          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return h * t;
          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return h * n;
          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return h * e;
          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return h;
          default:
            return;
        }
      }
    }
  }
  function l(c) {
    return c >= a ? Math.round(c / a) + "d" : c >= t ? Math.round(c / t) + "h" : c >= n ? Math.round(c / n) + "m" : c >= e ? Math.round(c / e) + "s" : c + "ms";
  }
  function u(c) {
    return s(c, a, "day") || s(c, t, "hour") || s(c, n, "minute") || s(c, e, "second") || c + " ms";
  }
  function s(c, d, h) {
    if (!(c < d))
      return c < d * 1.5 ? Math.floor(c / d) + " " + h : Math.ceil(c / d) + " " + h + "s";
  }
  return br;
}
var So;
function c$() {
  return So || (So = 1, function(e, n) {
    n = e.exports = o.debug = o.default = o, n.coerce = s, n.disable = l, n.enable = i, n.enabled = u, n.humanize = l$(), n.names = [], n.skips = [], n.formatters = {};
    var t;
    function a(c) {
      var d = 0, h;
      for (h in c)
        d = (d << 5) - d + c.charCodeAt(h), d |= 0;
      return n.colors[Math.abs(d) % n.colors.length];
    }
    function o(c) {
      function d() {
        if (d.enabled) {
          var h = d, f = +/* @__PURE__ */ new Date(), m = f - (t || f);
          h.diff = m, h.prev = t, h.curr = f, t = f;
          for (var _ = new Array(arguments.length), g = 0; g < _.length; g++)
            _[g] = arguments[g];
          _[0] = n.coerce(_[0]), typeof _[0] != "string" && _.unshift("%O");
          var $ = 0;
          _[0] = _[0].replace(/%([a-zA-Z%])/g, function(b, C) {
            if (b === "%%") return b;
            $++;
            var p = n.formatters[C];
            if (typeof p == "function") {
              var v = _[$];
              b = p.call(h, v), _.splice($, 1), $--;
            }
            return b;
          }), n.formatArgs.call(h, _);
          var x = d.log || n.log || console.log.bind(console);
          x.apply(h, _);
        }
      }
      return d.namespace = c, d.enabled = n.enabled(c), d.useColors = n.useColors(), d.color = a(c), typeof n.init == "function" && n.init(d), d;
    }
    function i(c) {
      n.save(c), n.names = [], n.skips = [];
      for (var d = (typeof c == "string" ? c : "").split(/[\s,]+/), h = d.length, f = 0; f < h; f++)
        d[f] && (c = d[f].replace(/\*/g, ".*?"), c[0] === "-" ? n.skips.push(new RegExp("^" + c.substr(1) + "$")) : n.names.push(new RegExp("^" + c + "$")));
    }
    function l() {
      n.enable("");
    }
    function u(c) {
      var d, h;
      for (d = 0, h = n.skips.length; d < h; d++)
        if (n.skips[d].test(c))
          return !1;
      for (d = 0, h = n.names.length; d < h; d++)
        if (n.names[d].test(c))
          return !0;
      return !1;
    }
    function s(c) {
      return c instanceof Error ? c.stack || c.message : c;
    }
  }(wn, wn.exports)), wn.exports;
}
var Eo;
function d$() {
  return Eo || (Eo = 1, function(e, n) {
    n = e.exports = c$(), n.log = o, n.formatArgs = a, n.save = i, n.load = l, n.useColors = t, n.storage = typeof chrome < "u" && typeof chrome.storage < "u" ? chrome.storage.local : u(), n.colors = [
      "lightseagreen",
      "forestgreen",
      "goldenrod",
      "dodgerblue",
      "darkorchid",
      "crimson"
    ];
    function t() {
      return typeof window < "u" && window.process && window.process.type === "renderer" ? !0 : typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // is firebug? http://stackoverflow.com/a/398120/376773
      typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // is firefox >= v31?
      // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
      typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // double check webkit in userAgent just in case we are in a worker
      typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
    }
    n.formatters.j = function(s) {
      try {
        return JSON.stringify(s);
      } catch (c) {
        return "[UnexpectedJSONParseError]: " + c.message;
      }
    };
    function a(s) {
      var c = this.useColors;
      if (s[0] = (c ? "%c" : "") + this.namespace + (c ? " %c" : " ") + s[0] + (c ? "%c " : " ") + "+" + n.humanize(this.diff), !!c) {
        var d = "color: " + this.color;
        s.splice(1, 0, d, "color: inherit");
        var h = 0, f = 0;
        s[0].replace(/%[a-zA-Z%]/g, function(m) {
          m !== "%%" && (h++, m === "%c" && (f = h));
        }), s.splice(f, 0, d);
      }
    }
    function o() {
      return typeof console == "object" && console.log && Function.prototype.apply.call(console.log, console, arguments);
    }
    function i(s) {
      try {
        s == null ? n.storage.removeItem("debug") : n.storage.debug = s;
      } catch {
      }
    }
    function l() {
      var s;
      try {
        s = n.storage.debug;
      } catch {
      }
      return !s && typeof process < "u" && "env" in process && (s = process.env.DEBUG), s;
    }
    n.enable(l());
    function u() {
      try {
        return window.localStorage;
      } catch {
      }
    }
  }(jn, jn.exports)), jn.exports;
}
var yr, ko;
function u$() {
  if (ko) return yr;
  ko = 1;
  var e = d$()("jsonp");
  yr = a;
  var n = 0;
  function t() {
  }
  function a(o, i, l) {
    typeof i == "function" && (l = i, i = {}), i || (i = {});
    var u = i.prefix || "__jp", s = i.name || u + n++, c = i.param || "callback", d = i.timeout != null ? i.timeout : 6e4, h = encodeURIComponent, f = document.getElementsByTagName("script")[0] || document.head, m, _;
    d && (_ = setTimeout(function() {
      g(), l && l(new Error("Timeout"));
    }, d));
    function g() {
      m.parentNode && m.parentNode.removeChild(m), window[s] = t, _ && clearTimeout(_);
    }
    function $() {
      window[s] && g();
    }
    return window[s] = function(x) {
      e("jsonp got", x), g(), l && l(null, x);
    }, o += (~o.indexOf("?") ? "&" : "?") + c + "=" + h(s), o = o.replace("?&", "?"), e('jsonp req "%s"', o), m = document.createElement("script"), m.src = o, f.parentNode.insertBefore(m, f), $;
  }
  return yr;
}
var h$ = u$();
const wt = /* @__PURE__ */ Dn(h$);
var f$ = Object.defineProperty, m$ = Object.defineProperties, _$ = Object.getOwnPropertyDescriptors, Fn = Object.getOwnPropertySymbols, bi = Object.prototype.hasOwnProperty, yi = Object.prototype.propertyIsEnumerable, Po = (e, n, t) => n in e ? f$(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, De = (e, n) => {
  for (var t in n || (n = {}))
    bi.call(n, t) && Po(e, t, n[t]);
  if (Fn)
    for (var t of Fn(n))
      yi.call(n, t) && Po(e, t, n[t]);
  return e;
}, Jr = (e, n) => m$(e, _$(n)), Qr = (e, n) => {
  var t = {};
  for (var a in e)
    bi.call(e, a) && n.indexOf(a) < 0 && (t[a] = e[a]);
  if (e != null && Fn)
    for (var a of Fn(e))
      n.indexOf(a) < 0 && yi.call(e, a) && (t[a] = e[a]);
  return t;
};
class $$ extends Error {
  constructor(n) {
    super(n), this.name = "AssertionError";
  }
}
function re(e, n) {
  if (!e)
    throw new $$(n);
}
function ee(e) {
  const n = Object.entries(e).filter(([, t]) => t != null).map(([t, a]) => `${encodeURIComponent(t)}=${encodeURIComponent(String(a))}`);
  return n.length > 0 ? `?${n.join("&")}` : "";
}
const p$ = (e) => !!e && (typeof e == "object" || typeof e == "function") && "then" in e && typeof e.then == "function", g$ = (e, n) => ({
  left: window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - e / 2,
  top: window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - n / 2
}), v$ = (e, n) => ({
  top: (window.screen.height - n) / 2,
  left: (window.screen.width - e) / 2
});
function x$(e, n, t) {
  var a = n, { height: o, width: i } = a, l = Qr(a, ["height", "width"]);
  const u = De({
    height: o,
    width: i,
    location: "no",
    toolbar: "no",
    status: "no",
    directories: "no",
    menubar: "no",
    scrollbars: "yes",
    resizable: "no",
    centerscreen: "yes",
    chrome: "yes"
  }, l), s = window.open(
    e,
    "",
    Object.keys(u).map((c) => `${c}=${u[c]}`).join(", ")
  );
  if (t) {
    const c = window.setInterval(() => {
      try {
        (s === null || s.closed) && (window.clearInterval(c), t(s));
      } catch (d) {
        console.error(d);
      }
    }, 1e3);
  }
  return s;
}
function b$(e) {
  var n = e, {
    beforeOnClick: t,
    children: a,
    className: o,
    disabled: i,
    disabledStyle: l = { opacity: 0.6 },
    forwardedRef: u,
    htmlTitle: s,
    networkLink: c,
    networkName: d,
    onClick: h,
    onShareWindowClose: f,
    openShareDialogOnClick: m = !0,
    opts: _,
    resetButtonStyle: g = !0,
    style: $,
    title: x,
    url: b,
    windowHeight: C = 400,
    windowPosition: p = "windowCenter",
    windowWidth: v = 550
  } = n, w = Qr(n, [
    "beforeOnClick",
    "children",
    "className",
    "disabled",
    "disabledStyle",
    "forwardedRef",
    "htmlTitle",
    "networkLink",
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    "networkName",
    // deconstructed from ...rest to prevent passing it to the button element
    "onClick",
    "onShareWindowClose",
    "openShareDialogOnClick",
    "opts",
    "resetButtonStyle",
    "style",
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    "title",
    // deconstructed from ...rest to prevent passing it to the button element
    "url",
    "windowHeight",
    "windowPosition",
    "windowWidth"
  ]);
  const S = async (O) => {
    const B = c(b, _);
    if (!i) {
      if (O.preventDefault(), t) {
        const M = t();
        p$(M) && await M;
      }
      if (m) {
        const M = De({
          height: C,
          width: v
        }, p === "windowCenter" ? g$(v, C) : v$(v, C));
        x$(B, M, f);
      }
      h && h(O, B);
    }
  }, D = y(
    "react-share__ShareButton",
    {
      "react-share__ShareButton--disabled": !!i,
      disabled: !!i
    },
    o
  ), Z = De(De(g ? {
    backgroundColor: "transparent",
    border: "none",
    padding: 0,
    font: "inherit",
    color: "inherit",
    cursor: "pointer"
  } : {}, $), i && l);
  return /* @__PURE__ */ r.jsx(
    "button",
    Jr(De({}, w), {
      className: D,
      onClick: S,
      ref: u,
      style: Z,
      title: s,
      children: a
    })
  );
}
function ie(e, n, t, a) {
  const o = (i, l) => {
    const u = t(i), s = De({}, i);
    return Object.keys(u).forEach((d) => {
      delete s[d];
    }), /* @__PURE__ */ r.jsx(
      b$,
      Jr(De(De({}, a), s), {
        forwardedRef: l,
        networkName: e,
        networkLink: n,
        opts: u
      })
    );
  };
  return o.displayName = `ShareButton-${e}`, Ri(o);
}
function y$(e, { title: n, separator: t }) {
  return re(e, "bluesky.url"), "https://bsky.app/intent/compose" + ee({
    text: n ? n + t + e : e
  });
}
ie(
  "bluesky",
  y$,
  (e) => ({
    title: e.title,
    separator: e.separator || " "
  }),
  {
    windowWidth: 660,
    windowHeight: 460,
    windowPosition: "windowCenter"
  }
);
function C$(e, { subject: n, body: t, separator: a }) {
  return "mailto:" + ee({ subject: n, body: t ? t + a + e : e });
}
const N$ = ie(
  "email",
  C$,
  (e) => ({
    subject: e.subject,
    body: e.body,
    separator: e.separator || " "
  }),
  {
    openShareDialogOnClick: !1,
    onClick: (e, n) => {
      window.location.href = n;
    }
  }
);
function j$(e, { appId: n, redirectUri: t, to: a }) {
  return "https://www.facebook.com/dialog/send" + ee({
    link: e,
    redirect_uri: t || e,
    app_id: n,
    to: a
  });
}
ie(
  "facebookmessenger",
  j$,
  (e) => ({
    appId: e.appId,
    redirectUri: e.redirectUri,
    to: e.to
  }),
  {
    windowWidth: 1e3,
    windowHeight: 820
  }
);
function w$(e, { hashtag: n }) {
  return re(e, "facebook.url"), "https://www.facebook.com/sharer/sharer.php" + ee({ u: e, hashtag: n });
}
const I$ = ie(
  "facebook",
  w$,
  (e) => ({ hashtag: e.hashtag }),
  {
    windowWidth: 550,
    windowHeight: 400
  }
);
function T$() {
  const e = Ee(!1);
  return fe(() => (e.current = !0, () => {
    e.current = !1;
  }), []), Nt(() => e.current, []);
}
function S$(e) {
  var n = e, {
    children: t = (f) => f,
    className: a,
    getCount: o,
    url: i
  } = n, l = Qr(n, [
    "children",
    "className",
    "getCount",
    "url"
  ]);
  const u = T$(), [s, c] = R(void 0), [d, h] = R(!1);
  return fe(() => {
    h(!0), o(i, (f) => {
      u() && (c(f), h(!1));
    });
  }, [i]), /* @__PURE__ */ r.jsx("span", Jr(De({ className: y("react-share__ShareCount", a) }, l), { children: !d && s !== void 0 && t(s) }));
}
function It(e) {
  const n = (t) => /* @__PURE__ */ r.jsx(S$, De({ getCount: e }, t));
  return n.displayName = `ShareCount(${e.name})`, n;
}
function E$(e, n) {
  const t = `https://graph.facebook.com/?id=${e}&fields=og_object{engagement}`;
  wt(t, (a, o) => {
    n(
      !a && o && o.og_object && o.og_object.engagement ? o.og_object.engagement.count : void 0
    );
  });
}
It(E$);
function k$(e, { title: n }) {
  return re(e, "hatena.url"), `http://b.hatena.ne.jp/add?mode=confirm&url=${e}&title=${n}`;
}
ie(
  "hatena",
  k$,
  (e) => ({
    title: e.title
  }),
  {
    windowWidth: 660,
    windowHeight: 460,
    windowPosition: "windowCenter"
  }
);
function P$(e, n) {
  wt(
    "https://bookmark.hatenaapis.com/count/entry" + ee({
      url: e
    }),
    (a, o) => {
      n(o ?? void 0);
    }
  );
}
It(P$);
function A$(e, { title: n, description: t }) {
  return re(e, "instapaper.url"), "http://www.instapaper.com/hello2" + ee({
    url: e,
    title: n,
    description: t
  });
}
ie(
  "instapaper",
  A$,
  (e) => ({
    title: e.title,
    description: e.description
  }),
  {
    windowWidth: 500,
    windowHeight: 500,
    windowPosition: "windowCenter"
  }
);
function R$(e, { title: n }) {
  return re(e, "line.url"), "https://social-plugins.line.me/lineit/share" + ee({
    url: e,
    text: n
  });
}
ie(
  "line",
  R$,
  (e) => ({
    title: e.title
  }),
  {
    windowWidth: 500,
    windowHeight: 500
  }
);
function O$(e, { title: n, summary: t, source: a }) {
  return re(e, "linkedin.url"), "https://linkedin.com/shareArticle" + ee({ url: e, mini: "true", title: n, summary: t, source: a });
}
const F$ = ie(
  "linkedin",
  O$,
  ({ title: e, summary: n, source: t }) => ({ title: e, summary: n, source: t }),
  {
    windowWidth: 750,
    windowHeight: 600
  }
);
function B$(e, { title: n, description: t }) {
  return re(e, "livejournal.url"), "https://www.livejournal.com/update.bml" + ee({
    subject: n,
    event: t
  });
}
ie(
  "livejournal",
  B$,
  (e) => ({
    title: e.title,
    description: e.description
  }),
  {
    windowWidth: 660,
    windowHeight: 460
  }
);
function M$(e, { title: n, description: t, imageUrl: a }) {
  return re(e, "mailru.url"), "https://connect.mail.ru/share" + ee({
    url: e,
    title: n,
    description: t,
    image_url: a
  });
}
ie(
  "mailru",
  M$,
  (e) => ({
    title: e.title,
    description: e.description,
    imageUrl: e.imageUrl
  }),
  {
    windowWidth: 660,
    windowHeight: 460
  }
);
function D$(e, { title: n, description: t, image: a }) {
  return re(e, "ok.url"), "https://connect.ok.ru/offer" + ee({
    url: e,
    title: n,
    description: t,
    imageUrl: a
  });
}
ie(
  "ok",
  D$,
  (e) => ({
    title: e.title,
    description: e.description,
    image: e.image
  }),
  {
    windowWidth: 588,
    windowHeight: 480,
    windowPosition: "screenCenter"
  }
);
function L$(e, n) {
  window.OK || (window.OK = {
    Share: {
      count: function(i, l) {
        var u, s;
        (s = (u = window.OK.callbacks)[i]) == null || s.call(u, l);
      }
    },
    callbacks: []
  });
  const t = "https://connect.ok.ru/dk", a = window.OK.callbacks.length;
  return window.ODKL = {
    updateCount(o, i) {
      var l, u;
      const s = o === "" ? 0 : parseInt(o.replace("react-share-", ""), 10);
      (u = (l = window.OK.callbacks)[s]) == null || u.call(l, i === "" ? void 0 : parseInt(i, 10));
    }
  }, window.OK.callbacks.push(n), wt(
    t + ee({
      "st.cmd": "extLike",
      uid: `react-share-${a}`,
      ref: e
    })
  );
}
It(L$);
function U$(e, { media: n, description: t, pinId: a }) {
  return a ? `https://pinterest.com/pin/${a}/repin/x/` : (re(e, "pinterest.url"), re(n, "pinterest.media"), "https://pinterest.com/pin/create/button/" + ee({
    url: e,
    media: n,
    description: t
  }));
}
ie(
  "pinterest",
  U$,
  (e) => ({
    media: e.media,
    description: e.description,
    pinId: e.pinId
  }),
  {
    windowWidth: 1e3,
    windowHeight: 730
  }
);
function V$(e, n) {
  wt(
    "https://api.pinterest.com/v1/urls/count.json" + ee({
      url: e
    }),
    (a, o) => {
      n(o ? o.count : void 0);
    }
  );
}
It(V$);
function W$(e, { title: n }) {
  return re(e, "pocket.url"), "https://getpocket.com/save" + ee({
    url: e,
    title: n
  });
}
ie(
  "pocket",
  W$,
  (e) => ({
    title: e.title
  }),
  {
    windowWidth: 500,
    windowHeight: 500
  }
);
function G$(e, { title: n }) {
  return re(e, "reddit.url"), "https://www.reddit.com/web/submit" + ee({
    url: e,
    title: n
  });
}
ie(
  "reddit",
  G$,
  (e) => ({
    title: e.title
  }),
  {
    windowWidth: 660,
    windowHeight: 460,
    windowPosition: "windowCenter"
  }
);
function z$(e, { title: n }) {
  return re(e, "gab.url"), "https://gab.com/compose" + ee({
    url: e,
    text: n
  });
}
ie(
  "gab",
  z$,
  (e) => ({
    title: e.title
  }),
  {
    windowWidth: 660,
    windowHeight: 640,
    windowPosition: "windowCenter"
  }
);
function H$(e, n) {
  const t = `https://www.reddit.com/api/info.json?limit=1&url=${e}`;
  wt(t, { param: "jsonp" }, (a, o) => {
    n(
      !a && o && o.data && o.data.children.length > 0 && o.data.children[0].data.score ? o.data.children[0].data.score : void 0
    );
  });
}
It(H$);
function q$(e, { title: n }) {
  return re(e, "telegram.url"), "https://telegram.me/share/url" + ee({
    url: e,
    text: n
  });
}
ie(
  "telegram",
  q$,
  (e) => ({
    title: e.title
  }),
  {
    windowWidth: 550,
    windowHeight: 400
  }
);
function Y$(e, { title: n }) {
  return re(e, "threads.url"), "https://threads.net/intent/post" + ee({
    url: e,
    text: n
  });
}
ie(
  "threads",
  Y$,
  (e) => ({
    title: e.title
  }),
  {
    windowWidth: 550,
    windowHeight: 600
  }
);
function K$(e, {
  title: n,
  caption: t,
  tags: a,
  posttype: o
}) {
  return re(e, "tumblr.url"), "https://www.tumblr.com/widgets/share/tool" + ee({
    canonicalUrl: e,
    title: n,
    caption: t,
    tags: a,
    posttype: o
  });
}
ie(
  "tumblr",
  K$,
  (e) => ({
    title: e.title,
    tags: (e.tags || []).join(","),
    caption: e.caption,
    posttype: e.posttype || "link"
  }),
  {
    windowWidth: 660,
    windowHeight: 460
  }
);
function X$(e, n) {
  return wt(
    "https://api.tumblr.com/v2/share/stats" + ee({
      url: e
    }),
    (a, o) => {
      n(!a && o && o.response ? o.response.note_count : void 0);
    }
  );
}
It(X$);
function Z$(e, {
  title: n,
  via: t,
  hashtags: a = [],
  related: o = []
}) {
  return re(e, "twitter.url"), re(Array.isArray(a), "twitter.hashtags is not an array"), re(Array.isArray(o), "twitter.related is not an array"), "https://twitter.com/intent/tweet" + ee({
    url: e,
    text: n,
    via: t,
    hashtags: a.length > 0 ? a.join(",") : void 0,
    related: o.length > 0 ? o.join(",") : void 0
  });
}
const J$ = ie(
  "twitter",
  Z$,
  (e) => ({
    hashtags: e.hashtags,
    title: e.title,
    via: e.via,
    related: e.related
  }),
  {
    windowWidth: 550,
    windowHeight: 400
  }
);
function Q$(e, { title: n, separator: t }) {
  return re(e, "viber.url"), "viber://forward" + ee({
    text: n ? n + t + e : e
  });
}
ie(
  "viber",
  Q$,
  (e) => ({
    title: e.title,
    separator: e.separator || " "
  }),
  {
    windowWidth: 660,
    windowHeight: 460
  }
);
function e5(e, { title: n, image: t, noParse: a, noVkLinks: o }) {
  return re(e, "vk.url"), "https://vk.com/share.php" + ee({
    url: e,
    title: n,
    image: t,
    noparse: a ? 1 : 0,
    no_vk_links: o ? 1 : 0
  });
}
ie(
  "vk",
  e5,
  (e) => ({
    title: e.title,
    image: e.image,
    noParse: e.noParse,
    noVkLinks: e.noVkLinks
  }),
  {
    windowWidth: 660,
    windowHeight: 460
  }
);
function t5(e, n) {
  window.VK || (window.VK = {}), window.VK.Share = {
    count: (o, i) => {
      var l, u;
      return (u = (l = window.VK.callbacks) == null ? void 0 : l[o]) == null ? void 0 : u.call(l, i);
    }
  }, window.VK.callbacks = [];
  const t = "https://vk.com/share.php", a = window.VK.callbacks.length;
  return window.VK.callbacks.push(n), wt(
    t + ee({
      act: "count",
      index: a,
      url: e
    })
  );
}
It(t5);
function n5(e, { title: n, image: t }) {
  return re(e, "weibo.url"), "http://service.weibo.com/share/share.php" + ee({
    url: e,
    title: n,
    pic: t
  });
}
ie(
  "weibo",
  n5,
  (e) => ({
    title: e.title,
    image: e.image
  }),
  {
    windowWidth: 660,
    windowHeight: 550,
    windowPosition: "screenCenter"
  }
);
function r5() {
  return /(android|iphone|ipad|mobile)/i.test(navigator.userAgent);
}
function a5(e, { title: n, separator: t }) {
  return re(e, "whatsapp.url"), "https://" + (r5() ? "api" : "web") + ".whatsapp.com/send" + ee({
    text: n ? n + t + e : e
  });
}
ie(
  "whatsapp",
  a5,
  (e) => ({
    title: e.title,
    separator: e.separator || " "
  }),
  {
    windowWidth: 550,
    windowHeight: 400
  }
);
function o5(e, { quote: n, hashtag: t }) {
  return re(e, "workplace.url"), "https://work.facebook.com/sharer.php" + ee({
    u: e,
    quote: n,
    hashtag: t
  });
}
ie(
  "workplace",
  o5,
  (e) => ({
    quote: e.quote,
    hashtag: e.hashtag
  }),
  {
    windowWidth: 550,
    windowHeight: 400
  }
);
const i5 = "_content_1japc_1", s5 = "_copy_1japc_7", l5 = "_list_1japc_14", Cr = {
  content: i5,
  copy: s5,
  list: l5
}, R7 = ({ title: e, copyText: n, children: t, subject: a }) => {
  const [o, i] = R(!1), l = {
    title: "{title}",
    url: "{window.location.href}"
  };
  function u() {
    const c = navigator.userAgent || navigator.vendor || window.opera;
    return !!(/iPad|iPhone|iPod/.test(c) && !window.MSStream || /android/i.test(c));
  }
  function s() {
    navigator.share && u() ? navigator.share({
      title: l.title,
      url: l.url
    }) : i(!o);
  }
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx("span", { onClick: () => s(), children: t }),
    o && /* @__PURE__ */ r.jsx(Bt, { title: e, onClose: () => i(!1), children: /* @__PURE__ */ r.jsxs("div", { className: Cr.content, children: [
      /* @__PURE__ */ r.jsx("span", { className: Cr.copy, children: n }),
      /* @__PURE__ */ r.jsx(sn, { truncate: 30, account: window.location.href }),
      /* @__PURE__ */ r.jsxs("div", { className: Cr.list, children: [
        /* @__PURE__ */ r.jsx(F$, { url: window.location.href, children: /* @__PURE__ */ r.jsx(E, { iconLeft: /* @__PURE__ */ r.jsx(Vi, {}), type: ne.OUTLINE, children: "LinkedIn" }) }),
        /* @__PURE__ */ r.jsx(I$, { url: window.location.href, children: /* @__PURE__ */ r.jsx(E, { iconLeft: /* @__PURE__ */ r.jsx(Ui, {}), type: ne.OUTLINE, children: "Facebook" }) }),
        /* @__PURE__ */ r.jsx(J$, { url: window.location.href, children: /* @__PURE__ */ r.jsx(E, { iconLeft: /* @__PURE__ */ r.jsx(Wi, {}), type: ne.OUTLINE, children: "Twitter" }) }),
        /* @__PURE__ */ r.jsx(N$, { url: window.location.href, subject: a, children: /* @__PURE__ */ r.jsx(E, { iconLeft: /* @__PURE__ */ r.jsx(Lo, {}), type: ne.OUTLINE, children: "Email" }) })
      ] })
    ] }) })
  ] });
}, bt = {
  DEPOSIT: "deposit",
  WITHDRAW: "withdraw"
}, c5 = "_pulse_1bc0x_1", d5 = "_container_1bc0x_17", u5 = "_box_1bc0x_36", h5 = "_rewards_1bc0x_42", f5 = "_content_1bc0x_50", m5 = "_info_1bc0x_56", _5 = "_header_1bc0x_80", $5 = "_headerTitle_1bc0x_91", p5 = "_headerSub_1bc0x_98", g5 = "_labelsContainer_1bc0x_104", v5 = "_valuesContainer_1bc0x_110", x5 = "_balanceContainer_1bc0x_118", b5 = "_boxTitle_1bc0x_141", y5 = "_highlighted_1bc0x_147", C5 = "_aprText_1bc0x_151", N5 = "_apr_1bc0x_151", j5 = "_balanceLabel_1bc0x_164", w5 = "_symbol_1bc0x_170", I5 = "_symbolContainer_1bc0x_174", T5 = "_symbolIcon_1bc0x_181", S5 = "_balance_1bc0x_118", E5 = "_dollar_1bc0x_187", k5 = "_buttonContainer_1bc0x_222", P5 = "_toggleContainer_1bc0x_227", A5 = "_inputContainer_1bc0x_233", R5 = "_inputBalance_1bc0x_242", O5 = "_inputBalanceLabel_1bc0x_250", F5 = "_input_1bc0x_233", B5 = "_inputBorder_1bc0x_267", M5 = "_inputSymbol_1bc0x_283", D5 = "_buttonsContainer_1bc0x_312", L5 = "_showMobile_1bc0x_323", U5 = "_hideMobile_1bc0x_328", V5 = "_aprContainer_1bc0x_343", W5 = "_burningFee_1bc0x_400", G5 = "_burningFeeValue_1bc0x_407", z5 = "_burningToken_1bc0x_413", H5 = "_feeModal_1bc0x_418", q5 = "_feeModalActions_1bc0x_423", Y5 = "_ctaContainer_1bc0x_433", T = {
  pulse: c5,
  container: d5,
  box: u5,
  rewards: h5,
  content: f5,
  info: m5,
  header: _5,
  headerTitle: $5,
  headerSub: p5,
  labelsContainer: g5,
  valuesContainer: v5,
  balanceContainer: x5,
  boxTitle: b5,
  highlighted: y5,
  aprText: C5,
  apr: N5,
  balanceLabel: j5,
  symbol: w5,
  symbolContainer: I5,
  symbolIcon: T5,
  balance: S5,
  dollar: E5,
  buttonContainer: k5,
  toggleContainer: P5,
  inputContainer: A5,
  inputBalance: R5,
  inputBalanceLabel: O5,
  input: F5,
  inputBorder: B5,
  inputSymbol: M5,
  buttonsContainer: D5,
  showMobile: L5,
  hideMobile: U5,
  aprContainer: V5,
  burningFee: W5,
  burningFeeValue: G5,
  burningToken: z5,
  feeModal: H5,
  feeModalActions: q5,
  ctaContainer: Y5
}, Ci = "2.25.0";
let Nr = {
  getDocsUrl: ({ docsBaseUrl: e, docsPath: n = "", docsSlug: t }) => n ? `${e ?? "https://viem.sh"}${n}${t ? `#${t}` : ""}` : void 0,
  version: `viem@${Ci}`
};
class Bn extends Error {
  constructor(n, t = {}) {
    const a = t.cause instanceof Bn ? t.cause.details : t.cause?.message ? t.cause.message : t.details, o = t.cause instanceof Bn && t.cause.docsPath || t.docsPath, i = Nr.getDocsUrl?.({ ...t, docsPath: o }), l = [
      n || "An error occurred.",
      "",
      ...t.metaMessages ? [...t.metaMessages, ""] : [],
      ...i ? [`Docs: ${i}`] : [],
      ...a ? [`Details: ${a}`] : [],
      ...Nr.version ? [`Version: ${Nr.version}`] : []
    ].join(`
`);
    super(l, t.cause ? { cause: t.cause } : void 0), Object.defineProperty(this, "details", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docsPath", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "metaMessages", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "shortMessage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "version", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "BaseError"
    }), this.details = a, this.docsPath = o, this.metaMessages = t.metaMessages, this.name = t.name ?? this.name, this.shortMessage = n, this.version = Ci;
  }
  walk(n) {
    return Ni(this, n);
  }
}
function Ni(e, n) {
  return n?.(e) ? e : e && typeof e == "object" && "cause" in e && e.cause !== void 0 ? Ni(e.cause, n) : n ? null : e;
}
const ji = {
  gwei: 9,
  wei: 18
};
function K5(e, n) {
  let t = e.toString();
  const a = t.startsWith("-");
  a && (t = t.slice(1)), t = t.padStart(n, "0");
  let [o, i] = [
    t.slice(0, t.length - n),
    t.slice(t.length - n)
  ];
  return i = i.replace(/(0+)$/, ""), `${a ? "-" : ""}${o || "0"}${i ? `.${i}` : ""}`;
}
function X5(e, n = "wei") {
  return K5(e, ji[n]);
}
class Z5 extends Bn {
  constructor({ value: n }) {
    super(`Number \`${n}\` is not a valid decimal number.`, {
      name: "InvalidDecimalNumberError"
    });
  }
}
function J5(e, n) {
  if (!/^(-?)([0-9]*)\.?([0-9]*)$/.test(e))
    throw new Z5({ value: e });
  let [t, a = "0"] = e.split(".");
  const o = t.startsWith("-");
  if (o && (t = t.slice(1)), a = a.replace(/(0+)$/, ""), n === 0)
    Math.round(+`.${a}`) === 1 && (t = `${BigInt(t) + 1n}`), a = "";
  else if (a.length > n) {
    const [i, l, u] = [
      a.slice(0, n - 1),
      a.slice(n - 1, n),
      a.slice(n)
    ], s = Math.round(+`${l}.${u}`);
    s > 9 ? a = `${BigInt(i) + BigInt(1)}0`.padStart(i.length + 1, "0") : a = `${i}${s}`, a.length > n && (a = a.slice(1), t = `${BigInt(t) + 1n}`), a = a.slice(0, n);
  } else
    a = a.padEnd(n, "0");
  return BigInt(`${o ? "-" : ""}${t}${a}`);
}
function jr(e, n = "wei") {
  return J5(e, ji[n]);
}
const Q5 = ({ actionOnClose: e, actionOnSubmit: n, literal: t, children: a }) => /* @__PURE__ */ r.jsx(Bt, { title: t.form.burningFee.modal.title, onClose: e, children: /* @__PURE__ */ r.jsxs("div", { className: T.feeModal, children: [
  a,
  /* @__PURE__ */ r.jsx("p", { children: t.form.burningFee.modal.text }),
  /* @__PURE__ */ r.jsxs("div", { className: T.feeModalActions, children: [
    /* @__PURE__ */ r.jsx(E, { onClick: e, type: "outline", children: t.form.actions.cancel }),
    /* @__PURE__ */ r.jsx(E, { onClick: n, children: t.form.actions.submit })
  ] })
] }) });
function e4(e) {
  return (Number(e) / 86400).toFixed(0);
}
const Ao = ({ burningFee: e, inputValue: n, yieldAction: t, balance: a, literal: o }) => {
  const { claim: i, withdraw: l } = e;
  if (!i || !l) return null;
  const u = l.percentage * +n / 100, s = e4(i.feeInterval);
  return /* @__PURE__ */ r.jsx(r.Fragment, { children: /* @__PURE__ */ r.jsx("div", { className: T.burningFee, children: t === bt.DEPOSIT ? /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx("p", { children: `🔥 ${o.form.burningFee.deposit}` }),
    " ",
    /* @__PURE__ */ r.jsxs("p", { className: T.burningFeeValue, children: [
      /* @__PURE__ */ r.jsx("b", { children: `${i.minPercentage} - ${i.maxPercentage}%` }),
      " ",
      `(${s} d)`
    ] })
  ] }) : /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx("p", { children: `🔥 ${o.form.burningFee.withdraw} ` }),
    /* @__PURE__ */ r.jsxs("p", { className: T.burningFeeValue, children: [
      /* @__PURE__ */ r.jsx("b", { children: `${l.percentage.toFixed(2)}%` }),
      u > 0 && /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
        "= ",
        /* @__PURE__ */ r.jsx("span", { className: T.burningToken, children: u.toFixed(2) }),
        " ",
        a.tokenID
      ] })
    ] })
  ] }) }) });
}, t4 = (e = !1) => {
  const [n, t] = R(e), a = Nt(() => {
    t((o) => !o);
  }, []);
  return [n, a];
}, n4 = ({
  getAmountAllowance: e,
  burningFee: n,
  isApproveLoading: t,
  isDepositLoading: a,
  isWithdrawLoading: o,
  isWalletActive: i,
  walletBalance: l,
  depositedBalance: u,
  onDeposit: s,
  onWithdraw: c,
  onApprove: d,
  literal: h,
  symbol: f,
  allowedBalance: m
}) => {
  const [_, g] = R(bt.DEPOSIT), [$, x] = R("0"), [b, C] = t4(), p = _ === bt.DEPOSIT, v = p ? l : u, w = jr($.toString()), S = ht(
    () => _ === bt.DEPOSIT ? m.number : v.number,
    [m, v, _]
  ), D = ht(
    () => w <= v.bigint && w > 0,
    [v.bigint, w]
  ), Z = p ? a : o, O = p ? e({ amount: $ }) : !0, B = [
    {
      value: bt.DEPOSIT,
      label: h.form.toggle.deposit
    },
    {
      value: bt.WITHDRAW,
      label: h.form.toggle.withdraw
    }
  ], M = (se) => {
    const Le = se.target.value;
    x(Le);
  }, k = Nt(
    (se) => {
      if (v.number === 0) return;
      const Le = v.bigint * jr(String(se)) / jr("100"), Tt = X5(Le);
      x(Tt);
    },
    [v]
  ), Oe = (se) => {
    g(se), x("0");
  }, Fe = Nt(() => {
    (p ? s : c)({ amount: $ }).then(() => {
      x("0"), C();
    });
  }, [p, s, c, $, C]);
  return /* @__PURE__ */ r.jsxs("div", { className: T.box, children: [
    /* @__PURE__ */ r.jsx("div", { className: T.toggleContainer, children: /* @__PURE__ */ r.jsx(
      Ko,
      {
        items: B,
        selectedItem: _,
        onChange: (se) => Oe(se)
      }
    ) }),
    n && /* @__PURE__ */ r.jsx(
      Ao,
      {
        balance: v,
        burningFee: n,
        inputValue: $,
        yieldAction: _,
        literal: h
      }
    ),
    /* @__PURE__ */ r.jsxs("div", { className: T.inputContainer, children: [
      /* @__PURE__ */ r.jsxs(
        "div",
        {
          className: y(T.inputBalance, {
            [T.pulse]: Z
          }),
          children: [
            /* @__PURE__ */ r.jsxs("span", { className: T.inputBalanceLabel, children: [
              h.form.allowed,
              ": "
            ] }),
            S
          ]
        }
      ),
      /* @__PURE__ */ r.jsx(
        "input",
        {
          className: T.input,
          inputMode: "decimal",
          type: "number",
          placeholder: "0.0",
          pattern: "[0-9]*(.[0-9]+)?",
          value: $,
          onChange: M
        }
      ),
      /* @__PURE__ */ r.jsx("span", { className: T.inputBorder }),
      /* @__PURE__ */ r.jsx("div", { className: T.inputSymbol, children: f })
    ] }),
    /* @__PURE__ */ r.jsxs("div", { className: T.buttonsContainer, children: [
      /* @__PURE__ */ r.jsx("div", { className: T.hideMobile, children: /* @__PURE__ */ r.jsx(
        E,
        {
          isFull: !0,
          type: ne.OUTLINE,
          color: P.SURFACE_INVERSE,
          size: dt.SMALL,
          onClick: () => k(25),
          children: "25%"
        }
      ) }),
      /* @__PURE__ */ r.jsx("div", { className: T.showMobile, children: /* @__PURE__ */ r.jsx(
        E,
        {
          isFull: !0,
          type: ne.OUTLINE,
          color: P.SURFACE_INVERSE,
          size: dt.SMALL,
          onClick: () => k(50),
          children: "50%"
        }
      ) }),
      /* @__PURE__ */ r.jsx("div", { className: T.hideMobile, children: /* @__PURE__ */ r.jsx(
        E,
        {
          isFull: !0,
          type: ne.OUTLINE,
          color: P.SURFACE_INVERSE,
          size: dt.SMALL,
          onClick: () => k(75),
          children: "75%"
        }
      ) }),
      /* @__PURE__ */ r.jsx("div", { className: T.showMobile, children: /* @__PURE__ */ r.jsx(
        E,
        {
          isFull: !0,
          type: ne.OUTLINE,
          color: P.SURFACE_INVERSE,
          size: dt.SMALL,
          onClick: () => k(100),
          children: "100%"
        }
      ) })
    ] }),
    /* @__PURE__ */ r.jsx("div", { className: T.ctaContainer, children: O ? /* @__PURE__ */ r.jsx(
      E,
      {
        isFull: !0,
        color: P.ACCENT,
        isDisabled: !D,
        isLoading: p ? a : o,
        onClick: n && _ === bt.WITHDRAW ? C : Fe,
        children: h.form.actions.submit
      }
    ) : /* @__PURE__ */ r.jsx(
      E,
      {
        isFull: !0,
        color: P.PRIMARY,
        isDisabled: !i || O,
        onClick: () => d({ amount: $ }),
        isLoading: t && !O,
        children: h.form.actions.approve
      }
    ) }),
    b && n && /* @__PURE__ */ r.jsx(Q5, { actionOnClose: C, actionOnSubmit: Fe, literal: h, children: /* @__PURE__ */ r.jsx(
      Ao,
      {
        balance: v,
        burningFee: n,
        inputValue: $,
        yieldAction: _,
        literal: h
      }
    ) })
  ] });
};
var wi = /* @__PURE__ */ ((e) => (e.USD = "en-US", e.EUR = "de-DE", e))(wi || {});
const Ii = ({
  number: e,
  currency: n,
  min: t = 0,
  max: a = 2
}) => {
  const o = wi[n];
  return e.toLocaleString(o, { minimumFractionDigits: t, maximumFractionDigits: a });
}, r4 = ({ literal: e, balance: n, onClaim: t, isClaiming: a, currencyID: o }) => {
  const i = n.number > 0, l = n.currencyAmounts?.find((s) => s.currencyID === o)?.formatted, u = Ii({ number: n.number, currency: o });
  return /* @__PURE__ */ r.jsx("div", { className: y(T.box, T.rewards), children: /* @__PURE__ */ r.jsxs("div", { className: T.content, children: [
    /* @__PURE__ */ r.jsxs("p", { className: T.boxTitle, children: [
      /* @__PURE__ */ r.jsx("span", { className: T.symbol, children: n.tokenID }),
      " ",
      e.rewards.pending
    ] }),
    /* @__PURE__ */ r.jsxs("div", { className: T.valuesContainer, children: [
      /* @__PURE__ */ r.jsxs("div", { children: [
        /* @__PURE__ */ r.jsx("span", { className: T.balance, children: u }),
        /* @__PURE__ */ r.jsx("span", { className: T.dollar, children: l })
      ] }),
      /* @__PURE__ */ r.jsx("div", { className: T.buttonContainer, children: /* @__PURE__ */ r.jsx(
        E,
        {
          isLoading: a,
          onClick: t,
          isDisabled: !i,
          color: P.ACCENT,
          size: dt.SMALL,
          children: e.rewards.claim
        }
      ) })
    ] })
  ] }) });
}, a4 = ({ icon: e, literal: n }) => /* @__PURE__ */ r.jsxs("header", { className: y(T.box, T.header), children: [
  e && /* @__PURE__ */ r.jsx("span", { className: T.tokenSymbolHeader, children: e }),
  /* @__PURE__ */ r.jsxs("div", { children: [
    /* @__PURE__ */ r.jsx("h3", { className: T.headerTitle, children: n.header.title }),
    /* @__PURE__ */ r.jsx("p", { className: T.headerSub, children: n.header.subtitle })
  ] })
] }), Ro = ({
  balanceType: e,
  currencyID: n,
  tokenIcon: t,
  onBalanceClick: a,
  isTransactionPending: o,
  balance: i,
  literal: l,
  symbol: u
}) => {
  const s = i.currencyAmounts?.find((d) => d.currencyID === n)?.formatted, c = Ii({ number: i.number, currency: n });
  return /* @__PURE__ */ r.jsxs("div", { className: T.box, children: [
    /* @__PURE__ */ r.jsxs("p", { className: y(T.highlighted, T.balanceLabel), children: [
      /* @__PURE__ */ r.jsx("span", { className: T.boxTitle, children: l.balance[e] }),
      /* @__PURE__ */ r.jsxs("span", { className: T.symbolContainer, children: [
        /* @__PURE__ */ r.jsx("span", { className: T.symbol, children: u }),
        /* @__PURE__ */ r.jsx("span", { className: T.symbolIcon, children: t })
      ] })
    ] }),
    /* @__PURE__ */ r.jsxs("div", { className: T.valuesContainer, children: [
      /* @__PURE__ */ r.jsxs(
        "div",
        {
          className: y(T.labelsContainer, {
            [T.pulse]: o
          }),
          children: [
            /* @__PURE__ */ r.jsx("span", { className: T.balance, children: c }),
            /* @__PURE__ */ r.jsx("span", { className: T.dollar, children: s })
          ]
        }
      ),
      a && /* @__PURE__ */ r.jsx("div", { className: T.buttonContainer, children: /* @__PURE__ */ r.jsx(E, { size: dt.SMALL, onClick: a, color: P.ACCENT, children: l.balance.get }) })
    ] })
  ] });
}, o4 = ({ apr: e }) => e ? /* @__PURE__ */ r.jsxs("div", { className: y(T.box, T.aprContainer), children: [
  /* @__PURE__ */ r.jsx("span", { className: y(T.aprText, T.highlighted), children: "APR" }),
  /* @__PURE__ */ r.jsxs("span", { className: T.apr, children: [
    e,
    "%"
  ] })
] }) : null, O7 = ({
  allowedBalance: e,
  apr: n,
  burningFee: t,
  currencyID: a,
  depositedBalance: o,
  getAmountAllowance: i,
  headerIcon: l,
  isApproveLoading: u = !1,
  isClaiming: s,
  isDepositLoading: c = !1,
  isWalletActive: d,
  isWithdrawLoading: h = !1,
  literal: f,
  onApprove: m,
  onBalanceClick: _,
  onClaim: g,
  onDeposit: $,
  onWithdraw: x,
  rewardsBalance: b,
  showHeader: C = !0,
  symbol: p,
  tokenIcon: v,
  walletBalance: w,
  yieldIcon: S
}) => {
  const D = ht(
    () => d && (!w || !o),
    [d, w, o]
  );
  return /* @__PURE__ */ r.jsxs("section", { className: T.container, children: [
    C && /* @__PURE__ */ r.jsx(a4, { icon: l, literal: f }),
    d && !D && /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
      /* @__PURE__ */ r.jsxs("div", { className: T.balanceContainer, children: [
        /* @__PURE__ */ r.jsx(
          Ro,
          {
            symbol: p,
            balanceType: "token",
            currencyID: a,
            tokenIcon: v,
            balance: w,
            onBalanceClick: _,
            literal: f
          }
        ),
        /* @__PURE__ */ r.jsx(
          Ro,
          {
            symbol: p,
            balanceType: "yield",
            tokenIcon: S,
            balance: o,
            literal: f,
            currencyID: a
          }
        )
      ] }),
      /* @__PURE__ */ r.jsx(
        n4,
        {
          symbol: p,
          allowedBalance: e,
          getAmountAllowance: i,
          burningFee: t,
          isApproveLoading: u,
          isDepositLoading: c,
          isWithdrawLoading: h,
          isWalletActive: d,
          walletBalance: w,
          depositedBalance: o,
          onDeposit: $,
          onWithdraw: x,
          onApprove: m,
          literal: f
        }
      ),
      /* @__PURE__ */ r.jsx(o4, { apr: n }),
      b && /* @__PURE__ */ r.jsx(
        r4,
        {
          currencyID: a,
          literal: f,
          balance: b,
          onClaim: g,
          isClaiming: s
        }
      )
    ] }),
    D && /* @__PURE__ */ r.jsx("div", { className: y(T.box, T.info), children: f.loading }),
    !d && /* @__PURE__ */ r.jsx("div", { className: y(T.box, T.info), children: f.connect })
  ] });
}, i4 = "_card_29oht_1", s4 = "_title_29oht_27", l4 = "_icon_29oht_35", c4 = "_info_29oht_40", d4 = "_row_29oht_52", u4 = "_label_29oht_59", h4 = "_value_29oht_65", f4 = "_highlighted_29oht_71", m4 = "_buttons_29oht_76", _4 = "_disabled_29oht_83", $4 = "_loading_29oht_87", de = {
  card: i4,
  title: s4,
  icon: l4,
  info: c4,
  row: d4,
  label: u4,
  value: h4,
  highlighted: f4,
  buttons: m4,
  disabled: _4,
  loading: $4
}, F7 = ({
  Icon: e,
  aprValue: n = "0 %",
  depositedValue: t = "$ 0",
  share: a = "0 %",
  rewardsValue: o = "$ 0",
  tvlValue: i = "$ 0",
  onClaimClick: l = () => {
  },
  onDepositClick: u = () => {
  },
  isClaimDisabled: s,
  isDepositDisabled: c,
  isUserActive: d,
  isUserLoading: h,
  t: f
}) => {
  const m = y(de.row, {
    [de.disabled]: !d,
    [de.loading]: h
  });
  return /* @__PURE__ */ r.jsxs("article", { className: de.card, children: [
    /* @__PURE__ */ r.jsx("h3", { className: de.title, children: f.title }),
    e && /* @__PURE__ */ r.jsx("span", { className: de.icon, children: /* @__PURE__ */ r.jsx(e, {}) }),
    /* @__PURE__ */ r.jsxs("div", { className: de.info, children: [
      /* @__PURE__ */ r.jsxs("div", { className: de.row, children: [
        /* @__PURE__ */ r.jsx("div", { className: de.label, children: f.apr }),
        /* @__PURE__ */ r.jsx("div", { className: y(de.value, de.highlighted), children: n })
      ] }),
      /* @__PURE__ */ r.jsxs("div", { className: de.row, children: [
        /* @__PURE__ */ r.jsx("div", { className: de.label, children: f.tvl }),
        /* @__PURE__ */ r.jsx("div", { className: de.value, children: i })
      ] }),
      /* @__PURE__ */ r.jsxs("div", { className: m, children: [
        /* @__PURE__ */ r.jsx("div", { className: de.label, children: f.share }),
        /* @__PURE__ */ r.jsx("div", { className: de.value, children: a })
      ] }),
      /* @__PURE__ */ r.jsxs("div", { className: m, children: [
        /* @__PURE__ */ r.jsx("div", { className: de.label, children: f.deposited }),
        /* @__PURE__ */ r.jsx("div", { className: de.value, children: t })
      ] }),
      /* @__PURE__ */ r.jsxs("div", { className: m, children: [
        /* @__PURE__ */ r.jsx("div", { className: de.label, children: f.rewards }),
        /* @__PURE__ */ r.jsx("div", { className: de.value, children: o })
      ] })
    ] }),
    /* @__PURE__ */ r.jsxs("div", { className: de.buttons, children: [
      /* @__PURE__ */ r.jsx(E, { isFull: !0, onClick: u, color: P.ACCENT, isDisabled: c, children: f.button.deposit }),
      /* @__PURE__ */ r.jsx(E, { isFull: !0, onClick: l, color: P.PRIMARY, isDisabled: s, children: f.button.claim })
    ] })
  ] });
}, p4 = "_container_1m43r_1", g4 = "_containerPrice_1m43r_13", v4 = "_logo_1m43r_17", x4 = "_priceValue_1m43r_23", b4 = "_addressTitle_1m43r_44", y4 = "_link_1m43r_60", At = {
  container: p4,
  containerPrice: g4,
  logo: v4,
  priceValue: x4,
  addressTitle: b4,
  link: y4
}, B7 = ({
  t: e,
  onClose: n = () => {
  },
  onAddToken: t = () => {
  },
  address: a,
  symbol: o,
  logo: i,
  link: l,
  price: u,
  isActive: s
}) => /* @__PURE__ */ r.jsx(Bt, { title: o, onClose: n, children: /* @__PURE__ */ r.jsxs("div", { className: At.container, children: [
  /* @__PURE__ */ r.jsxs("div", { className: At.containerPrice, children: [
    /* @__PURE__ */ r.jsx("img", { className: At.logo, src: i, alt: "logo" }),
    /* @__PURE__ */ r.jsx("span", { className: At.priceValue, children: u })
  ] }),
  /* @__PURE__ */ r.jsxs("div", { children: [
    /* @__PURE__ */ r.jsx("h3", { className: At.addressTitle, children: e.addressTitle }),
    /* @__PURE__ */ r.jsx(sn, { truncate: 10, account: a })
  ] }),
  /* @__PURE__ */ r.jsx("a", { className: At.link, href: l, target: "_blank", rel: "noreferrer", children: e.explorer }),
  /* @__PURE__ */ r.jsx(E, { onClick: t, isDisabled: !s, children: e.addToken })
] }) }), C4 = "_navbar_fz73j_1", N4 = "_menuButtonItem_fz73j_17", j4 = "_navItem_fz73j_26", w4 = "_current_fz73j_37", I4 = "_navIcon_fz73j_41", T4 = "_tag_fz73j_47", S4 = "_burger_fz73j_64", E4 = "_menuBackground_fz73j_116", k4 = "_open_fz73j_132", P4 = "_menuContent_fz73j_137", Me = {
  navbar: C4,
  menuButtonItem: N4,
  navItem: j4,
  current: w4,
  navIcon: I4,
  tag: T4,
  burger: S4,
  menuBackground: E4,
  open: k4,
  menuContent: P4
}, A4 = ({ t: e, bottomItems: n, menuItems: t, currentRoute: a, onOpenChange: o, onRouteChange: i }) => {
  const [l, u] = R(!1);
  fe(() => {
    u(!1);
  }, [a]);
  const s = () => {
    const f = !l;
    u(f), o && o(f);
  }, c = () => {
    u(!1), o && o(!1);
  }, d = ({ isOpen: f }) => /* @__PURE__ */ r.jsx("div", { className: y(Me.menuBackground, { [Me.open]: f }), onClick: c, children: /* @__PURE__ */ r.jsx("div", { className: y(Me.menuContent, { [Me.open]: f }), onClick: (m) => m.stopPropagation(), children: /* @__PURE__ */ r.jsx("div", { className: Me.menu, children: /* @__PURE__ */ r.jsx(
    pi,
    {
      t: e,
      menu: t,
      currentRoute: a,
      onOpenChange: o,
      onRouteChange: i
    }
  ) }) }) }), h = ({ url: f, icon: m, onClick: _, tag: g }) => {
    const $ = (x) => {
      _ && _(), x && i(x);
    };
    return /* @__PURE__ */ r.jsx(
      "div",
      {
        className: y(Me.navItem, {
          [Me.current]: a === f
        }),
        onClick: () => $(f),
        children: /* @__PURE__ */ r.jsxs("div", { className: Me.navIcon, children: [
          /* @__PURE__ */ r.jsx(m, {}),
          g && /* @__PURE__ */ r.jsx("span", { className: Me.tag, children: g })
        ] })
      }
    );
  };
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsxs("div", { className: Me.navbar, children: [
      n?.slice(0, 4).map((f) => /* @__PURE__ */ Ir(h, { ...f, key: f.label })),
      /* @__PURE__ */ r.jsx("div", { className: Me.menuButtonItem, children: /* @__PURE__ */ r.jsxs("label", { className: Me.burger, htmlFor: "burger", children: [
        /* @__PURE__ */ r.jsx("input", { onClick: s, type: "checkbox", id: "burger", checked: l, readOnly: !0 }),
        /* @__PURE__ */ r.jsx("span", {}),
        /* @__PURE__ */ r.jsx("span", {}),
        /* @__PURE__ */ r.jsx("span", {})
      ] }) })
    ] }),
    /* @__PURE__ */ r.jsx(d, { isOpen: l })
  ] });
}, M7 = A4, R4 = "_btnMobile_myt72_3", O4 = "_btnDesktop_myt72_7", F4 = "_modalContainer_myt72_11", B4 = "_rowTitle_myt72_16", M4 = "_moduleBottom_myt72_22", D4 = "_title_myt72_28", L4 = "_earnedText_myt72_45", U4 = "_earnedQuantity_myt72_54", V4 = "_moduleProgress_myt72_62", W4 = "_fontBase_myt72_68", G4 = "_containerModule_myt72_72", z4 = "_moduleAvailable_myt72_91", H4 = "_available_myt72_99", q4 = "_symbol_myt72_104", Y4 = "_quantityUsd_myt72_109", K4 = "_progress_myt72_115", X4 = "_integer_myt72_121", Z4 = "_integerTotal_myt72_125", ue = {
  btnMobile: R4,
  btnDesktop: O4,
  modalContainer: F4,
  rowTitle: B4,
  moduleBottom: M4,
  title: D4,
  earnedText: L4,
  earnedQuantity: U4,
  moduleProgress: V4,
  fontBase: W4,
  containerModule: G4,
  moduleAvailable: z4,
  available: H4,
  symbol: q4,
  quantityUsd: Y4,
  progress: K4,
  integer: X4,
  integerTotal: Z4
}, D7 = ({ t: e, rewards: n, onClaim: t, isLoading: a }) => {
  const [o, i] = R(!1), l = n.reduce((d, h) => d + h.available?.number, 0), u = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(l), s = n.some((d) => d.isLoading) || a, c = ({ header: d, available: h, earned: f, earnedLabel: m, progress: _, claim: g, claimTxType: $, symbol: x, isLoading: b }) => {
    const [C, p] = h.formatted.split("."), v = `(${_}%)`;
    return /* @__PURE__ */ r.jsxs("div", { className: ue.containerModule, children: [
      /* @__PURE__ */ r.jsxs("div", { className: ue.rowTitle, children: [
        /* @__PURE__ */ r.jsx("h3", { className: ue.title, children: d }),
        /* @__PURE__ */ r.jsxs("div", { className: ue.moduleProgress, children: [
          /* @__PURE__ */ r.jsx("span", { className: ue.earnedText, children: m }),
          /* @__PURE__ */ r.jsxs("div", { className: ue.earnedQuantity, children: [
            /* @__PURE__ */ r.jsx("span", { className: ue.integerTotal, children: f.formatted }),
            /* @__PURE__ */ r.jsx("span", { className: ue.symbol, children: x }),
            _ && /* @__PURE__ */ r.jsx("span", { className: ue.progress, children: v })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ r.jsxs("div", { className: ue.moduleBottom, children: [
        /* @__PURE__ */ r.jsxs("div", { className: ue.moduleAvailable, children: [
          /* @__PURE__ */ r.jsxs("div", { className: ue.available, children: [
            /* @__PURE__ */ r.jsx("span", { className: ue.integer, children: C }),
            p && /* @__PURE__ */ r.jsxs("span", { className: ue.decimalTut, children: [
              ".",
              p
            ] }),
            /* @__PURE__ */ r.jsx("span", { className: ue.symbol, children: x })
          ] }),
          /* @__PURE__ */ r.jsx("span", { className: ue.quantityUsd, children: h.formattedUSD })
        ] }),
        /* @__PURE__ */ r.jsx("div", { className: ue.moduleButton, children: /* @__PURE__ */ r.jsx(
          E,
          {
            isDisabled: h.number === 0 || b,
            isLoading: b,
            onClick: () => t({ claim: g, claimTxType: $ }),
            color: P.ACCENT,
            children: e.claim
          }
        ) })
      ] })
    ] });
  };
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx("div", { className: ue.btnMobile, children: /* @__PURE__ */ r.jsx(
      E,
      {
        isLoading: s,
        type: ne.OUTLINE,
        onClick: () => i(!o),
        iconLeft: /* @__PURE__ */ r.jsx(ra, {}),
        isDisabled: l === 0
      }
    ) }),
    /* @__PURE__ */ r.jsx("div", { className: ue.btnDesktop, children: /* @__PURE__ */ r.jsx(
      E,
      {
        isLoading: s,
        type: ne.OUTLINE,
        onClick: () => i(!o),
        iconLeft: /* @__PURE__ */ r.jsx(ra, {}),
        isDisabled: l === 0,
        children: /* @__PURE__ */ r.jsx("span", { className: ue.fontBase, children: u })
      }
    ) }),
    o && /* @__PURE__ */ r.jsx(Bt, { onClose: () => i(!1), title: e.title, children: /* @__PURE__ */ r.jsx("div", { className: ue.modalContainer, children: n.map((d, h) => /* @__PURE__ */ r.jsx(c, { ...d }, h)) }) })
  ] });
}, J4 = "_totalBox_lj4nd_1", Q4 = "_totalBoxTitle_lj4nd_12", ep = "_totalBoxValue_lj4nd_21", tp = "_highlighted_lj4nd_33", In = {
  totalBox: J4,
  totalBoxTitle: Q4,
  totalBoxValue: ep,
  highlighted: tp
}, L7 = ({ title: e, value: n = "$ 0.00", isHighlighted: t = !1 }) => {
  const a = y(In.totalBox, {
    [In.highlighted]: t
  });
  return /* @__PURE__ */ r.jsxs("div", { className: a, children: [
    /* @__PURE__ */ r.jsx("span", { className: In.totalBoxTitle, children: e }),
    /* @__PURE__ */ r.jsx("span", { className: In.totalBoxValue, children: n })
  ] });
}, np = "_walletBox_1cxxp_1", rp = "_walletBoxTitle_1cxxp_13", ap = "_walletBoxIcon_1cxxp_24", op = "_walletBoxRow_1cxxp_31", ip = "_walletBoxValue_1cxxp_40", sp = "_walletBoxTotalValue_1cxxp_47", lp = "_walletBoxPoolRow_1cxxp_56", cp = "_walletBoxPoolValue_1cxxp_65", dp = "_walletBoxPoolIcon_1cxxp_72", up = "_walletBoxLabel_1cxxp_78", Ne = {
  walletBox: np,
  walletBoxTitle: rp,
  walletBoxIcon: ap,
  walletBoxRow: op,
  walletBoxValue: ip,
  walletBoxTotalValue: sp,
  walletBoxPoolRow: lp,
  walletBoxPoolValue: cp,
  walletBoxPoolIcon: dp,
  walletBoxLabel: up
}, Oo = "$ 0.00", Fo = "0", hp = {
  amount: "Amount",
  price: "Price",
  get: "Get"
}, U7 = ({
  t: e = hp,
  title: n,
  amount: t = Fo,
  value: a = Oo,
  price: o = Oo,
  icon: i,
  pool: l = null,
  onGetClick: u = () => {
  },
  hidePrice: s = !1
}) => {
  const c = Array.isArray(l) && l.length > 0;
  return /* @__PURE__ */ r.jsxs("div", { className: Ne.walletBox, children: [
    /* @__PURE__ */ r.jsxs("div", { className: Ne.walletBoxContent, children: [
      /* @__PURE__ */ r.jsx("h3", { className: Ne.walletBoxTitle, children: n }),
      /* @__PURE__ */ r.jsx("div", { className: Ne.walletBoxIcon, children: i }),
      /* @__PURE__ */ r.jsx("span", { className: Ne.walletBoxTotalValue, children: a }),
      !s && /* @__PURE__ */ r.jsxs("div", { className: Ne.walletBoxRow, children: [
        /* @__PURE__ */ r.jsx("span", { className: Ne.walletBoxLabel, children: e.amount }),
        /* @__PURE__ */ r.jsx("span", { className: Ne.walletBoxValue, children: t })
      ] }),
      c ? l.map(({ icon: d, amount: h = Fo }, f) => /* @__PURE__ */ r.jsx(r.Fragment, { children: !s && /* @__PURE__ */ r.jsxs("div", { className: Ne.walletBoxPoolRow, children: [
        /* @__PURE__ */ r.jsx("span", { className: Ne.walletBoxPoolIcon, children: d() }),
        /* @__PURE__ */ r.jsx("span", { className: Ne.walletBoxPoolValue, children: h })
      ] }, f) })) : /* @__PURE__ */ r.jsx(r.Fragment, { children: !s && /* @__PURE__ */ r.jsxs("div", { className: Ne.walletBoxRow, children: [
        /* @__PURE__ */ r.jsx("span", { className: Ne.walletBoxLabel, children: e.price }),
        /* @__PURE__ */ r.jsx("span", { className: Ne.walletBoxValue, children: o })
      ] }) })
    ] }),
    /* @__PURE__ */ r.jsx("div", { className: Ne.walletBoxCta, children: /* @__PURE__ */ r.jsx(E, { color: P.ACCENT, onClick: u, isFull: !0, children: e.get }) })
  ] });
}, fp = "_yieldBox_1117j_1", mp = "_yieldBoxTitle_1117j_17", _p = "_yieldBoxIcon_1117j_27", $p = "_yieldBoxTotalValue_1117j_34", pp = "_yieldBoxRow_1117j_43", gp = "_yieldBoxBlock_1117j_49", vp = "_yieldBoxRowIcon_1117j_53", xp = "_yieldBoxRowHeader_1117j_58", bp = "_yieldBoxRowValue_1117j_62", yp = "_yieldBoxCta_1117j_72", Q = {
  yieldBox: fp,
  yieldBoxTitle: mp,
  yieldBoxIcon: _p,
  yieldBoxTotalValue: $p,
  yieldBoxRow: pp,
  yieldBoxBlock: gp,
  yieldBoxRowIcon: vp,
  yieldBoxRowHeader: xp,
  yieldBoxRowValue: bp,
  yieldBoxCta: yp
}, Gt = "$ 0.00", wr = "0", Cp = {
  supplied: "Supplied",
  value: "Value",
  rewards: "Rewards",
  deposit: "Deposit",
  claim: "Claim",
  obtained: "Obtained"
}, V7 = ({
  t: e = Cp,
  title: n,
  value: t = Gt,
  icon: a,
  supplied: o = [],
  obtained: i = [],
  rewards: l = {},
  onDepositClick: u = () => {
  },
  onClaimClick: s = () => {
  }
}) => {
  const { icon: c, amount: d = wr, value: h = Gt } = l;
  return /* @__PURE__ */ r.jsxs("div", { className: Q.yieldBox, children: [
    /* @__PURE__ */ r.jsx("h3", { className: Q.yieldBoxTitle, children: n }),
    /* @__PURE__ */ r.jsx("div", { className: Q.yieldBoxIcon, children: a }),
    /* @__PURE__ */ r.jsx("span", { className: Q.yieldBoxTotalValue, children: t }),
    /* @__PURE__ */ r.jsxs("div", { className: Q.yieldBoxBlock, children: [
      /* @__PURE__ */ r.jsxs("div", { className: Q.yieldBoxRow, children: [
        /* @__PURE__ */ r.jsx("span", { className: y(Q.yieldBoxRowHeader), children: e.supplied }),
        /* @__PURE__ */ r.jsx("span", { className: Q.yieldBoxRowHeader, children: e.value })
      ] }),
      o.map(({ icon: f, amount: m = wr, value: _ = Gt, showValue: g = !0 }, $) => /* @__PURE__ */ r.jsxs("div", { className: Q.yieldBoxRow, children: [
        /* @__PURE__ */ r.jsxs("span", { className: Q.yieldBoxRowValue, children: [
          /* @__PURE__ */ r.jsx("div", { className: Q.yieldBoxRowIcon, children: f() }),
          m
        ] }),
        g && /* @__PURE__ */ r.jsx("span", { className: Q.yieldBoxRowValue, children: _ })
      ] }, $))
    ] }),
    i.map(({ icon: f, amount: m = wr, value: _ = Gt, showValue: g = !0 }, $) => /* @__PURE__ */ r.jsxs("div", { className: Q.yieldBoxBlock, children: [
      /* @__PURE__ */ r.jsx("div", { className: Q.yieldBoxRow, children: /* @__PURE__ */ r.jsx("span", { className: y(Q.yieldBoxRowHeader), children: e.obtained }) }),
      /* @__PURE__ */ r.jsxs("div", { className: Q.yieldBoxRow, children: [
        /* @__PURE__ */ r.jsxs("span", { className: Q.yieldBoxRowValue, children: [
          /* @__PURE__ */ r.jsx("div", { className: Q.yieldBoxRowIcon, children: f() }),
          m
        ] }),
        g && /* @__PURE__ */ r.jsx("span", { className: Q.yieldBoxRowValue, children: _ })
      ] })
    ] }, $)),
    /* @__PURE__ */ r.jsxs("div", { className: Q.yieldBoxBlock, children: [
      /* @__PURE__ */ r.jsxs("div", { className: Q.yieldBoxRow, children: [
        /* @__PURE__ */ r.jsx("span", { className: Q.yieldBoxRowHeader, children: e.rewards }),
        /* @__PURE__ */ r.jsx("span", { className: Q.yieldBoxRowHeader, children: e.value })
      ] }),
      /* @__PURE__ */ r.jsxs("div", { className: Q.yieldBoxRow, children: [
        /* @__PURE__ */ r.jsxs("span", { className: Q.yieldBoxRowValue, children: [
          /* @__PURE__ */ r.jsx("div", { className: Q.yieldBoxRowIcon, children: c() }),
          d
        ] }),
        /* @__PURE__ */ r.jsx("span", { className: Q.yieldBoxRowValue, children: h })
      ] })
    ] }),
    /* @__PURE__ */ r.jsxs("div", { className: Q.yieldBoxCta, children: [
      /* @__PURE__ */ r.jsx(E, { color: P.ACCENT, onClick: u, isFull: !0, children: e.deposit }),
      /* @__PURE__ */ r.jsx(E, { color: P.PRIMARY, onClick: s, isFull: !0, isDisabled: h === Gt, children: e.claim })
    ] })
  ] });
}, Np = "_burger_1b3ft_1", jp = "_menu_1b3ft_6", wp = "_menuLogo_1b3ft_11", Ip = "_menuBackground_1b3ft_19", Tp = "_menuContent_1b3ft_34", Sp = "_closeModal_1b3ft_44", Ep = "_closeModalIcon_1b3ft_54", vt = {
  burger: Np,
  menu: jp,
  menuLogo: wp,
  menuBackground: Ip,
  menuContent: Tp,
  closeModal: Sp,
  closeModalIcon: Ep
}, kp = ({
  t: e,
  currentRoute: n,
  menuItems: t,
  menuLogo: a,
  onMenuLogoClick: o,
  onOpenChange: i,
  onRouteChange: l
}) => {
  const [u, s] = R(!1);
  fe(() => {
    s(!1);
  }, [n]);
  const c = () => {
    s(!0), i && i(!0);
  }, d = () => {
    s(!1), i && i(!1);
  }, h = () => /* @__PURE__ */ r.jsxs("div", { className: vt.menuBackground, children: [
    /* @__PURE__ */ r.jsxs("div", { className: vt.menuContent, children: [
      /* @__PURE__ */ r.jsx("div", { className: vt.menuLogo, children: /* @__PURE__ */ r.jsx("img", { src: a, alt: "logo", onClick: o }) }),
      /* @__PURE__ */ r.jsx("div", { className: vt.menu, children: /* @__PURE__ */ r.jsx(
        pi,
        {
          t: e,
          menu: t,
          currentRoute: n,
          onOpenChange: i,
          onRouteChange: l
        }
      ) })
    ] }),
    /* @__PURE__ */ r.jsx("div", { className: vt.closeModal, onClick: d, children: /* @__PURE__ */ r.jsx("div", { className: vt.closeModalIcon, children: /* @__PURE__ */ r.jsx(an, {}) }) })
  ] });
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx("div", { className: vt.burger, onClick: c, children: /* @__PURE__ */ r.jsx(qi, {}) }),
    u && /* @__PURE__ */ r.jsx(h, {})
  ] });
}, Pp = (e, n) => e.isOpen === n.isOpen && e.currentRoute === n.currentRoute, W7 = Oi(kp, Pp), Ap = "_poolContent_24qpt_1", Rp = "_container_24qpt_10", Op = "_formsContainer_24qpt_26", Fp = "_form_24qpt_26", Bp = "_earned_24qpt_60", Mp = "_icon_24qpt_68", Dp = "_buttonContainer_24qpt_97", Lp = "_settingsContainer_24qpt_112", Se = {
  poolContent: Ap,
  container: Rp,
  formsContainer: Op,
  form: Fp,
  earned: Bp,
  icon: Mp,
  buttonContainer: Dp,
  settingsContainer: Lp
}, Up = "_container_j4je0_1", Vp = "_iconWrapper_j4je0_8", Wp = "_tokenIcon_j4je0_13", Gp = "_tokenDetails_j4je0_24", zp = "_tokenLabel_j4je0_30", Hp = "_tokenSymbol_j4je0_34", qp = "_inputWrapper_j4je0_39", Yp = "_inputRow_j4je0_50", Kp = "_inputDecoratorWrapper_j4je0_57", Xp = "_balanceDecorator_j4je0_61", Zp = "_percentageDecorator_j4je0_66", Jp = "_input_j4je0_39", Qp = "_maxButton_j4je0_108", eg = "_estimatedAmount_j4je0_125", tg = "_resize_j4je0_138", ng = "_error_j4je0_144", rg = "_hidden_j4je0_148", he = {
  container: Up,
  iconWrapper: Vp,
  tokenIcon: Wp,
  tokenDetails: Gp,
  tokenLabel: zp,
  tokenSymbol: Hp,
  inputWrapper: qp,
  inputRow: Yp,
  inputDecoratorWrapper: Kp,
  balanceDecorator: Xp,
  percentageDecorator: Zp,
  input: Jp,
  maxButton: Qp,
  estimatedAmount: eg,
  resize: tg,
  error: ng,
  hidden: rg
}, ag = "_box_127tg_1", og = {
  box: ag
}, ea = ({ children: e, className: n }) => {
  const t = y(og.box, n);
  return /* @__PURE__ */ r.jsx("div", { className: t, children: e });
}, Ur = ({
  actionTypeText: e,
  balanceAmount: n,
  balanceText: t,
  currencyAmount: a,
  handleMax: o,
  hasBalance: i = !0,
  inputType: l = "amount",
  resize: u = !0,
  symbol: s,
  tokenIcon: c,
  ...d
}) => {
  const h = l === "percentage", f = y(he.inputDecoratorWrapper, {
    [he.error]: !i,
    [he.hidden]: d.disabled
  }), m = y(he.container, {
    [he.resize]: !u
  }), _ = y(he.inputRow, {
    [he.hidden]: d.disabled || h
  });
  return /* @__PURE__ */ r.jsxs(ea, { className: m, children: [
    /* @__PURE__ */ r.jsxs("div", { className: he.iconWrapper, children: [
      /* @__PURE__ */ r.jsx("div", { className: he.tokenIcon, children: c }),
      /* @__PURE__ */ r.jsxs("div", { className: he.tokenDetails, children: [
        /* @__PURE__ */ r.jsx("div", { className: he.tokenLabel, children: e }),
        /* @__PURE__ */ r.jsx("label", { htmlFor: d.id, className: he.tokenSymbol, children: s })
      ] })
    ] }),
    /* @__PURE__ */ r.jsxs("div", { className: he.inputWrapper, children: [
      /* @__PURE__ */ r.jsxs("div", { className: he.inputRow, children: [
        /* @__PURE__ */ r.jsx("div", { className: f, children: h ? /* @__PURE__ */ r.jsx("span", { className: he.percentageDecorator, children: "%" }) : /* @__PURE__ */ r.jsx(r.Fragment, { children: /* @__PURE__ */ r.jsxs("span", { className: he.balanceDecorator, children: [
          t,
          " ",
          n
        ] }) }) }),
        /* @__PURE__ */ r.jsx(
          "input",
          {
            autoComplete: "off",
            ...d,
            className: he.input,
            type: "text",
            inputMode: "decimal",
            placeholder: "0.00",
            lang: "en-US"
          }
        )
      ] }),
      /* @__PURE__ */ r.jsxs("div", { className: _, children: [
        /* @__PURE__ */ r.jsx("button", { onClick: o, className: he.maxButton, type: "button", children: "Max" }),
        /* @__PURE__ */ r.jsxs("span", { className: he.estimatedAmount, children: [
          "~",
          a
        ] })
      ] })
    ] })
  ] });
}, ig = "_dataWrapper_zogh5_1", sg = "_dataLabel_zogh5_8", lg = "_valueHolder_zogh5_13", cg = "_inputHolder_zogh5_29", dg = "_icon_zogh5_52", Ot = {
  dataWrapper: ig,
  dataLabel: sg,
  valueHolder: lg,
  inputHolder: cg,
  icon: dg
}, ft = ({ tooltip: e, format: n, title: t, ...a }) => /* @__PURE__ */ r.jsxs("div", { className: Ot.dataWrapper, children: [
  /* @__PURE__ */ r.jsx(nn, { size: yt.L, text: e, placement: tn.BOTTOM, children: /* @__PURE__ */ r.jsx("span", { className: Ot.icon, children: /* @__PURE__ */ r.jsx(Ft, {}) }) }),
  /* @__PURE__ */ r.jsx("span", { className: Ot.dataLabel, children: t }),
  /* @__PURE__ */ r.jsxs("div", { className: Ot.valueHolder, children: [
    /* @__PURE__ */ r.jsx("input", { ...a, className: Ot.inputHolder }),
    /* @__PURE__ */ r.jsx("span", { children: n })
  ] })
] }), Ti = { deadline: 20, slippage: 0.2 }, ug = ({
  depositInputAmounts: e,
  getAmountAllowance: n,
  isLoading: t,
  literal: a,
  onApprove: o,
  onChange: i,
  onDeposit: l,
  reservesConfig: u,
  userTokenBalances: s
}) => {
  const [c, d] = R(Ti), h = ht(
    () => u.map(({ id: m }) => {
      const _ = e.find(($) => $.tokenID === m), g = n({ amount: _ }) || !1;
      return { tokenID: m, isApproved: g };
    }),
    [n, e, u]
  ), f = h.every(({ isApproved: m }) => m);
  return /* @__PURE__ */ r.jsxs("div", { className: Se.container, children: [
    /* @__PURE__ */ r.jsx("div", { className: Se.formsContainer, children: u.map(({ id: m, decimals: _, symbol: g }, $) => {
      const x = s.find((v) => v.tokenID === m), b = e.find((v) => v.tokenID === m), C = x?.bigint >= b.bigint, p = $ === u.length - 1;
      return /* @__PURE__ */ r.jsxs("div", { className: Se.form, children: [
        /* @__PURE__ */ r.jsx(
          Ur,
          {
            actionTypeText: a.add.actions.deposit,
            balanceAmount: x.formatted,
            balanceText: a.add.balance,
            currencyAmount: b.formattedCurrencyAmount,
            handleMax: () => i({ tokenID: m, amount: x.amount }),
            hasBalance: C,
            id: m,
            name: m,
            onChange: (v) => i({ tokenID: m, amount: v.target.value }),
            pattern: Sr(_).source,
            symbol: g,
            tokenIcon: /* @__PURE__ */ r.jsx(jt, { iconKey: m }),
            value: b.amount
          }
        ),
        !p && /* @__PURE__ */ r.jsx("span", { className: Se.icon, children: /* @__PURE__ */ r.jsx(Go, {}) })
      ] }, m);
    }) }),
    /* @__PURE__ */ r.jsx("div", { className: Se.buttonContainer, children: f ? /* @__PURE__ */ r.jsx(
      E,
      {
        isFull: !0,
        color: "accent",
        isLoading: t,
        isDisabled: t,
        onClick: () => l({ amounts: e, txSettings: c }),
        children: a.add.actions.deposit
      }
    ) : u.map(({ id: m }) => {
      if (h.find((C) => C.tokenID === m).isApproved) return null;
      const g = s.find((C) => C.tokenID === m), $ = e.find((C) => C.tokenID === m), x = g?.bigint >= $.bigint, b = t || $.bigint === 0n || !x;
      return /* @__PURE__ */ r.jsxs(
        E,
        {
          isFull: !0,
          onClick: () => o({ amount: $ }),
          isLoading: t,
          isDisabled: b,
          children: [
            a.add.actions.approve,
            " ",
            m
          ]
        },
        m
      );
    }) }),
    /* @__PURE__ */ r.jsxs("div", { className: Se.settingsContainer, children: [
      /* @__PURE__ */ r.jsx(
        ft,
        {
          format: "%",
          onChange: (m) => d({ ...c, slippage: Number(m.target.value) }),
          tooltip: a.transactionSettings.slippage.description,
          type: "number",
          title: "Slippage",
          id: "slippage",
          name: "slippage",
          value: c.slippage,
          step: "0.1",
          min: "1",
          max: "100",
          placeholder: "00"
        }
      ),
      /* @__PURE__ */ r.jsx(
        ft,
        {
          format: "min",
          onChange: (m) => d({ ...c, deadline: Number(m.target.value) }),
          tooltip: a.transactionSettings.deadline.description,
          type: "number",
          title: "Deadline",
          id: "deadline",
          name: "deadline",
          value: c.slippage,
          step: "0.1",
          min: "1",
          max: "1440",
          placeholder: "00"
        }
      )
    ] })
  ] });
};
var Kt = /* @__PURE__ */ ((e) => (e.DEPOSIT = "deposit", e.WITHDRAW = "withdraw", e))(Kt || {});
const hg = "_card_1a11m_1", fg = {
  card: hg
}, mg = ({ children: e, className: n }) => {
  const t = y(fg.card, n);
  return /* @__PURE__ */ r.jsx("section", { className: t, children: e });
}, _g = ({
  getAmountAllowance: e,
  inputAmount: n,
  isLoading: t,
  literal: a,
  onApprove: o,
  onChange: i,
  onWithdraw: l,
  outputAmounts: u,
  poolConfig: s,
  reservesConfig: c,
  userPoolBalance: d
}) => {
  const [h, f] = R(Ti), m = s.id, _ = ht(() => e({ amount: n }), [e, n]), g = d.bigint >= n.bigint, $ = t || !g;
  return /* @__PURE__ */ r.jsxs("div", { className: Se.container, children: [
    /* @__PURE__ */ r.jsxs("div", { className: Se.formsContainer, children: [
      /* @__PURE__ */ r.jsxs("div", { id: m, className: Se.form, children: [
        /* @__PURE__ */ r.jsx(
          Ur,
          {
            actionTypeText: a.add.actions.deposit,
            balanceAmount: d.formatted,
            balanceText: a.add.balance,
            currencyAmount: n.formattedCurrencyAmount,
            handleMax: () => i({ tokenID: d.tokenID, amount: d.amount }),
            hasBalance: g,
            id: m,
            name: m,
            onChange: (x) => i({ tokenID: m, amount: x.target.value }),
            pattern: Sr(s.decimals).source,
            symbol: s.symbol,
            tokenIcon: /* @__PURE__ */ r.jsx(jt, { iconKey: m }),
            value: n.amount
          }
        ),
        /* @__PURE__ */ r.jsx("span", { className: Se.icon, children: /* @__PURE__ */ r.jsx(Yi, {}) })
      ] }),
      /* @__PURE__ */ r.jsx("div", { className: Se.earned, children: c.map(({ id: x, decimals: b, symbol: C }) => {
        const p = u.find((v) => v.tokenID === x);
        return /* @__PURE__ */ r.jsx(
          Ur,
          {
            pattern: Sr(b).source,
            disabled: !0,
            symbol: C,
            value: p.formatted,
            id: x,
            tokenIcon: /* @__PURE__ */ r.jsx(jt, { iconKey: x }),
            actionTypeText: a.remove.receive,
            resize: !1
          },
          x
        );
      }) })
    ] }),
    /* @__PURE__ */ r.jsx("div", { className: Se.buttonContainer, children: _ ? /* @__PURE__ */ r.jsx(
      E,
      {
        isFull: !0,
        color: "accent",
        isLoading: t,
        isDisabled: $,
        onClick: () => l({ amount: n, txSettings: h }),
        children: a.remove.actions.retire
      }
    ) : /* @__PURE__ */ r.jsx(
      E,
      {
        isFull: !0,
        isLoading: t,
        isDisabled: $,
        onClick: () => o({ amount: n }),
        children: a.remove.actions.approve
      }
    ) }),
    /* @__PURE__ */ r.jsxs("div", { id: m, className: Se.settingsContainer, children: [
      /* @__PURE__ */ r.jsx(
        ft,
        {
          format: "%",
          onChange: (x) => f({ ...h, slippage: Number(x.target.value) }),
          tooltip: a.transactionSettings.slippage.description,
          type: "number",
          title: "Slippage",
          id: "slippage",
          value: h.slippage,
          step: "0.1",
          min: "1",
          max: "100",
          placeholder: "00"
        }
      ),
      /* @__PURE__ */ r.jsx(
        ft,
        {
          format: "min",
          onChange: (x) => f({ ...h, deadline: Number(x.target.value) }),
          tooltip: a.transactionSettings.deadline.description,
          type: "number",
          title: "Deadline",
          id: "deadline",
          value: h.deadline,
          step: "0.1",
          min: "1",
          max: "1440",
          placeholder: "00"
        }
      )
    ] })
  ] });
}, $g = "_container_p2uy6_1", pg = "_skeleton_p2uy6_7", gg = "_skeletonTitle_p2uy6_24", vg = "_skeletonSubTitle_p2uy6_30", xg = "_skeletonSubInfo_p2uy6_35", bg = "_title_p2uy6_61", yg = "_symbol_p2uy6_72", Cg = "_balance_p2uy6_76", Ng = "_value_p2uy6_86", jg = "_integer_p2uy6_90", wg = "_currency_p2uy6_104", Ig = "_share_p2uy6_105", Tg = "_icon_p2uy6_118", Sg = "_poolTokens_p2uy6_126", Eg = "_poolValue_p2uy6_134", kg = "_shareIcon_p2uy6_150", Pg = "_poolSymbol_p2uy6_156", Ag = "_info_p2uy6_160", pe = {
  container: $g,
  skeleton: pg,
  skeletonTitle: gg,
  skeletonSubTitle: vg,
  skeletonSubInfo: xg,
  title: bg,
  symbol: yg,
  balance: Cg,
  value: Ng,
  integer: jg,
  currency: wg,
  share: Ig,
  icon: Tg,
  poolTokens: Sg,
  poolValue: Eg,
  shareIcon: kg,
  poolSymbol: Pg,
  info: Ag
}, Rg = () => /* @__PURE__ */ r.jsxs(ea, { className: pe.skeleton, "data-testid": "skeleton", children: [
  /* @__PURE__ */ r.jsx("span", { className: pe.skeletonTitle }),
  /* @__PURE__ */ r.jsx("span", { className: pe.skeletonSubTitle }),
  /* @__PURE__ */ r.jsx("span", { className: pe.skeletonSubInfo })
] }), Og = ({
  balance: e,
  isLoading: n,
  reserves: t,
  share: a,
  symbol: o,
  title: i,
  reservesConfig: l,
  valueIcon: u
}) => n ? /* @__PURE__ */ r.jsx(Rg, {}) : /* @__PURE__ */ r.jsxs(ea, { className: pe.container, children: [
  /* @__PURE__ */ r.jsxs("h3", { className: pe.title, children: [
    i,
    /* @__PURE__ */ r.jsx("span", { className: pe.symbol, children: o }),
    /* @__PURE__ */ r.jsx("span", { className: pe.icon, children: u })
  ] }),
  /* @__PURE__ */ r.jsx("div", { className: pe.balance, children: /* @__PURE__ */ r.jsx("div", { className: pe.value, children: /* @__PURE__ */ r.jsx("span", { className: pe.integer, children: e.formatted }) }) }),
  t && /* @__PURE__ */ r.jsx("div", { className: pe.poolTokens, children: t.map((s) => {
    const c = l.find((d) => d.id === s.tokenID)?.symbol;
    return /* @__PURE__ */ r.jsxs("div", { className: pe.poolValue, children: [
      /* @__PURE__ */ r.jsx("span", { children: s.formatted }),
      /* @__PURE__ */ r.jsx("span", { className: pe.poolSymbol, children: c })
    ] }, c);
  }) }),
  /* @__PURE__ */ r.jsxs("div", { className: pe.info, children: [
    /* @__PURE__ */ r.jsx("span", { className: pe.currency, children: e.formattedCurrencyAmount }),
    a && /* @__PURE__ */ r.jsxs("div", { className: pe.share, children: [
      /* @__PURE__ */ r.jsx("span", { children: a }),
      " ",
      /* @__PURE__ */ r.jsx("div", { className: pe.shareIcon, children: "%" })
    ] })
  ] })
] }), G7 = ({
  action: e,
  depositInputAmounts: n,
  getAmountAllowance: t,
  isApproveLoading: a,
  isDepositLoading: o,
  isWithdrawLoading: i,
  literal: l,
  onActionChange: u,
  onDepositApproveSubmit: s,
  onDepositChange: c,
  onDepositSubmit: d,
  onWithdrawApproveSubmit: h,
  onWithdrawChange: f,
  onWithdrawSubmit: m,
  poolConfig: _,
  poolReservesConfig: g,
  share: $,
  showBalance: x = !1,
  userPoolBalance: b,
  userPoolReservesBalances: C,
  userTokensBalances: p,
  withdrawInputAmount: v,
  withdrawOutputAmounts: w
}) => {
  const S = [
    {
      value: Kt.DEPOSIT,
      label: l.actions.add
    },
    {
      value: Kt.WITHDRAW,
      label: l.actions.remove
    }
  ];
  return /* @__PURE__ */ r.jsxs(mg, { className: Se.poolContent, children: [
    /* @__PURE__ */ r.jsx(
      Ko,
      {
        items: S,
        selectedItem: e,
        onChange: (D) => u(D)
      }
    ),
    x && C && /* @__PURE__ */ r.jsx(
      Og,
      {
        balance: b,
        isLoading: o || i,
        reserves: C,
        reservesConfig: g,
        share: $,
        symbol: _.symbol,
        title: l.balance.title,
        valueIcon: /* @__PURE__ */ r.jsx(jt, { iconKey: _.id, variant: "outlined" })
      }
    ),
    e === Kt.DEPOSIT && /* @__PURE__ */ r.jsx(
      ug,
      {
        depositInputAmounts: n,
        getAmountAllowance: t,
        isLoading: a || o,
        literal: l.forms,
        onApprove: s,
        onChange: c,
        onDeposit: d,
        reservesConfig: g,
        userTokenBalances: p
      }
    ),
    e === Kt.WITHDRAW && /* @__PURE__ */ r.jsx(
      _g,
      {
        getAmountAllowance: t,
        inputAmount: v,
        isLoading: a || i,
        literal: l.forms,
        onApprove: h,
        onChange: f,
        onWithdraw: m,
        outputAmounts: w,
        poolConfig: _,
        reservesConfig: g,
        userPoolBalance: b
      }
    )
  ] });
}, z7 = ({ literal: e, txSettings: n, handleTxSettingsChange: t }) => /* @__PURE__ */ r.jsxs("form", { className: Ot.container, children: [
  /* @__PURE__ */ r.jsx(
    ft,
    {
      format: "%",
      title: "Slippage",
      onChange: t,
      tooltip: e.slippage.description,
      type: "number",
      name: "slippage",
      id: "slippage",
      defaultValue: n.slippage,
      step: "0.1",
      min: "0",
      placeholder: "0.00"
    }
  ),
  /* @__PURE__ */ r.jsx(
    ft,
    {
      format: "min",
      title: "Deadline",
      onChange: t,
      tooltip: e.deadline.description,
      type: "number",
      name: "deadline",
      id: "deadline",
      defaultValue: n.deadline,
      step: "1",
      min: "1",
      placeholder: "0.00"
    }
  )
] }), Si = (e) => `${e.slice(0, 6)}...${e.slice(-4)}`, Fg = "_modalContent_gnrm9_1", Bg = "_modalContainer_gnrm9_8", Mg = "_tokenContainer_gnrm9_21", Dg = "_tokenContent_gnrm9_42", Lg = "_tokenIconWrapper_gnrm9_48", Ug = "_tokenIcon_gnrm9_48", Vg = "_tokenName_gnrm9_63", Wg = "_tokenInfo_gnrm9_70", it = {
  modalContent: Fg,
  modalContainer: Bg,
  tokenContainer: Mg,
  tokenContent: Dg,
  tokenIconWrapper: Lg,
  tokenIcon: Ug,
  tokenName: Vg,
  tokenInfo: Wg
}, Gg = ({
  availableTokens: e,
  inputTokenID: n,
  outputTokenID: t,
  onTokenChange: a,
  onClose: o,
  literals: i
}) => {
  const l = ({ tokenID: u }) => {
    a({ tokenID: u }), o();
  };
  return /* @__PURE__ */ r.jsx(Bt, { title: i.selectTokenModalTitle, onClose: o, children: /* @__PURE__ */ r.jsx("div", { className: it.modalContainer, children: /* @__PURE__ */ r.jsx("div", { className: it.modalContent, children: e.filter((u) => u.tokenID !== n && u.tokenID !== t).map((u) => /* @__PURE__ */ r.jsx(
    "div",
    {
      className: it.tokenContainer,
      onClick: () => l({ tokenID: u.tokenID }),
      children: /* @__PURE__ */ r.jsxs("div", { className: it.tokenContent, children: [
        /* @__PURE__ */ r.jsx("div", { children: /* @__PURE__ */ r.jsx("div", { className: it.tokenIconWrapper, children: /* @__PURE__ */ r.jsx("span", { className: it.tokenIcon, children: u.icon }) }) }),
        /* @__PURE__ */ r.jsxs("div", { children: [
          /* @__PURE__ */ r.jsx("div", { className: it.tokenName, children: u.name }),
          /* @__PURE__ */ r.jsxs("div", { className: it.tokenInfo, children: [
            /* @__PURE__ */ r.jsx("span", { children: u.symbol }),
            " ",
            /* @__PURE__ */ r.jsx("span", { children: Si(u.address) })
          ] })
        ] })
      ] })
    },
    u.tokenID
  )) }) }) });
}, zg = "_container_17wrz_1", Hg = "_tokenContainer_17wrz_14", qg = "_tokenText_17wrz_20", Yg = "_tokenSelector_17wrz_25", Kg = "_tokenTextColor_17wrz_33", Xg = "_caret_17wrz_41", Zg = "_inputContainer_17wrz_50", Jg = "_inputWrapper_17wrz_56", Qg = "_inputWrapperContent_17wrz_62", e9 = "_setMax_17wrz_69", t9 = "_valueHolder_17wrz_86", n9 = "_priceImpact_17wrz_95", r9 = "_priceImpactNone_17wrz_99", a9 = "_priceImpactHigh_17wrz_103", o9 = "_priceImpactMedium_17wrz_107", i9 = "_priceImpactPossitive_17wrz_111", s9 = "_currencyImage_17wrz_116", l9 = "_iconContainer_17wrz_124", c9 = "_balanceLabel_17wrz_140", d9 = "_balance_17wrz_140", u9 = "_notEnought_17wrz_155", h9 = "_inputAmount_17wrz_220", f9 = "_loading_17wrz_272", ae = {
  container: zg,
  tokenContainer: Hg,
  tokenText: qg,
  tokenSelector: Yg,
  tokenTextColor: Kg,
  caret: Xg,
  inputContainer: Zg,
  inputWrapper: Jg,
  inputWrapperContent: Qg,
  setMax: e9,
  valueHolder: t9,
  priceImpact: n9,
  priceImpactNone: r9,
  priceImpactHigh: a9,
  priceImpactMedium: o9,
  priceImpactPossitive: i9,
  currencyImage: s9,
  iconContainer: l9,
  balanceLabel: c9,
  balance: d9,
  notEnought: u9,
  inputAmount: h9,
  loading: f9
};
var Mn = /* @__PURE__ */ ((e) => (e.INPUT = "INPUT", e.OUTPUT = "OUTPUT", e))(Mn || {});
const Bo = ({
  availableTokens: e,
  balance: n,
  inputTokenID: t,
  isLoading: a,
  literals: o,
  onAmountChange: i,
  onTokenChange: l,
  outputTokenID: u,
  priceImpact: s,
  tokenAmount: c,
  tokenInfo: d,
  type: h
}) => {
  const [f, m] = R(!1), _ = ({ tokenID: S }) => {
    l({ tokenID: S }), m(!1);
  }, g = () => i({ amount: n.amount }), $ = () => m(!0), x = h === Mn.INPUT, b = n.bigint >= c.bigint, C = y(ae.container, {
    [ae.loading]: a
  }), p = y(ae.balance, {
    [ae.notEnought]: !b && x
  }), v = y(ae.priceImpact, {
    [ae.priceImpactPossitive]: s !== void 0 && s >= 1,
    [ae.priceImpactNone]: s !== void 0 && s < 1 && s > -1,
    [ae.priceImpactMedium]: s !== void 0 && s <= -1 && s > -5,
    [ae.priceImpactHigh]: s !== void 0 && s <= -5
  }), w = s !== void 0 && s > 0 ? "+" : "";
  return /* @__PURE__ */ r.jsxs("div", { className: C, children: [
    f && /* @__PURE__ */ r.jsx(
      Gg,
      {
        availableTokens: e,
        inputTokenID: t,
        outputTokenID: u,
        onTokenChange: _,
        onClose: () => m(!1),
        literals: o
      }
    ),
    /* @__PURE__ */ r.jsxs("div", { className: ae.iconContainer, children: [
      /* @__PURE__ */ r.jsxs("div", { className: ae.tokenText, children: [
        x ? o.youPay : o.youReceive,
        ":"
      ] }),
      /* @__PURE__ */ r.jsxs("div", { className: ae.tokenContainer, children: [
        /* @__PURE__ */ r.jsx("span", { className: ae.currencyImage, children: d.icon }),
        /* @__PURE__ */ r.jsxs("div", { className: ae.tokenSelector, onClick: $, children: [
          /* @__PURE__ */ r.jsx("div", { className: ae.tokenTextColor, children: d.symbol }),
          /* @__PURE__ */ r.jsx("span", { className: ae.caret, children: /* @__PURE__ */ r.jsx(rn, {}) })
        ] })
      ] }),
      /* @__PURE__ */ r.jsxs("div", { className: ae.tokenText, children: [
        d.name,
        " ",
        Si(d.address)
      ] })
    ] }),
    /* @__PURE__ */ r.jsxs("div", { className: ae.inputContainer, children: [
      /* @__PURE__ */ r.jsxs("div", { className: ae.balanceLabel, children: [
        /* @__PURE__ */ r.jsxs("div", { className: p, children: [
          /* @__PURE__ */ r.jsx("span", { children: o.balanceLabel }),
          /* @__PURE__ */ r.jsx("span", { children: n.formatted || "0" })
        ] }),
        /* @__PURE__ */ r.jsx("span", { onClick: g, className: ae.setMax, children: "Max" })
      ] }),
      /* @__PURE__ */ r.jsxs("div", { className: ae.inputWrapper, children: [
        /* @__PURE__ */ r.jsxs("div", { className: ae.inputWrapperContent, children: [
          /* @__PURE__ */ r.jsx(
            "input",
            {
              className: ae.inputAmount,
              inputMode: "decimal",
              type: "number",
              placeholder: "0.0",
              pattern: "[0-9]*(.[0-9]+)?",
              value: c.amount,
              onChange: (S) => i({ amount: S.target.value })
            }
          ),
          /* @__PURE__ */ r.jsx("span", {})
        ] }),
        /* @__PURE__ */ r.jsxs("div", { className: ae.valueHolder, children: [
          /* @__PURE__ */ r.jsx("span", { children: c.currencyAmount }),
          !x && s !== void 0 && s !== 0 && /* @__PURE__ */ r.jsxs("span", { className: v, children: [
            w,
            s.toFixed(2),
            "%"
          ] })
        ] })
      ] })
    ] })
  ] });
}, m9 = "_rateContainer_3zgkw_1", _9 = "_rateContainerInner_3zgkw_15", $9 = "_rateLabel_3zgkw_33", p9 = "_rateLabelIcon_3zgkw_39", g9 = "_rateLabelBold_3zgkw_44", zt = {
  rateContainer: m9,
  rateContainerInner: _9,
  rateLabel: $9,
  rateLabelIcon: p9,
  rateLabelBold: g9
}, v9 = /^\d*\.?\d{0,2}$/, x9 = "_container_c0hmt_1", b9 = "_dataWrapper_c0hmt_9", y9 = "_dataLabel_c0hmt_15", C9 = "_valueHolder_c0hmt_20", N9 = "_toLeft_c0hmt_29", j9 = "_toRight_c0hmt_35", w9 = "_inputHolder_c0hmt_39", I9 = "_icon_c0hmt_55", je = {
  container: x9,
  dataWrapper: b9,
  dataLabel: y9,
  valueHolder: C9,
  toLeft: N9,
  toRight: j9,
  inputHolder: w9,
  icon: I9
}, T9 = ({
  slippage: e,
  deadline: n,
  onSlippageChange: t,
  onDeadlineChange: a,
  literals: o
}) => {
  const [i, l] = R(e.toString()), [u, s] = R(n.toString());
  fe(() => {
    l(e === 0 ? "" : e.toString());
  }, [e]), fe(() => {
    s(n === 0 ? "" : n.toString());
  }, [n]);
  const c = (f) => {
    const m = f.replace(",", "."), _ = m === "" || v9.test(m), g = m === "" || m === "." ? 0 : parseFloat(m);
    return { valid: _, value: g };
  }, d = (f) => {
    const { valid: m, value: _ } = c(f.target.value);
    m && (l(f.target.value), t({ slippage: _ }));
  }, h = (f) => {
    const { valid: m, value: _ } = c(f.target.value);
    m && (s(f.target.value), a({ deadline: _ }));
  };
  return /* @__PURE__ */ r.jsxs("div", { className: je.container, children: [
    /* @__PURE__ */ r.jsxs("div", { className: je.dataWrapper, children: [
      /* @__PURE__ */ r.jsx(nn, { size: yt.L, text: o.slippageTooltip, placement: tn.BOTTOM, children: /* @__PURE__ */ r.jsx("span", { className: je.icon, children: /* @__PURE__ */ r.jsx(aa, {}) }) }),
      /* @__PURE__ */ r.jsx("span", { className: je.dataLabel, children: "Slippage:" }),
      /* @__PURE__ */ r.jsxs("div", { className: je.valueHolder, children: [
        /* @__PURE__ */ r.jsx("div", { className: je.toLeft, children: /* @__PURE__ */ r.jsx(
          "input",
          {
            className: je.inputHolder,
            type: "text",
            inputMode: "decimal",
            value: i,
            placeholder: "0.00",
            onChange: d
          }
        ) }),
        /* @__PURE__ */ r.jsx("div", { className: je.toRight, children: "%" })
      ] })
    ] }),
    /* @__PURE__ */ r.jsxs("div", { className: je.dataWrapper, children: [
      /* @__PURE__ */ r.jsx(nn, { size: yt.L, text: o.deadlineTooltip, placement: tn.BOTTOM, children: /* @__PURE__ */ r.jsx("span", { className: je.icon, children: /* @__PURE__ */ r.jsx(aa, {}) }) }),
      /* @__PURE__ */ r.jsx("span", { className: je.dataLabel, children: "Deadline:" }),
      /* @__PURE__ */ r.jsxs("div", { className: je.valueHolder, children: [
        /* @__PURE__ */ r.jsx("div", { className: je.toLeft, children: /* @__PURE__ */ r.jsx(
          "input",
          {
            className: je.inputHolder,
            type: "text",
            inputMode: "decimal",
            value: u,
            placeholder: "0.00",
            onChange: h
          }
        ) }),
        /* @__PURE__ */ r.jsx("div", { className: je.toRight, children: "min" })
      ] })
    ] })
  ] });
}, S9 = ({
  deadline: e,
  inputTokenAmount: n,
  inputTokenInfo: t,
  isLoading: a,
  literals: o,
  onDeadlineChange: i,
  onSlippageChange: l,
  outputTokenAmount: u,
  outputTokenInfo: s,
  slippage: c
}) => {
  const [d, h] = R(!1), [f, m] = R("0"), _ = () => {
    h(!d);
  };
  if (fe(() => {
    if (a) return;
    const x = Number(u.amount) / Number(n.amount);
    if (Number.isNaN(x))
      m("?");
    else {
      const C = (d ? 1 / x : x)?.toFixed(6) || "0";
      m(C);
    }
  }, [n, a, d, u]), !t || !s || !n || !u) return null;
  const g = d ? s : t, $ = d ? t : s;
  return /* @__PURE__ */ r.jsxs("div", { className: zt.rateContainer, children: [
    /* @__PURE__ */ r.jsxs("div", { className: zt.rateContainerInner, onClick: _, children: [
      /* @__PURE__ */ r.jsxs("div", { className: zt.rateLabel, children: [
        o.rateLabel,
        ":"
      ] }),
      /* @__PURE__ */ r.jsxs("div", { className: zt.rateLabelBold, children: [
        /* @__PURE__ */ r.jsx("span", { children: "1" }),
        /* @__PURE__ */ r.jsx("span", { children: g.symbol }),
        /* @__PURE__ */ r.jsx("span", { children: "=" }),
        /* @__PURE__ */ r.jsx("span", { children: f }),
        /* @__PURE__ */ r.jsx("span", { children: $.symbol }),
        /* @__PURE__ */ r.jsx("span", { className: zt.rateLabelIcon, children: /* @__PURE__ */ r.jsx(Ji, {}) })
      ] })
    ] }),
    /* @__PURE__ */ r.jsx(
      T9,
      {
        deadline: e,
        slippage: c,
        literals: o,
        onDeadlineChange: i,
        onSlippageChange: l
      }
    )
  ] });
}, E9 = "_buttons_17olt_1", k9 = {
  buttons: E9
}, P9 = ({
  getTokenAllowance: e,
  inputTokenAmount: n,
  inputTokenBalance: t,
  inputTokenInfo: a,
  isApproveLoading: o,
  isSwapLoading: i,
  literals: l,
  onApprove: u,
  onSwap: s
}) => {
  const c = e(n), d = n.bigint > 0, h = t.bigint >= n.bigint;
  return /* @__PURE__ */ r.jsx("div", { className: k9.buttons, children: c ? /* @__PURE__ */ r.jsx(
    E,
    {
      color: "accent",
      isFull: !0,
      isDisabled: !h || !d || !c,
      isLoading: i,
      onClick: s,
      children: l.swap
    }
  ) : /* @__PURE__ */ r.jsx(
    E,
    {
      color: "primary",
      isFull: !0,
      onClick: u,
      isDisabled: !d || !h || c,
      isLoading: o,
      children: `${l.approve} ${a.symbol}`
    }
  ) });
}, A9 = "_boxGradient_g4whw_13", R9 = "_boxContent_g4whw_29", O9 = "_dexWrapper_g4whw_91", F9 = "_switchButton_g4whw_143", B9 = "_detailContainer_g4whw_397", Ht = {
  boxGradient: A9,
  boxContent: R9,
  dexWrapper: O9,
  switchButton: F9,
  detailContainer: B9
}, M9 = "_container_wg669_1", D9 = "_token_wg669_12", L9 = "_arrow_wg669_19", U9 = "_text_wg669_24", Tn = {
  container: M9,
  token: D9,
  arrow: L9,
  text: U9
}, V9 = ({ availableTokens: e, path: n, literals: t }) => /* @__PURE__ */ r.jsxs("div", { className: Tn.container, children: [
  /* @__PURE__ */ r.jsx("p", { className: Tn.text, children: t.path }),
  n.map((a, o) => {
    const i = e.find((u) => u.tokenID === a)?.symbol || a, l = o === n.length - 1;
    return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
      /* @__PURE__ */ r.jsxs("div", { className: Tn.token, children: [
        /* @__PURE__ */ r.jsx(jt, { iconKey: a, size: "l" }),
        /* @__PURE__ */ r.jsx("span", { children: i })
      ] }, o),
      !l && /* @__PURE__ */ r.jsx("div", { className: Tn.arrow, children: /* @__PURE__ */ r.jsx(Gr, {}) }, `arrow-${o}`)
    ] });
  })
] }), H7 = ({
  availableTokens: e,
  deadline: n,
  getAmountAllowance: t,
  inputTokenAmount: a,
  inputTokenBalance: o,
  inputTokenID: i,
  isApproveLoading: l = !1,
  isInputLoading: u = !1,
  isOutputLoading: s = !1,
  isSwapLoading: c = !1,
  literals: d,
  onApprove: h,
  onDeadlineChange: f,
  onInputTokenChange: m,
  onInputTokenAmountChange: _,
  onOutputTokenChange: g,
  onOutputTokenAmountChange: $,
  onSlippageChange: x,
  onSwap: b,
  onSwitchTokens: C,
  outputTokenAmount: p,
  outputTokenBalance: v,
  outputTokenID: w,
  path: S,
  priceImpact: D,
  slippage: Z
}) => {
  const [O, B] = R(!1), M = e.find(({ tokenID: se }) => se === i), k = e.find(({ tokenID: se }) => se === w);
  if (!M || !k) throw new Error("Token not found");
  const Oe = async () => await h(a), Fe = async () => {
    await b({
      input: a,
      output: p,
      slippage: Z,
      deadline: n
    });
  };
  return /* @__PURE__ */ r.jsx("div", { className: Ht.boxGradient, children: /* @__PURE__ */ r.jsx("div", { className: Ht.boxContent, children: /* @__PURE__ */ r.jsxs("div", { className: Ht.dexWrapper, children: [
    /* @__PURE__ */ r.jsx(
      Bo,
      {
        availableTokens: e,
        balance: o,
        inputTokenID: i,
        isLoading: u,
        literals: d,
        onAmountChange: _,
        onTokenChange: m,
        outputTokenID: w,
        tokenAmount: a,
        tokenInfo: M,
        type: Mn.INPUT
      }
    ),
    /* @__PURE__ */ r.jsx("div", { className: Ht.switchButton, onClick: C, children: /* @__PURE__ */ r.jsx(Xi, {}) }),
    /* @__PURE__ */ r.jsx(
      Bo,
      {
        availableTokens: e,
        balance: v,
        inputTokenID: w,
        isLoading: s,
        literals: d,
        onAmountChange: $,
        onTokenChange: g,
        outputTokenID: i,
        priceImpact: D,
        tokenAmount: p,
        tokenInfo: k,
        type: Mn.OUTPUT
      }
    ),
    /* @__PURE__ */ r.jsx(
      P9,
      {
        getTokenAllowance: t,
        inputTokenAmount: a,
        inputTokenBalance: o,
        inputTokenInfo: M,
        isApproveLoading: l,
        isSwapLoading: c,
        literals: d,
        onApprove: Oe,
        onSwap: Fe
      }
    ),
    /* @__PURE__ */ r.jsxs("div", { className: Ht.detailContainer, children: [
      /* @__PURE__ */ r.jsx(
        E,
        {
          type: "text",
          iconRight: O ? /* @__PURE__ */ r.jsx(Ki, {}) : /* @__PURE__ */ r.jsx(rn, {}),
          onClick: () => B(!O),
          isFull: !0,
          children: d.details
        }
      ),
      O && /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
        /* @__PURE__ */ r.jsx(
          S9,
          {
            deadline: n,
            inputTokenAmount: a,
            inputTokenInfo: M,
            isLoading: u || s,
            literals: d,
            onDeadlineChange: f,
            onSlippageChange: x,
            outputTokenAmount: p,
            outputTokenInfo: k,
            slippage: Z
          }
        ),
        /* @__PURE__ */ r.jsx(V9, { availableTokens: e, path: S, literals: d })
      ] })
    ] })
  ] }) }) });
}, W9 = "_container_efyfs_1", G9 = "_receivedAmount_efyfs_11", z9 = "_detailsContent_efyfs_19", H9 = "_detailsContentShowDetailsButton_efyfs_29", q9 = "_detailsContentShowDetailsButtonActive_efyfs_38", Y9 = "_detailsContentShowDetailsButtonIcon_efyfs_38", K9 = "_detailsContentDetailsList_efyfs_48", X9 = "_detailsContentDetailsListKey_efyfs_66", Z9 = "_detailsContentDetailsListValue_efyfs_71", tt = {
  container: W9,
  receivedAmount: G9,
  detailsContent: z9,
  detailsContentShowDetailsButton: H9,
  detailsContentShowDetailsButtonActive: q9,
  detailsContentShowDetailsButtonIcon: Y9,
  detailsContentDetailsList: K9,
  detailsContentDetailsListKey: X9,
  detailsContentDetailsListValue: Z9
}, q7 = ({
  tokenIconKey: e,
  button: n,
  status: t,
  details: a,
  literals: { expectedSynthetics: o, details: i }
}) => {
  const [l, u] = R(!1), s = () => u(!l);
  return /* @__PURE__ */ r.jsxs("div", { className: y(tt.container), children: [
    /* @__PURE__ */ r.jsx(i3, { bgColor: t ?? "background", padding: "s", children: /* @__PURE__ */ r.jsxs("div", { className: tt.receivedAmount, children: [
      /* @__PURE__ */ r.jsx(vi, { align: "center", as: "h2", color: t, children: o }),
      /* @__PURE__ */ r.jsx(jt, { iconKey: e, size: "xl", variant: "outlined" })
    ] }) }),
    /* @__PURE__ */ r.jsxs("div", { className: tt.detailsContent, children: [
      /* @__PURE__ */ r.jsxs(
        "button",
        {
          onClick: s,
          className: y(
            tt.detailsContentShowDetailsButton,
            l && tt.detailsContentShowDetailsButtonActive
          ),
          children: [
            i,
            /* @__PURE__ */ r.jsx("span", { className: tt.detailsContentShowDetailsButtonIcon, children: /* @__PURE__ */ r.jsx(rn, {}) })
          ]
        }
      ),
      /* @__PURE__ */ r.jsx("dl", { className: y(tt.detailsContentDetailsList), children: Object.entries(a).map(([c, d]) => /* @__PURE__ */ r.jsxs(nt.Fragment, { children: [
        /* @__PURE__ */ r.jsx("dt", { className: tt.detailsContentDetailsListKey, children: c }),
        /* @__PURE__ */ r.jsx("dd", { className: tt.detailsContentDetailsListValue, children: d })
      ] }, c)) })
    ] }),
    n
  ] });
}, J9 = "_inputRange_1izd1_1", Q9 = {
  inputRange: J9
}, e6 = ({ ref: e, ...n }) => {
  const t = Ee(null);
  Vr(e, () => t.current);
  const a = "var(--color-primary), var(--color-primary-strong)", o = "var(--color-gray-soft)", i = Nt(() => {
    if (!t.current?.checkValidity()) return;
    const l = n.value ? Number(n.value) : t.current?.valueAsNumber || 0, u = t.current?.min ? parseFloat(t.current.min) : 0, s = t.current?.max ? parseFloat(t.current.max) : 100, c = (l - u) / (s - u) * 100;
    t.current && (t.current.style.background = `linear-gradient(90deg, transparent ${c}%, ${o} ${c}%),
      linear-gradient(180deg, ${a})`);
  }, [n.value]);
  return fe(() => {
    const l = t.current;
    return i(), l?.addEventListener("input", i), () => {
      l?.removeEventListener("input", i);
    };
  }, [i]), /* @__PURE__ */ r.jsx(
    "input",
    {
      type: "range",
      ...n,
      className: Q9.inputRange,
      ref: t,
      onInput: i
    }
  );
};
e6.displayName = "InputRange";
const t6 = "_content_1a3zd_1", n6 = "_info_1a3zd_7", r6 = "_iconWrapper_1a3zd_18", a6 = "_tokenDetails_1a3zd_24", o6 = "_tokenLabel_1a3zd_30", i6 = "_tokenSymbol_1a3zd_34", s6 = "_percentageButtons_1a3zd_40", l6 = "_resize_1a3zd_53", st = {
  content: t6,
  info: n6,
  iconWrapper: r6,
  tokenDetails: a6,
  tokenLabel: o6,
  tokenSymbol: i6,
  percentageButtons: s6,
  resize: l6
}, Ei = ({ ref: e, decimals: n = 18, ...t }) => {
  const a = new RegExp(`^\\d+(\\.\\d{0,${n}})?$`), o = Ee(null);
  Vr(e, () => o.current);
  const i = () => {
    const l = o.current;
    if (l) {
      const u = l.value;
      l.validity.patternMismatch && (l.value = u.slice(0, -1));
    }
  };
  return /* @__PURE__ */ r.jsx(
    "input",
    {
      type: "text",
      pattern: a.source,
      ...t,
      ref: o,
      onInput: i,
      inputMode: "decimal"
    }
  );
};
Ei.displayName = "InputEther";
const c6 = "_content_9zrhk_1", d6 = "_row_9zrhk_9", u6 = "_balanceText_9zrhk_17", h6 = "_currencyAmount_9zrhk_18", f6 = "_isError_9zrhk_24", m6 = "_inputContainer_9zrhk_28", _6 = "_input_9zrhk_28", $6 = "_symbol_9zrhk_47", p6 = "_maxButton_9zrhk_66", Je = {
  content: c6,
  row: d6,
  balanceText: u6,
  currencyAmount: h6,
  isError: f6,
  inputContainer: m6,
  input: _6,
  symbol: $6,
  maxButton: p6
}, ki = ({
  ref: e,
  balanceAmount: n,
  balanceLabel: t,
  currencyAmount: a,
  hasBalance: o = !0,
  onMax: i,
  symbol: l,
  ...u
}) => {
  const s = y(Je.balanceText, {
    [Je.isError]: !o
  });
  return /* @__PURE__ */ r.jsx(gi, { bgColor: "background", padding: "s", children: /* @__PURE__ */ r.jsxs("div", { className: Je.content, children: [
    /* @__PURE__ */ r.jsxs("div", { className: Je.row, children: [
      /* @__PURE__ */ r.jsx("div", { className: s, children: n && t && /* @__PURE__ */ r.jsxs("span", { children: [
        t,
        ": ",
        n
      ] }) }),
      /* @__PURE__ */ r.jsx("div", { className: Je.currencyAmount, children: a })
    ] }),
    /* @__PURE__ */ r.jsxs("div", { className: Je.row, children: [
      i && /* @__PURE__ */ r.jsx("button", { className: Je.maxButton, onClick: i, children: "Max" }),
      /* @__PURE__ */ r.jsxs("label", { className: Je.inputContainer, children: [
        /* @__PURE__ */ r.jsx(Ei, { ref: e, autoComplete: "off", className: Je.input, placeholder: "0", ...u }),
        l && /* @__PURE__ */ r.jsx("span", { className: Je.symbol, children: l })
      ] })
    ] })
  ] }) });
};
ki.displayName = "InputToken";
const g6 = ({
  action: e,
  onPercentageClick: n,
  resize: t = !0,
  tokenID: a,
  tokenName: o,
  hasBalance: i = !0,
  cardBgColor: l = "surface",
  ...u
}) => {
  const s = y(st.info, {
    [st.resize]: !t
  });
  return /* @__PURE__ */ r.jsx(gi, { bgColor: l, children: /* @__PURE__ */ r.jsxs("div", { className: st.content, children: [
    /* @__PURE__ */ r.jsxs("div", { className: s, children: [
      /* @__PURE__ */ r.jsxs("div", { className: st.iconWrapper, children: [
        /* @__PURE__ */ r.jsx(jt, { size: "4xl", iconKey: a }),
        /* @__PURE__ */ r.jsxs("div", { className: st.tokenDetails, children: [
          /* @__PURE__ */ r.jsx("div", { className: st.tokenLabel, children: e }),
          /* @__PURE__ */ r.jsx("label", { className: st.tokenSymbol, children: o })
        ] })
      ] }),
      /* @__PURE__ */ r.jsx(ki, { hasBalance: i, ...u })
    ] }),
    n && /* @__PURE__ */ r.jsxs("div", { className: st.percentageButtons, children: [
      /* @__PURE__ */ r.jsx(E, { isFull: !0, onClick: () => n(25), isDisabled: !i, type: "outline", children: "25%" }),
      /* @__PURE__ */ r.jsx(E, { isFull: !0, onClick: () => n(50), isDisabled: !i, type: "outline", children: "50%" }),
      /* @__PURE__ */ r.jsx(E, { isFull: !0, onClick: () => n(75), isDisabled: !i, type: "outline", children: "75%" }),
      /* @__PURE__ */ r.jsx(E, { isFull: !0, onClick: () => n(100), isDisabled: !i, type: "outline", children: "100%" })
    ] })
  ] }) });
}, v6 = "_container_1mnam_1", x6 = "_formsContainer_1mnam_17", b6 = "_form_1mnam_17", y6 = "_icon_1mnam_48", C6 = "_buttonContainer_1mnam_65", N6 = "_settingsContainer_1mnam_73", Rt = {
  container: v6,
  formsContainer: x6,
  form: b6,
  icon: y6,
  buttonContainer: C6,
  settingsContainer: N6
}, Y7 = ({
  depositInputAmounts: e,
  isLoading: n = !1,
  literal: t,
  onChange: a,
  onSubmit: o,
  reservesConfig: i,
  transactionSettings: l,
  userTokenBalances: u
}) => {
  const [s, c] = R(l), d = e.every(({ bigint: m }) => m > 0n), h = e.every(({ tokenID: m, bigint: _ }) => u.find(($) => $.tokenID === m).bigint >= _), f = n || !d || !h;
  return /* @__PURE__ */ r.jsxs("div", { className: Rt.container, children: [
    /* @__PURE__ */ r.jsx("div", { className: Rt.formsContainer, children: i.map(({ id: m, symbol: _ }, g) => {
      const $ = u.find((p) => p.tokenID === m), x = e.find((p) => p.tokenID === m), b = $?.bigint >= x.bigint, C = g === i.length - 1;
      return /* @__PURE__ */ r.jsxs("div", { className: Rt.form, children: [
        /* @__PURE__ */ r.jsx(
          g6,
          {
            action: t.amounts.action,
            balanceAmount: $.formatted,
            balanceLabel: t.amounts.balance,
            currencyAmount: x.formattedCurrencyAmount,
            hasBalance: b,
            onChange: (p) => a({ tokenID: m, amount: p.target.value }),
            onMax: () => a({ tokenID: m, amount: $.amount }),
            tokenID: m,
            tokenName: _,
            value: x.amount,
            cardBgColor: "surface2"
          }
        ),
        !C && /* @__PURE__ */ r.jsx("span", { className: Rt.icon, children: /* @__PURE__ */ r.jsx(Go, {}) })
      ] }, m);
    }) }),
    /* @__PURE__ */ r.jsxs("div", { className: Rt.settingsContainer, children: [
      /* @__PURE__ */ r.jsx(
        ft,
        {
          format: "%",
          onChange: (m) => c({ ...s, slippage: Number(m.target.value) }),
          tooltip: t.transactionSettings.slippage.description,
          type: "number",
          title: "Slippage",
          id: "slippage",
          name: "slippage",
          value: s.slippage,
          step: "0.1",
          min: "1",
          max: "100",
          placeholder: "00"
        }
      ),
      /* @__PURE__ */ r.jsx(
        ft,
        {
          format: "min",
          onChange: (m) => c({ ...s, deadline: Number(m.target.value) }),
          tooltip: t.transactionSettings.deadline.description,
          type: "number",
          title: "Deadline",
          id: "deadline",
          name: "deadline",
          value: s.deadline,
          step: "0.1",
          min: "1",
          max: "1440",
          placeholder: "00"
        }
      )
    ] }),
    /* @__PURE__ */ r.jsx("div", { className: Rt.buttonContainer, children: /* @__PURE__ */ r.jsx(
      E,
      {
        isFull: !0,
        color: "accent",
        isLoading: n,
        isDisabled: f,
        onClick: () => o({ amounts: e, txSettings: s }),
        children: t.amounts.submit
      }
    ) })
  ] });
}, j6 = "ahora-crypto-container", w6 = "_container_a4qw6_1", I6 = {
  container: w6
}, K7 = ({
  address: e,
  backgroundColor: n,
  borderRadius: t,
  borderWithShadow: a,
  buttonColor: o,
  containerId: i = j6,
  cryptoCurrency: l,
  iframeHeight: u,
  iframeWidth: s,
  language: c,
  logoUrl: d,
  theme: h
}) => {
  const f = Ee(null), m = Ee(null), _ = Ee(!1);
  return fe(() => {
    const g = () => new Promise((x, b) => {
      if (window.AhoraCrypto) {
        x();
        return;
      }
      const C = document.createElement("script");
      C.src = "https://webwidget.ahoracrypto.com/webwidget.js", C.async = !0, C.onload = () => x(), C.onerror = () => b(new Error("Failed to load AhoraCrypto widget script")), document.head.appendChild(C), f.current = C;
    }), $ = () => {
      if (!window.AhoraCrypto || !m.current || _.current) return;
      const x = {
        backgroundColor: n,
        borderRadius: t,
        borderWithShadow: a,
        buttonColor: o,
        containerId: i,
        cryptoCurrency: l,
        iframeHeight: u,
        iframeWidth: s,
        language: c,
        logoUrl: d,
        theme: h
      }, b = window.AhoraCrypto.renderWebwidget(x);
      b.onReady(() => {
        e && b.setWalletAddress(e);
      }), _.current = !0;
    };
    return g().then(() => setTimeout($, 100)).catch(console.error), () => {
      f.current && f.current.parentNode && f.current.parentNode.removeChild(f.current);
    };
  }, [
    e,
    n,
    t,
    a,
    o,
    i,
    l,
    u,
    s,
    c,
    d,
    h
  ]), /* @__PURE__ */ r.jsx("div", { id: i, ref: m, className: I6.container });
}, T6 = "_tableComponentContainer_m9bwo_1", S6 = "_sortedHeaderCell_m9bwo_11", E6 = "_asc_m9bwo_32", k6 = "_desc_m9bwo_37", P6 = "_rightAligned_m9bwo_42", qt = {
  tableComponentContainer: T6,
  sortedHeaderCell: S6,
  asc: E6,
  desc: k6,
  rightAligned: P6
};
BigInt.prototype.toJSON = function() {
  return Number(this);
};
function X7({
  data: e,
  columns: n,
  defaultSort: t = { key: null, direction: null },
  getRowKey: a = (_) => JSON.stringify(_),
  onRowClick: o,
  isRowClickable: i = () => !!o,
  collapsibleContent: l,
  isRowCollapsible: u = () => !1,
  variant: s,
  headerButton: c,
  rowButton: d,
  caption: h,
  isLoading: f,
  emptyTableContent: m
}) {
  const [_, g] = nt.useState(t);
  function $(p, v) {
    return v.split(".").reduce(
      (w, S) => w && typeof w == "object" && S in w ? w[S] : void 0,
      p
    );
  }
  const x = (p) => {
    g((v) => ({
      key: p,
      direction: v.key === p ? v.direction === null ? "asc" : v.direction === "asc" ? "desc" : null : "asc"
    }));
  }, b = (p, v) => {
    ["Enter", " "].includes(p.key) && (p.target instanceof HTMLElement && p.target.tagName === "BUTTON" || (p.preventDefault(), v?.()));
  }, C = () => !_.key || _.direction === null ? e : [...e].sort((p, v) => {
    const S = n.find((O) => O.key === _.key)?.sortValue, D = S ? S(p) : $(p, _.key), Z = S ? S(v) : $(v, _.key);
    return D === Z ? 0 : D == null ? 1 : Z == null ? -1 : typeof D == "number" && typeof Z == "number" ? _.direction === "asc" ? D - Z : Z - D : _.direction === "asc" ? String(D).localeCompare(String(Z)) : String(Z).localeCompare(String(D));
  });
  return /* @__PURE__ */ r.jsx("section", { className: qt.tableComponentContainer, children: /* @__PURE__ */ r.jsxs(Uh, { variant: s, children: [
    /* @__PURE__ */ r.jsx(Vh, { children: h }),
    /* @__PURE__ */ r.jsx(Yh, { children: /* @__PURE__ */ r.jsx($n, { children: /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
      n.map((p) => {
        const w = _.key === p.key ? _.direction : null, S = p.sortable !== !1;
        return /* @__PURE__ */ r.jsx(
          gt,
          {
            scope: "col",
            align: p.align,
            onClick: S ? () => x(p.key) : void 0,
            role: S ? "button" : void 0,
            tabIndex: S ? 0 : void 0,
            children: /* @__PURE__ */ r.jsx(
              "div",
              {
                className: y(qt.sortedHeaderCell, {
                  [qt.asc]: w === "asc",
                  [qt.desc]: w === "desc",
                  [qt.rightAligned]: p.align === "right"
                }),
                children: p.header
              }
            )
          },
          String(p.key)
        );
      }),
      c && /* @__PURE__ */ r.jsx(gt, { align: "right", role: "button", children: c(e) })
    ] }) }) }),
    /* @__PURE__ */ r.jsxs(Wh, { children: [
      f && /* @__PURE__ */ r.jsx($n, { children: /* @__PURE__ */ r.jsx(gt, { align: "center", colSpan: n.length + (d ? 1 : 0), children: /* @__PURE__ */ r.jsx(L2, { size: "l" }) }) }),
      !f && e.length === 0 && /* @__PURE__ */ r.jsx($n, { children: /* @__PURE__ */ r.jsx(gt, { align: "center", colSpan: n.length + (d ? 1 : 0), children: m }) }),
      C().map((p, v) => {
        const w = a(p, v), S = i(p), D = S ? () => o?.(p) : void 0, Z = u(p, v), O = l?.(p, v);
        return /* @__PURE__ */ r.jsx(
          $n,
          {
            onClick: D,
            onKeyDown: S ? (B) => b(B, D) : void 0,
            role: S ? "button" : void 0,
            tabIndex: S ? 0 : void 0,
            isCollapsible: Z,
            collapsibleContent: O,
            children: /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
              n.map((B) => {
                const M = $(p, B.key) ?? void 0;
                if (M === void 0)
                  return /* @__PURE__ */ r.jsx(gt, {}, String(B.key));
                const k = B.isCellClickable?.(p) ?? !1, Oe = (Fe) => {
                  k && (Fe.stopPropagation(), B.onClick?.(p));
                };
                return /* @__PURE__ */ r.jsx(
                  gt,
                  {
                    align: B.align,
                    valign: B.valign,
                    onClick: Oe,
                    onKeyDown: k ? (Fe) => b(Fe, () => B.onClick?.(p)) : void 0,
                    role: k ? "button" : void 0,
                    tabIndex: k ? 0 : void 0,
                    "aria-label": k ? `Click to interact with ${B.header}` : void 0,
                    children: B.content?.(p) ?? M ?? null
                  },
                  String(B.key)
                );
              }),
              d && /* @__PURE__ */ r.jsx(gt, { align: "right", children: d(p) })
            ] })
          },
          w
        );
      })
    ] })
  ] }) });
}
const A6 = "_toaster_1g5r1_1", R6 = {
  toaster: A6
}, O6 = ({ ref: e, maxToasts: n = 10, defaultDuration: t = 1e4 }) => {
  const [a, o] = R([]), i = Ee(/* @__PURE__ */ new Map()), l = (u) => {
    const s = i.current.get(u);
    s && (clearTimeout(s), i.current.delete(u)), o((c) => c.map((d) => d.id === u ? { ...d, isExiting: !0 } : d)), setTimeout(() => {
      o((c) => c.filter((d) => d.id !== u));
    }, 300);
  };
  return Vr(e, () => ({
    addToast: (u) => {
      const s = crypto.randomUUID();
      o((d) => [...d, { ...u, id: s, isExiting: !1 }].slice(-n));
      const c = setTimeout(() => {
        l(s);
      }, u.duration ?? t);
      return i.current.set(s, c), s;
    },
    removeToast: l,
    clearAllToasts: () => {
      i.current.forEach((u) => clearTimeout(u)), i.current.clear(), o((u) => u.map((s) => ({ ...s, isExiting: !0 }))), setTimeout(() => o([]), 300);
    }
  })), fe(() => {
    const u = i.current;
    return () => {
      u.forEach((s) => clearTimeout(s)), u.clear();
    };
  }, []), /* @__PURE__ */ r.jsx("div", { className: R6.toaster, role: "alert", "aria-live": "polite", "aria-relevant": "additions removals", children: a.map(({ id: u, isExiting: s, ...c }) => /* @__PURE__ */ r.jsx(ef, { ...c, isExiting: s, onClose: () => l(u) }, u)) });
};
O6.displayName = "Toaster";
const F6 = "_card_upyny_1", B6 = "_container_upyny_8", M6 = "_iconWrapper_upyny_26", D6 = "_label_upyny_31", L6 = "_helperText_upyny_35", U6 = "_radioWrapper_upyny_39", V6 = "_detailsContainer_upyny_43", W6 = "_details_upyny_43", lt = {
  card: F6,
  container: B6,
  iconWrapper: M6,
  label: D6,
  helperText: L6,
  radioWrapper: U6,
  detailsContainer: V6,
  details: W6
}, G6 = ({ label: e, helperText: n, children: t, icon: a, ...o }) => /* @__PURE__ */ r.jsxs("div", { className: lt.card, children: [
  /* @__PURE__ */ r.jsxs("label", { className: lt.container, children: [
    /* @__PURE__ */ r.jsx("span", { className: lt.iconWrapper, children: a }),
    /* @__PURE__ */ r.jsxs("p", { className: lt.label, children: [
      e,
      " ",
      /* @__PURE__ */ r.jsx("span", { className: lt.helperText, children: n })
    ] }),
    /* @__PURE__ */ r.jsx("div", { className: lt.radioWrapper, children: /* @__PURE__ */ r.jsx($i, { ...o }) })
  ] }),
  /* @__PURE__ */ r.jsx("div", { className: lt.detailsContainer, children: /* @__PURE__ */ r.jsx("div", { className: lt.details, children: t }) })
] }), z6 = "_container_ekibs_1", H6 = {
  container: z6
}, Z7 = ({ options: e, name: n }) => /* @__PURE__ */ r.jsx("fieldset", { className: H6.container, children: e.map((t) => /* @__PURE__ */ r.jsx(G6, { ...t, name: n }, t.id)) }), q6 = "_container_okeio_1", Y6 = "_title_okeio_8", K6 = "_filters_okeio_15", X6 = "_types_okeio_22", Z6 = "_list_okeio_29", J6 = "_empty_okeio_35", Q6 = "_searchContainer_okeio_42", xt = {
  container: q6,
  title: Y6,
  filters: K6,
  types: X6,
  list: Z6,
  empty: J6,
  searchContainer: Q6
}, J7 = ({
  t: e = void 0,
  title: n,
  textEmpty: t,
  textSearch: a,
  posts: o,
  filterType: i,
  handleToggleFilter: l,
  search: u,
  setSearch: s,
  communityItemTypes: c,
  NextImage: d,
  onHandleCardClick: h,
  onHandleCardVideoClick: f
}) => {
  const m = (_) => {
    switch (_) {
      case c.POST:
        return "Posts";
      case c.VIDEO:
        return "Tutellus TV";
      case c.PRESS:
        return "Prensa y Medios";
    }
  };
  return /* @__PURE__ */ r.jsxs("div", { className: xt.container, children: [
    /* @__PURE__ */ r.jsx("h1", { className: xt.title, children: n }),
    /* @__PURE__ */ r.jsxs("div", { className: xt.filters, children: [
      /* @__PURE__ */ r.jsx("div", { className: xt.types, children: Object.values(c).map((_) => /* @__PURE__ */ r.jsx(
        Wl,
        {
          status: i === _ ? Jt.SELECTED : Jt.DEFAULT,
          onClick: () => l(_),
          iconLeft: /* @__PURE__ */ r.jsx(Is, {}),
          children: e ? e(`common:community.type.${_}`) : m(_)
        },
        _
      )) }),
      /* @__PURE__ */ r.jsx("div", { className: xt.searchContainer, children: /* @__PURE__ */ r.jsx(
        Iu,
        {
          type: "search",
          placeholder: a,
          value: u,
          onChange: (_) => s(_.target.value)
        }
      ) })
    ] }),
    /* @__PURE__ */ r.jsx("div", { className: xt.list, children: o?.map((_) => /* @__PURE__ */ r.jsx("div", { children: /* @__PURE__ */ r.jsx(
      xf,
      {
        post: _,
        communityItemTypes: c,
        customImage: d ? /* @__PURE__ */ r.jsx(d, { src: _.image, alt: _.title, layout: "fill", objectFit: "cover" }) : void 0,
        onClick: h,
        onVideoClick: f
      }
    ) }, _.id)) }),
    o?.length === 0 && /* @__PURE__ */ r.jsx("div", { className: xt.empty, children: t })
  ] });
}, ev = "_container_pyaly_1", tv = "_unit_pyaly_13", nv = "_circleIcon_pyaly_19", rv = "_infoTitle_pyaly_32", av = "_info_pyaly_32", ov = "_infoMin_pyaly_45", iv = "_arrow_pyaly_50", sv = "_rotateArrow_pyaly_54", lv = "_containerItems_pyaly_58", cv = "_containerItem_pyaly_58", dv = "_itemInfo_pyaly_84", uv = "_containerItemInfoIcon_pyaly_90", hv = "_fill_pyaly_103", fv = "_halfFill_pyaly_107", mv = "_noFill_pyaly_111", _v = "_itemInfoIcon_pyaly_115", $v = "_itemInfoTitle_pyaly_124", pv = "_itemInfoMin_pyaly_131", me = {
  container: ev,
  unit: tv,
  circleIcon: nv,
  infoTitle: rv,
  info: av,
  infoMin: ov,
  arrow: iv,
  rotateArrow: sv,
  containerItems: lv,
  containerItem: cv,
  itemInfo: dv,
  containerItemInfoIcon: uv,
  fill: hv,
  halfFill: fv,
  noFill: mv,
  itemInfoIcon: _v,
  itemInfoTitle: $v,
  itemInfoMin: pv
}, Q7 = ({ title: e, min: n, unit: t, items: a }) => {
  const [o, i] = R(!1), l = y(me.arrow, {
    [me.rotateArrow]: o
  });
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsxs("div", { className: me.container, onClick: () => i(!o), children: [
      /* @__PURE__ */ r.jsxs("div", { className: me.unit, children: [
        /* @__PURE__ */ r.jsx("div", { className: me.circleIcon, children: t }),
        /* @__PURE__ */ r.jsxs("div", { className: me.info, children: [
          /* @__PURE__ */ r.jsx("div", { className: me.infoTitle, children: e }),
          /* @__PURE__ */ r.jsx("div", { className: me.infoMin, children: n })
        ] })
      ] }),
      /* @__PURE__ */ r.jsx("div", { className: l, children: /* @__PURE__ */ r.jsx(Zt, {}) })
    ] }),
    o && /* @__PURE__ */ r.jsx("div", { className: me.containerItems, children: a?.map((u, s) => /* @__PURE__ */ r.jsxs("div", { className: me.containerItem, children: [
      /* @__PURE__ */ r.jsxs("div", { className: me.itemInfo, children: [
        /* @__PURE__ */ r.jsx(
          "div",
          {
            className: y(me.containerItemInfoIcon, {
              [me.noFill]: u.filled === 0,
              [me.halfFill]: u.filled === 0.5,
              [me.fill]: u.filled === 1
            }),
            children: /* @__PURE__ */ r.jsx("div", { className: me.itemInfoIcon, children: /* @__PURE__ */ r.jsx(zr, {}) })
          }
        ),
        /* @__PURE__ */ r.jsx("div", { className: me.itemInfoTitle, children: u.title })
      ] }),
      /* @__PURE__ */ r.jsx("div", { className: me.itemInfoMin, children: u.min })
    ] }, s)) })
  ] });
}, gv = "_container_13g5q_1", vv = "_colorPersonal_13g5q_14", xv = "_image_13g5q_19", bv = "_info_13g5q_33", yv = "_infoText_13g5q_40", Cv = "_infoTop_13g5q_44", Nv = "_name_13g5q_51", jv = "_icons_13g5q_55", wv = "_addUserIcon_13g5q_61", Iv = "_mailIcon_13g5q_62", Tv = "_infoMiddle_13g5q_80", Sv = "_percentageBar_13g5q_84", Ev = "_percentageBarComleted_13g5q_91", kv = "_infoBottom_13g5q_97", Pv = "_percentageInfo_13g5q_104", Av = "_earnInfo_13g5q_105", Rv = "_earnIcon_13g5q_115", _e = {
  container: gv,
  colorPersonal: vv,
  image: xv,
  info: bv,
  infoText: yv,
  infoTop: Cv,
  name: Nv,
  icons: jv,
  addUserIcon: wv,
  mailIcon: Iv,
  infoMiddle: Tv,
  percentageBar: Sv,
  percentageBarComleted: Ev,
  infoBottom: kv,
  percentageInfo: Pv,
  earnInfo: Av,
  earnIcon: Rv
}, eb = ({ name: e, imageStudent: n, percentageCourse: t, earnCourse: a, isPersonalCard: o = !1 }) => {
  const i = y(_e.container, {
    [_e.colorPersonal]: o
  });
  return /* @__PURE__ */ r.jsxs("div", { className: i, children: [
    /* @__PURE__ */ r.jsx("div", { className: _e.imageContainer, children: /* @__PURE__ */ r.jsx("div", { className: _e.image, children: /* @__PURE__ */ r.jsx("img", { src: n, alt: `${e} img` }) }) }),
    /* @__PURE__ */ r.jsxs("div", { className: _e.info, children: [
      /* @__PURE__ */ r.jsxs("div", { className: _e.infoTop, children: [
        /* @__PURE__ */ r.jsx("span", { className: _e.name, children: e }),
        !o && /* @__PURE__ */ r.jsxs("div", { className: _e.icons, children: [
          /* @__PURE__ */ r.jsx("div", { className: _e.addUserIcon, children: /* @__PURE__ */ r.jsx(Ss, {}) }),
          /* @__PURE__ */ r.jsx("div", { className: _e.mailIcon, children: /* @__PURE__ */ r.jsx(Es, {}) })
        ] })
      ] }),
      /* @__PURE__ */ r.jsx("div", { className: _e.infoMiddle, children: /* @__PURE__ */ r.jsx("div", { className: _e.percentageBar, children: /* @__PURE__ */ r.jsx("div", { className: _e.percentageBarComleted, style: { width: `${t}%` } }) }) }),
      /* @__PURE__ */ r.jsxs("div", { className: _e.infoBottom, children: [
        /* @__PURE__ */ r.jsxs("span", { className: _e.percentageInfo, children: [
          t,
          "% ",
          /* @__PURE__ */ r.jsx("span", { className: _e.infoText, children: "Completado" })
        ] }),
        /* @__PURE__ */ r.jsxs("span", { className: _e.earnInfo, children: [
          /* @__PURE__ */ r.jsx("span", { children: a }),
          /* @__PURE__ */ r.jsx("span", { className: _e.earnIcon, children: /* @__PURE__ */ r.jsx(zo, {}) }),
          "course"
        ] })
      ] })
    ] })
  ] });
}, Ov = "_container_yd3kj_1", Fv = "_notAllowed_yd3kj_5", Bv = "_infoTop_yd3kj_9", Mv = "_image_yd3kj_14", Dv = "_info_yd3kj_9", Lv = "_name_yd3kj_32", Uv = "_text_yd3kj_37", Vv = "_title_yd3kj_42", Wv = "_infoBottom_yd3kj_71", Gv = "_earnInfo_yd3kj_78", zv = "_voteInfo_yd3kj_83", Hv = "_earnButton_yd3kj_89", qv = "_commentsButton_yd3kj_90", Yv = "_voteUp_yd3kj_111", Kv = "_voteDown_yd3kj_112", Xv = "_reply_yd3kj_123", Zv = "_actions_yd3kj_128", Jv = "_actionsElements_yd3kj_133", Qv = "_actionsText_yd3kj_149", e8 = "_editIcon_yd3kj_155", t8 = "_deleteIcon_yd3kj_159", oe = {
  container: Ov,
  notAllowed: Fv,
  infoTop: Bv,
  image: Mv,
  info: Dv,
  name: Lv,
  text: Uv,
  title: Vv,
  infoBottom: Wv,
  earnInfo: Gv,
  voteInfo: zv,
  earnButton: Hv,
  commentsButton: qv,
  voteUp: Yv,
  voteDown: Kv,
  reply: Xv,
  actions: Zv,
  actionsElements: Jv,
  actionsText: Qv,
  editIcon: e8,
  deleteIcon: t8
}, tb = ({
  textReply: e = "Responder",
  textEdit: n = "Editar",
  textDelete: t = "Borrar",
  title: a,
  name: o,
  imageStudent: i,
  earnCourse: l = 0,
  text: u,
  answers: s,
  voteUp: c = 0,
  voteDown: d = 0,
  onClickStudent: h,
  onClickReply: f,
  onClickMoreAnswers: m,
  onClickEarn: _,
  onClickVoteUp: g,
  onClickVoteDown: $,
  onClickEdit: x,
  onClickDelete: b,
  isAnswer: C = !0,
  owner: p = !1
}) => /* @__PURE__ */ r.jsxs("div", { className: oe.container, children: [
  /* @__PURE__ */ r.jsxs("div", { className: oe.infoTop, children: [
    /* @__PURE__ */ r.jsx("div", { className: oe.image, children: /* @__PURE__ */ r.jsx("img", { src: i, width: 58, height: 58, alt: `${o} img` }) }),
    /* @__PURE__ */ r.jsxs("div", { className: oe.info, children: [
      /* @__PURE__ */ r.jsx("span", { className: oe.title, children: a }),
      /* @__PURE__ */ r.jsx("span", { className: oe.name, onClick: h, children: o }),
      /* @__PURE__ */ r.jsx("div", { className: oe.text, dangerouslySetInnerHTML: { __html: u } })
    ] })
  ] }),
  /* @__PURE__ */ r.jsxs("div", { className: oe.infoBottom, children: [
    /* @__PURE__ */ r.jsxs("div", { className: oe.voteInfo, children: [
      /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
        /* @__PURE__ */ r.jsx("span", { children: c }),
        /* @__PURE__ */ r.jsx(
          "span",
          {
            className: y(oe.voteUp, {
              [oe.notAllowed]: p
            }),
            onClick: g,
            children: /* @__PURE__ */ r.jsx(fa, {})
          }
        )
      ] }),
      /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
        /* @__PURE__ */ r.jsx(
          "span",
          {
            className: y(oe.voteDown, {
              [oe.notAllowed]: p
            }),
            onClick: $,
            children: /* @__PURE__ */ r.jsx(fa, {})
          }
        ),
        /* @__PURE__ */ r.jsx("span", { children: d })
      ] })
    ] }),
    !C && !p && /* @__PURE__ */ r.jsx("div", { className: oe.reply, onClick: f, children: e }),
    !C && p && /* @__PURE__ */ r.jsxs("div", { className: oe.actions, children: [
      /* @__PURE__ */ r.jsxs("div", { className: oe.actionsElements, onClick: x, children: [
        /* @__PURE__ */ r.jsx("span", { className: oe.editIcon, children: /* @__PURE__ */ r.jsx(qo, {}) }),
        /* @__PURE__ */ r.jsx("span", { className: oe.actionsText, children: n })
      ] }),
      /* @__PURE__ */ r.jsxs("div", { className: oe.actionsElements, onClick: b, children: [
        /* @__PURE__ */ r.jsx("span", { className: oe.deleteIcon, children: /* @__PURE__ */ r.jsx(Ho, {}) }),
        /* @__PURE__ */ r.jsx("span", { className: oe.actionsText, children: t })
      ] })
    ] }),
    /* @__PURE__ */ r.jsxs("div", { className: oe.earnInfo, children: [
      l && /* @__PURE__ */ r.jsxs("span", { className: oe.earnButton, onClick: _, children: [
        /* @__PURE__ */ r.jsx(zo, {}),
        /* @__PURE__ */ r.jsx("span", { children: l })
      ] }),
      !C && /* @__PURE__ */ r.jsxs("span", { className: oe.commentsButton, onClick: m, children: [
        /* @__PURE__ */ r.jsx(ks, {}),
        /* @__PURE__ */ r.jsx("span", { children: s })
      ] })
    ] })
  ] })
] }), n8 = "_card_18ou8_1", r8 = "_header_18ou8_15", a8 = "_text_18ou8_30", o8 = "_title_18ou8_34", i8 = "_author_18ou8_40", s8 = "_body_18ou8_44", l8 = "_footer_18ou8_49", c8 = "_optionsLink_18ou8_56", d8 = "_optionsMenu_18ou8_65", u8 = "_optionsMenuText_18ou8_82", h8 = "_info_18ou8_127", f8 = "_description_18ou8_145", $e = {
  card: n8,
  header: r8,
  text: a8,
  title: o8,
  author: i8,
  body: s8,
  footer: l8,
  optionsLink: c8,
  optionsMenu: d8,
  optionsMenuText: u8,
  info: h8,
  description: f8
}, nb = ({ image: e, title: n, link: t, author: a, likes: o, views: i, tuts: l, description: u, saveText: s, shareText: c }) => /* @__PURE__ */ r.jsxs("a", { href: t, className: $e.card, children: [
  /* @__PURE__ */ r.jsx("div", { className: $e.header, children: e }),
  /* @__PURE__ */ r.jsxs("div", { className: $e.body, children: [
    /* @__PURE__ */ r.jsxs("div", { className: $e.text, children: [
      /* @__PURE__ */ r.jsx("h2", { className: $e.title, children: n }),
      /* @__PURE__ */ r.jsx("p", { className: $e.author, children: a })
    ] }),
    /* @__PURE__ */ r.jsx("span", { className: $e.optionsLink, children: /* @__PURE__ */ r.jsx(Rs, {}) }),
    /* @__PURE__ */ r.jsxs("div", { className: $e.optionsMenu, children: [
      /* @__PURE__ */ r.jsxs("span", { className: $e.optionsMenuText, children: [
        /* @__PURE__ */ r.jsx(Os, {}),
        " ",
        s
      ] }),
      /* @__PURE__ */ r.jsxs("span", { className: $e.optionsMenuText, children: [
        /* @__PURE__ */ r.jsx(Vo, {}),
        " ",
        c
      ] })
    ] })
  ] }),
  /* @__PURE__ */ r.jsxs("div", { className: $e.footer, children: [
    /* @__PURE__ */ r.jsxs("span", { className: $e.info, children: [
      /* @__PURE__ */ r.jsx("span", { className: $e.likeIcon, children: /* @__PURE__ */ r.jsx(As, {}) }),
      o
    ] }),
    /* @__PURE__ */ r.jsxs("span", { className: $e.info, children: [
      /* @__PURE__ */ r.jsx("span", { className: $e.viewIcon, children: /* @__PURE__ */ r.jsx(Fs, {}) }),
      i
    ] }),
    /* @__PURE__ */ r.jsxs("span", { className: $e.info, children: [
      /* @__PURE__ */ r.jsx("span", { className: $e.coinIcon, children: /* @__PURE__ */ r.jsx(Ps, {}) }),
      l
    ] })
  ] }),
  /* @__PURE__ */ r.jsx("div", { className: $e.description, children: /* @__PURE__ */ r.jsx("p", { children: u }) })
] }), m8 = "_container_1kxh1_1", _8 = "_info_1kxh1_11", $8 = "_infoBottom_1kxh1_16", p8 = "_infoBottomIcon_1kxh1_22", g8 = "_icon_1kxh1_33", We = {
  container: m8,
  info: _8,
  infoBottom: $8,
  infoBottomIcon: p8,
  icon: g8
}, rb = ({ min: e, textEdit: n, textDelete: t, text: a }) => /* @__PURE__ */ r.jsx("div", { className: We.container, children: /* @__PURE__ */ r.jsxs("div", { className: We.info, children: [
  /* @__PURE__ */ r.jsx("div", { className: We.infoTop, children: /* @__PURE__ */ r.jsx("div", { className: We.text, dangerouslySetInnerHTML: { __html: a } }) }),
  /* @__PURE__ */ r.jsxs("div", { className: We.infoBottom, children: [
    /* @__PURE__ */ r.jsxs("div", { className: We.infoBottomIcon, children: [
      /* @__PURE__ */ r.jsx("span", { className: We.icon, children: /* @__PURE__ */ r.jsx(Bs, {}) }),
      /* @__PURE__ */ r.jsx("span", { children: e })
    ] }),
    /* @__PURE__ */ r.jsxs("div", { className: We.infoBottomIcon, children: [
      /* @__PURE__ */ r.jsx("span", { className: We.icon, children: /* @__PURE__ */ r.jsx(qo, {}) }),
      /* @__PURE__ */ r.jsx("span", { children: n })
    ] }),
    /* @__PURE__ */ r.jsxs("div", { className: We.infoBottomIcon, children: [
      /* @__PURE__ */ r.jsx("span", { className: We.icon, children: /* @__PURE__ */ r.jsx(Ho, {}) }),
      /* @__PURE__ */ r.jsx("span", { children: t })
    ] })
  ] })
] }) });
export {
  P7 as $,
  Js as A,
  E as B,
  Wl as C,
  o7 as D,
  f7 as E,
  $7 as F,
  lh as G,
  xf as H,
  C7 as I,
  N7 as J,
  j7 as K,
  n7 as L,
  Ze as M,
  c7 as N,
  w7 as O,
  tn as P,
  gn as Q,
  vn as R,
  Jt as S,
  r7 as T,
  I7 as U,
  xn as V,
  T7 as W,
  Io as X,
  S7 as Y,
  E7 as Z,
  k7 as _,
  P as a,
  I_ as a0,
  Nn as a1,
  A7 as a2,
  R7 as a3,
  F7 as a4,
  rf as a5,
  B7 as a6,
  M7 as a7,
  D7 as a8,
  L7 as a9,
  i3 as aA,
  vi as aB,
  y7 as aC,
  xi as aD,
  Bt as aE,
  ef as aF,
  O7 as aG,
  G7 as aH,
  ug as aI,
  _g as aJ,
  z7 as aK,
  H7 as aL,
  q7 as aM,
  e6 as aN,
  Y7 as aO,
  g6 as aP,
  ki as aQ,
  K7 as aR,
  X7 as aS,
  O6 as aT,
  G6 as aU,
  Z7 as aV,
  U7 as aa,
  V7 as ab,
  W7 as ac,
  J7 as ad,
  Q7 as ae,
  eb as af,
  tb as ag,
  rb as ah,
  nb as ai,
  jt as aj,
  Iu as ak,
  Zu as al,
  $i as am,
  xo as an,
  p7 as ao,
  g7 as ap,
  Uh as aq,
  Vh as ar,
  Wh as as,
  gt as at,
  v7 as au,
  Yh as av,
  $n as aw,
  x7 as ax,
  b7 as ay,
  gi as az,
  dt as b,
  ne as c,
  Ko as d,
  a7 as e,
  _i as f,
  mi as g,
  nn as h,
  yt as i,
  i7 as j,
  s7 as k,
  l7 as l,
  On as m,
  ze as n,
  bo as o,
  pt as p,
  sn as q,
  Z0 as r,
  d7 as s,
  pi as t,
  u7 as u,
  L2 as v,
  m7 as w,
  _7 as x,
  sh as y,
  ch as z
};
